(function() {
    'use strict';

    angular
        .module('xposApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            // 'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ngAnimate',
            'moment-picker',
            'toastr',
            'ng-virtual-keyboard',
            'uiSwitch'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', 'keyboardHandler'];

    function run(stateHandler, translationHandler , keyboardHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
        keyboardHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')
        .factory('User', User);

    User.$inject = ['$resource','$localStorage'];

    function User ($resource, $localStorage) {
        var service = $resource($localStorage.API_URL+'api/users/:login', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http', '$localStorage'];

    function ProfileService($http, $localStorage) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo,
            getProfileInfoUrl: getProfileInfoUrl
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get($localStorage.API_URL+'api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
        function getProfileInfoUrl(url) {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get(url+'api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')
        .factory('Register', Register);

    Register.$inject = ['$resource', '$localStorage'];

    function Register ($resource, $localStorage) {
        return $resource($localStorage.API_URL+'api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$localStorage'];

    function Principal ($q, Account, $localStorage) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource', '$localStorage'];

    function PasswordResetInit($resource, $localStorage) {
        var service = $resource($localStorage.API_URL+'api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource', '$localStorage'];

    function PasswordResetFinish($resource, $localStorage) {
        var service = $resource($localStorage.API_URL+'api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('Password', Password);

    Password.$inject = ['$resource', '$localStorage'];

    function Password($resource, $localStorage) {
        var service = $resource($localStorage.API_URL+'api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal', '$localStorage'];

    function hasAuthority(Principal, $localStorage) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal', '$localStorage'];

    function hasAnyAuthority(Principal, $localStorage) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');
            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$localStorage'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, $localStorage) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            loginWithKey:loginWithKey,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('home');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        // $state.go('home').then(function() {
                        //     LoginService.open();
                        // });
                        $state.go('home');
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        /*
                        $translate.use(account.langKey).then(function () {
                            // comment for XPOS
                            $translate.refresh();
                        });
                        */
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithKey (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.loginWithKey(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    /*
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            //$translate.refresh();
                        });
                    }
                    */
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithKey:loginWithKey,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }
        function login (credentials) {
            //console.log(credentials);
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: false
            };
            return $http.post($localStorage.API_URL+'api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }
        function loginWithKey (credentials) {
            //console.log("loginWithKey"+credentials);
            var data = {
                username: "",
                password: "",
                rememberMe: false,
                loginKey:credentials.loginKey
            };
            return $http.post($localStorage.API_URL+'api/authenticate_key', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource', '$localStorage'];

    function Activate ($resource, $localStorage) {
        var service = $resource($localStorage.API_URL+'api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('Account', Account);

    Account.$inject = ['$resource', '$localStorage'];

    function Account ($resource, $localStorage) {
        var service = $resource($localStorage.API_URL +'api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['PosSetting','$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$rootScope', '$localStorage', '$scope', '$translate','ngVirtualKeyboardService','JhiLanguageService', '$sessionStorage','$http', '$q','OrderPos'];

    function NavbarController(PosSetting, $state, Auth, Principal, ProfileService, LoginService, $rootScope, $localStorage, $scope, $translate, ngVirtualKeyboardService, JhiLanguageService, $sessionStorage,$http, $q, OrderPos) {
        var vm = this;
        vm.isNav = true;
        vm.isExternalDisplay = false;
        vm.isNavbarCollapsed = true;
        vm.isSearchButton = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.styleDefault = true;
        vm.shutdownMode = {};



         $rootScope.$on('isHideNav', function() {
            vm.isNav = false;
        });

        $rootScope.$on('isExternalDisplay', function() {
            vm.isNav = false;
            vm.isExternalDisplay = true;
        });

        $rootScope.$on('order-fast-on', function() {
            vm.isNav = false;
        });
        $rootScope.$on('order-fast-off', function() {
            vm.isNav = true;
        });

         $rootScope.$on('turnOffSmart', function() {
            vm.shutdownMode.setting = '1';
        });

         var makeRestCall   = function (url) {

            return $http.get($localStorage.API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

       makeRestCall('api/setting?type=STYLE').then(function(data){
                     if(data.data == null || data.data.setting == 'Default'){
                        vm.styleDefault = true;
                    }else {
                         vm.styleDefault = false;
                    }
                   },function(error){

                });

        $rootScope.$on('resetShutdownMode', function() {
           makeRestCall('api/setting?type=SHUTDOWNMODE').then(function(data){
                vm.shutdownMode = data.data;
                vm.shutdownMode.setting = '0';

                },function(error){
            });

            //console.log( vm.shutdownMode);
        });

         $rootScope.$on("shudownModeAfterSync", function(evt,data){
           vm.shutdownMode.setting = data;
        });

        makeRestCall('api/setting?type=SHUTDOWNMODE').then(function(data){
                vm.shutdownMode = data.data;
                },function(error){
            });
         makeRestCall('api/setting?type=USE_TIM').then(function(data){
                      vm.useTIM = data.data.setting;
                  },function(error){
          });
         makeRestCall('api/setting?type=SHOW_BILLS_SUPER_USER').then(function(data){
                      vm.showBillsSuper = data.data.setting;
                  },function(error){
          });
        makeRestCall('api/setting?type=POS_VERSION').then(function(data){
                      vm.posVersion = data.data.setting;
                  },function(error){
          });


        var cleanHttpErrorListener = $rootScope.$on('innovationApp.httpError', function (event, httpResponse) {
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                break;
            case 400:
                break;
            case 404:
                $state.go('pagenotfound');
                break;
            default:

            }
        });

        vm.goOrder = function(){
           $state.go('order-fast-advance');
        }

        vm.shutDown = function(){
          if(vm.shutdownMode.setting == '0'){
                vm.shutdownMode.setting = '1';
                PosSetting.update(vm.shutdownMode,function(result){
                    $rootScope.$broadcast('turnOffSmart');
                })
                //
          }else
          if(vm.shutdownMode.setting == '1'){
                //if(vm.currentRole == 'ROLE_ADMIN'){
                  // check there is opening order
                  checkOpeningOrder(function(){
                    var shutdown = require('electron-shutdown-command');
                    shutdown.shutdown();
                    console.log("Shut down!");
                  });

                /*}else{
                  var notify = document.getElementById("alertShutdown").innerHTML;
                  alert(notify);
                }*/

          }
        }
        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        initKeyboard();

        $scope.listYear = [];
        $scope.search = search;

        $rootScope.$on("searchData", function(evt,data){
        	vm.searchData = data;
          if(vm.searchData.length >0){
            vm.isSearchButton = false;
          }else{
            vm.isSearchButton = true;
          }
         });

        getAccount();

        $scope.$on('languageChange', function(data) {
            initKeyboard();
        });

        function initKeyboard(){
            $scope.t01Config = {layout: JhiLanguageService.getKeyboard(), kt: 'US International', showKbSelect: true,
             numberPad: true, showVersion: true, usePreview: false, autoAccept : true, reposition : true,
             position : {
                  // null (attach to input/textarea) or a jQuery object (attach elsewhere)
                  of : $(window),
                  my : 'center bottom',
                  at : 'center bottom',
                  // at2 is used when "usePreview" is false (centers keyboard at the bottom
                  // of the input/textarea)
                  at2: 'center bottom',
                  collision: 'flipfit flipfit'
                }
        };
        }
        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                // $rootScope.flag = vm.account.langKey;
                vm.isAuthenticated = Principal.isAuthenticated;
                 vm.currentRole = 'ROLE_USER';
                  for (var j = 0; j < vm.account.authorities.length; j++) {
                    if(vm.account.authorities[j] == 'ROLE_ADMIN'){
                        vm.currentRole = 'ROLE_ADMIN';
                        break;
                    }else if(vm.account.authorities[j] == 'ROLE_SUPER_USER'){
                      vm.currentRole = 'ROLE_SUPER_USER';
                      break;
                    }
                  }
            });
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function search() {
          if(vm.searchData.length >0){
            vm.isSearchButton = false;
          }else{
            vm.isSearchButton = true;
          }
            if(vm.searchData.includes("0000000000000000")){
               vm.searchData = '';
               //$localStorage.searchData = null;
                Auth.logout();
                $state.go('home');
            }else{
              if($localStorage.searchData  != "clear"){
                $rootScope.$emit('searchData',vm.searchData);
                vm.searchData = null;
              }
              $localStorage.searchData = vm.searchData;

            }

        }

      vm.clearSearch = clearSearch;
      function clearSearch() {
        vm.searchData = '';
          if(vm.searchData.length >0){
            vm.isSearchButton = false;
          }else{
            vm.isSearchButton = true;
          }
            //$localStorage.searchData = vm.searchData;
            $rootScope.$emit('searchData',vm.searchData);
        }
        $rootScope.$on('authenticationSuccess', function () {
            getAccount();
            vm.isNav = true;
        });



        vm.checkLogOut = checkLogOut;
         function checkLogOut( inputCheck){
            if(inputCheck != null && inputCheck.includes("0000000000000000")){
              vm.inputFocus = '';
                Auth.logout();
                $state.go('home');
            }

        }

        vm.reFocus =reFocus;
        function reFocus(){
            angular.element('#input_focus').focus();
        }

        function checkOpeningOrder (callback) {
           var dataQueryLoadAllOrder = {
                pageNo: null,
                pageSize: null,
                sortBy: sort()
            };

            dataQueryLoadAllOrder.orderStatus = "INPROGRESS";

            OrderPos.query(dataQueryLoadAllOrder, onSuccess, onError);
            function sort() {
                var result = [];
                result.push('id:asc');
                return result;
            }
            function onSuccess(data, headers) {
                var orders = data.content;

                if(orders.length == 0){
                    vm.ordersIsOpen = false;
                    callback();
                }else{
                    vm.ordersIsOpen = true;
                    alert("There are any opeing order")
                }
            }
            function onError(error) {
                AlertService.error(error.data);
            }
        }

        vm.onKeyup = function(event){
            //console.log(event.keyCode);
           
            if(event.keyCode == 13){
                search();
            }
            //console.log(vm.searchedProductIndex);
        }

        vm.inputSearch = function(){
          if(vm.searchData.length == 0){
            search();
          }
        }

        

    }
})();

(function () {
    'use strict';

    angular
            .module('xposApp')
            .controller('LeftMenuController', LeftMenuController);

    LeftMenuController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function LeftMenuController($scope, $state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        // ProfileService.getProfileInfo().then(function (response) {
        //     vm.inProduction = response.inProduction;
        //     vm.swaggerEnabled = response.swaggerEnabled;
        // });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            vm.account = Principal.identity().$$state.value;
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            //vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            //vm.isNavbarCollapsed = true;
        }

        $scope.$on('$viewContentLoaded', function () {
//            jQuery.ajax({
//                url: "/app/custom.js",
//                dataType: 'script',
//                success: function () {},
//                async: true
//            });
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('NavigateController', NavigateController);

    NavigateController.$inject = ['Auth','$scope', 'Principal', '$state','$localStorage'];

    function NavigateController (Auth, $scope, Principal,$state,  $localStorage) {
        var vm = this;
        
        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                // $rootScope.flag = vm.account.langKey;
                vm.isAuthenticated = Principal.isAuthenticated;
                 if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
                 }

                 //console.log(vm.currentRole);
            });
        }

        vm.switchTo = function(state){
            $state.go(state);
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        })
        .state('navigate', {
            parent: 'entity',
            url: '/navigate',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/navigate.html',
                    controller: 'NavigateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['PosSetting','$scope', 'Principal', 'LoginService', '$state','toastr', 
                                '$rootScope','$timeout','Auth','JhiLanguageService','$localStorage',
                                '$window', 'ProfileService', 'AlertService','$http', '$q','$stateParams'];

    function HomeController (PosSetting,$scope, Principal, LoginService, $state, toastr, 
                            $rootScope, $timeout, Auth, JhiLanguageService, $localStorage, $window, ProfileService, AlertService,$http, $q, $stateParams) {
        var vm = this;
        $timeout(function (){angular.element('#username').focus();});
       
        if (!angular.isUndefined($localStorage.isFirstApp)){
            //delete $localStorage.isFirstApp;
            $window.location.reload();
        }

       

        $rootScope.isHeader = true;
        vm.apiUrl = $localStorage.API_URL;
        var API_URL = $localStorage.API_URL;
        
        vm.account = null;
        vm.isAuthenticated = null;

        vm.authenticationError = false;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        $rootScope.$broadcast('isHideNav');
        getAccount();
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });
       
       
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

     

        function login (event) {
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: true
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    console.log('Stage 0');
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }else{
                   $state.go('navigate');  
                  
                }
            }).catch(function (e) {
               // console.log(e);
                vm.authenticationError = true;
            });
        }
        
    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('TicketDialogController',
			TicketDialogController);

	TicketDialogController.$inject = ['Config','Principal', '$timeout', '$scope', '$stateParams','$state','entity', 'Ticket', 'Upload', '$localStorage'];

	function TicketDialogController(Config, Principal, $timeout, $scope, $stateParams,$state,entity, Ticket, Upload, $localStorage) {
		var vm = this;
		vm.ticket = entity;
		//console.log(vm.ticket);
		vm.apiUrl = $localStorage.API_URL;
		vm.save = save;
		$timeout(function() {
			angular.element('.form-group:eq(0)>input').focus();
		});


		getAccount();
        function getAccount(callback) {
            Principal.identity().then(function (account) {
                vm.account = account;
                // $rootScope.flag = vm.account.langKey;
                vm.isAuthenticated = Principal.isAuthenticated;
                 if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
                 }

                 //console.log(vm.account);
                 if(callback != null){
                 	callback();
                 }
            });
        }

		function save() {
			_save();

			function _save(){
				vm.isSaving = true;
				if (vm.ticket.id !== null) {
					//console.log(vm.ticket);
					Ticket.update(vm.ticket, onSaveSuccess, onSaveError);
				} else {
					vm.ticket.store = vm.account.store;
					Ticket.save(vm.ticket, onSaveSuccess, onSaveError);
				}
			}
			
			function onSaveSuccess(result) {
				$state.go('ticket');
				vm.isSaving = false;
			}

			function onSaveError(result) {
				
				if(result.status == 400){
					alert("Không được phép tạo phòng mới trùng tên với phòng cũ");
				}
				vm.isSaving = false;
			}
		}

		
		

		vm.back = function(){
			$state.go('ticket');
		}

		
	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('TicketDetailController', TicketDetailController);

    TicketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticket','$localStorage'];

    function TicketDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticket, $localStorage) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.ticket = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:ticketUpdate', function(event, result) {
            vm.ticket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('TicketDeleteController',TicketDeleteController);

    TicketDeleteController.$inject = ['$localStorage','$uibModalInstance', 'entity', 'Ticket'];

    function TicketDeleteController($localStorage,  $uibModalInstance, entity, Ticket) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.ticket = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
           Ticket.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket', {
            parent: 'entity',
            url: '/ticket',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.ticket.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/ticket.html',
                    controller: 'TicketController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-detail', {
            parent: 'ticket',
            url: '/ticket/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.ticket.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/ticket-detail.html',
                    controller: 'TicketDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ticket', function($stateParams, Ticket) {
                    return Ticket.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-detail.edit', {
            parent: 'ticket-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Ticket','$stateParams', function(Ticket,$stateParams) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('ticket.new', {
            parent: 'ticket',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                id: null
                            };
                }
            }
            
        })
        .state('ticket.edit', {
            parent: 'ticket',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Ticket','$stateParams', function(Ticket,$stateParams) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                }]
            }
            
        })
        .state('ticket.delete', {
            parent: 'ticket',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-delete-dialog.html',
                    controller: 'TicketDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ticket', function(Ticket) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket', null, { reload: 'ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       ;
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Ticket', Ticket);

    Ticket.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Ticket ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('TicketController', TicketController);

    TicketController.$inject = ['Auth','Principal','$q','Upload','$timeout','$rootScope','$stateParams','$state', 'Ticket', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage','$http'];

    function TicketController(Auth, Principal, $q,Upload, $timeout, $rootScope, $stateParams, $state, Ticket, ParseLinks, AlertService, paginationConstants, pagingParams, $localStorage, $http) {

        var vm = this;
        vm.$state = $state;
        vm.apiUrl = $localStorage.API_URL;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 100;
        vm.cleanTransition = cleanTransition;
        vm.search = {};
       

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            loadAll();
           
        });


        
        function loadAll () {
        	var dataQuery = {
                   active: 1,
                   storeId : vm.currentAccount.store.id
                };
               
                // get Tickets
                Ticket.query(dataQuery, onSuccessGetTicket, onErrorGetTicket);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetTicket(data, headers) {
                    vm.totalItems =data.totalElements;
                    vm.queryCount = data.totalElements;
                    vm.tickets = data.content;
                    vm.page = pagingParams.page;
                }
                function onErrorGetTicket(error) {
                    AlertService.error(error.data.message);
                }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){

        	transition();
        }


        vm.selectTicket = function(ticket){
            vm.currentTicketId = ticket.id;
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('ThuchiDialogController',
			ThuchiDialogController);

	ThuchiDialogController.$inject = ['Config','Principal', '$timeout', '$scope', '$stateParams','$state','entity', 'Thuchi', 'Upload', '$localStorage'];

	function ThuchiDialogController(Config, Principal, $timeout, $scope, $stateParams,$state,entity, Thuchi, Upload, $localStorage) {
		var vm = this;
		vm.thuchi = entity;
		
		
		//console.log(vm.thuchi);
		vm.apiUrl = $localStorage.API_URL;
		vm.save = save;
		$timeout(function() {
			angular.element('.form-group:eq(0)>input').focus();
		});


		getAccount();
        function getAccount(callback) {
            Principal.identity().then(function (account) {
                vm.account = account;
                // $rootScope.flag = vm.account.langKey;
                vm.isAuthenticated = Principal.isAuthenticated;
                 if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
                 }

                 //console.log(vm.account);
                 if(callback != null){
                 	callback();
                 }
                 if(vm.thuchi.id == null){
					vm.thuchi.inputAt = new Date();
					vm.thuchi.person = vm.account.login;
				}
            });
        }

		function save() {
			_save();

			function _save(){
				if(vm.thuchi.thu == null && vm.thuchi.chi == null){
					alert("Phải nhập khoản thu hoặc chi hoặc cả 2");
				}else{
					vm.isSaving = true;
					if (vm.thuchi.id !== null) {
						//console.log(vm.thuchi);
						Thuchi.update(vm.thuchi, onSaveSuccess, onSaveError);
					} else {
						vm.thuchi.store = vm.account.store;
						Thuchi.save(vm.thuchi, onSaveSuccess, onSaveError);
					}	
				}
				
			}
			
			function onSaveSuccess(result) {
				$state.go('thuchi');
				vm.isSaving = false;
			}

			function onSaveError(result) {
				
				if(result.status == 400){
					alert("Lỗi");
				}
				vm.isSaving = false;
			}
		}

		
		

		vm.back = function(){
			$state.go('thuchi');
		}

		
	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ThuchiDetailController', ThuchiDetailController);

    ThuchiDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Thuchi','$localStorage'];

    function ThuchiDetailController($scope, $rootScope, $stateParams, previousState, entity, Thuchi, $localStorage) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.thuchi = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:thuchiUpdate', function(event, result) {
            vm.thuchi = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ThuchiDeleteController',ThuchiDeleteController);

    ThuchiDeleteController.$inject = ['$localStorage','$uibModalInstance', 'entity', 'Thuchi'];

    function ThuchiDeleteController($localStorage,  $uibModalInstance, entity, Thuchi) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.thuchi = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
           Thuchi.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('thuchi', {
            parent: 'entity',
            url: '/thuchi',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.thuchi.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/thuchi/thuchi.html',
                    controller: 'ThuchiController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('thuchi-detail', {
            parent: 'thuchi',
            url: '/thuchi/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.thuchi.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/thuchi/thuchi-detail.html',
                    controller: 'ThuchiDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Thuchi', function($stateParams, Thuchi) {
                    return Thuchi.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'thuchi',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('thuchi-detail.edit', {
            parent: 'thuchi-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/thuchi/thuchi-dialog.html',
                    controller: 'ThuchiDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Thuchi','$stateParams', function(Thuchi,$stateParams) {
                            return Thuchi.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('thuchi.new', {
            parent: 'thuchi',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/thuchi/thuchi-dialog.html',
                    controller: 'ThuchiDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                id: null
                            };
                }
            }
            
        })
        .state('thuchi.edit', {
            parent: 'thuchi',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/thuchi/thuchi-dialog.html',
                    controller: 'ThuchiDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Thuchi','$stateParams', function(Thuchi,$stateParams) {
                            return Thuchi.get({id : $stateParams.id}).$promise;
                }]
            }
            
        })
        .state('thuchi.delete', {
            parent: 'thuchi',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/thuchi/thuchi-delete-dialog.html',
                    controller: 'ThuchiDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Thuchi', function(Thuchi) {
                            return Thuchi.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('thuchi', null, { reload: 'thuchi' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       ;
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Thuchi', Thuchi);

    Thuchi.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Thuchi ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/thuChis/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ThuchiController', ThuchiController);

    ThuchiController.$inject = ['Store','$scope','Auth','Principal','$q','Upload','$timeout','$rootScope','$stateParams','$state', 'Thuchi', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage','$http'];

    function ThuchiController(Store, $scope, Auth, Principal, $q,Upload, $timeout, $rootScope, $stateParams, $state, Thuchi, ParseLinks, AlertService, paginationConstants, pagingParams, $localStorage, $http) {

        var vm = this;
        vm.$state = $state;
        vm.apiUrl = $localStorage.API_URL;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 100;
        vm.cleanTransition = cleanTransition;
        vm.search = {};
       
        vm.dateformat = 'dd-MM-yyyy';
        vm.dateSearch = new Date();
        vm.dateSearch.setHours(0);
        vm.dateSearch.setMinutes(0);
        vm.dateSearch.setSeconds(0);

        vm.dateTo = new Date();
         vm.dateTo.setHours(0);
        vm.dateTo.setMinutes(0);
        vm.dateTo.setSeconds(0);

        $scope.open1 = function() {
            $scope.popup1.opened = true;
          };

        $scope.popup1 = {
            opened: false
          };

           $scope.open2 = function() {
            $scope.popup2.opened = true;
          };

        $scope.popup2 = {
            opened: false
          };

        Principal.identity().then(function(account) {
            vm.account = account;
            if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
            }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
             }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
             }

            vm.filterStore = vm.account.store;
            loadAllStore();
            loadAll();
           
        });


        vm.loadAll = loadAll;
        function loadAll () {
             var searchFrom = new Date(vm.dateSearch);
            var searchTo = new Date(vm.dateTo);
        	var dataQuery = {
                   searchFrom: searchFrom,
                    searchTo: searchTo
                };
                if(vm.filterStore.id != 1){
                    dataQuery.storeId =  vm.filterStore.id;
                 }
               //console.log(dataQuery);
                // get Thuchis
                Thuchi.query(dataQuery, onSuccessGetThuchi, onErrorGetThuchi);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetThuchi(data, headers) {
                    vm.thuchis = data.content;
                    vm.totalThu =0;
                    vm.totalChi = 0;
                    for(var i = 0;i<vm.thuchis.length;i++){
                        if(vm.thuchis[i].thu != null){
                            vm.totalThu += vm.thuchis[i].thu;
                        }
                        if(vm.thuchis[i].chi != null){
                            vm.totalChi += vm.thuchis[i].chi;
                        }
                    }
                }
                function onErrorGetThuchi(error) {
                    AlertService.error(error.data.message);
                }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){

        	transition();
        }


        vm.selectThuchi = function(thuchi){
            vm.currentThuchiId = thuchi.id;
        }

        vm.loadAllStore = loadAllStore;
         function loadAllStore(){
                 var dataQuery = {
                 };
                 // get Bills
                 Store.query(dataQuery, onSuccess, onError);
                 
                 function onSuccess(data, headers) {
                     vm.stores = data.content;
                    //console.log(vm.stores);
                 }
                 function onError(error) {
                     AlertService.error(error);
                 }
         }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('StoreDialogController',
			StoreDialogController);

	StoreDialogController.$inject = [ '$timeout', '$scope', '$stateParams','$state','entity', 'Store', 'Upload', '$localStorage'];

	function StoreDialogController($timeout, $scope, $stateParams,$state,entity, Store, Upload, $localStorage) {
		var vm = this;
		vm.store = entity;
		//console.log(vm.store);
		vm.apiUrl = $localStorage.API_URL;
		vm.save = save;
		$timeout(function() {
			angular.element('.form-group:eq(0)>input').focus();
		});

		function save() {
			vm.isSaving = true;
			if (vm.store.id !== null) {
				Store.update(vm.store, onSaveSuccess, onSaveError);
			} else {
				Store.save(vm.store, onSaveSuccess, onSaveError);
			}
			
		}

		function onSaveSuccess(result) {
			$state.go('store');
			vm.isSaving = false;
		}

		function onSaveError(result) {
			
			if(result.status == 400){
				alert("Không được phép tạo cơ sở mới trùng tên với cơ sở cũ");
			}
			vm.isSaving = false;
		}


		vm.back = function(){
			$state.go('store');
		}

		vm.uploadImage = uploadImage;
        function uploadImage(){
            var file = vm.uploadedImage;
            var resourceUrl =  $localStorage.API_URL+'api/upload_product_image';
            //console.log(resourceUrl);
            if(file != null){
            	console.log(resourceUrl);
                Upload.upload({
                url: resourceUrl,
                data: {file: file}
                }).then(function (data, header, status) {
                	vm.store.storeImage = data.data.hash;
                    //vm.uploadedImage = data.data.hash;
                   // console.log(data.data.hash);
                    alert("OK");
                    
                }, function (resp) {
                    alert("Lỗi upload ảnh");
                });
            }
             
        }
	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('StoreDetailController', StoreDetailController);

    StoreDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Store','$localStorage'];

    function StoreDetailController($scope, $rootScope, $stateParams, previousState, entity, Store, $localStorage) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.store = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:storeUpdate', function(event, result) {
            vm.store = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('StoreDeleteController',StoreDeleteController);

    StoreDeleteController.$inject = ['$localStorage','$q','$http','$uibModalInstance', 'entity', 'Store'];

    function StoreDeleteController($localStorage, $q, $http, $uibModalInstance, entity, Store) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

         function makePutCall(url,data) {
            return $http.put(vm.apiUrl+url,data)
                .then(function (response) {
                  return response;
                }, function (response) {
                    return $q.reject(response.data);
                });
        };
        function confirmDelete (id) {
            makePutCall('api/stores/deactive',id).then(function(data){
                     $uibModalInstance.close(true);
            },function(error){
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('store', {
            parent: 'entity',
            url: '/store',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'xposApp.store.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store/store.html',
                    controller: 'StoreController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('store-detail', {
            parent: 'store',
            url: '/store/{id}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'xposApp.store.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store/store-detail.html',
                    controller: 'StoreDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Store', function($stateParams, Store) {
                    return Store.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'store',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('store-detail.edit', {
            parent: 'store-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store/store-dialog.html',
                    controller: 'StoreDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Store','$stateParams', function(Store,$stateParams) {
                            return Store.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('store.new', {
            parent: 'store',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store/store-dialog.html',
                    controller: 'StoreDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                storeCode: null,
                                storeArticalNumber: null,
                                storeName: null,
                                storeImage: null,
                                storePurchasePrice: null,
                                storeSalePrice: null,
                                storeCurrencyUnit: null,
                                storeType: null,
                                lastUpdate: null,
                                version: null,
                                id: null
                            };
                }
            }
            
        })
        .state('store.edit', {
            parent: 'store',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/store/store-dialog.html',
                    controller: 'StoreDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Store','$stateParams', function(Store,$stateParams) {
                            return Store.get({id : $stateParams.id}).$promise;
                }]
            }
            
        })
        .state('store.delete', {
            parent: 'store',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/store/store-delete-dialog.html',
                    controller: 'StoreDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Store', function(Store) {
                            return Store.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('store', null, { reload: 'store' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       ;
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Store', Store);

    Store.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Store ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/stores/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('StoreController', StoreController);

    StoreController.$inject = ['Auth','Principal','$q','Upload','$timeout','$rootScope','$stateParams','$state', 'Store', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage','$http'];

    function StoreController(Auth, Principal, $q,Upload, $timeout, $rootScope, $stateParams, $state, Store, ParseLinks, AlertService, paginationConstants, pagingParams, $localStorage, $http) {

        var vm = this;
        vm.$state = $state;
        vm.apiUrl = $localStorage.API_URL;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 50;
        vm.cleanTransition = cleanTransition;
        vm.search = {};
       

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
           
        });


        loadAll();
        function loadAll () {
        	var dataQuery = {
                   active: 1
                };
               
                // get Stores
                Store.query(dataQuery, onSuccessGetStore, onErrorGetStore);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetStore(data, headers) {
                    vm.totalItems =data.totalElements;
                    vm.queryCount = data.totalElements;
                    vm.stores = data.content;
                    vm.page = pagingParams.page;
                }
                function onErrorGetStore(error) {
                    AlertService.error(error.data.message);
                }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){

        	transition();
        }


        vm.selectStore = function(store){
            vm.currentStoreId = store.id;
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('StockinDialogController',
			StockinDialogController);

	StockinDialogController.$inject = ['Principal', 'Product','$timeout', '$scope', '$stateParams','$state','entity', 'Stockin', 'Upload', '$localStorage'];

	function StockinDialogController(Principal, Product, $timeout, $scope, $stateParams,$state,entity, Stockin, Upload, $localStorage) {
		var vm = this;
		vm.stockin = {};
		vm.stockin.inputAt = new Date();

		vm.apiUrl = $localStorage.API_URL;
		vm.save = save;

		Principal.identity().then(function(account) {
            vm.currentAccount = account;
			vm.stockin.waiter = vm.currentAccount.login;
			loadAllProduct();
        });

		
		function loadAllProduct() {
        		var dataQuery = {
                };
               dataQuery.storeId = vm.currentAccount.store.id;
                // get Products
                Product.query(dataQuery, onSuccessGetProduct, onErrorGetProduct);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetProduct(data, headers) {
                   
                    vm.products = data.content;
                    for(var i=0;i<vm.products.length;i++){
                    	vm.products[i].quantity = 0;
                    }
                    
                }
                function onErrorGetProduct(error) {
                    AlertService.error(error.data.message);
                }
        }

		function save() {
			vm.isSaving = true;
			if (vm.stockin.id != null) {
				Stockin.update(vm.stockin, onSaveSuccess, onSaveError);
			} else {
				var listStockinProduct = [];
				for(var i=0;i< vm.products.length;i++){
					if(vm.products[i].quantity >0){
						var stockinProductDTO = {};
						stockinProductDTO.productId = vm.products[i].id;
						stockinProductDTO.productName = vm.products[i].productName;
						stockinProductDTO.productCode = vm.products[i].productCode;
						stockinProductDTO.inputQuantity = vm.products[i].quantity;
						listStockinProduct.push(stockinProductDTO);
					}
					
				}
				vm.stockin.listStockinProduct = listStockinProduct;
				Stockin.save(vm.stockin, onSaveSuccess, onSaveError);
			}
			
		}

		function onSaveSuccess(result) {
			$state.go('stockin');
			vm.isSaving = false;
		}

		function onSaveError(result) {
			
			if(result.status == 400){
				alert("The code is invalid!");
			}
			vm.isSaving = false;
		}


		vm.back = function(){
			$state.go('stockin');
		}

		
	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('StockinDetailController', StockinDetailController);

    StockinDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Stockin', 'StockinCategory', 'HappyHousePrice', 'StockinGroup', 'Pos'];

    function StockinDetailController($scope, $rootScope, $stateParams, previousState, entity, Stockin, StockinCategory, HappyHousePrice, StockinGroup, Pos) {
        var vm = this;

        vm.stockin = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:stockinUpdate', function(event, result) {
            vm.stockin = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('StockinDeleteController',StockinDeleteController);

    StockinDeleteController.$inject = ['$uibModalInstance', 'entity', 'Stockin'];

    function StockinDeleteController($uibModalInstance, entity, Stockin) {
        var vm = this;

        vm.stockin = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            console.log(id);
            Stockin.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stockin', {
            parent: 'entity',
            url: '/stockin?page&sort&waiter&shipper',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.stockin.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stockin/stockin.html',
                    controller: 'StockinController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        waiter: $stateParams.waiter,
                        shipper: $stateParams.shipper
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('stockin-detail', {
            parent: 'stockin',
            url: '/stockin/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.stockin.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stockin/stockin-detail.html',
                    controller: 'StockinDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Stockin', function($stateParams, Stockin) {
                    return Stockin.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'stockin',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('stockin-detail.edit', {
            parent: 'stockin-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stockin/stockin-dialog.html',
                    controller: 'StockinDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Stockin','$stateParams', function(Stockin,$stateParams) {
                            return Stockin.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('stockin.new', {
            parent: 'stockin',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stockin/stockin-dialog.html',
                    controller: 'StockinDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                stockinCode: null,
                                stockinArticalNumber: null,
                                stockinName: null,
                                stockinImage: null,
                                stockinPurchasePrice: null,
                                stockinSalePrice: null,
                                stockinCurrencyUnit: null,
                                stockinType: null,
                                lastUpdate: null,
                                version: null,
                                id: null
                            };
                }
            }
            
        })
        .state('stockin.edit', {
            parent: 'stockin',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stockin/stockin-dialog.html',
                    controller: 'StockinDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Stockin','$stateParams', function(Stockin,$stateParams) {
                            return Stockin.get({id : $stateParams.id}).$promise;
                }]
            }
            
        })
        .state('stockin.delete', {
            parent: 'stockin',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stockin/stockin-delete-dialog.html',
                    controller: 'StockinDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Stockin', function(Stockin) {
                            return Stockin.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stockin', null, { reload: 'stockin' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stockin.edit-quantity-popup', {
            parent: 'stockin',
            url: '/{id}/edit-quantity',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stockin/stockin-edit-quantity.html',
                    controller: 'EditQuantityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Stockin', function(Stockin) {
                            return Stockin.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stockin', null, { reload: 'stockin' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Stockin', Stockin);

    Stockin.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Stockin ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/stockins/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('StockinController', StockinController);

    StockinController.$inject = ['Auth','Principal', '$q','Upload','$timeout','$rootScope','$stateParams','$state', 'Stockin', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage','$http'];

    function StockinController(Auth, Principal, $q,Upload, $timeout, $rootScope, $stateParams, $state, Stockin, ParseLinks, AlertService, paginationConstants, pagingParams, $localStorage, $http) {

        var vm = this;
        vm.$state = $state;
        vm.apiUrl = $localStorage.API_URL;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 15;
        vm.cleanTransition = cleanTransition;
        vm.search = {};
        
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        loadAll();
        var makeRestCall   = function (url) {
            return $http.get($localStorage.API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

        

        function loadAll () {
        	var dataQuery = {
                   
                };
               
                // get Stockins
                Stockin.query(dataQuery, onSuccessGetStockin, onErrorGetStockin);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetStockin(data, headers) {
                    vm.totalItems =data.totalElements;
                    vm.queryCount = data.totalElements;
                    vm.stockins = data.content;
                    vm.page = pagingParams.page;
                }
                function onErrorGetStockin(error) {
                    AlertService.error(error.data.message);
                }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                stockinCode: vm.search.stockinCode,
                stockinArticalNumber: vm.search.stockinArticalNumber,
                stockinName: vm.search.stockinName,
                stockinType: vm.search.stockinType == 'ALL' ? '' : vm.search.stockinType,
                stockinCategoryId: vm.search.stockinCategoryId == 'ALL' ? '' : vm.search.stockinCategoryId,
                stockinGroupId: vm.search.stockinGroupId == 'ALL' ? '' : vm.search.stockinGroupId
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){
        	vm.search.stockinCode = '';
        	vm.search.stockinArticalNumber = '';
        	vm.search.stockinName = '';
        	vm.search.stockinType = 'ALL';
        	vm.search.stockinCategoryId = 'ALL';
        	vm.search.stockinGroupId = 'ALL';
        	transition();
        }

       

      

        vm.selectStockin = function(stockin){
            vm.currentStockinId = stockin.id;
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('RoomDialogController',
			RoomDialogController);

	RoomDialogController.$inject = ['Principal', '$timeout', '$scope', '$stateParams','$state','entity', 'Room', 'Upload', '$localStorage'];

	function RoomDialogController(Principal, $timeout, $scope, $stateParams,$state,entity, Room, Upload, $localStorage) {
		var vm = this;
		vm.room = entity;
		if(vm.room != null && vm.room.listPriceByTimeFrameDTO != null){
			vm.listPriceByTimeFrameDTO = vm.room.listPriceByTimeFrameDTO;
		}else{
			vm.listPriceByTimeFrameDTO = [];
		}
		//console.log(vm.room);
		vm.apiUrl = $localStorage.API_URL;
		vm.save = save;
		$timeout(function() {
			angular.element('.form-group:eq(0)>input').focus();
		});

		vm.types = ['VIP','LUXURY'];

		getAccount();
        function getAccount(callback) {
            Principal.identity().then(function (account) {
                vm.account = account;
                // $rootScope.flag = vm.account.langKey;
                vm.isAuthenticated = Principal.isAuthenticated;
                 if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
                 }

                 //console.log(vm.account);
                 if(callback != null){
                 	callback();
                 }
            });
        }

		function save() {
			getAccount(_save);

			function _save(){
				vm.isSaving = true;
				if(checkValidListTimeFrame() == true ){
					if (vm.room.id !== null) {
						//console.log(vm.room);
						vm.room.listPriceByTimeFrameDTO = vm.listPriceByTimeFrameDTO;
						Room.update(vm.room, onSaveSuccess, onSaveError);
					} else {
						vm.room.store = vm.account.store;
						vm.room.listPriceByTimeFrameDTO = vm.listPriceByTimeFrameDTO;
						Room.save(vm.room, onSaveSuccess, onSaveError);
					}
				}else{
					alert("Có vẻ như bạn đã nhập sai giá tiền theo khung giờ. Hãy nhập lại!");
				}
				
			}
			
			function onSaveSuccess(result) {
				$state.go('room');
				vm.isSaving = false;
			}

			function onSaveError(result) {
				
				if(result.status == 400){
					alert("Không được phép tạo phòng mới trùng tên với phòng cũ");
				}
				vm.isSaving = false;
			}
		}

		
		vm.addTimeFrameToListPriceByTimeFrameDTO = function(){
			var timeFrame = {};
			timeFrame.fromHour = 0;
			timeFrame.toHour = 24;
			timeFrame.price = vm.room.price;
			if(vm.listPriceByTimeFrameDTO == null){
				vm.listPriceByTimeFrameDTO = [];
			}
			vm.listPriceByTimeFrameDTO.push(timeFrame);
		}

		vm.deleteTimeFrame = function(index){
			vm.listPriceByTimeFrameDTO.splice(index, 1);
		}

		vm.back = function(){
			$state.go('room');
		}

		function checkValidListTimeFrame(){
			var validCounter = 0;
			for(var i=0;i<vm.listPriceByTimeFrameDTO.length;i++){
				var el = vm.listPriceByTimeFrameDTO[i];
				if(Number(el.fromHour) > -1 && Number(el.toHour) > -1 && Number(el.toHour) <= 24){
					if(Number(el.price) > -1){
						validCounter +=1;
					}
				}
			}
			console.log(Number(el.price));
			console.log(validCounter);
			console.log(vm.listPriceByTimeFrameDTO.length);
			if(validCounter == vm.listPriceByTimeFrameDTO.length){
				return true;
			}
			return false;
		}
		
	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('RoomDetailController', RoomDetailController);

    RoomDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Room','$localStorage'];

    function RoomDetailController($scope, $rootScope, $stateParams, previousState, entity, Room, $localStorage) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.room = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:roomUpdate', function(event, result) {
            vm.room = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('RoomDeleteController',RoomDeleteController);

    RoomDeleteController.$inject = ['$localStorage','$uibModalInstance', 'entity', 'Room'];

    function RoomDeleteController($localStorage,  $uibModalInstance, entity, Room) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
           Room.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('room', {
            parent: 'entity',
            url: '/room',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.room.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room/room.html',
                    controller: 'RoomController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('room-detail', {
            parent: 'room',
            url: '/room/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.room.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room/room-detail.html',
                    controller: 'RoomDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Room', function($stateParams, Room) {
                    return Room.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'room',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('room-detail.edit', {
            parent: 'room-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room/room-dialog.html',
                    controller: 'RoomDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Room','$stateParams', function(Room,$stateParams) {
                            return Room.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('room.new', {
            parent: 'room',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room/room-dialog.html',
                    controller: 'RoomDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                roomCode: null,
                                roomArticalNumber: null,
                                roomName: null,
                                roomImage: null,
                                roomPurchasePrice: null,
                                roomSalePrice: null,
                                roomCurrencyUnit: null,
                                roomType: null,
                                lastUpdate: null,
                                version: null,
                                id: null
                            };
                }
            }
            
        })
        .state('room.edit', {
            parent: 'room',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room/room-dialog.html',
                    controller: 'RoomDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Room','$stateParams', function(Room,$stateParams) {
                            return Room.get({id : $stateParams.id}).$promise;
                }]
            }
            
        })
        .state('room.delete', {
            parent: 'room',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room/room-delete-dialog.html',
                    controller: 'RoomDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Room', function(Room) {
                            return Room.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('room', null, { reload: 'room' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       ;
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Room', Room);

    Room.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Room ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/rooms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('RoomController', RoomController);

    RoomController.$inject = ['Auth','Principal','$q','Upload','$timeout','$rootScope','$stateParams','$state', 'Room', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage','$http'];

    function RoomController(Auth, Principal, $q,Upload, $timeout, $rootScope, $stateParams, $state, Room, ParseLinks, AlertService, paginationConstants, pagingParams, $localStorage, $http) {

        var vm = this;
        vm.$state = $state;
        vm.apiUrl = $localStorage.API_URL;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 100;
        vm.cleanTransition = cleanTransition;
        vm.search = {};
       

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            loadAll();
           
        });


        
        function loadAll () {
        	var dataQuery = {
                   active: 1,
                   storeId : vm.currentAccount.store.id
                };
               
                // get Rooms
                Room.query(dataQuery, onSuccessGetRoom, onErrorGetRoom);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetRoom(data, headers) {
                    vm.totalItems =data.totalElements;
                    vm.queryCount = data.totalElements;
                    vm.rooms = data.content;
                    vm.page = pagingParams.page;
                }
                function onErrorGetRoom(error) {
                    AlertService.error(error.data.message);
                }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){

        	transition();
        }


        vm.selectRoom = function(room){
            vm.currentRoomId = room.id;
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('ProductDialogController',
			ProductDialogController);

	ProductDialogController.$inject = ['Config','Principal', '$timeout', '$scope', '$stateParams','$state','entity', 'Product', 'Upload', '$localStorage'];

	function ProductDialogController(Config, Principal, $timeout, $scope, $stateParams,$state,entity, Product, Upload, $localStorage) {
		var vm = this;
		vm.product = entity;
		//console.log(vm.product);
		vm.apiUrl = $localStorage.API_URL;
		vm.save = save;
		$timeout(function() {
			angular.element('.form-group:eq(0)>input').focus();
		});


		getAccount();
        function getAccount(callback) {
            Principal.identity().then(function (account) {
                vm.account = account;
                // $rootScope.flag = vm.account.langKey;
                vm.isAuthenticated = Principal.isAuthenticated;
                 if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
                 }

                 //console.log(vm.account);
                 if(callback != null){
                 	callback();
                 }
                 getGroup();
            });
        }

		function save() {
			_save();

			function _save(){
				vm.isSaving = true;
				if (vm.product.id !== null) {
					//console.log(vm.product);
					Product.update(vm.product, onSaveSuccess, onSaveError);
				} else {
					vm.product.store = vm.account.store;
					Product.save(vm.product, onSaveSuccess, onSaveError);
				}
			}
			
			function onSaveSuccess(result) {
				$state.go('product');
				vm.isSaving = false;
			}

			function onSaveError(result) {
				
				if(result.status == 400){
					alert("Không được phép tạo phòng mới trùng tên với phòng cũ");
				}
				vm.isSaving = false;
			}
		}

		
		function getGroup(){
				var dataQuery = {
                   storeId : vm.account.store.id,
                   type: 'Nhóm sản phẩm'
                };
               
                // get Products
                Config.query(dataQuery, onSuccess, onError);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccess(data, headers) {
                    vm.groups = data.content;
                    console.log(vm.groups);
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
		}

		vm.back = function(){
			$state.go('product');
		}

		
	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Product','$localStorage'];

    function ProductDetailController($scope, $rootScope, $stateParams, previousState, entity, Product, $localStorage) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.product = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$localStorage','$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($localStorage,  $uibModalInstance, entity, Product) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
           Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product', {
            parent: 'entity',
            url: '/product',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-detail', {
            parent: 'product',
            url: '/product/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.product.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-detail.html',
                    controller: 'ProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product', function($stateParams, Product) {
                    return Product.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'product',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('product-detail.edit', {
            parent: 'product-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Product','$stateParams', function(Product,$stateParams) {
                            return Product.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('product.new', {
            parent: 'product',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                id: null
                            };
                }
            }
            
        })
        .state('product.edit', {
            parent: 'product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Product','$stateParams', function(Product,$stateParams) {
                            return Product.get({id : $stateParams.id}).$promise;
                }]
            }
            
        })
        .state('product.delete', {
            parent: 'product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-delete-dialog.html',
                    controller: 'ProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: 'product' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       ;
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Product', Product);

    Product.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Product ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['Store','Auth','Principal','$q','Upload','$timeout','$rootScope','$stateParams','$state', 'Product', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage','$http'];

    function ProductController(Store, Auth, Principal, $q,Upload, $timeout, $rootScope, $stateParams, $state, Product, ParseLinks, AlertService, paginationConstants, pagingParams, $localStorage, $http) {

        var vm = this;
        vm.$state = $state;
        vm.apiUrl = $localStorage.API_URL;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 100;
        vm.cleanTransition = cleanTransition;
        vm.search = {};
        vm.loadAll = loadAll;

        Principal.identity().then(function(account) {
            vm.account = account;
            if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
            }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
             }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
             }

            vm.filterStore = vm.account.store;
            loadAll();
            loadAllStore();
        });


        
        function loadAll () {
        	var dataQuery = {
                   active: 1
                };
               if(vm.filterStore.id != 1){
                    dataQuery.storeId =  vm.filterStore.id;
                 }
                // get Products
                Product.query(dataQuery, onSuccessGetProduct, onErrorGetProduct);
                
                function onSuccessGetProduct(data, headers) {
                    vm.totalItems =data.totalElements;
                    vm.queryCount = data.totalElements;
                    vm.products = data.content;
                    vm.page = pagingParams.page;
                }
                function onErrorGetProduct(error) {
                    AlertService.error(error.data.message);
                }
        }

        vm.loadAllStore = loadAllStore;
         function loadAllStore(){
                 var dataQuery = {
                 };
                 // get Bills
                 Store.query(dataQuery, onSuccess, onError);
                 
                 function onSuccess(data, headers) {
                     vm.stores = data.content;
                    //console.log(vm.stores);
                 }
                 function onError(error) {
                     AlertService.error(error);
                 }
         }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){

        	transition();
        }


        vm.selectProduct = function(product){
            vm.currentProductId = product.id;
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('PosSettingDialogController', PosSettingDialogController);

    PosSettingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PosSetting'];

    function PosSettingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PosSetting) {
        var vm = this;

        vm.posSetting = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.posSetting.id !== null) {
                PosSetting.update(vm.posSetting, onSaveSuccess, onSaveError);
            } else {
                PosSetting.save(vm.posSetting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('xposApp:posSettingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastUpdate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('PosSettingDetailController', PosSettingDetailController);

    PosSettingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PosSetting'];

    function PosSettingDetailController($scope, $rootScope, $stateParams, previousState, entity, PosSetting) {
        var vm = this;

        vm.posSetting = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:posSettingUpdate', function(event, result) {
            vm.posSetting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('PosSettingDeleteController',PosSettingDeleteController);

    PosSettingDeleteController.$inject = ['$uibModalInstance', 'entity', 'PosSetting'];

    function PosSettingDeleteController($uibModalInstance, entity, PosSetting) {
        var vm = this;

        vm.posSetting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PosSetting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pos-setting', {
            parent: 'entity',
            url: '/pos-setting',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.posSetting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pos-setting/pos-settings.html',
                    controller: 'PosSettingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pos-setting-detail', {
            parent: 'pos-setting',
            url: '/pos-setting/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.posSetting.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pos-setting/pos-setting-detail.html',
                    controller: 'PosSettingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PosSetting', function($stateParams, PosSetting) {
                    return PosSetting.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pos-setting',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pos-setting-detail.edit', {
            parent: 'pos-setting-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pos-setting/pos-setting-dialog.html',
                    controller: 'PosSettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PosSetting', function(PosSetting) {
                            return PosSetting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pos-setting.new', {
            parent: 'pos-setting',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pos-setting/pos-setting-dialog.html',
                    controller: 'PosSettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                pos: null,
                                setting: null,
                                type: null,
                                lastUpdate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pos-setting', null, { reload: 'pos-setting' });
                }, function() {
                    $state.go('pos-setting');
                });
            }]
        })
        .state('pos-setting.edit', {
            parent: 'pos-setting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pos-setting/pos-setting-dialog.html',
                    controller: 'PosSettingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PosSetting', function(PosSetting) {
                            return PosSetting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pos-setting', null, { reload: 'pos-setting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pos-setting.delete', {
            parent: 'pos-setting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pos-setting/pos-setting-delete-dialog.html',
                    controller: 'PosSettingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PosSetting', function(PosSetting) {
                            return PosSetting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pos-setting', null, { reload: 'pos-setting' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('PosSetting', PosSetting);

    PosSetting.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function PosSetting ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/pos-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('PosSettingController', PosSettingController);

    PosSettingController.$inject = ['PosSetting'];

    function PosSettingController(PosSetting) {

        var vm = this;

        vm.posSettings = [];

        loadAll();

        function loadAll() {
            PosSetting.query(function(result) {
                vm.posSettings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('PaymentDialogController2', PaymentDialogController2);

    PaymentDialogController2.$inject = ['Auth','$state','$timeout', '$rootScope', '$stateParams', '$uibModalInstance','AlertService', 
    'entity', 'OrderPos','Bill','PosSetting', '$http', '$q','$localStorage'];

    function PaymentDialogController2 (Auth, $state, $timeout, $rootScope, $stateParams, $uibModalInstance, AlertService, entity,
     OrderPos, Bill,PosSetting, $http, $q, $localStorage) {
    	var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        var API_URL = $localStorage.API_URL;
        vm.currentOrder = entity;
        vm.clear = clear;
        vm.payment = payment;

        vm.cash = 0;
        vm.card = 0;
        vm.voucher = 0;
        vm.check = 0;
        vm.summe = 0;
        vm.totalValue = Number(vm.currentOrder.totalValue);
        vm.charge = vm.totalValue * (-1);
        vm.currentMethod = 'cash';
       
        //print region
        // *****
        var makeRestCall   = function (url) {
            return $http.get(API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
        makeRestCall('api/setting?type=PRINTORDER').then(function(data){
                vm.selectPrintOrder = data.data.setting;
            },function(error){
        });
        makeRestCall('api/setting?type=PRINTA4').then(function(data){
                vm.selectPrintA4 = data.data.setting;
            },function(error){
        });
         makeRestCall('api/setting?type=SINGLE_KITCHEN').then(function(data){
            if(data.data != null){
                vm.singleItemKitchenMode = data.data.setting;
                }
            },function(error){
          });

        var makeRestCall   = function (url) {
            return $http.get(API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
        function printBill(mode, billId){
            if(mode == 'BILL'){
                makeRestCall('api/print/invoce?objectid='+billId+'&mode=bill&printerName='+vm.selectPrintOrder).then(function(data){
                },function(error){

                });
            }
            if(mode == 'EVIDENCE'){
                makeRestCall('api/print/invoce?objectid='+billId+'&mode=evidence&printerName='+vm.selectPrintOrder).then(function(data){
                },function(error){

                });
            }
            if(mode == 'BILLA4'){
                makeRestCall('api/print/a4?objectid='+billId+'&mode=billa4&printerName='+vm.selectPrintA4).then(function(data){
                },function(error){

                });
            }

        }
        // payment region
        // ***
        vm.selectPaymentMethod = function(method){
            vm.currentMethod = method;
        }
        vm.typeNumber = function(number){
            var method = vm.currentMethod;
            if(method == 'cash'){
                if(number == 'Full'){
                    vm.cash = 0;
                    vm.card = 0;
                    vm.voucher = 0;
                    vm.check = 0;
                    vm.cash = vm.totalValue;
                }else
                if(number == 'CE'){
                    vm.cash = 0;
                }else
                if(vm.cash == 0){
                    vm.cash = Number(number);
                }else{
                    vm.cash = String(vm.cash) + String(number);
                }
            }else if(method == 'card'){
                if(number == 'Full'){
                    vm.cash = 0;
                    vm.card = 0;
                    vm.voucher = 0;
                    vm.check = 0;
                    vm.card = vm.totalValue;
                }else
                if(number == 'CE'){
                    vm.card = 0;
                }else
                if(vm.card == 0){
                    vm.card = Number(number);
                }else{
                    vm.card = String(vm.card) + String(number);
                }
            }else if(method == 'voucher'){
                 if(number == 'Full'){
                    vm.cash = 0;
                    vm.card = 0;
                    vm.voucher = 0;
                    vm.check = 0;
                    vm.voucher = vm.totalValue;
                }else
                if(number == 'CE'){
                    vm.voucher = 0;
                }else
                if(vm.voucher == 0){
                    vm.voucher = Number(number);
                }else{
                    vm.voucher = String(vm.voucher) + String(number);
                }
            }else if(method == 'check'){
                if(number == 'Full'){
                    vm.cash = 0;
                    vm.card = 0;
                    vm.voucher = 0;
                    vm.check = 0;
                    vm.check = vm.totalValue;
                }else
                if(number == 'CE'){
                    vm.check = 0;
                }else
                 if(vm.check == 0){
                    vm.check = Number(number);
                }else{
                    vm.check = String(vm.check) + String(number);
                }
            }
             vm.cash =  String(vm.cash).replace(",", ".");
            vm.card =  String(vm.card).replace(",", ".");
            vm.voucher =  String(vm.voucher).replace(",", ".");
            vm.check =  String(vm.check).replace(",", ".");

            vm.summe = Number(vm.cash) + Number(vm.card) + Number(vm.check) + Number(vm.voucher);
            vm.summe = Math.round(vm.summe* 100.0) / 100.0;
            vm.charge =  Number(vm.summe) - Number(vm.totalValue);
            vm.charge = Math.round(vm.charge * 100.0) / 100.0;
        }

        vm.typeMoneyIcon = function(number){
            if(vm.currentMethod == 'cash'){
                if(vm.cash == 0){
                    vm.cash = Number(number);
                }
                else{
                    vm.cash = Number(vm.cash) + Number(number);
                    vm.cash = Math.round(vm.cash * 100.0) / 100.0;
                }
            }else if(vm.currentMethod == 'card'){
                if(vm.card == 0){
                    vm.card = Number(number);
                }else{
                    vm.card = Number(vm.card) + Number(number);
                    vm.card = Math.round(vm.card * 100.0) / 100.0;
                }
            }else if(vm.currentMethod == 'voucher'){
                if(vm.voucher == 0){
                    vm.voucher = Number(number);
                }else{
                    vm.voucher = Number(vm.voucher) + Number(number);
                    vm.voucher = Math.round(vm.voucher * 100.0) / 100.0;
                }
            }else if(vm.currentMethod == 'check'){
                if(vm.check == 0){
                    vm.check = Number(number);
                }else{
                    vm.check = Number(vm.check) + Number(number);
                    vm.check = Math.round(vm.check * 100.0) / 100.0;
                }
            }
           

            vm.summe = Number(vm.cash) + Number(vm.card) + Number(vm.check) + Number(vm.voucher);
            vm.summe = Math.round(vm.summe* 100.0) / 100.0;
            vm.charge =  Number(vm.summe) - Number(vm.totalValue);
            vm.charge = Math.round(vm.charge * 100.0) / 100.0;
        }
        // ***
        // Payment
        function payment(mode){
        	
        	if(Number(vm.charge) >= 0 ){
                vm.currentOrder.requireFinish = '0';
                vm.currentOrder.cash = Number(vm.cash);
                vm.currentOrder.card = Number(vm.card);
                vm.currentOrder.voucher = Number(vm.voucher);
                vm.currentOrder.checkMoney = Number(vm.check);
                vm.currentOrder.chargeMoney = Number(vm.charge);
              
              if(vm.currentOrder.card > 0 || vm.currentOrder.voucher > 0 || vm.currentOrder.checkMoney >0){
                vm.currentOrder.requireFinish = '1';
              }
              if(mode == 'BILL' || mode == 'BILLA4' || mode=='EVIDENCE'){
                    vm.currentOrder.requireFinish = '1';
              }

             if(mode == 'WAIT'){
                vm.currentOrder.endAt = new Date();
                vm.currentOrder.orderStatus = 'WAIT';
             }
                // update currentOrder to db

               // console.log("Request Update Order (Khi thanh toan)")
               // console.log(JSON.stringify(vm.currentOrder, null, "    ") )
               OrderPos.get({ id: vm.currentOrder.id  }, onSuccessLoadCurrentOrder, onErrorLoadCurrentOrder);
                function onSuccessLoadCurrentOrder(data, headers) {
                    var dbOrder = shallowCopy(data);
                    if(dbOrder.totalValue != vm.currentOrder.totalValue){
                        alert("Warnung! Jemand anders hat diese Reihenfolge geändert");
                         Auth.logout();
                        $state.go('home');
                        $uibModalInstance.dismiss('cancel');
                    }else{
                        OrderPos.update(vm.currentOrder, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                        function onSaveCurrentOrderSuccess (data) {
                            //console.log(data);
                            
                            $rootScope.$broadcast('lastChargeMoney', vm.currentOrder.chargeMoney);
                            printKitchen(data.id);
                            if(mode != 'WAIT'){
                               insertNewBill(data,mode);
                             }
                            
                            vm.currentOrder = null;
                            $localStorage["currentOrder.id"] = null;
                            $rootScope.$broadcast('updateCurrentOrder', vm.currentOrder);

                            $uibModalInstance.dismiss('cancel');

                        }

                        function onSaveCurrentOrderError () {
                            alert("Diese Bestellung kann nicht aktualisiert werden!");
                            $uibModalInstance.dismiss('cancel');
                            //$state.go('make-order');
                        }
                    }

                }
                function onErrorLoadCurrentOrder(error) {
                    AlertService.error(error);
                }

                
           
            }

          
        }
        $timeout(function (){
            //angular.element('.in-money>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.orderPos.id !== null) {
                OrderPos.update(vm.orderPos, onSaveSuccess, onSaveError);
            } else {
                OrderPos.save(vm.orderPos, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('xposApp:orderPosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function insertNewBill(order, mode){
        	// insert new bill to db
        	var bill = {};
        	bill.id = null;
        	bill.code = null;
        	bill.tablePos = order.tablePos;
        	bill.waiter = order.waiter;
        	bill.startedAt = order.startedAt;
        	bill.endAt = new Date();
        	bill.orderId = order.id;
        	bill.numberGuest = order.numberGuest;
        	bill.customerDTO = order.customerDTO;
        	bill.listProducts = order.listProducts;
        	bill.totalValue = order.totalValue;
        	bill.discountValue = order.totalDiscount;
        	bill.totalVAT = order.totalVAT;
        	bill.subTotal = order.subTotal;


        	bill.cash = order.cash;
            bill.card = order.card;
            bill.voucher = order.voucher;
            bill.checkMoney = order.checkMoney;
            bill.chargeMoney = order.chargeMoney;
         

        	bill.splitOrder = order.splitOrder;

            if(mode == 'BILL' || mode == 'BILLA4' || mode=='EVIDENCE'){
                bill.requireFinish = true;
                bill.print = '1';
            }else{
                 bill.print = '0';
            }
           // console.log("Request Create New Bill")
            //console.log(JSON.stringify(bill, null, "    ") )
        	Bill.save(bill, onSaveBillSuccess, onSaveBillError);

        	function onSaveBillSuccess(data){
                // 1. finish order
                order.orderStatus = "FINISH";
                order.endAt = new Date();
                OrderPos.update(order, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                function onSaveCurrentOrderSuccess (data) {
                }

                function onSaveCurrentOrderError (error) {
                    alert(error);
                }
                // 2. print bill
        		if(mode == 'BILL' || mode == 'BILLA4' || mode=='EVIDENCE'){

        			printBill(mode, data.id);
        		}

        	}
        	function onSaveBillError(){
        		AlertService.error("Insert Bill Error");
        	}
        }
        // ******
        // Print kitchen when finish
        function printKitchen(orderID){
            if(vm.singleItemKitchenMode == '0'){
                makeRestCall('api/print/invoce?objectid='+orderID+'&mode=kitchen&printerName='+vm.selectPrintKichen).then(function(data){

                },function(error){
                });
            }
            if(vm.singleItemKitchenMode == '1'){
                makeRestCall('api/print/singleKitchen?objectid='+orderID+'&mode=kitchen').then(function(data){


                },function(error){
                });
            }

        }

        function shallowCopy( original )
        {
            // First create an empty object with
            // same prototype of our original source
            var clone = Object.create( Object.getPrototypeOf( original ) ) ;

            var i , keys = Object.getOwnPropertyNames( original ) ;

            for ( i = 0 ; i < keys.length ; i ++ )
            {
                // copy each property into the clone
                Object.defineProperty( clone , keys[ i ] ,
                    Object.getOwnPropertyDescriptor( original , keys[ i ] )
                ) ;
            }

            return clone ;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('PaymentDialogController', PaymentDialogController);

    PaymentDialogController.$inject = ['Auth','$state','$timeout', '$rootScope', '$stateParams', '$uibModalInstance','AlertService', 
    'entity', 'OrderPos','Bill','PosSetting', '$http', '$q','$localStorage'];

    function PaymentDialogController (Auth, $state, $timeout, $rootScope, $stateParams, $uibModalInstance, AlertService, entity,
     OrderPos, Bill,PosSetting, $http, $q, $localStorage) {
    	var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        var API_URL = $localStorage.API_URL;
        vm.currentOrder = entity;
        vm.clear = clear;
        vm.typeNumber = typeNumber;
        vm.payment = payment;
        vm.paymnetMethod = "CASH";

        vm.cash = Math.round((Number(vm.currentOrder.totalValue) * 100) * 100.0) / 100.0;
        vm.charge = 0;
       
        //print region
        // *****
        var makeRestCall   = function (url) {
            return $http.get(API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
        makeRestCall('api/setting?type=PRINTORDER').then(function(data){
                vm.selectPrintOrder = data.data.setting;
            },function(error){
        });
        makeRestCall('api/setting?type=PRINTA4').then(function(data){
                vm.selectPrintA4 = data.data.setting;
            },function(error){
        });
         makeRestCall('api/setting?type=SINGLE_KITCHEN').then(function(data){
            if(data.data != null){
                vm.singleItemKitchenMode = data.data.setting;
                }
            },function(error){
          });

        var makeRestCall   = function (url) {
            return $http.get(API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
        function printBill(mode, billId){
            if(mode == 'BILL'){
                makeRestCall('api/print/invoce?objectid='+billId+'&mode=bill&printerName='+vm.selectPrintOrder).then(function(data){
                },function(error){

                });
            }
            if(mode == 'EVIDENCE'){
                makeRestCall('api/print/invoce?objectid='+billId+'&mode=evidence&printerName='+vm.selectPrintOrder).then(function(data){
                },function(error){

                });
            }
            if(mode == 'BILLA4'){
                makeRestCall('api/print/a4?objectid='+billId+'&mode=billa4&printerName='+vm.selectPrintA4).then(function(data){
                },function(error){

                });
            }

        }
        // payment region
        // ***
        vm.selectPaymentMethod = function(method){
            vm.paymnetMethod = method;
        }
        var firstClick = false;
        function typeNumber(mode,number){
        	if(mode =='Number' && number != null){
        		if(firstClick == false || vm.cash ==0){
            		firstClick = true;
            		vm.cash = '';
            	}

            	vm.cash = String(vm.cash) + String(number);
            	if(number != '.'){
            		//vm.charge = Math.round((parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue)) * 100) / 100;
                    var c = parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue * 100);
                    vm.charge = Math.round(c * 100.0) / 100.0;
            	}
            	if(number == '.'){
            		vm.charge = 'N/A';
            	}
        	}else if(mode == 'Total'){
                var a = Math.round((number*100) * 100.0) / 100.0;
                vm.cash = String(a);
                var b = parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue * 100);
                vm.charge = Math.round(b * 100.0) / 100.0;
            }
            else
        	if(mode =='Delete'){

        		//vm.charge = Math.round((0 - parseFloat(vm.currentOrder.totalValue)) * 100) / 100;
                 vm.charge = 0 - parseFloat(vm.currentOrder.totalValue * 100);
        		vm.cash = '0';
        	}else
        	if(mode =='Slice'){
        		firstClick = true;
        		vm.cash = String(vm.cash).slice(0,-1);
        		//vm.charge = Math.round((parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue)) * 100) / 100;
                 vm.charge = parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue * 100);
        	}

        }

        vm.typeMoneyIcon = function(cent){
            vm.cash += cent;
            vm.charge = parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue * 100);
        }
        // ***
        // Payment
        function payment(mode){
        	
        	if(Number(vm.cash) > 0){
                //console.log("vm.cash: "+vm.cash);
                vm.currentOrder.requireFinish = '0';

                vm.currentOrder.cash = Number(vm.cash)/100;
                vm.currentOrder.paymentMethod = vm.paymnetMethod;

              if(vm.paymnetMethod == 'CASH'){
                vm.currentOrder.chargeMoney = Number(vm.charge)/100;
                vm.currentOrder.tipMoney = 0;
              }
              if(vm.paymnetMethod == 'CARD'){
                vm.currentOrder.chargeMoney = 0;
                vm.currentOrder.tipMoney = Number(vm.charge)/100;
                vm.currentOrder.requireFinish = '1';
              }


              
              if(mode == 'BILL' || mode == 'BILLA4' || mode=='EVIDENCE'){
                    vm.currentOrder.requireFinish = '1';
              }

             if(mode == 'WAIT'){
                vm.currentOrder.endAt = new Date();
                vm.currentOrder.orderStatus = 'WAIT';
             }
                // update currentOrder to db

               // console.log("Request Update Order (Khi thanh toan)")
               // console.log(JSON.stringify(vm.currentOrder, null, "    ") )
               OrderPos.get({ id: vm.currentOrder.id  }, onSuccessLoadCurrentOrder, onErrorLoadCurrentOrder);
                function onSuccessLoadCurrentOrder(data, headers) {
                    var dbOrder = shallowCopy(data);
                    if(dbOrder.totalValue != vm.currentOrder.totalValue){
                        alert("Warnung! Jemand anders hat diese Reihenfolge geändert");
                         Auth.logout();
                        $state.go('home');
                        $uibModalInstance.dismiss('cancel');
                    }else{
                        OrderPos.update(vm.currentOrder, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                        function onSaveCurrentOrderSuccess (data) {
                            //console.log(data);
                           
                            printKitchen(data.id);
                            if(mode != 'WAIT'){
                                insertNewBill(data,mode);
                             }
                            
                            vm.currentOrder = null;
                            $localStorage["currentOrder.id"] = null;
                            $rootScope.$broadcast('updateCurrentOrder', vm.currentOrder);
                            $uibModalInstance.dismiss('cancel');

                        }

                        function onSaveCurrentOrderError () {
                            alert("Diese Bestellung kann nicht aktualisiert werden!");
                            $uibModalInstance.dismiss('cancel');
                            //$state.go('make-order');
                        }
                    }

                }
                function onErrorLoadCurrentOrder(error) {
                    AlertService.error(error);
                }

                
           
            }

          
        }
        $timeout(function (){
            //angular.element('.in-money>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.orderPos.id !== null) {
                OrderPos.update(vm.orderPos, onSaveSuccess, onSaveError);
            } else {
                OrderPos.save(vm.orderPos, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('xposApp:orderPosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function insertNewBill(order, mode){
        	// insert new bill to db
        	var bill = {};
        	bill.id = null;
        	bill.code = null;
        	bill.tablePos = order.tablePos;
        	bill.waiter = order.waiter;
        	bill.startedAt = order.startedAt;
        	bill.endAt = new Date();
        	bill.orderId = order.id;
        	bill.numberGuest = order.numberGuest;
        	bill.customerDTO = order.customerDTO;
        	bill.listProducts = order.listProducts;
        	bill.totalValue = order.totalValue;
        	bill.discountValue = order.totalDiscount;
        	bill.totalVAT = order.totalVAT;
        	bill.subTotal = order.subTotal;
        	bill.cash = Number(vm.cash) / 100;
        	bill.paymentMethod = vm.paymnetMethod;

          if(vm.paymnetMethod == 'CASH'){

            bill.chargeMoney = Number(vm.charge)/100;
            bill.tipMoney = 0;
          }
          if(vm.paymnetMethod == 'CARD'){
            bill.chargeMoney = 0;
            bill.tipMoney = Number(vm.charge)/100;
          }

        	bill.splitOrder = order.splitOrder;

            if(mode == 'BILL' || mode == 'BILLA4' || mode=='EVIDENCE'){
                bill.requireFinish = true;
            }
           // console.log("Request Create New Bill")
            //console.log(JSON.stringify(bill, null, "    ") )
        	Bill.save(bill, onSaveBillSuccess, onSaveBillError);

        	function onSaveBillSuccess(data){
                // 1. finish order
                order.orderStatus = "FINISH";
                order.endAt = new Date();
                OrderPos.update(order, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                function onSaveCurrentOrderSuccess (data) {
                }

                function onSaveCurrentOrderError (error) {
                    alert(error);
                }
                // 2. print bill
        		if(mode == 'BILL' || mode == 'BILLA4' || mode=='EVIDENCE'){

        			printBill(mode, data.id);
        		}

        	}
        	function onSaveBillError(){
        		AlertService.error("Insert Bill Error");
        	}
        }
        // ******
        // Print kitchen when finish
        function printKitchen(orderID){
            if(vm.singleItemKitchenMode == '0'){
                makeRestCall('api/print/invoce?objectid='+orderID+'&mode=kitchen&printerName='+vm.selectPrintKichen).then(function(data){

                },function(error){
                });
            }
            if(vm.singleItemKitchenMode == '1'){
                makeRestCall('api/print/singleKitchen?objectid='+orderID+'&mode=kitchen').then(function(data){


                },function(error){
                });
            }

        }

        function shallowCopy( original )
        {
            // First create an empty object with
            // same prototype of our original source
            var clone = Object.create( Object.getPrototypeOf( original ) ) ;

            var i , keys = Object.getOwnPropertyNames( original ) ;

            for ( i = 0 ; i < keys.length ; i ++ )
            {
                // copy each property into the clone
                Object.defineProperty( clone , keys[ i ] ,
                    Object.getOwnPropertyDescriptor( original , keys[ i ] )
                ) ;
            }

            return clone ;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosSelectMealController', OrderPosSelectMealController);

    OrderPosSelectMealController.$inject = ['$state','$stateParams', 'OrderPos', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OrderPosSelectMealController($state, $stateParams, OrderPos, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;
       
        vm.test = $stateParams.table;

        
        
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosDialogController', OrderPosDialogController);

    OrderPosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','Principal', 'entity', 'OrderPos','User'];

    function OrderPosDialogController ($timeout, $scope, $stateParams, $uibModalInstance,Principal, entity, OrderPos, User) {
        var vm = this;

        vm.account = null;
        vm.waiters = null;
        vm.orderPos = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        getLoginAccount();
       

        function getLoginAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.orderPos.waiter === null || vm.orderPos.waiter === ''){
                	vm.orderPos.waiter = account.login;
                }
                getAllWaiter();
            });
        }
        
        function getAllWaiter () {
            User.query({
            	// add condition: authorities = ROLE_USER here???
            	//
            }, onSuccessGetAllWaiter, onErrorGetAllWaiter);
        }

        function onSuccessGetAllWaiter(data, headers) {
            vm.waiters = data.filter(function (el) {
            	  return el.authorities.length === 1 &&
            	  el.authorities[0] === 'ROLE_USER';
         });
            
        }

        function onErrorGetAllWaiter(error) {
            AlertService.error(error.data.message);
        }
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.orderPos.id !== null) {
                OrderPos.update(vm.orderPos, onSaveSuccess, onSaveError);
            } else {
                OrderPos.save(vm.orderPos, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('xposApp:orderPosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startedAt = false;
        vm.datePickerOpenStatus.endAt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosDetailController', OrderPosDetailController);

    OrderPosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OrderPos'];

    function OrderPosDetailController($scope, $rootScope, $stateParams, previousState, entity, OrderPos) {
        var vm = this;

        vm.orderPos = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:orderPosUpdate', function(event, result) {
            vm.orderPos = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosDeleteController',OrderPosDeleteController);

    OrderPosDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrderPos'];

    function OrderPosDeleteController($uibModalInstance, entity, OrderPos) {
        var vm = this;

        vm.orderPos = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OrderPos.delete({id: id},
                function () {
                    
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosCreateNewController', OrderPosCreateNewController);

    OrderPosCreateNewController.$inject = ['$state', 'TablePos', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OrderPosCreateNewController($state, TablePos, ParseLinks, AlertService, paginationConstants, pagingParams) {

    	var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.cleanTransition = cleanTransition;
        vm.itemsPerPage = 10;
        vm.search = {};
        vm.clickMakeOrder = clickMakeOrder;
        loadAll();

        function loadAll () {
            var dataQuery = {
            	pageNo: pagingParams.page,
                pageSize: vm.itemsPerPage,
                sortBy: sort()
            };
            dataQuery.requestStatusForOrder = true;
            
            if (!angular.isUndefined(pagingParams.tableNo)){
                dataQuery.tableNo = pagingParams.tableNo;
                vm.search.tableNo = pagingParams.tableNo;
            }
            if (!angular.isUndefined(pagingParams.tableZone)){
                dataQuery.tableZone = pagingParams.tableZone;
                vm.search.tableZone = pagingParams.tableZone;
            }
           
            TablePos.query(dataQuery, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }
            function onSuccess(data, headers) {
                vm.totalItems =data.totalElements;
                vm.queryCount = data.totalElements;
                vm.tablePos = data.content;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                tableNo: vm.search.tableNo,
                tableZone: vm.search.tableZone
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){
        	vm.search.tableNo = '';
        	transition();
        }
        
        function clickMakeOrder(tableID){
        	$state.go('select-meal', {
        		table: tableID //get tableID from row
        	});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-pos', {
            parent: 'entity',
            url: '/order-pos?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.orderPos.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pos/order-pos.html',
                    controller: 'OrderPosController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('order-pos-detail', {
            parent: 'order-pos',
            url: '/order-pos/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.orderPos.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pos/order-pos-detail.html',
                    controller: 'OrderPosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OrderPos', function($stateParams, OrderPos) {
                    return OrderPos.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'order-pos',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

        .state('order-pos-detail.edit', {
            parent: 'order-pos-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/order-pos-dialog.html',
                    controller: 'OrderPosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order-pos.new', {
            parent: 'order-pos',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/order-pos-dialog.html',
                    controller: 'OrderPosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tablePos: null,
                                waiter: null,
                                startedAt: null,
                                endAt: null,
                                orderStatus: null,
                                products: null,
                                totalValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('order-pos', null, { reload: 'order-pos' });
                }, function() {
                    $state.go('order-pos');
                });
            }]
        })

        //*************
        .state('new-order', {
            parent: 'order-pos',
            url: '/table-map?page&sort&search&tableNo&tableZone',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.orderPos.createNew.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pos/order-pos-create-new.html',
                    controller: 'OrderPosCreateNewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        tableNo: $stateParams.tableNo,
                        tableZone: $stateParams.tableZone
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

      .state('select-meal', {
            parent: 'order-pos',
            url: '/select-meal?table',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.orderPos.createNew.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pos/order-pos-select-meal.html',
                    controller: 'OrderPosSelectMealController',
                    controllerAs: 'vm'
                }
            },
            resolve: {

                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('make-order.split-bill', {
            parent: 'make-order',
            url: '/split/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Split Order'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pos/make-order-split.html',
                    controller: 'OrderPosSplitController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OrderPos', function($stateParams, OrderPos) {
                    return OrderPos.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'make-order',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('make-order.payment', {
            parent: 'make-order',
            url: '/{id}/payment',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/payment-dialog.html',
                    controller: 'PaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('make-order', {
            parent: 'order-pos',
            url: '/make-order?customerId',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.orderPos.createNew.actionMakeOrder'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-pos/make-order.html',
                    controller: 'OrderPosMakeOrderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('order-pos.create-new-order', {
            parent: 'make-order',
            url: '/new?tableNo',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-new-order.html',
                    controller: 'OrderPosMakeNewOrderController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order-pos.delete-order', {
            parent: 'make-order',
            url: '/delete?order',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-delete-order.html',
                    controller: 'OrderPosDeleteOrderController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       .state('order-pos.change-table', {
            parent: 'make-order',
            url: '/{id}/changetable',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-change-table.html',
                    controller: 'OrderPosChangeTableController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order-pos.merge-table', {
            parent: 'make-order',
            url: '/{id}/mergetable',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-merge-table.html',
                    controller: 'OrderPosMergeTableController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('order-pos.quick-comment', {
            parent: 'make-order',
            url: '/{id}/{productName}/comment',
            data: {
                authorities: ['ROLE_USER']
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-quick-comment.html',
                    controller: 'OrderPosQuickCommentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order-pos.select-customer', {
            parent: 'make-order',
            url: '/{id}/selectcustomer',
            data: {
                authorities: ['ROLE_USER']
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-select-customer.html',
                    controller: 'OrderPosSelectCustomerController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         .state('order-pos.add-customer', {
            parent: 'make-order',
            url: '/{id}/addcustomer',
            data: {
                authorities: ['ROLE_USER']
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-add-customer.html',
                    controller: 'OrderPosAddCustomerController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order-pos.split-bil', {
            parent: 'make-order',
            url: '/{id}/split-bil',
            data: {
                authorities: ['ROLE_USER']
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/make-order-split-bil.html',
                    controller: 'OrderPosSplitBilController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('make-order', null, { reload: 'make-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        //**************
        .state('order-pos.edit', {
            parent: 'order-pos',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/order-pos-dialog.html',
                    controller: 'OrderPosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('order-pos', null, { reload: 'order-pos' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order-pos.delete', {
            parent: 'order-pos',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-pos/order-pos-delete-dialog.html',
                    controller: 'OrderPosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OrderPos', function(OrderPos) {
                            return OrderPos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('order-pos', null, { reload: 'order-pos' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('OrderPos', OrderPos);

    OrderPos.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function OrderPos ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/order-pos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertDateTimeFromServer(data.startedAt);
                        data.endAt = DateUtils.convertDateTimeFromServer(data.endAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosController', OrderPosController);

    OrderPosController.$inject = ['$uibModal','TableZone','$scope', '$localStorage','$q','$http','Principal','$state', 'OrderPos', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OrderPosController($uibModal, TableZone, $scope, $localStorage, $q, $http, Principal, $state, OrderPos, ParseLinks, AlertService, paginationConstants, pagingParams) {

         var vm = this;
         vm.apiUrl = $localStorage.API_URL;
         vm.loadPage = loadPage;
         vm.predicate = pagingParams.predicate;
         vm.reverse = pagingParams.ascending;
         vm.transition = transition;
         vm.itemsPerPage = 5;
         vm.cleanTransition = cleanTransition;
         


         Principal.identity().then(function(account) {
            vm.currentAccount = account;
            vm.currentRole = 'ROLE_USER';
            for (var j = 0; j < vm.currentAccount.authorities.length; j++) {
                if(vm.currentAccount.authorities[j] == 'ROLE_ADMIN'){
                    vm.currentRole = 'ROLE_ADMIN';
                    break;
                }
                if(vm.currentAccount.authorities[j] == 'ROLE_SUPER_USER'){
                    vm.currentRole = 'ROLE_SUPER_USER';
                    break;
                }
            }

             if(vm.currentRole == 'ROLE_USER'){
               vm.filterWaiter = vm.currentAccount.login;
             }
             loadAllOrder();
             loadReport();
        });

         var makeRestCall   = function (url) {

            return $http.get(vm.apiUrl +url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

        

         makeRestCall('api/setting?type=PRINTORDER').then(function(data){
                vm.selectPrintOrder = data.data.setting;
            },function(error){
        });

         vm.dateformat = 'dd-MM-yyyy';
        vm.dateSearch = new Date();
        vm.dateSearch.setHours(0);
        vm.dateSearch.setMinutes(0);
        vm.dateSearch.setSeconds(0);

        vm.dateTo = new Date();
        vm.dateTo.setHours(0);
        vm.dateTo.setMinutes(0);
        vm.dateTo.setSeconds(0);

        $scope.open1 = function() {
            $scope.popup1.opened = true;
          };

        $scope.popup1 = {
            opened: false
          };

           $scope.open2 = function() {
            $scope.popup2.opened = true;
          };

        $scope.popup2 = {
            opened: false
          };

        vm.loadAllOrder = loadAllOrder;
        function loadAllOrder () {

            vm.total = 0;
            vm.totalWait = 0;

            var searchFrom = new Date(vm.dateSearch);
            var searchTo = null;
            

            var dataQuery = {
                searchFrom: searchFrom,
                searchTo: searchTo,
                now: true,
                sort: sort()
            };
            //console.log(dataQuery);
            OrderPos.query(dataQuery, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                result.push('startedAt,asc');
                return result;
            }
            function onSuccess(data, headers) {
                vm.totalItems =data.totalElements;
                    vm.queryCount = data.totalElements;
                    vm.orderPos = data.content;
                    //console.log(vm.bills);
                    vm.page = pagingParams.page;

                    for(var i=0;i<vm.orderPos.length;i++){
                        vm.total += vm.orderPos[i].totalValue;
                        if(vm.orderPos[i].orderStatus == 'WAIT'){
                            vm.totalWait += vm.orderPos[i].totalValue;
                        }
                    }

            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
       
       

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

         function cleanTransition(){
            transition();
         }


         vm.print = function(mode,order){
            
          if(order.bid == null ){
               printBillMaster(order.id, mode);
           
          }else if(order.bid != null ){
               printBill(order.bid, mode);
           
          }
          
        }

        function printBillMaster(oId, mode){
              makeRestCall('/api/print/invocemaster?oId='+oId+'&mode='+mode+'&printerName='+vm.selectPrintOrder).then(function(data){
                 loadAllOrder();
            },function(error){
                alert("Xảy ra lỗi");
            });
        }

        vm.printBill = printBill;
        function printBill(billId,mode){
              makeRestCall('/api/print/invoce?objectid='+billId+'&mode='+mode+'&printerName='+vm.selectPrintOrder).then(function(data){
            },function(error){

            });
        }

        vm.delete = function(orderPos){
          if(orderPos.id != null){
            makeRestCall('/api/order-pos/stornos?orderId='+orderPos.id).then(function(data){
              loadAllOrder();
            },function(error){

            }); 
          }
                
        }

        function loadReport(){
          if(vm.currentRole == 'ROLE_SUPER_USER'){
             var dataQueryLoadAllTableZone = {
                            pageNo: null,
                            pageSize: null,
                            sortBy: sortLoadAllTableZone()
                        };

                        TableZone.query(dataQueryLoadAllTableZone, onSuccessLoadAllTableZone, onErrorLoadAllTableZone);
                        function sortLoadAllTableZone() {
                          var result = [];
                            result.push('tableZoneName:asc');
                            return result;
                        }
                        function onSuccessLoadAllTableZone(data, headers) {
                           vm.report = {};
                            var zones = data.content;
                            //console.log(data);
                            if(zones != null && zones.length >0){
                               var code = zones[0].tableZoneCode;
                               var token = code.split("@");

                               if(token.length == 5){
                                  vm.report.totalTurnOver = token[0];
                                  vm.report.cash = token[1];
                                  vm.report.card = token[2];
                                  vm.report.tipMoney = token[3];
                               }
                            }
                            
                        }
                        function onErrorLoadAllTableZone(error) {
                            AlertService.error(error.data.message);
                        }  
          }
                               
        }

        

        vm.printwaiter = printwaiter;
         function printwaiter(){
            var waiter = vm.filterWaiter;
            if(waiter == 'ALL'){
                waiter = 'Alles';
            }
            // print report
             makeRestCall('/api/print/reportForWaiter'
             ).then(function(data){
                        },function(error){

            });
            
         }

          // *** Modal Verify
        // ***
        vm.openModalVerify = function () {
                $uibModal.open({
                  templateUrl: 'app/entities/bill-master/modal-verify.html',
                  controller: function ($scope, $uibModalInstance) {
                    $scope.verified = false;
                    
                   $scope.t0003Config = {layout: 'custom',
                      customLayout: {
                        'default': [
                          '{accept} {b}',
                          '6 7 8 9',
                          '2 3 4 5',
                          '000 00 0 1'   
                        ]
                      },
                      display: {
                        'accept': 'OK'
                      },
                      kt: 'US International', showKbSelect: true,
                     numberPad: true, showVersion: true, usePreview: false, autoAccept : true, reposition : true,
                      position : {
                          // null (attach to input/textarea) or a jQuery object (attach elsewhere)
                          of : '#keyboard-wrapper',
                          my : 'center top',
                          at : 'center bottom',
                          // at2 is used when "usePreview" is false (centers keyboard at the bottom
                          // of the input/textarea)
                          at2: 'center bottom',
                          collision: 'flipfit flipfit'
                        },
                        beforeVisible: function(e, keyboard, el) {
                          var inModal = $(el).parents('.modal').length > 0;
                          if (inModal) {
                            keyboard.$keyboard.appendTo($(el).parents('.modal-body'));
                          }
                        }
                    }
          
                    $scope.cancel = function () {
                      $uibModalInstance.dismiss('cancel');
                    };
                    
                    $scope.tryPassword = function(){
                        //console.log($scope.passVerify);
                         makeRestCall('api/setting?type=PASS_2').then(function(data){
                          if(data != null){
                                vm.pass = data.data.setting;
                                if($scope.passVerify == vm.pass){
                                    vm.deleteReport(vm.reset);
                                    $scope.cancel();
                                }else {
                                    $scope.cancel();
                                }
                          }
                               
                            },function(error){
                        });
                         /*
                        
                        */
                    }
                }
            })

        };
        // ** end modal verify

        vm.deleteReport = deleteReport;
        function deleteReport(callback){
           makeRestCall('/api/table-zone/delete-all'
             ).then(function(data){
               loadReport();
               if(callback != null){
                 callback();
               }
            },function(error){

            });
        }
        
        vm.reset = reset;
        function reset(){
           makeRestCall('/api/delete-all-orders'
             ).then(function(data){
               loadAllOrder();
            },function(error){

            });
        }
    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('OrderPosSplitController',
			OrderPosSplitController);

	OrderPosSplitController.$inject = [ '$state', '$rootScope','entity','$stateParams', 'previousState', 'AlertService', 'OrderPos', 'Principal' ,'Customer','Bill','PosSetting', '$http', '$q','$localStorage'];

	function OrderPosSplitController($state, $rootScope,entity, $stateParams,previousState, AlertService, OrderPos, Principal, Customer, Bill, PosSetting, $http, $q, $localStorage) {

		var vm = this;
		vm.previousState = previousState.name;
		vm.currentOrderId = $stateParams.order;
		var API_URL = $localStorage.API_URL;
		vm.currentOrder = entity;
		vm.switchItem = switchItem;
		vm.removeSplitting = removeSplitting;
		vm.back = back;
		vm.changeNumberOfCustomer = changeNumberOfCustomer;
		vm.selectCustomer = selectCustomer;
		vm.rightView = null;
		vm.paymentView = null;
		vm.customerView = null;
		vm.isPaymentSplitting = true;
		vm.searchCustomer = searchCustomer;
		vm.openPaymentSplitting = openPaymentSplitting;
		vm.loadAllCustomer = loadAllCustomer;
		vm.cancelSplitMeal = cancelSplitMeal;

		vm.cancelSplitting = cancelSplitting;
		vm.typeNumber = typeNumber;
          vm.paymentSplitting = paymentSplitting;
          vm.openPaymentCurrentOrder = openPaymentCurrentOrder;

      vm.closeSelectCustomer = closeSelectCustomer;
      var firstClick = false;
	   vm.paymnetMethod = "CASH";

		initSplittingOrder();

		//print region
        // *****
				var makeRestCall   = function (url) {
						return $http.get(API_URL+url)
								.then(function (response) {
									return response;
								}, function (response) {
										// something went wrong
										return $q.reject(response.data);
								});
				};

				makeRestCall('api/setting?type=PRINTORDER').then(function(data){
                vm.selectPrintOrder = data.data.setting;
            },function(error){
        });

				makeRestCall('api/setting?type=PRINTA4').then(function(data){
                vm.selectPrintA4 = data.data.setting;
            },function(error){
        });



        var makeRestCall   = function (url) {
            return $http.get(API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

				function printBill(mode, billId){
            if(mode == 'BILL'){
                makeRestCall('api/print/invoce?objectid='+billId+'&mode=bill&printerName='+vm.selectPrintOrder).then(function(data){
                },function(error){

                });
            }
            if(mode == 'EVIDENCE'){
                makeRestCall('api/print/invoce?objectid='+billId+'&mode=evidence&printerName='+vm.selectPrintOrder).then(function(data){
                },function(error){

                });
            }
            if(mode == 'BILLA4'){
                makeRestCall('api/print/a4?objectid='+billId+'&mode=billa4&printerName='+vm.selectPrintA4).then(function(data){
                },function(error){

                });
            }

        }
        // end Print function


		function initSplittingOrder(){
			vm.splittingOrder = {};
			vm.splittingOrder.id= null;
			vm.splittingOrder.customerDTO = {};
			vm.splittingOrder.customerDTO = shallowCopy(vm.currentOrder.customerDTO);
			vm.splittingOrder.numberGuest = vm.currentOrder.numberGuest;
			vm.splittingOrder.tablePos = vm.currentOrder.tablePos;
			vm.splittingOrder.startedAt =  vm.currentOrder.startedAt;
			vm.splittingOrder.waiter = vm.currentOrder.waiter;
			vm.splittingOrder.listProducts = [];
			vm.splittingOrder.orderStatus = "INPROGRESS";
			vm.splittingOrder.splitOrder = "YES";

            vm.currentOrder.orderStatus = "INPROGRESS";
		}


		function searchCustomer(){
			vm.rightView = true;
			vm.customerView = true;
			loadAllCustomer();

		}
		function closeSelectCustomer (){
			vm.rightView = null;
			vm.customerView = null;
		}

		function openPaymentSplitting(){
			firstClick = false;
			vm.rightView = true;
			vm.paymentView = true;
			vm.isPaymentSplitting = true;
		    vm.cash = vm.splittingOrder.totalValue;
		    vm.charge = parseFloat(vm.cash) - parseFloat(vm.splittingOrder.totalValue);
		}
		function cancelSplitting(){
			vm.rightView = null;
			vm.paymentView= null;
			vm.isPaymentSplitting = true;
		}

		function openPaymentCurrentOrder(){
			firstClick = false;
			vm.rightView = true;
			vm.paymentView = true;
			vm.isPaymentSplitting = false;
		    vm.cash = vm.currentOrder.totalValue;
		    vm.charge = parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue);
		}


		function switchItem(orderedProduct){
			// 1.
			// update current Order
            
			var indexCurrent = null;
        	for (var i = 0; i < vm.currentOrder.listProducts.length; i++) {
    		    if(vm.currentOrder.listProducts[i].product.productName == orderedProduct.product.productName){
    		    	indexCurrent = i;
    		    	break;
    		    }
    		}
        	if(indexCurrent != null && indexCurrent != -1){
        		vm.currentOrder = changeQuantityOrderedProduct(shallowCopy(vm.currentOrder), 'Slice', indexCurrent,1);
        		if(vm.currentOrder.listProducts[indexCurrent].quantity <= 0){
        			vm.currentOrder.listProducts.splice(indexCurrent, 1);
        		}
        	}
        	// 2.
        	// update splitting order
        	var flag_check_exist = false;
    		for (var i = 0; i < vm.splittingOrder.listProducts.length; i++) {
    		    if(vm.splittingOrder.listProducts[i].product.productName == orderedProduct.product.productName){
    		    	vm.splittingOrder = changeQuantityOrderedProduct(shallowCopy(vm.splittingOrder),'Add', i,1);
    		    	flag_check_exist = true;
    		    	break;
    		    }
    		}

    		if(flag_check_exist == false){
    			var updatingProduct = {};
    			var product = shallowCopy(orderedProduct.product);
    			    updatingProduct.id = product.id;
                    updatingProduct.productName = product.productName;
                    updatingProduct.productCode = product.productCode;
                    updatingProduct.productPurchasePrice = product.productPurchasePrice;
                    updatingProduct.productSalePrice = product.productSalePrice;
                    updatingProduct.productCurrencyUnit = product.productCurrencyUnit;
                    updatingProduct.productType = product.productType;
                    updatingProduct.tax = shallowCopy(product.tax);
                    updatingProduct.productCategory = shallowCopy(product.productCategory);
                    var taxRate = orderedProduct.taxRate;
                    if(taxRate == null){
                        taxRate = 0.19;
                    }

    			vm.splittingOrder.listProducts.push({quantity:1, taxRate: taxRate,  product: updatingProduct});
		    	vm.splittingOrder = computeOrderedTotals(shallowCopy(vm.splittingOrder));
		    }
            //console.log(vm.splittingOrder);

		}

		function removeSplitting(orderedProduct){
			// 1.
			// update current Order
			var flag_check_exist = false;
    		for (var i = 0; i < vm.currentOrder.listProducts.length; i++) {
    		    if(vm.currentOrder.listProducts[i].product.productName == orderedProduct.product.productName){
    		    	vm.currentOrder = changeQuantityOrderedProduct(shallowCopy(vm.currentOrder), 'Add', i,1);
    		    	flag_check_exist = true;
    		    	break;
    		    }
    		}
    		if(flag_check_exist == false){
    			var updatingProduct = {};
    			var product = shallowCopy(orderedProduct.product);
    			 updatingProduct.id = product.id;
                    updatingProduct.productName = product.productName;
                    updatingProduct.productCode = product.productCode;
                    updatingProduct.productPurchasePrice = product.productPurchasePrice;
                    updatingProduct.productSalePrice = product.productSalePrice;
                    updatingProduct.productCurrencyUnit = product.productCurrencyUnit;
                    updatingProduct.productType = product.productType;
                    updatingProduct.tax = shallowCopy(product.tax);
                    updatingProduct.productCategory = shallowCopy(product.productCategory);
                    var taxRate = 0.19;
                    if(updatingProduct.tax != null && updatingProduct.tax.taxRate != null){
                        taxRate = updatingProduct.tax.taxRate;
                    }

    			vm.currentOrder.listProducts.push({quantity:1, taxRate: taxRate, product: updatingProduct});
    			vm.currentOrder = computeOrderedTotals(shallowCopy(vm.currentOrder));
    		}

        	// 2.
        	// update splitting order
        	var indexSplitting = null;
        	for (var i = 0; i < vm.splittingOrder.listProducts.length; i++) {
    		    if(vm.splittingOrder.listProducts[i].product.productName == orderedProduct.product.productName){
    		    	indexSplitting = i;
    		    	break;
    		    }
    		}
        	if(indexSplitting != null && indexSplitting != -1){
        		vm.splittingOrder = changeQuantityOrderedProduct(shallowCopy(vm.splittingOrder), 'Slice', indexSplitting,1);
        		if(vm.splittingOrder.listProducts[indexSplitting].quantity <= 0){
        			vm.splittingOrder.listProducts.splice(indexSplitting, 1);
        		}

        	}
		}

		function back() {
			//deleteCurrentOrder(vm.splittingOrder.id);
			OrderPos.get({ id:  vm.currentOrder.id  }, onSuccessLoadCurrentOrder, onErrorLoadCurrentOrder);
            function onSuccessLoadCurrentOrder(data, headers) {
                vm.currentOrder = data;
                $rootScope.$broadcast('updateCurrentOrder', vm.currentOrder);
    			makeRestCall('api/setting?type=STYLE').then(function(data){
                          if(data.data == null || data.data.setting == 'Default'){
                              $state.go('make-order');
                          }
                          else if(data.data == null || data.data.setting == 'Fast'){
                              $state.go('order-fast-advance');
                          }
                      },function(error){
                              $state.go('home');
                });
            }
            function onErrorLoadCurrentOrder(error) {
                AlertService.error(error.data.message);
            }

		}
		//***
        // Change number of customer
        function changeNumberOfCustomer(operator){
        	if(vm.splittingOrder.numberGuest != null && vm.splittingOrder.numberGuest != 'undefined'){
        		if(operator == 'Add'){
        			vm.splittingOrder.numberGuest += 1;
            	}
            	if(operator == 'Sub'){
            		vm.splittingOrder.numberGuest -= 1;
            		if(vm.splittingOrder.numberGuest <= 0){
            			vm.splittingOrder.numberGuest = 1;
            		}
            	}
        	}

        }

        // ***
		// Load all Customers resource
		function loadAllCustomer() {
			var dataQueryLoadAllCustomer = {
				pageNo : null,
				pageSize : null,
				sortBy : sortLoadAllCustomer()
			};
			if(vm.search != null && vm.search != ''){
				console.log(vm.search);
				dataQueryLoadAllCustomer.searchOr =true;
				dataQueryLoadAllCustomer.customerName = vm.search;
				dataQueryLoadAllCustomer.customerAddress = vm.search;
				dataQueryLoadAllCustomer.customerTaxCode = vm.search;
				dataQueryLoadAllCustomer.customerPhone = vm.search;
				dataQueryLoadAllCustomer.customerMail = vm.search;
			}


			Customer.query(dataQueryLoadAllCustomer, onSuccessLoadAllCustomer,
					onErrorLoadAllCustomer);
			function sortLoadAllCustomer() {
				var result = [];
				result.push('customerName:asc');
				return result;
			}
			function onSuccessLoadAllCustomer(data, headers) {
				vm.customers = data.content;
				// console.log(vm.customers);
			}
			function onErrorLoadAllCustomer(error) {
				AlertService.error(error.data.message);
			}
		}

		function selectCustomer(customer){
			vm.splittingOrder.customerDTO = customer;
			vm.rightView = null;
			vm.customerView = null;
		}

		function typeNumber(mode,number){
        	if(mode =='Number' && number != null){
        		if(firstClick == false || vm.cash ==0){
            		firstClick = true;
            		vm.cash = '';
            	}

            	vm.cash = String(vm.cash) + String(number);
            	if(number != '.'){
            		if(vm.isPaymentSplitting == true){
            			vm.charge = Math.round((parseFloat(vm.cash) - parseFloat(vm.splittingOrder.totalValue)) * 100) / 100;
            		}
            		if(vm.isPaymentSplitting == false){
            			vm.charge = Math.round((parseFloat(vm.cash) - parseFloat(vm.currentOrder.totalValue)) * 100) / 100;
            		}

            	}
            	if(number == '.'){
            		vm.charge = 'N/A';
            	}
        	}else
        	if(mode =='Delete'){
        		if(vm.isPaymentSplitting == true){
        			vm.charge = Math.round((0 - parseFloat(vm.splittingOrder.totalValue)) * 100) / 100;
        		}
        		if(vm.isPaymentSplitting == false){
        			vm.charge = Math.round((0 - parseFloat(vm.currentOrder.totalValue)) * 100) / 100;
        		}
        		vm.cash = '0';
        	}else
        	if(mode =='Slice'){
        		firstClick = true;
        		vm.cash = String(vm.cash).slice(0,-1);
        		vm.charge = Math.round((parseFloat(vm.cash) - parseFloat(vm.splittingOrder.totalValue)) * 100) / 100;
        	}

        }

		function cancelSplitMeal(){
			mergeProducts();
			initSplittingOrder();
		}
        // ***
        // Payment
        function paymentSplitting(mode){
        	if(vm.isPaymentSplitting == true){
        		if(Number(vm.cash) > 0){
                	vm.splittingOrder.splitOrder = "YES";
                    vm.splittingOrder.cash = vm.cash;
    				vm.splittingOrder.paymentMethod = vm.paymnetMethod;
    				if(vm.paymnetMethod == 'CASH'){
    					vm.splittingOrder.chargeMoney = vm.charge;
    					vm.splittingOrder.tipMoney = 0;
    				}
    				if(vm.paymnetMethod == 'CARD'){
    					vm.splittingOrder.chargeMoney = 0;
    					vm.splittingOrder.tipMoney = vm.charge;
                        
    				}
                    vm.splittingOrder.place = "IN-HOUSE";
                	// update currentOrder to db
                  //console.log("vm.splittingOrder");
                  //console.log(vm.splittingOrder);
                	OrderPos.save(vm.splittingOrder, onSaveSplittingOrderSuccess, onSaveSplittingOrderError);
                	function onSaveSplittingOrderSuccess (data) {
                         console.log(data);
                		insertNewBill(data, mode);
                		initSplittingOrder();
                		vm.rightView = null;
                		updateCurrentOrderToDB();
            	    }

            	    function onSaveSplittingOrderError () {
            	    	AlertService.error("Update Order Error");
            	    }
                }
        	}
        	if(vm.isPaymentSplitting == false){
        		if(Number(vm.cash) > 0){
                	vm.currentOrder.splitOrder = "NO";
                    vm.currentOrder.cash = vm.cash;
    				vm.currentOrder.paymentMethod = vm.paymnetMethod;
    				if(vm.paymnetMethod == 'CASH'){
    								vm.currentOrder.chargeMoney = vm.charge;
    								vm.currentOrder.tipMoney = 0;
    				}
    				if(vm.paymnetMethod == 'CARD'){
    								vm.currentOrder.chargeMoney = 0;
    								vm.currentOrder.tipMoney = vm.charge;
    			     }
                     vm.currentOrder.place = "IN-HOUSE";
                	//console.log(vm.currentOrder);
                	// update currentOrder to db
                	OrderPos.update(vm.currentOrder, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                	function onSaveCurrentOrderSuccess (data) {
                		insertNewBill(data, mode, callbackFinishSplitBill);
                		vm.rightView = null;
            	    }

            	    function onSaveCurrentOrderError () {
            	    	AlertService.error("Update Order Error");
            	    }
                    // private function
                    function callbackFinishSplitBill(){
                             //console.log("callback: callbackFinishSplitBill");
    						  $localStorage["currentOrder.id"] = null;
                              localStorage["jhi-currentOrder.id"] = null;
                             $state.go('order-fast-advance');
                    }
                }
        	}

        }

		// *** Private Functions
		// *****
		// private function
		 function changeQuantityOrderedProduct(order, mode, i, added){
	        	if(mode == 'Add'){
	        		order.listProducts[i].quantity = order.listProducts[i].quantity + added;
	        	}else
	        	if(mode == 'Slice'){
	        		order.listProducts[i].quantity = order.listProducts[i].quantity - added;
	        	}
	        	order.listProducts[i].totalTax = Math.round((order.listProducts[i].quantity*order.listProducts[i].tax) * 100) / 100;
	        	order.listProducts[i].totalDiscount = Math.round((order.listProducts[i].quantity*order.listProducts[i].discount) * 100) / 100;
	        	order.listProducts[i].totalMoney = Math.round((order.listProducts[i].quantity*order.listProducts[i].product.productPurchasePrice) * 100) / 100;

		    	order = computeOrderedTotals(shallowCopy(order));
		    	return order;
	    }

        // private function
        function computeOrderedTotals(order){
            var totalValue = 0;
        	for (var i = 0; i < order.listProducts.length; i++) {
        		totalValue += order.listProducts[i].quantity * order.listProducts[i].product.productSalePrice;
    		}

        	order.totalValue = Math.round(totalValue * 100.0) / 100.0;

        	return order;
        }

        function updateCurrentOrderToDB(){
        	OrderPos.update(vm.currentOrder, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
        	function onSaveCurrentOrderSuccess (data, headers) {
        		vm.currentOrder = data;
    	    }

    	    function onSaveCurrentOrderError (error) {
    	    	AlertService.error(error.data.message);
    	    }
        }

        function updateSplittingOrderToDB(){
        	OrderPos.update(vm.splittingOrder, onSaveSplittingOrderSuccess, onSaveSplittingOrderError);
        	function onSaveSplittingOrderSuccess (data, headers) {
        		vm.splittingOrder = data;
    	    }

    	    function onSaveSplittingOrderError (error) {
    	    	AlertService.error(error.data.message);
    	    }
        }

        // private function
		function createNewtOrderToDB() {
			OrderPos.save(vm.splittingOrder, onCreateNewtOrderSuccess,
					onCreateNewtOrderSuccess);

			function onCreateNewtOrderSuccess(result) {
				vm.splittingOrder = result;
			}

			function onSaveCurrentOrderError(error) {
				AlertService.error(error.data.message);
			}
		}

		function deleteCurrentOrder(orderID){
        	OrderPos.delete({ id: orderID  }, onDeleteSuccess);
        	function onDeleteSuccess(){
        	}

        }

		function mergeProducts(){
			//console.log(vm.splittingOrder);
			//console.log(vm.currentOrder);
			if(vm.splittingOrder.listProducts != null && vm.splittingOrder.listProducts.length >0){
				for(var j = 0; j < vm.splittingOrder.listProducts.length; j++){
	            	var targetProduct = vm.splittingOrder.listProducts[j];
	            	var flag_check_exist = false;
	            	for (var i = 0; i < vm.currentOrder.listProducts.length; i++) {
	        		    if(vm.currentOrder.listProducts[i].product.productName == targetProduct.product.productName){
	        		    	vm.currentOrder = changeQuantityOrderedProduct(shallowCopy(vm.currentOrder), 'Add',i, targetProduct.quantity);
	        		    	flag_check_exist = true;
	        		    	break;
	        		    }
	        		}
	        		if(flag_check_exist == false){
	        			vm.currentOrder.listProducts.push(targetProduct);
	        			vm.currentOrder = computeOrderedTotals(shallowCopy(vm.currentOrder));
	        		}
	            }
				//updateCurrentOrderToDB();
			}

			//deleteCurrentOrder(vm.splittingOrder.id);
			vm.splittingOrder = null;
		}

		 function insertNewBill(order, mode, callback){
	        	// insert new bill to db
	        	var bill = {}
	        	bill.id = null;
	        	bill.code = null;
	        	bill.tablePos = order.tablePos;
	        	bill.waiter = order.waiter;
	        	bill.startedAt = order.startedAt;
	        	bill.endAt = new Date();
	        	bill.orderId = order.id;
	        	bill.numberGuest = order.numberGuest;
	        	bill.customerDTO = order.customerDTO;
	        	bill.listProducts = order.listProducts;
	        	bill.totalValue = order.totalValue;
	        	bill.discountValue = order.totalDiscount;
	        	bill.totalVAT = order.totalVAT;
	        	bill.subTotal = order.subTotal;

	        	bill.cash = vm.cash;
				bill.paymentMethod = vm.paymnetMethod;
    			if(vm.paymnetMethod == 'CASH'){
    	            bill.chargeMoney = vm.charge;
    	            bill.tipMoney = 0;
    	       }
    	       if(vm.paymnetMethod == 'CARD'){
    	            bill.chargeMoney = 0;
    	            bill.tipMoney = vm.charge;
    	          }


	        	bill.splitOrder = order.splitOrder;
	        	bill.requireFinish = true;
	        	Bill.save(bill, onSaveBillSuccess, onSaveBillError);

	        	function onSaveBillSuccess(data){
                    /* 1. finish order */
                    order.orderStatus = "FINISH";
                    order.endAt = new Date();
                    OrderPos.update(order, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                    function onSaveCurrentOrderSuccess (data) {

                    }

                    function onSaveCurrentOrderError () {
                    }
                    /* 2. print bill */
					if(mode == 'BILL' || mode == 'BILLA4' || mode=='EVIDENCE'){
	        			  printBill(mode, data.id);
	        		}
              if(callback != null){
                  callback();
              }
	        	}
	        	function onSaveBillError(){
	        		AlertService.error("Insert Bill Error");
	        	}
	        }

		 function shallowCopy( original )
	        {
		    	if(original == null || original == 'undefined'){
		    		return null;
		    	}
	            // First create an empty object with
	            // same prototype of our original source
	            var clone = Object.create( Object.getPrototypeOf( original ) ) ;

	            var i , keys = Object.getOwnPropertyNames( original ) ;

	            for ( i = 0 ; i < keys.length ; i ++ )
	            {
	                // copy each property into the clone
	                Object.defineProperty( clone , keys[ i ] ,
	                    Object.getOwnPropertyDescriptor( original , keys[ i ] )
	                ) ;
	            }

	            return clone ;
	        }

	}
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('OrderPosSelectCustomerController',
			OrderPosSelectCustomerController);

	OrderPosSelectCustomerController.$inject = [ '$timeout', '$rootScope', '$scope',
			'$stateParams', '$uibModalInstance', 'AlertService', 'entity','Customer' ,'JhiLanguageService'];

	function OrderPosSelectCustomerController($timeout, $rootScope,$scope,
			$stateParams, $uibModalInstance, AlertService, entity, Customer, JhiLanguageService) {
		var vm = this;
		vm.currentOrder = entity;
		vm.clear = clear;
		vm.loadAllCustomer = loadAllCustomer;
		vm.selectCustomer = selectCustomer;
		initKeyboard();
		loadAllCustomer();

		$scope.$on('languageChange', function(data) {
            initKeyboard();
        });
		function initKeyboard(){
            
            vm.t04Config = {layout: JhiLanguageService.getKeyboard(), kt: 'US International', showKbSelect: true,
             numberPad: true, showVersion: true, usePreview: false, autoAccept : true, reposition : true,
             position : {
                  // null (attach to input/textarea) or a jQuery object (attach elsewhere)
                  of : $(window),
                  my : 'center bottom',
                  at : 'center bottom',
                  // at2 is used when "usePreview" is false (centers keyboard at the bottom
                  // of the input/textarea)
                  at2: 'center bottom',
                  collision: 'flipfit flipfit'
                },
                visible: function(e, keyboard, el) {
                  keyboard.$preview[0].select();
                },
                change: function(event, keyboard, el) {
                    vm.search = (keyboard.$preview.val());
                    loadAllCustomer();
                  }
         }
        }

		// ***
		// Load all Customers resource
		function loadAllCustomer() {
			var dataQueryLoadAllCustomer = {
				pageNo : null,
				pageSize : null,
				sortBy : sortLoadAllCustomer()
			};
			if(vm.search != null && vm.search != ''){
				//console.log(vm.search);
				dataQueryLoadAllCustomer.searchOr =true;
				dataQueryLoadAllCustomer.customerName = vm.search;
				dataQueryLoadAllCustomer.customerAddress = vm.search;
				dataQueryLoadAllCustomer.customerTaxCode = vm.search;
				dataQueryLoadAllCustomer.customerPhone = vm.search;
				dataQueryLoadAllCustomer.customerMail = vm.search;
				dataQueryLoadAllCustomer.street = vm.search;
				dataQueryLoadAllCustomer.customerPostCode = vm.search;
			}
			

			Customer.query(dataQueryLoadAllCustomer, onSuccessLoadAllCustomer,
					onErrorLoadAllCustomer);
			function sortLoadAllCustomer() {
				var result = [];
				result.push('customerName:asc');
				return result;
			}
			function onSuccessLoadAllCustomer(data, headers) {
				vm.customers = data.content;
				// console.log(vm.customers);
			}
			function onErrorLoadAllCustomer(error) {
				AlertService.error(error.data.message);
			}
		}

		function selectCustomer(customer){
			vm.currentOrder.customerDTO = customer;
			$rootScope.$broadcast('updateCurrentOrder', vm.currentOrder);
            $uibModalInstance.dismiss('cancel');
		}
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

	}
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('OrderPosQuickCommentController',
			OrderPosQuickCommentController);

	OrderPosQuickCommentController.$inject = [ '$timeout', '$rootScope', '$scope','PosSetting', '$http', '$q','$localStorage',
			'$stateParams', '$uibModalInstance', 'AlertService', 'entity','Customer' ,'JhiLanguageService'];

	function OrderPosQuickCommentController($timeout, $rootScope,$scope,PosSetting, $http, $q,$localStorage,
			$stateParams, $uibModalInstance, AlertService, entity, Customer, JhiLanguageService) {
		var vm = this;
		 vm.apiUrl = $localStorage.API_URL;
        var API_URL = $localStorage.API_URL;
		vm.currentOrder = entity;
		vm.clear = clear;
		vm.loadAllComment = loadAllComment;
		vm.addComment = addComment;
    vm.selectCommentTemplate = selectCommentTemplate;

		var makeRestCall   = function (url) {
            return $http.get($localStorage.API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

		for (var i = 0; i < vm.currentOrder.listProducts.length; i++) { 
                    if(vm.currentOrder.listProducts[i].product.productName == $stateParams.productName){
                        vm.comment = vm.currentOrder.listProducts[i].comment;
                    }
         }

		initKeyboard();
		loadAllComment();

		$scope.$on('languageChange', function(data) {
            initKeyboard();
        });
		function initKeyboard(){
            
            vm.t04Config = {layout: JhiLanguageService.getKeyboard(), kt: 'US International', showKbSelect: true,
             numberPad: true, showVersion: true, usePreview: false, autoAccept : true, reposition : true,
             position : {
                  // null (attach to input/textarea) or a jQuery object (attach elsewhere)
                  of : $(window),
                  my : 'center bottom',
                  at : 'center bottom',
                  // at2 is used when "usePreview" is false (centers keyboard at the bottom
                  // of the input/textarea)
                  at2: 'center bottom',
                  collision: 'flipfit flipfit'
                },
                visible: function(e, keyboard, el) {
                  keyboard.$preview[0].select();
                }
         }
        }

       

		// ***
		// Load all Comment resource
		function loadAllComment() {
			makeRestCall('api/setting?type=COMMENTS_TEMPLATE').then(function(data){
                      var commentsString = data.data.setting;
                      vm.comments = commentsString.split(";");

                  },function(error){
          });
		}

		function addComment(comment){
			vm.comment = comment;
			var itemName = $stateParams.productName;
			for (var i = 0; i < vm.currentOrder.listProducts.length; i++) { 
                    if(vm.currentOrder.listProducts[i].product.productName == itemName){
                        vm.currentOrder.listProducts[i].comment = vm.comment;
                    }
            }

			$rootScope.$broadcast('updateCurrentOrder', vm.currentOrder);
            $uibModalInstance.dismiss('cancel');
		}
		
    function selectCommentTemplate(comment){
      if(vm.comment && vm.comment.length >0){
        vm.comment = vm.comment +"; "+comment;
      }else{
        vm.comment = comment;
      }
    }
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

	}
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('OrderPosMakeNewOrderController',
			OrderPosMakeNewOrderController);

	OrderPosMakeNewOrderController.$inject = [ '$timeout', '$rootScope',
			'$stateParams', '$uibModalInstance', 'AlertService', 'OrderPos', 'Principal' ];

	function OrderPosMakeNewOrderController($timeout, $rootScope, $stateParams,
			$uibModalInstance, AlertService, OrderPos, Principal) {
		var vm = this;
		vm.tableNo = $stateParams.tableNo;
		vm.clear = clear;
		vm.createNewOrder = createNewOrder;
		vm.currentOrder = null;
		vm.showErrorOrderAfterReport = false;
		function createNewOrder() {
			vm.currentOrder = {};
			vm.currentOrder.id = null;
			vm.currentOrder.tablePos = vm.tableNo;
			vm.currentOrder.customerDTO = {};
			vm.currentOrder.customerDTO.customerName = "";
			vm.currentOrder.splitOrder = "NO";
			vm.currentOrder.numberGuest = 1;
			vm.currentOrder.orderStatus = "INPROGRESS";
			
			Principal.identity().then(function(account) {
				vm.currentOrder.waiter = account.login;
			});
			vm.currentOrder.startedAt = new Date();
			vm.currentOrder.totalValue = 0;

			createNewtOrderToDB();
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		// private function
		function createNewtOrderToDB() {
			//console.log("Request Create New Order:")
			//console.log(JSON.stringify(vm.currentOrder, null, "    ") )
			OrderPos.save(vm.currentOrder, onCreateNewtOrderSuccess,
					onCreateNewtOrderSuccess);

			function onCreateNewtOrderSuccess(result) {
				if(result.status == 400){
					vm.showErrorOrderAfterReport = true;
				}else{
					vm.currentOrder = result;
					$rootScope.$broadcast('newOrder', vm.currentOrder);
					 $uibModalInstance.dismiss('cancel');
				}

				
			}

			function onSaveCurrentOrderError(error) {
				
				AlertService.error(error.data);
			}
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosMergeTableController', OrderPosMergeTableController);

    OrderPosMergeTableController.$inject =  ['$timeout', '$rootScope', '$stateParams', '$uibModalInstance', 'AlertService','entity', 'OrderPos','TablePos','TableZone'];
   
    function OrderPosMergeTableController($timeout, $rootScope, $stateParams, $uibModalInstance, AlertService, entity, OrderPos,TablePos,TableZone) {
        var vm = this;
        vm.currentOrder = entity;
        vm.clear = clear;
        vm.mergeTable = mergeTable;
        vm.filter = filter;
        
        
        vm.filterTableZone = '';
      
        loadAllTable();
        loadAllTableZone();
      
        // ***
        // Load all tables resource
        function loadAllTable () {
            var dataQueryLoadAllTable = {
            	pageNo: null,
                pageSize: null,
                sortBy: sortLoadAllTable()
            };
            dataQueryLoadAllTable.requestStatusForOrder = true;
           
            TablePos.query(dataQueryLoadAllTable, onSuccessLoadAllTable, onErrorLoadAllTable);
            function sortLoadAllTable() {
            	var result = [];
                result.push('tableNo:asc');
                return result;
            }
            function onSuccessLoadAllTable(data, headers) {
                vm.tables = data.content;
                vm.allTables = shallowCopy(data.content);
            }
            function onErrorLoadAllTable(error) {
                AlertService.error(error.data.message);
            }
        }
        // ***
        // Load all table zones resource
        function loadAllTableZone () {
            var dataQueryLoadAllTableZone = {
            	pageNo: null,
                pageSize: null,
                sortBy: sortLoadAllTableZone()
            };
           
            TableZone.query(dataQueryLoadAllTableZone, onSuccessLoadAllTableZone, onErrorLoadAllTableZone);
            function sortLoadAllTableZone() {
            	var result = [];
                result.push('tableZoneName:asc');
                return result;
            }
            function onSuccessLoadAllTableZone(data, headers) {
                vm.tableZones = data.content;
                //console.log( vm.tableZones);
            }
            function onErrorLoadAllTableZone(error) {
                AlertService.error(error.data.message);
            }
        }
        
     // ***
        // Filter Functions
        function filter(filter, value){
            if(filter == 'TableZone'){
                if(value == 'All'){
                    vm.filterTableZone = '';
                    vm.tables = shallowCopy( vm.allTables);
                }
                if(value != 'All'){
                    vm.filterTableZone = value;
                    vm.tables = [];
                    for(var i = 0;i< vm.allTables.length; i++){
                        if(vm.allTables[i].tableZone == vm.filterTableZone){
                            vm.tables.push(vm.allTables[i]);
                        }
                    }
                }
            }
            
        }
        
        
        // ***
        // Change table function
        function mergeTable(table){
            // update table
            var targetOrderId = table.currentOrderId ;
            var targetTable = null;
            for(var i =0; i< vm.allTables.length; i++){
                if(vm.allTables[i].tableNo == table.tableNo){
                    targetTable = vm.allTables[i];
                    targetTable.statusForOrder = "FINISH";
                    targetTable.currentOrderId = -1;
                }
               
            }
            if(targetTable != null){
                TablePos.update(targetTable,onSaveTargetTableSuccess, onSaveTargetError);
                function onSaveTargetTableSuccess(result){
                    // update order
                    vm.isSaving = true;
                    OrderPos.get({ id: targetOrderId  }, onSuccessLoadCurrentOrder, onErrorLoadCurrentOrder);
                    function onSuccessLoadCurrentOrder(data, headers) {
                        var targetOrder = data;
                        
                        for(var j = 0; j < targetOrder.listProducts.length; j++){
                            var targetProduct = targetOrder.listProducts[j];
                            var flag_check_exist = false;
                            for (var i = 0; i < vm.currentOrder.listProducts.length; i++) { 
                                if(vm.currentOrder.listProducts[i].product.productName == targetProduct.product.productName){
                                    changeQuantityOrderedProduct( i, targetProduct.quantity);
                                    flag_check_exist = true;
                                    break;
                                }
                            }
                            if(flag_check_exist == false){
                                vm.currentOrder.listProducts.push(targetProduct);
                                computeOrderedTotals();
                            }
                        }
                        
                        // delete target order
                        OrderPos.delete({ id: targetOrder.id  }, onDeleteSuccess);
                        function onDeleteSuccess(){
                            // update current order
                            OrderPos.update(vm.currentOrder, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                            function onSaveCurrentOrderSuccess (result) {
                                $rootScope.$broadcast('updateCurrentOrder', result);
                                $uibModalInstance.close(result);
                                vm.isSaving = false;
                            }
                            function onSaveCurrentOrderError () {
                                vm.isSaving = false;
                            }
                        }
                        
                    }
                    function onErrorLoadCurrentOrder(error) {
                        vm.isSaving = false;
                        AlertService.error(error.data.message);
                    }
                }
                function onSaveTargetError(error){
                    AlertService.error(error);
                }
            }

            
            
        	
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        // ****
        // private function
        function changeQuantityOrderedProduct(i, added){
        	vm.currentOrder.listProducts[i].quantity = vm.currentOrder.listProducts[i].quantity +added;
	    	vm.currentOrder.listProducts[i].totalTax = Math.round((vm.currentOrder.listProducts[i].quantity*vm.currentOrder.listProducts[i].tax) * 100) / 100;
	    	vm.currentOrder.listProducts[i].totalDiscount = Math.round((vm.currentOrder.listProducts[i].quantity*vm.currentOrder.listProducts[i].discount) * 100) / 100;
	    	vm.currentOrder.listProducts[i].totalMoney = Math.round((vm.currentOrder.listProducts[i].quantity*vm.currentOrder.listProducts[i].product.productPurchasePrice) * 100) / 100;
	    	
	    	computeOrderedTotals();
        }
        // private function
        function computeOrderedTotals(){
        	vm.currentOrder.subTotal = 0;
        	vm.currentOrder.totalDiscount = 0;
        	vm.currentOrder.totalVAT = 0;
        	for (var i = 0; i < vm.currentOrder.listProducts.length; i++) { 
        		vm.currentOrder.subTotal += vm.currentOrder.listProducts[i].totalMoney;
        		vm.currentOrder.totalDiscount += vm.currentOrder.listProducts[i].totalDiscount;
        		vm.currentOrder.totalVAT += vm.currentOrder.listProducts[i].totalTax;
    		}
        	vm.currentOrder.totalValue = vm.currentOrder.subTotal - vm.currentOrder.totalDiscount + vm.currentOrder.totalVAT;
        	vm.currentOrder.subTotal = Math.round((vm.currentOrder.subTotal) * 100) / 100;
        	vm.currentOrder.totalDiscount = Math.round((vm.currentOrder.totalDiscount) * 100) / 100;
        	vm.currentOrder.totalVAT = Math.round((vm.currentOrder.totalVAT) * 100) / 100;
        	
        }

         function shallowCopy( original )  
        {
            if(original == null || original == 'undefined'){
                return null;
            }
            // First create an empty object with
            // same prototype of our original source
            var clone = Object.create( Object.getPrototypeOf( original ) ) ;

            var i , keys = Object.getOwnPropertyNames( original ) ;

            for ( i = 0 ; i < keys.length ; i ++ )
            {
                // copy each property into the clone
                Object.defineProperty( clone , keys[ i ] ,
                    Object.getOwnPropertyDescriptor( original , keys[ i ] )
                ) ;
            }

            return clone ;
        }
        
    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('OrderPosDeleteOrderController',
			OrderPosDeleteOrderController);

	OrderPosDeleteOrderController.$inject = [ '$timeout', '$rootScope',
			'$stateParams', '$uibModalInstance', 'AlertService', 'OrderPos', 'Principal','Bill','Product','$http','$localStorage'];

	function OrderPosDeleteOrderController($timeout, $rootScope, $stateParams,
			$uibModalInstance, AlertService, OrderPos, Principal,Bill, Product, $http,$localStorage) {
		var vm = this;
		vm.orderId = $stateParams.order;
		
		vm.clear = clear;
		vm.deleteOrder = deleteOrder;
		
		getcurrentOrder(vm.orderId);

		var makeRestCall   = function (url) {
            return $http.get($localStorage.API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

		makeRestCall('api/setting?type=STOCK_MANAGEMENT').then(function(data){
                     if(data.data != null){
                        vm.stockManagement = data.data.setting;
                    }
                  },function(error){
          });


		function getcurrentOrder(orderID){
        	OrderPos.get({ id: orderID  }, onSuccessLoadCurrentOrder, onErrorLoadCurrentOrder);
            function onSuccessLoadCurrentOrder(data, headers) {
                vm.currentOrder = data;
            }
            function onErrorLoadCurrentOrder(error) {
                AlertService.error(error.data.message);
            }
        }
		
		function deleteOrder(){
			if( vm.orderId != null){
				if(vm.currentOrder.listProducts.length <1){
					// neu khong co san pham thi xoa
					OrderPos.delete({ id: vm.orderId  }, onDeleteSuccess);
		        	function onDeleteSuccess(data){
		        		vm.currentOrder = null;
	 					$rootScope.$broadcast('newOrder', vm.currentOrder);
	                    //$uibModalInstance.close(true);
	                    $uibModalInstance.dismiss('cancel');
		        	}
				}else{
					//// neu order co san pham thi switch sang stornos (mat hang xoa) roi luu Bill
					//switch stornos
					for(var i=0;i<vm.currentOrder.listProducts.length;i++){
						vm.currentOrder.listProducts[i].stornors = vm.currentOrder.listProducts[i].stornors+ vm.currentOrder.listProducts[i].quantity;
						
						// update quantity of product in warehouse
						if(vm.stockManagement == '1'){
							vm.currentOrder.listProducts[i].product.quantity = vm.currentOrder.listProducts[i].product.quantity + vm.currentOrder.listProducts[i].quantity;
							Product.update(vm.currentOrder.listProducts[i].product, onSaveProductSuccess, onSaveProductError);
				             function onSaveProductSuccess(data, headers){
				                   if(data != null){
				                    
				                   }
				            }
				            function onSaveProductError(){
				            }
						}
						
			            

						//update quantity of current orderedProduct
						vm.currentOrder.listProducts[i].quantity = 0;
					}
					//save bill
					vm.currentOrder.orderStatus = "FINISH";
		            vm.currentOrder.endAt = new Date();
		            vm.currentOrder.cash = 0;
		    		vm.currentOrder.quantity = 0;
		    		vm.currentOrder.totalMoney = 0;

		            OrderPos.update(vm.currentOrder, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
		            function onSaveCurrentOrderSuccess (data) {
		                insertNewBill(data);
		                vm.currentOrder = null;
		            }

		            function onSaveCurrentOrderError () {
		                vm.currentOrder = null;
		                alert("Error Delete")
		            }
				}
				
			}else{
				$uibModalInstance.dismiss('cancel');
			}
			
		}

		function insertNewBill(order){
            // insert new bill to db
            var bill = {}
            bill.id = null;
            bill.code = null;
            bill.tablePos = order.tablePos;
            bill.waiter = order.waiter;
            bill.startedAt = order.startedAt;
            bill.endAt = order.endAt;
            bill.orderId = order.id;
            bill.numberGuest = order.numberGuest;
            bill.customerDTO = order.customerDTO;
            bill.listProducts = order.listProducts;
            bill.totalValue = order.totalValue;
            bill.discountValue = order.totalDiscount;
            bill.totalVAT = order.totalVAT;
            bill.subTotal = order.subTotal;
            bill.chargeMoney = 0;
            bill.cash = order.totalValue;
            bill.paymentMethod = 'CASH';
            bill.splitOrder = 'NO';
            
            
            //console.log("Request Create New Bill")
            //console.log(JSON.stringify(bill, null, "    ") )
            Bill.save(bill, onSaveBillSuccess, onSaveBillError);
            
            function onSaveBillSuccess(data){
                vm.currentOrder = null;
	 			$rootScope.$broadcast('newOrder', vm.currentOrder);
	            //$uibModalInstance.close(true);
	            $uibModalInstance.dismiss('cancel');
            }
            function onSaveBillError(){
                AlertService.error("Insert Bill Error");
            }
        }
		

		function clear() {
			
			$uibModalInstance.dismiss('cancel');
		}



	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderPosChangeTableController', OrderPosChangeTableController);

    OrderPosChangeTableController.$inject =  ['$timeout', '$rootScope', '$stateParams', '$uibModalInstance','AlertService', 'entity', 'OrderPos','TablePos','TableZone'];
   
    function OrderPosChangeTableController($timeout, $rootScope, $stateParams, $uibModalInstance, AlertService, entity, OrderPos,TablePos,TableZone) {
        var vm = this;
        vm.currentOrder = entity;
        vm.clear = clear;
        vm.changeTable = changeTable;
        vm.filter = filter;
        
        
        vm.filterTableZone = '';
      
        loadAllTable();
        loadAllTableZone();
      
        // ***
        // Load all tables resource
        function loadAllTable () {
            var dataQueryLoadAllTable = {
            	pageNo: null,
                pageSize: null,
                sortBy: sortLoadAllTable()
            };
            dataQueryLoadAllTable.requestStatusForOrder = true;
           
            TablePos.query(dataQueryLoadAllTable, onSuccessLoadAllTable, onErrorLoadAllTable);
            function sortLoadAllTable() {
            	var result = [];
                result.push('tableNo:asc');
                return result;
            }
            function onSuccessLoadAllTable(data, headers) {
                vm.tables = data.content;
                vm.allTables = shallowCopy(data.content);
                //console.log(vm.tables);
            }
            function onErrorLoadAllTable(error) {
                AlertService.error(error.data.message);
            }
        }
        // ***
        // Load all table zones resource
        function loadAllTableZone () {
            var dataQueryLoadAllTableZone = {
            	pageNo: null,
                pageSize: null,
                sortBy: sortLoadAllTableZone()
            };
           
            TableZone.query(dataQueryLoadAllTableZone, onSuccessLoadAllTableZone, onErrorLoadAllTableZone);
            function sortLoadAllTableZone() {
            	var result = [];
                result.push('tableZoneName:asc');
                return result;
            }
            function onSuccessLoadAllTableZone(data, headers) {
                vm.tableZones = data.content;
                //console.log( vm.tableZones);
            }
            function onErrorLoadAllTableZone(error) {
                AlertService.error(error.data.message);
            }
        }
        
        // ***
        // Filter Functions
        function filter(filter, value){
        	if(filter == 'TableZone'){
        		if(value == 'All'){
            		vm.filterTableZone = '';
            		vm.tables = shallowCopy( vm.allTables);
            	}
            	if(value != 'All'){
            		vm.filterTableZone = value;
        	    	vm.tables = [];
                    for(var i = 0;i< vm.allTables.length; i++){
                        if(vm.allTables[i].tableZone == vm.filterTableZone){
                            vm.tables.push(vm.allTables[i]);
                        }
                    }
                }
        	}
        	
        }
        
        
        // ***
        // Change table function
        function changeTable(tableNo){
        	vm.isSaving = true;
            var oldTable = null;
            var newTable = null;
            for(var i =0; i< vm.allTables.length; i++){
                if(vm.allTables[i].tableNo == tableNo){
                    newTable = vm.allTables[i];
                    newTable.statusForOrder = "INPROGRESS";
                    newTable.currentOrderId = vm.currentOrder.id;
                }
                if(vm.allTables[i].tableNo == vm.currentOrder.tablePos){
                    oldTable = vm.allTables[i];
                    oldTable.statusForOrder = "FINISH";
                    oldTable.currentOrderId = -1;
                }
            }
            if(newTable != null && oldTable != null){
                TablePos.update(oldTable,onSaveOldTableSuccess, onSaveOldTableError);
                function onSaveOldTableSuccess(result){
                    TablePos.update(newTable,onSaveNewTableSuccess, onSaveNewTableError);
                    function onSaveNewTableSuccess(result){
                        vm.currentOrder.tablePos = tableNo;
                        OrderPos.update(vm.currentOrder, onSaveCurrentOrderSuccess, onSaveCurrentOrderError);
                        function onSaveCurrentOrderSuccess (result) {
                            $rootScope.$broadcast('updateCurrentOrder', result);
                            $uibModalInstance.close(result);
                            vm.isSaving = false;
                        }

                        function onSaveCurrentOrderError () {
                            vm.isSaving = false;
                        }
                    }
                    function onSaveNewTableError(error){
                        AlertService.error(error);
                    }
                }
                function onSaveOldTableError(error){
                    AlertService.error(error);
                }
                
            }
        	
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        

         function shallowCopy( original )  
        {
            if(original == null || original == 'undefined'){
                return null;
            }
            // First create an empty object with
            // same prototype of our original source
            var clone = Object.create( Object.getPrototypeOf( original ) ) ;

            var i , keys = Object.getOwnPropertyNames( original ) ;

            for ( i = 0 ; i < keys.length ; i ++ )
            {
                // copy each property into the clone
                Object.defineProperty( clone , keys[ i ] ,
                    Object.getOwnPropertyDescriptor( original , keys[ i ] )
                ) ;
            }

            return clone ;
        }
    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('OrderPosAddCustomerController',
			OrderPosAddCustomerController);

	OrderPosAddCustomerController.$inject = [ '$timeout', '$scope',
			'$stateParams', '$uibModalInstance', 'AlertService', 'entity','Customer' ,'JhiLanguageService','Location'];

		function OrderPosAddCustomerController($timeout, $scope,
					$stateParams, $uibModalInstance, AlertService, entity, Customer, JhiLanguageService, Location) {
						var vm = this;

						vm.customer = entity;
						if(vm.customer.customerType == '' || vm.customer.customerType == null){
							vm.customer.customerType = 'ECONOMIC';
						}
						vm.clear = clear;
						vm.datePickerOpenStatus = {};
						vm.openCalendar = openCalendar;
						vm.save = save;
						vm.streets = [];
						initKeyboard();


				$scope.$on('languageChange', function(data) {
		            initKeyboard();
		        });


		        function initKeyboard(){
		            
		            vm.t05Config = {layout: JhiLanguageService.getKeyboard(), kt: 'US International', showKbSelect: true,
		             numberPad: true, showVersion: true, usePreview: false, autoAccept : true, reposition : true,

		             position : {
                          // null (attach to input/textarea) or a jQuery object (attach elsewhere)
                          of : '#keyboard-wrapper',
                          my : 'center top',
                          at : 'center bottom',
                          // at2 is used when "usePreview" is false (centers keyboard at the bottom
                          // of the input/textarea)
                          at2: 'center bottom',
                          collision: 'flipfit flipfit'
                        },
                        beforeVisible: function(e, keyboard, el) {
                          var inModal = $(el).parents('.modal').length > 0;
                          if (inModal) {
                            keyboard.$keyboard.appendTo($(el).parents('.modal-body'));
                          }
                        }
		         }
		        }


				$timeout(function (){
						angular.element('.form-group:eq(0)>input').focus();
				});

				function clear () {
						$uibModalInstance.dismiss('cancel');
				}

				function save () {
						vm.isSaving = true;
						vm.customer.lastUpdateAt = new Date();
						vm.customer.street = document.getElementById("streetInput").value;
						if (vm.customer.id !== null) {
								Customer.update(vm.customer, onSaveSuccess, onSaveError);
						} else {
								Customer.save(vm.customer, onSaveSuccess, onSaveError);
						}
				}

				function onSaveSuccess (result) {
						$scope.$emit('xposApp:customerUpdate', result);
						$uibModalInstance.close(result);
						vm.isSaving = false;
				}

				function onSaveError () {
						vm.isSaving = false;
				}

				vm.datePickerOpenStatus.lastUpdateAt = false;

				function openCalendar (date) {
						vm.datePickerOpenStatus[date] = true;
				}

				//*
        // region autocomplete street by postcode
        //*
        /*initiate the autocomplete function on the "streetInput" element, and pass along the streets array as possible autocomplete values:*/
        vm.activeStreetSuggestion = activeStreetSuggestion
        
        function activeStreetSuggestion(){
            if(vm.customer.customerPostCode != null && vm.customer.customerPostCode.length >0){
                loadAllLocations(vm.customer.customerPostCode);

            }
        }
        

        function loadAllLocations(postCode){
            var dataQueryLoadAllLocations = {
                pageNo : null,
                pageSize : null,
                postCode : postCode,
                sortBy : sortLoadAllLocations()
            };
            

            Location.query(dataQueryLoadAllLocations, onSuccessLoadAllLocation,
                    onErrorLoadAllLocations);
            function sortLoadAllLocations() {
                var result = [];
                result.push('street:asc');
                return result;
            }
            function onSuccessLoadAllLocation(data, headers) {
                vm.locations = data.content;
                if(vm.locations  != null){
                    vm.streets = vm.locations.map(
                        function getStreet(location) {
                            return location.street;
                        }

                    );
                    // console.log(vm.streets);
                    /*An array containing all the street names of the postcode:*/
                    autocomplete(document.getElementById("streetInput"), vm.streets);
                }
                
               
            }
            function onErrorLoadAllLocations(error) {
                AlertService.error(error);
            }
        }

	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderMatxaController', OrderMatxaController);

    OrderMatxaController.$inject = ['$uibModal','Auth','$timeout','$state','$rootScope','$stateParams', 'Principal',
    'Ticket', 'ParseLinks', 'AlertService',
     'paginationConstants', 'pagingParams', 'PosSetting', '$http', '$q', '$scope','$localStorage', 
      'BillMatxa'];

    function OrderMatxaController( $uibModal,Auth, $timeout, $state, $rootScope, $stateParams,Principal,
         Ticket, ParseLinks, AlertService, paginationConstants, 
        pagingParams, PosSetting, $http, $q, $scope, $localStorage,   BillMatxa 
        ) {

        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        var API_URL = $localStorage.API_URL;
        vm.selectedOrderedProductIndex = null;

        function makePutCall(url,data) {
            return $http.put(vm.apiUrl+url,data)
                .then(function (response) {
                  return response;
                }, function (response) {
                    return $q.reject(response.data);
                });
        };

       Principal.identity().then(function(account) {
            vm.currentAccount = account;
            loadAllTickets();
            loadAllBillMatxa();
        });

      
       function loadAllTickets () {
                var dataQuery = {
                    storeId: vm.currentAccount.store.id
                };
               
                // get Products
                Ticket.query(dataQuery, onSuccess, onError);
               
                function onSuccess(data, headers) {
                    vm.tickets = data.content;
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
        }


        function loadAllBillMatxa () {
                var dataQuery = {
                    storeId: vm.currentAccount.store.id,
                    paymentStatus: 'CHUA_IN_VE',
                    status: 'THANH_CONG'
                };
               
                // get Products
                BillMatxa.query(dataQuery, onSuccess, onError);
               
                function onSuccess(data, headers) {
                    vm.billMatxas = data.content;
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
        }
        vm.selectTicket = function(ticket){
          var txt =  "Bạn thực sự muốn bán vé này?";
          var r = confirm(txt);
          if (r == true) {
             var billMatxa = {};
             billMatxa.id = null;
             billMatxa.store = vm.currentAccount.store;
             billMatxa.ticket = ticket;
             billMatxa.waiter = vm.currentAccount.login;
             billMatxa.startedAt = new Date();
             billMatxa.paymentStatus = 'CHUA_IN_VE';

             BillMatxa.save(billMatxa, onSaveSuccess, onSaveError);
             function onSaveSuccess(){
              loadAllBillMatxa();
             }
             function onSaveError(){

             }

           }
        }

       vm.cancelTicket = function(billMatxa){
          billMatxa.status = "XOA";
          billMatxa.waiter = vm.currentAccount.login;
          billMatxa.endAt = new Date();
          billMatxa.totalValue = billMatxa.ticket.price - billMatxa.discountValue;
          BillMatxa.update(billMatxa, onSaveSuccess, onSaveError);
             function onSaveSuccess(){
              loadAllBillMatxa();
             }
             function onSaveError(){

             }
       }

       vm.printBillMatxa = function(billMatxa){
        console.log(billMatxa);
          billMatxa.paymentStatus = "DA_IN_VE";
          billMatxa.waiter = vm.currentAccount.login;
          billMatxa.endAt = new Date();
          billMatxa.totalValue = billMatxa.ticket.price - billMatxa.discountValue;
          
          
          BillMatxa.update(billMatxa, onSaveSuccess, onSaveError);
             function onSaveSuccess(){
                $state.go('billMatxa-print-preview',{id:billMatxa.id});
             }
             function onSaveError(){

             }
           
       }

      
        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

        // copy function
        function shallowCopy( original )
        {
            if(original == null || original == 'undefined'){
                return null;
            }
            // First create an empty object with
            // same prototype of our original source
            var clone = Object.create( Object.getPrototypeOf( original ) ) ;

            var i , keys = Object.getOwnPropertyNames( original ) ;

            for ( i = 0 ; i < keys.length ; i ++ )
            {
                // copy each property into the clone
                Object.defineProperty( clone , keys[ i ] ,
                    Object.getOwnPropertyDescriptor( original , keys[ i ] )
                ) ;
            }

            return clone ;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('OrderKaraokeController', OrderKaraokeController);

    OrderKaraokeController.$inject = ['$uibModal','Auth','$timeout','$state','$rootScope','$stateParams', 'Principal',
    'Product', 'ParseLinks', 'AlertService',
     'paginationConstants', 'pagingParams', 'PosSetting', '$http', '$q', '$scope','$localStorage', 
      'Bill','Room'];

    function OrderKaraokeController( $uibModal,Auth, $timeout, $state, $rootScope, $stateParams,Principal,
         Product, ParseLinks, AlertService, paginationConstants, 
        pagingParams, PosSetting, $http, $q, $scope, $localStorage,   Bill ,Room
        ) {

        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        var API_URL = $localStorage.API_URL;
        vm.selectedOrderedProductIndex = null;

        function makePutCall(url,data) {
            return $http.put(vm.apiUrl+url,data)
                .then(function (response) {
                  return response;
                }, function (response) {
                    return $q.reject(response.data);
                });
        };

       Principal.identity().then(function(account) {
            vm.currentAccount = account;
            loadAllRoom();
            loadAllProducts();
        });
       vm.loadAllRoom = loadAllRoom;
       function loadAllRoom(){
                var dataQuery = {
                    storeId: vm.currentAccount.store.id
                };
               
                // get Products
                Room.query(dataQuery, onSuccess, onError);
                function onSuccess(data, headers) {
                    vm.rooms = data.content;
                    //console.log(vm.rooms);
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
       }
       vm.selectRoom = function(room){
           //console.log(room);
           if(room.orderStatus == null || room.orderStatus == 'FINISH'){
             vm.currentOrder = {};
             vm.currentOrder.id= null;
             vm.currentOrder.store = vm.currentAccount.store;
             room.orderStatus = 'INPROGRESS';
             room.orderStartAt = new Date();
             vm.currentOrder.room = room;
             vm.currentOrder.startedAt = room.orderStartAt;
             vm.currentOrder.waiter = vm.currentAccount.login;
             Bill.save(vm.currentOrder, onSuccess,
                    onError);
            function onSuccess(result) {
                vm.currentOrder = result;
                console.log("1");
                console.log(vm.currentOrder);
                loadAllRoom();
            }
            function onError(error) {
                AlertService.error(error.data);
            }
           }else{
                Bill.get({ id: room.orderId  }, onSuccess, onError);
                function onSuccess(data, headers) {
                   vm.currentOrder = data;
                   console.log("2");
                   console.log(vm.currentOrder);
                   loadAllRoom();
                  //console.log(vm.currentOrder);
                }
                function onError(error) {
                    AlertService.error(error);
                }
           }
        }
       function loadAllProducts () {
                var dataQuery = {
                    storeId: vm.currentAccount.store.id
                };
               
                // get Products
                Product.query(dataQuery, onSuccessGetProduct, onErrorGetProduct);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetProduct(data, headers) {
                    vm.products = data.content;
                }
                function onErrorGetProduct(error) {
                    AlertService.error(error.data.message);
                }
        }

        vm.selectProduct = function(product){
            // if(product.quantity >0){
            //     if(vm.currentOrder != null && vm.currentOrder.discountValue <=0){
            //         vm.openModalUpdateProductNumber('ADD', product, null);
            //    }else{
            //       if(vm.currentOrder.discountValue >0){
            //           alert("Không được phép sửa đồ khi giá trị khuyến mại > 0");
            //       }
            //    }
            //   }else{
            //     alert("Kho đã hết mặt hàng này. Không thể chọn");
            //   }  
            // TuanLA Update
          if(product.quantity >0){
            if(vm.currentOrder != null ){
                vm.openModalUpdateProductNumber('ADD', product, null);
            }
          }else{
            alert("Kho đã hết mặt hàng này. Không thể chọn");
          }
           
        }

        vm.changeQuantityProduct = function(orderedProduct){
        //     if(vm.currentOrder != null && vm.currentOrder.discountValue <=0){
        //         vm.openModalUpdateProductNumber('UPDATE', null, orderedProduct);
        //    }else{
        //     if(vm.currentOrder.discountValue >0){
        //         alert("Không được phép sửa đồ khi giá trị khuyến mại > 0");
        //     }
        //    }
        /** Not check discount Tuan LA */
            if(vm.currentOrder != null){
                vm.openModalUpdateProductNumber('UPDATE', null, orderedProduct);
            }

        }

        vm.openModalUpdateProductNumber = function (mode, product, orderedProduct) {
            if(vm.currentOrder != null){
                $uibModal.open({
                  templateUrl: 'app/entities/order-fast-advance/modal-update-product.html',
                  controller: function ($scope, $uibModalInstance) {
                    $scope.productName = null;;
                    if(product != null){
                        $scope.productName = product.productName;
                    }else if(orderedProduct != null){
                        $scope.productName = orderedProduct.name;
                        $scope.number = String(orderedProduct.quantity);
                    }

                    $scope.listNumber = [0,1,2,3,4,5,6,7,8,9];
                    $scope.selectNumber = function(n){
                       if($scope.number == null){
                            $scope.number =  String(n);
                       }else{
                            $scope.number = String($scope.number) + String(n);
                       }
                        
                       var n2 = Number($scope.number);
                        $scope.number = String(n2);   
                        
                    }

                    $scope.deleteNumber = function(){
                         $scope.number = null;
                    }

                    $scope.updateNumber = function(){
                        var updatedProductDTO = {};
                        updatedProductDTO.billId = vm.currentOrder.id;
                        updatedProductDTO.mode = mode;
                        if(mode == 'ADD'){
                            updatedProductDTO.productId = product.id;
                            updatedProductDTO.number = Number($scope.number);
                        }else if(mode == 'UPDATE'){
                            updatedProductDTO.orderedProductId = orderedProduct.orderedProductId;
                            updatedProductDTO.number = Number($scope.number);
                        }
                        

                        makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                            vm.currentOrder = data.data;
                            loadAllProducts();
                            //console.log(data);
                            $uibModalInstance.close(true);
                        },function(error){
                          
                        });
                    }

                    $scope.cancel = function () {
                      $uibModalInstance.dismiss('cancel');
                    };
                  }
                })
                 }
        };

        vm.openModalDiscount = function () {
            if(vm.currentOrder != null){
                $uibModal.open({
                  templateUrl: 'app/entities/order-fast-advance/modal-discount.html',
                  controller: function ($scope, $uibModalInstance) {

                    $scope.listNumber = [0,1,2,3,4,5,6,7,8,9];
                    $scope.selectNumber = function(n){
                       if($scope.number == null){
                            $scope.number =  String(n);
                       }else{
                            $scope.number = String($scope.number) + String(n);
                       }
                        
                       var n2 = Number($scope.number);
                        $scope.number = String(n2);   
                        
                    }

                    $scope.deleteNumber = function(){
                         $scope.number = null;
                    }

                    $scope.discount = function(){
                        var updatedProductDTO = {};
                        updatedProductDTO.billId = vm.currentOrder.id;
                        updatedProductDTO.mode = "DISCOUNT";
                        updatedProductDTO.orderDiscount = Number($scope.number);
                        

                        makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                            vm.currentOrder = data.data;
                            $uibModalInstance.close(true);
                        },function(error){
                        });
                    }

                    $scope.cancel = function () {
                      $uibModalInstance.dismiss('cancel');
                    };
                  }
                })
                 }
        };
       
        vm.selectItem = function(orderedProductId, quantity){
            vm.selectedOrderedProductIndex  = orderedProductId;
            vm.selectedOrderedProductQuantity = quantity;
        }

        vm.deleteSelectedOrderedItem = function(){
            if(vm.currentOrder != null && vm.selectedOrderedProductIndex != null){
                var txt =  "Bạn thực sự muốn xóa đồ này?";
                var r = confirm(txt);
                if (r == true) {
                    var updatedProductDTO = {};
                    updatedProductDTO.billId = vm.currentOrder.id;
                    updatedProductDTO.mode = "DELETE";
                    updatedProductDTO.orderedProductId = vm.selectedOrderedProductIndex;
                    updatedProductDTO.number = Number(vm.selectedOrderedProductQuantity);
                     makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                        vm.currentOrder = data.data;
                        vm.selectedOrderedProductIndex  = null;
                        vm.selectedOrderedProductQuantity = null;    
                        loadAllProducts();   
                    },function(error){
                    });
                 }
            }
        }

        vm.deleteCurrentOrder = function(){
             if(vm.currentOrder != null){
                var txt =  "Bạn thực sự muốn hủy phòng này?";
                var r = confirm(txt);
                if (r == true) {
                    var updatedProductDTO = {};
                    updatedProductDTO.billId = vm.currentOrder.id;
                    updatedProductDTO.mode = "DELETE-ORDER";
                     makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                        alert("Hủy phòng thành công");
                        loadAllRoom();
                        loadAllProducts();
                        vm.currentOrder = null;
                        vm.selectedOrderedProductIndex  = null;
                        vm.selectedOrderedProductQuantity = null;       
                    },function(error){
                    });
                 }
            }
        }

        vm.checkout = function(){
            if(vm.currentOrder != null){
                var txt =  "Bạn thực sự muốn kết thúc và thanh toán phòng này?";
                var r = confirm(txt);
                if (r == true) {
                    var updatedProductDTO = {};
                    updatedProductDTO.billId = vm.currentOrder.id;
                    updatedProductDTO.mode = "CHECKOUT";
                     makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                        vm.currentOrder = null;
                        vm.selectedOrderedProductIndex  = null;
                        vm.selectedOrderedProductQuantity = null;   
                        $state.go('bill-print-preview',{id: data.data.id});
                    },function(error){
                    });
                 }
            }
        }

        vm.discountRoom = function(){
          if(vm.currentOrder != null){
                        var updatedProductDTO = {};
                        updatedProductDTO.billId = vm.currentOrder.id;
                        updatedProductDTO.mode = "DISCOUNT-ROOM";
                        
                       // console.log(updatedProductDTO);
                        makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                            vm.currentOrder = data.data;
                            alert("Đã thiết lập miễn phí giờ hát cho đơn hàng này thành công!");
                        },function(error){
                        });
          }
        }

        vm.cancelDiscountRoom = function(){
          if(vm.currentOrder != null){
                        var updatedProductDTO = {};
                        updatedProductDTO.billId = vm.currentOrder.id;
                        updatedProductDTO.mode = "CANCEL-DISCOUNT-ROOM";
                        
                       // console.log(updatedProductDTO);
                        makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                            vm.currentOrder = data.data;
                            alert("Đã hủy miễn phí giờ hát và thiết lập lại giá phòng hát cho đơn hàng này thành công!");
                        },function(error){
                        });
          }
        }

        vm.changeRoom = function(){
                var dataQuery = {
                    storeId: vm.currentAccount.store.id
                };
                // get Products
                Room.query(dataQuery, onSuccess, onError);
                function onSuccess(data, headers) {
                    vm.rooms = data.content;
                    vm.openModalChangeRoom();
                }
                function onError(error) {
                    AlertService.error(error.data.message);
                }
        }

        vm.openModalChangeRoom = function () {
            if(vm.currentOrder != null){
                $uibModal.open({
                  templateUrl: 'app/entities/order-fast-advance/modal-change-room.html',
                  controller: function ($scope, $uibModalInstance) {


                    $scope.emptyRooms = [];
                    loadEmptyRooms();

                    function loadEmptyRooms(){
                      for(var i=0;i<vm.rooms.length;i++){
                        if(vm.rooms[i].orderStatus != 'INPROGRESS'){
                          $scope.emptyRooms.push(vm.rooms[i]);
                        }
                      }
                    }

                    $scope.selectRoom = function(room){
                        var updatedProductDTO = {};
                        updatedProductDTO.billId = vm.currentOrder.id;
                        updatedProductDTO.mode = "CHANGE-ROOM";
                        updatedProductDTO.targetRoomId = Number(room.id);
                        
                       // console.log(updatedProductDTO);
                        makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                            vm.currentOrder = data.data;
                            vm.loadAllRoom();;
                            $uibModalInstance.close(true);
                        },function(error){
                        });
                    }

                    $scope.cancel = function () {
                      $uibModalInstance.dismiss('cancel');
                    };
                  }
                })
                 }
        };

        
       vm.printBill = function(billId){
        $state.go('bill-print-preview',{id:billId});
       }
        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

        // copy function
        function shallowCopy( original )
        {
            if(original == null || original == 'undefined'){
                return null;
            }
            // First create an empty object with
            // same prototype of our original source
            var clone = Object.create( Object.getPrototypeOf( original ) ) ;

            var i , keys = Object.getOwnPropertyNames( original ) ;

            for ( i = 0 ; i < keys.length ; i ++ )
            {
                // copy each property into the clone
                Object.defineProperty( clone , keys[ i ] ,
                    Object.getOwnPropertyDescriptor( original , keys[ i ] )
                ) ;
            }

            return clone ;
        }




    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-karaoke', {
            parent: 'order-pos',
            url: '/order-karaoke',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Karaoke'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-fast-advance/order-karaoke.html',
                    controller: 'OrderKaraokeController',
                    controllerAs: 'vm'
                }
            },
          
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
       .state('order-matxa', {
            parent: 'order-pos',
            url: '/order-matxa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Karaoke'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order-fast-advance/order-matxa.html',
                    controller: 'OrderMatxaController',
                    controllerAs: 'vm'
                }
            },
          
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('CustomerDialogController', CustomerDialogController);

    CustomerDialogController.$inject = ['$q','$http','$localStorage','JhiLanguageService','Auth','$timeout', '$state','$scope', '$stateParams', 'entity', 'Customer'];

    function CustomerDialogController ($q, $http, $localStorage, JhiLanguageService,  Auth, $timeout,$state, $scope, $stateParams,  entity, Customer) {
        var vm = this;
        vm.customer = entity;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        var makeRestCall   = function (url) {
            return $http.get($localStorage.API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

        

        function save () {
            vm.isSaving = true;
            if (vm.customer.id !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                Customer.save(vm.customer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $state.go('customer');
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.back = function(){
            $state.go('customer');
        }

       
       
       

    }

})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('CustomerDetailController', CustomerDetailController);

    CustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Customer'];

    function CustomerDetailController($scope, $rootScope, $stateParams, previousState, entity, Customer) {
        var vm = this;

        vm.customer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:customerUpdate', function(event, result) {
            vm.customer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('CustomerDeleteController',CustomerDeleteController);

    CustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Customer'];

    function CustomerDeleteController($uibModalInstance, entity, Customer) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Customer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer', {
            parent: 'entity',
            url: '/customer?page&sort&customerName&code&customerPhone&searchValue&orderId',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.customer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customers.html',
                    controller: 'CustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        searchValue: $stateParams.searchValue,
                        customerName: $stateParams.customerName,
                        code: $stateParams.code,
                        customerPhone: $stateParams.customerPhone,
                        orderId: $stateParams.orderId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-detail', {
            parent: 'customer',
            url: '/customer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.customer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customer-detail.html',
                    controller: 'CustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Customer', function($stateParams, Customer) {
                    return Customer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customer-detail.edit', {
            parent: 'customer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer.new', {
            parent: 'customer',
            url: '/new/{orderId}',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                customerName: null,
                                customerAddress: null,
                                customerTaxCode: null,
                                customerPhone: null,
                                customerMail: null,
                                customerType: null,
                                lastUpdateAt: null,
                                id: null
                            };
                }
            }
        })
        .state('customer.edit', {
            parent: 'customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Customer','$stateParams', function(Customer,$stateParams) {
                            return Customer.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('customer.delete', {
            parent: 'customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-delete-dialog.html',
                    controller: 'CustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: 'customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Customer ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdateAt = DateUtils.convertDateTimeFromServer(data.lastUpdateAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();




(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['Auth','Principal','$q','$http','Upload','OrderPos','$timeout','$rootScope','$stateParams','$state', 'Customer', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage'];

    function CustomerController(Auth, Principal, $q, $http, Upload,OrderPos, $timeout, $rootScope, $stateParams,$state, Customer, ParseLinks, AlertService, paginationConstants, pagingParams,$localStorage) {

    	var vm = this;
        vm.$state = $state;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.cleanTransition = cleanTransition;
        vm.itemsPerPage = 50;
        vm.search = {};
       
        loadAll();

        var makeRestCall   = function (url) {
            return $http.get($localStorage.API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

       Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            var dataQuery = {
                pageNo: pagingParams.page,
                pageSize: vm.itemsPerPage,
                sortBy: sort()
            };
            
            if (!angular.isUndefined(pagingParams.searchValue)){
                    dataQuery.searchValue = pagingParams.searchValue;
                    vm.searchData = pagingParams.searchValue;
                
            }
            else{
                if (!angular.isUndefined(pagingParams.customerName)){
                    dataQuery.customerName = pagingParams.customerName;
                    vm.search.customerName = pagingParams.customerName;
                }
               
                if (!angular.isUndefined(pagingParams.customerPhone)){
                    dataQuery.customerPhone = pagingParams.customerPhone;
                    vm.search.customerPhone = pagingParams.customerPhone;
                }
                
               
            
           }
            //console.log(dataQuery);
            Customer.query(dataQuery, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }
            function onSuccess(data, headers) {
                vm.totalItems =data.totalElements;
                vm.queryCount = data.totalElements;
                vm.customers = data.content;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchValue: vm.searchData,
                customerName: vm.search.customerName,
                customerPhone: vm.search.customerPhone
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){
            vm.searchData = null;
            vm.search.customerName = null;
            vm.search.customerPhone  = null;
        
            transition();
        }

         vm.selectCustomer = function(customer){
            vm.currentCustomerId = customer.id;
         }

         
       vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }
    }
})();

(function() {
	'use strict';

	angular.module('xposApp').controller('ConfigDialogController',
			ConfigDialogController);

	ConfigDialogController.$inject = ['$http','Principal', '$timeout', '$scope', '$stateParams','$state','entity', 'Config', 'Upload', '$localStorage'];

	function ConfigDialogController($http, Principal, $timeout, $scope, $stateParams,$state,entity, Config, Upload, $localStorage) {
		var vm = this;
		vm.config = entity;
		//console.log(vm.Config);
		vm.apiUrl = $localStorage.API_URL;
		vm.save = save;
		$timeout(function() {
			angular.element('.form-group:eq(0)>input').focus();
		});


		var makeRestCall   = function (url) {
            return $http.get(vm.apiUrl +url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
        makeRestCall('api/configs/system-string').then(function(data){
              vm.systemConfigs = (data.data);
            },function(error){
        });

		getAccount();
        function getAccount(callback) {
            Principal.identity().then(function (account) {
                vm.account = account;
                // $rootScope.flag = vm.account.langKey;
                vm.isAuthenticated = Principal.isAuthenticated;
                 if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
                 }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
                 }

                 //console.log(vm.account);
                 if(callback != null){
                 	callback();
                 }
            });
        }

		function save() {
			getAccount(_save);

			function _save(){
				vm.isSaving = true;
				if (vm.config.id !== null) {
					Config.update(vm.config, onSaveSuccess, onSaveError);
				} else {
					vm.config.store = vm.account.store;
					Config.save(vm.config, onSaveSuccess, onSaveError);
				}
			}
			
			function onSaveSuccess(result) {
				$state.go('config');
				vm.isSaving = false;
			}

			function onSaveError(result) {
				
				if(result.status == 400){
					alert("Không được phép tạo thiết lập mới trùng tên với thiết lập cũ");
				}
				vm.isSaving = false;
			}
		}

		


		vm.back = function(){
			$state.go('config');
		}

		
	}
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ConfigDetailController', ConfigDetailController);

    ConfigDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Config','$localStorage'];

    function ConfigDetailController($scope, $rootScope, $stateParams, previousState, entity, Config, $localStorage) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.config = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:configUpdate', function(event, result) {
            vm.config = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ConfigDeleteController',ConfigDeleteController);

    ConfigDeleteController.$inject = ['$localStorage','$uibModalInstance', 'entity', 'Config'];

    function ConfigDeleteController($localStorage,  $uibModalInstance, entity, Config) {
        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        
        function confirmDelete (id) {
           Config.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('config', {
            parent: 'entity',
            url: '/config',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.config.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/config/config.html',
                    controller: 'ConfigController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('config-detail', {
            parent: 'config',
            url: '/config/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'xposApp.config.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/config/config-detail.html',
                    controller: 'ConfigDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Config', function($stateParams, Config) {
                    return Config.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'config',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('config-detail.edit', {
            parent: 'config-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/config/config-dialog.html',
                    controller: 'ConfigDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Config','$stateParams', function(Config,$stateParams) {
                            return Config.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('config.new', {
            parent: 'config',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/config/config-dialog.html',
                    controller: 'ConfigDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                            return {
                                configCode: null,
                                configArticalNumber: null,
                                configName: null,
                                configImage: null,
                                configPurchasePrice: null,
                                configSalePrice: null,
                                configCurrencyUnit: null,
                                configType: null,
                                lastUpdate: null,
                                version: null,
                                id: null
                            };
                }
            }
            
        })
        .state('config.edit', {
            parent: 'config',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/config/config-dialog.html',
                    controller: 'ConfigDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['Config','$stateParams', function(Config,$stateParams) {
                            return Config.get({id : $stateParams.id}).$promise;
                }]
            }
            
        })
        .state('config.delete', {
            parent: 'config',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/config/config-delete-dialog.html',
                    controller: 'ConfigDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Config', function(Config) {
                            return Config.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('config', null, { reload: 'config' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
       ;
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Config', Config);

    Config.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Config ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ConfigController', ConfigController);

    ConfigController.$inject = ['Auth','Principal','$q','Upload','$timeout','$rootScope','$stateParams','$state', 'Config', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$localStorage','$http'];

    function ConfigController(Auth, Principal, $q,Upload, $timeout, $rootScope, $stateParams, $state, Config, ParseLinks, AlertService, paginationConstants, pagingParams, $localStorage, $http) {

        var vm = this;
        vm.$state = $state;
        vm.apiUrl = $localStorage.API_URL;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 100;
        vm.cleanTransition = cleanTransition;
        vm.search = {};
       

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            loadAll();
           
        });


        
        function loadAll () {
        	var dataQuery = {
                   storeId : vm.currentAccount.store.id
                };
               
                // get Configs
                Config.query(dataQuery, onSuccessGetConfig, onErrorGetConfig);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetConfig(data, headers) {
                    vm.totalItems =data.totalElements;
                    vm.queryCount = data.totalElements;
                    vm.configs = data.content;
                    vm.page = pagingParams.page;
                }
                function onErrorGetConfig(error) {
                    AlertService.error(error.data.message);
                }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var query = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            }
            
            $state.transitionTo($state.$current, query);
        }
        
        function cleanTransition(){

        	transition();
        }


        vm.selectConfig = function(config){
            vm.currentConfigId = config.id;
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('BillMatxaPrintPreviewController', BillMatxaPrintPreviewController);

    BillMatxaPrintPreviewController.$inject = ['entity','Principal','$timeout','$scope','$rootScope','$state', 'BillMatxa', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','PosSetting','$http', '$q', '$localStorage','DateUtils'];

    function BillMatxaPrintPreviewController(entity, Principal, $timeout, $scope, $rootScope, $state, BillMatxa, ParseLinks, AlertService, paginationConstants, pagingParams, PosSetting,$http, $q, $localStorage,DateUtils) {

    	 var vm = this;
         vm.apiUrl = $localStorage.API_URL;
         vm.billMatxa = entity;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            vm.store = vm.currentAccount.store;
            //console.log(vm.store);
        });


        vm.back = function(){
             $state.go('order-matxa');
        }

        vm.print = function(){
            window.print();
            $state.go('order-matxa');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('BillMatxaDetailController', BillMatxaDetailController);

    BillMatxaDetailController.$inject = ['$timeout','$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BillMatxa', 'Customer'];

    function BillMatxaDetailController($timeout, $scope, $rootScope, $stateParams, previousState, entity, BillMatxa, Customer) {
        var vm = this;

        vm.billMatxa = entity;
        //console.log(vm.billMatxa);
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:billMatxaUpdate', function(event, result) {
            vm.billMatxa = result;

        });
        $scope.$on('$destroy', unsubscribe);
/*
         vm.reFocus =reFocus;
        function reFocus(){
            angular.element('#input_focus').focus();
        }
        $timeout(function (){
            vm.reFocus();
        });
        */
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('billMatxa', {
            parent: 'entity',
            url: '/billMatxa?page&sort&search&tablePos&waiter&customer&products&searchFrom&searchTo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.billMatxa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billMatxa/billMatxas.html',
                    controller: 'BillMatxaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchFrom: $stateParams.searchFrom,
                        searchTo: $stateParams.searchTo,
                        tablePos: $stateParams.tablePos,
                        waiter: $stateParams.waiter,
                        customer: $stateParams.customer,
                        products: $stateParams.products
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('billMatxa-edit', {
            parent: 'entity',
            url: '/billMatxa-edit?page&sort&search&tablePos&waiter&customer&products&searchFrom&searchTo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.billMatxa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billMatxa/billMatxa-edit.html',
                    controller: 'BillMatxaEditController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchFrom: $stateParams.searchFrom,
                        searchTo: $stateParams.searchTo,
                        tablePos: $stateParams.tablePos,
                        waiter: $stateParams.waiter,
                        customer: $stateParams.customer,
                        products: $stateParams.products
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('billMatxa-detail', {
            parent: 'billMatxa',
            url: '/billMatxa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.billMatxa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billMatxa/billMatxa-detail.html',
                    controller: 'BillMatxaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BillMatxa', function($stateParams, BillMatxa) {
                    return BillMatxa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'billMatxa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        }).state('billMatxa-print-preview', {
            parent: 'billMatxa',
            url: '/billMatxa-print-preview/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.billMatxa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billMatxa/billMatxa-print-preview.html',
                    controller: 'BillMatxaPrintPreviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BillMatxa', function($stateParams, BillMatxa) {
                    return BillMatxa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'billMatxa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('BillMatxa', BillMatxa);

    BillMatxa.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function BillMatxa ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/billMatxas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false,params: {searchFrom: null, searchTo: null}},
            'get': {
                method: 'GET',
                params: {searchFrom: null, searchTo: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertDateTimeFromServer(data.startedAt);
                        data.endAt = DateUtils.convertDateTimeFromServer(data.endAt);
                        data.createAt = DateUtils.convertDateTimeFromServer(data.createAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('BillMatxaController', BillMatxaController);

    BillMatxaController.$inject = ['Store','Auth','Principal','$timeout','$scope','$rootScope','$state', 'BillMatxa', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','PosSetting','$http', '$q', '$localStorage','DateUtils','User'];

    function BillMatxaController(Store,Auth, Principal, $timeout, $scope, $rootScope, $state, BillMatxa, ParseLinks, AlertService, paginationConstants, pagingParams, PosSetting,$http, $q, $localStorage,DateUtils, User) {

    	 var vm = this;
         vm.apiUrl = $localStorage.API_URL;
         vm.$state = $state;

         vm.dateformat = 'dd-MM-yyyy';
       
         vm.printBillMatxa = printBillMatxa;
         vm.search = {};
         vm.loadAll = loadAll;
        

        vm.dateSearch = new Date();
        vm.dateSearch.setHours(0);
        vm.dateSearch.setMinutes(0);
        vm.dateSearch.setSeconds(0);

        vm.dateTo = new Date();
         vm.dateTo.setHours(0);
        vm.dateTo.setMinutes(0);
        vm.dateTo.setSeconds(0);

        Principal.identity().then(function(account) {
            vm.account = account;
            if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
            }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
             }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
             }

            vm.filterStore = vm.account.store;
            loadAll();
            loadAllStore();
           
        });

         $scope.open1 = function() {
            $scope.popup1.opened = true;
          };

        $scope.popup1 = {
            opened: false
          };

           $scope.open2 = function() {
            $scope.popup2.opened = true;
          };

        $scope.popup2 = {
            opened: false
          };



        var makeRestCall   = function (url) {

            return $http.get(vm.apiUrl +url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
       
        
      

        function printBillMatxa(billMatxaId){
            
           $state.go('billMatxa-print-preview',{id:billMatxaId});
           
        }

         function loadAll () {
            var searchFrom = new Date(vm.dateSearch);
            var searchTo = new Date(vm.dateTo);

         	var dataQuery = {
                     searchFrom: searchFrom,
                     searchTo: searchTo,
                     sortBy: sort()
                 };
                 if(vm.filterStore.id != 1){
                    dataQuery.storeId =  vm.filterStore.id;
                 }
                
                 // get BillMatxas
                 BillMatxa.query(dataQuery, onSuccessGetBillMatxa, onErrorGetBillMatxa);
                 function sort() {
                     var result = ['id:desc'];
                     return result;
                 }
                 function onSuccessGetBillMatxa(data, headers) {
                     vm.billMatxas = data.content;
                     //console.log(vm.billMatxas);
                     // for computing report
                     computeReport(vm.billMatxas);
                     


                 }
                 function onErrorGetBillMatxa(error) {
                     AlertService.error(error);
                 }
         }

        function computeReport(billMatxas){
            vm.time = new Date();
            vm.billMatxaCount = billMatxas.length;
            vm.totalMoney = 0;
            vm.totalMoneyDelete = 0;

            vm.products = [];
            for(var i=0;i< billMatxas.length; i++){
                if(billMatxas[i].status == 'THANH_CONG'){
                   vm.totalMoney += billMatxas[i].totalValue;             
                }else  if(billMatxas[i].status == 'XOA'){
                    vm.totalMoneyDelete += billMatxas[i].totalValue;
                }

                if(billMatxas[i].status == 'THANH_CONG'){
                        var exist = false;
                        for(var t=0;t<vm.products.length;t++){
                            if(vm.products[t].type == billMatxas[i].ticket.type){
                                exist = true;
                                vm.products[t].count += 1;
                                vm.products[t].totalMoney += billMatxas[i].totalValue;

                            }
                        }
                        if(exist == false){
                            var p = {};
                            p.type = billMatxas[i].ticket.type;
                            p.count = 1;
                            p.totalMoney = billMatxas[i].totalValue;
                            vm.products.push(p);
                        }
                   
                }
            }
            //console.log(vm.totalMoney);
         }
         vm.loadAllStore = loadAllStore;
         function loadAllStore(){
                 var dataQuery = {
                 };
                 // get BillMatxas
                 Store.query(dataQuery, onSuccess, onError);
                 
                 function onSuccess(data, headers) {
                     vm.stores = data.content;
                    //console.log(vm.stores);
                 }
                 function onError(error) {
                     AlertService.error(error);
                 }
         }
   
        vm.resetList = resetList;
        function resetList(){
            loadAll();
        }

        vm.gotoDetail = function(id){
            $state.go('billMatxa-detail',{id:id});
        }

        vm.deleteBillMatxa = function(billMatxa){
              var txt =  "Bạn thực sự muốn xoá vé này?";
              var r = confirm(txt);
              if (r == true) {
                billMatxa.status = 'XOA';
                BillMatxa.update(billMatxa, onSaveSuccess, onSaveError);
                 function onSaveSuccess(){
                  loadAll();
                 }
                 function onSaveError(){

                 }
            }
        }
         
         vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('BillPrintPreviewController', BillPrintPreviewController);

    BillPrintPreviewController.$inject = ['entity','Principal','$timeout','$scope','$rootScope','$state', 'Bill', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','PosSetting','$http', '$q', '$localStorage','DateUtils'];

    function BillPrintPreviewController(entity, Principal, $timeout, $scope, $rootScope, $state, Bill, ParseLinks, AlertService, paginationConstants, pagingParams, PosSetting,$http, $q, $localStorage,DateUtils) {

    	 var vm = this;
         vm.apiUrl = $localStorage.API_URL;
         vm.bill = entity;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            vm.store = vm.bill.store;
             //console.log(vm.store);
        });



     
       

        vm.back = function(){
             $state.go('order-karaoke');
        }

        vm.print = function(){
            window.print();
            $state.go('order-karaoke');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('BillDetailController', BillDetailController);

    BillDetailController.$inject = ['$timeout','$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Bill', 'Customer'];

    function BillDetailController($timeout, $scope, $rootScope, $stateParams, previousState, entity, Bill, Customer) {
        var vm = this;

        vm.bill = entity;
        //console.log(vm.bill);
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('xposApp:billUpdate', function(event, result) {
            vm.bill = result;

        });
        $scope.$on('$destroy', unsubscribe);
/*
         vm.reFocus =reFocus;
        function reFocus(){
            angular.element('#input_focus').focus();
        }
        $timeout(function (){
            vm.reFocus();
        });
        */
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bill', {
            parent: 'entity',
            url: '/bill?page&sort&search&tablePos&waiter&customer&products&searchFrom&searchTo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.bill.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bill/bills.html',
                    controller: 'BillController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchFrom: $stateParams.searchFrom,
                        searchTo: $stateParams.searchTo,
                        tablePos: $stateParams.tablePos,
                        waiter: $stateParams.waiter,
                        customer: $stateParams.customer,
                        products: $stateParams.products
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bill-edit', {
            parent: 'entity',
            url: '/bill-edit?page&sort&search&tablePos&waiter&customer&products&searchFrom&searchTo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.bill.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bill/bill-edit.html',
                    controller: 'BillEditController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchFrom: $stateParams.searchFrom,
                        searchTo: $stateParams.searchTo,
                        tablePos: $stateParams.tablePos,
                        waiter: $stateParams.waiter,
                        customer: $stateParams.customer,
                        products: $stateParams.products
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bill-detail', {
            parent: 'bill',
            url: '/bill/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.bill.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bill/bill-detail.html',
                    controller: 'BillDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Bill', function($stateParams, Bill) {
                    return Bill.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'bill',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        }).state('bill-print-preview', {
            parent: 'bill',
            url: '/bill-print-preview/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'xposApp.bill.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bill/bill-print-preview.html',
                    controller: 'BillPrintPreviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Bill', function($stateParams, Bill) {
                    return Bill.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'bill',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('Bill', Bill);

    Bill.$inject = ['$resource', 'DateUtils', '$localStorage'];

    function Bill ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/bills/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false,params: {searchFrom: null, searchTo: null}},
            'get': {
                method: 'GET',
                params: {searchFrom: null, searchTo: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertDateTimeFromServer(data.startedAt);
                        data.endAt = DateUtils.convertDateTimeFromServer(data.endAt);
                        data.createAt = DateUtils.convertDateTimeFromServer(data.createAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('BillController', BillController);

    BillController.$inject = ['Store','Auth','Principal','$timeout','$scope','$rootScope','$state', 'Bill', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','PosSetting','$http', '$q', '$localStorage','DateUtils','User'];

    function BillController(Store,Auth, Principal, $timeout, $scope, $rootScope, $state, Bill, ParseLinks, AlertService, paginationConstants, pagingParams, PosSetting,$http, $q, $localStorage,DateUtils, User) {

    	 var vm = this;
         vm.apiUrl = $localStorage.API_URL;
         vm.$state = $state;

         vm.dateformat = 'dd-MM-yyyy';
       
         vm.printBill = printBill;
         vm.search = {};
         vm.loadAll = loadAll;
        

        vm.dateSearch = new Date();
        vm.dateSearch.setHours(0);
        vm.dateSearch.setMinutes(0);
        vm.dateSearch.setSeconds(0);

        vm.dateTo = new Date();
         vm.dateTo.setHours(0);
        vm.dateTo.setMinutes(0);
        vm.dateTo.setSeconds(0);

        function makePutCall(url,data) {
            return $http.put(vm.apiUrl+url,data)
                .then(function (response) {
                  return response;
                }, function (response) {
                    return $q.reject(response.data);
                });
        };

        Principal.identity().then(function(account) {
            vm.account = account;
            if(vm.account.authorities.includes("ROLE_SUPER_ADMIN")){
                    vm.currentRole = 'ROLE_SUPER_ADMIN';
            }else if(vm.account.authorities.includes("ROLE_ADMIN")){
                    vm.currentRole = 'ROLE_ADMIN';
             }else if(vm.account.authorities.includes("ROLE_USER")){
                    vm.currentRole = 'ROLE_USER';
             }

            vm.filterStore = vm.account.store;
            loadAll();
            loadAllStore();
           
        });

         $scope.open1 = function() {
            $scope.popup1.opened = true;
          };

        $scope.popup1 = {
            opened: false
          };

           $scope.open2 = function() {
            $scope.popup2.opened = true;
          };

        $scope.popup2 = {
            opened: false
          };



        var makeRestCall   = function (url) {

            return $http.get(vm.apiUrl +url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
       
        
      

        function printBill(billId){
            
           $state.go('bill-print-preview',{id:billId});
           
        }

         function loadAll () {
            var searchFrom = new Date(vm.dateSearch);
            var searchTo = new Date(vm.dateTo);

         	var dataQuery = {
                     searchFrom: searchFrom,
                     searchTo: searchTo,
                     sortBy: sort()
                 };
                 if(vm.filterStore.id != 1){
                    dataQuery.storeId =  vm.filterStore.id;
                 }
                
                 // get Bills
                 Bill.query(dataQuery, onSuccessGetBill, onErrorGetBill);
                 function sort() {
                     var result = ['id:desc'];
                     return result;
                 }
                 function onSuccessGetBill(data, headers) {
                     vm.bills = data.content;
                     //console.log(vm.bills);
                     // for computing report
                     computeReport(vm.bills);
                     


                 }
                 function onErrorGetBill(error) {
                     AlertService.error(error);
                 }
         }

        function computeReport(bills){
            vm.time = new Date();
            vm.billCount = bills.length;
            vm.totalMoney = 0;
            vm.totalInputMoney = 0;
            vm.totalMoneyDelete = 0;
            vm.totalMoneyProduct = 0;
            vm.totalInputMoneyProduct = 0;
            vm.totalProduct = 0;

            vm.products = [];
            for(var i=0;i< bills.length; i++){
                if(bills[i].status == 'FINISH'){
                   vm.totalMoney += bills[i].totalValue;       
                }else  if(bills[i].status == 'DELETE'){
                    vm.totalMoneyDelete += bills[i].totalValue;
                }

                if(bills[i].status == 'FINISH'){
                    var listProducts = bills[i].listProducts;
                    for(var j=0;j<listProducts.length;j++){
                        var exist = false;
                        for(var t=0;t<vm.products.length;t++){
                            if(vm.products[t].productId == listProducts[j].productId){
                                exist = true;
                                vm.products[t].count += listProducts[j].quantity;
                                vm.products[t].totalMoney += listProducts[j].totalMoney;

                                vm.products[t].inputMoney += listProducts[j].inputMoney;
                            }
                        }
                        if(exist == false){
                            var p = {};
                            p.productId = listProducts[j].productId;
                            p.name = listProducts[j].name;
                            p.count = listProducts[j].quantity;
                            p.inputMoney = listProducts[j].inputMoney;
                            p.totalMoney = listProducts[j].totalMoney;
                            vm.products.push(p);
                        }
                    }
                    
                }
            }
            for(var i=0;i<vm.products.length;i++){
                vm.totalMoneyProduct += vm.products[i].totalMoney;
                vm.totalInputMoneyProduct += vm.products[i].inputMoney;
                vm.totalProduct += vm.products[i].count;
            }
            //console.log(vm.totalMoney);
         }
         vm.loadAllStore = loadAllStore;
         function loadAllStore(){
                 var dataQuery = {
                 };
                 // get Bills
                 Store.query(dataQuery, onSuccess, onError);
                 
                 function onSuccess(data, headers) {
                     vm.stores = data.content;
                    //console.log(vm.stores);
                 }
                 function onError(error) {
                     AlertService.error(error);
                 }
         }
   
        vm.resetList = resetList;
        function resetList(){
            loadAll();
        }

        vm.gotoDetail = function(id){
            $state.go('bill-detail',{id:id});
        }
         
         vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }

        vm.deleteBill = function(bill){
            if(bill.status != 'DELETE'){
                var txt =  "Bạn thực sự muốn đơn hàng này?";
                var r = confirm(txt);
                if (r == true) {
                    var updatedProductDTO = {};
                    updatedProductDTO.billId = bill.id;
                    updatedProductDTO.mode = "DELETE-ORDER";
                     makePutCall('api/bills/update-product',updatedProductDTO).then(function(data){
                        alert("Xóa đơn hàng "+updatedProductDTO.billCode+" thành công.");
                        loadAll();
                    },function(error){
                    });
                 }
            }
            
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('xposApp')
        .factory('storageService', storageService);

    function storageService () {

        return {
            get: function(key) {
                return localStorage.getItem(key);
            },
            set: function(key, data) {
                localStorage.setItem(key, data);
            },
            put: function(key, data){
                localStorage.setItem(key, data);
            }
        };        
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('xposApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('ngEnter', ngEnter);

     function ngEnter() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if(event.which === 13) {
                        scope.$apply(function(){
                                scope.$eval(attrs.ngEnter);
                        });
                        event.preventDefault();
                }
            });
        };
    }
})();



(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('mAppLoading', mAppLoading);
    mAppLoading.$inject = ['$animate'];
     function mAppLoading($animate) {
        return({
                    link: link,
                    restrict: "C"
                }); 
        function link( scope, element, attributes ) {
            $animate.leave( element.children().eq( 1 ) ).then(
                function cleanupAfterAnimation() {
                    element.remove();
                    scope = element = attributes = null;
                }
            );
        }
    }
})();



(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('xposApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('fallbackSrc', fallbackSrc);

     function fallbackSrc() {
        var fallbackSrc = {
            link: function postLink(scope, iElement, iAttrs) {
            iElement.bind('error', function() {
                angular.element(this).attr("src", iAttrs.fallbackSrc);
            });
            }
        }
        return fallbackSrc;
    }
})();



(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('xposApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent,
            getKeyboard: getKeyboard
        };
        return service;
        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }

        function getKeyboard(){
           var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');
            if ( language == "en"){
                //return "ms-US-International";
                return "ms-German (IBM)";
            } else if(language == "vi")  {
                //return "ms-Vietnamese";
                return "ms-German (IBM)";
            } else {
                return "ms-German (IBM)";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
         'en': { name: 'English' },
        'de': { name: 'Deutsch' },
        'vi': { name: '中国' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale', '$rootScope', '$window'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale, $rootScope, $window) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
            $rootScope.$broadcast('languageChange', {key : languageKey});
            localStorage["jhi-isFirstApp"] = "No";
            $window.location.reload();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'de',
            'vi'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('xposApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('xposApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('xposApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('xposApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('xposApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$localStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION','RegisterAppSrevice'];

    function stateHandler($rootScope, $state, $localStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION, RegisterAppSrevice) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;
            
            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;


                ////RegisterAppSrevice.initialize(toState.url);
                if($localStorage.API_URL == null || $localStorage.API_URL.length == 0 || $localStorage.API_URL == 'null'){
                    console.log("rewrite API_URL");
                    $localStorage.API_URL = "http://localhost:9090/";
                    $localStorage.API_URL_VAL = "localhost:9090";
                }
              


                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('keyboardHandler', keyboardHandler);

    keyboardHandler.$inject = ['$rootScope', '$state', '$localStorage'];

    function keyboardHandler($rootScope, $state, $localStorage ) {
        return {
            initialize: initialize
        };

        function initialize() {
            // if (angular.isUndefined($localStorage.API_URL_VAL)){
               // $localStorage.API_URL_VAL = "pos.myphamshuface.vn";
               // $localStorage.API_URL = "https://pos.myphamshuface.vn/";
               
                //$localStorage.API_URL_VAL = "127.0.0.1:9090";
                //$localStorage.API_URL = "http://127.0.0.1:9090/";

               $localStorage.API_URL_VAL = "thuthanhminh.com";
               $localStorage.API_URL = "https://thuthanhminh.com/";

                
            // } 
            if (angular.isUndefined($localStorage.setting)){
                $localStorage.setting = {};
                if (angular.isUndefined($localStorage.virtualkeyboard))
                $localStorage.setting.virtualkeyboard = false;
            }
            };

        }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES', 'storageService'];

    function translationStorageProvider($cookies, $log, LANGUAGES, storageService ) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            // if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
            if (LANGUAGES.indexOf(storageService.get(name)) === -1) {
                // $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                //$cookies.putObject(name, 'de');
                storageService.put(name,'en');
            }
            // return $cookies.getObject(name);
            return storageService.get(name);
        }

        function put(name, value) {
            // $cookies.putObject(name, value);
            storageService.put(name,value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        // console.log($translateProvider);
        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        // tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.useStorage('storageService');
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(keyboardConfig);

    keyboardConfig.$inject = ['VKI_CONFIG'];

    function keyboardConfig(VKI_CONFIG) {
        // set below to true to make alerts look like toast
    	VKI_CONFIG.position = {
			of: 'body',
			my: 'center top',
			at: 'center bottom',
			at2: 'center bottom'
		};
		VKI_CONFIG.tabNavigation = true;
		VKI_CONFIG.css = {
			container: 'blue-grey darken-1',
			buttonDefault: 'btn waves-effect waves-light',
			buttonHover: 'orange',
			buttonAction: 'orange',
			buttonActive: 'orange',
			buttonDisabled: 'disabled'
		};
		VKI_CONFIG.extensions = {
			addTyping: false
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider',  '$urlMatcherFactoryProvider'];

    // function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        function httpConfig($urlRouterProvider, $httpProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        // httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'leftmenu@': {
                    templateUrl: 'app/layouts/navbar/leftmenu.html',
                    controller: 'LeftMenuController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

//"use strict"
/**
 * Resize function without multiple trigger
 *
 * Usage:
 * $(window).smartresize(function(){
 *     // code here
 * });
 */
(function ($, sr) {
    // debouncing function from John Hann
    // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    var debounce = function (func, threshold, execAsap) {
        var timeout;

        return function debounced() {
            var obj = this, args = arguments;
            function delayed() {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            }

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    };

    // smartresize
    jQuery.fn[sr] = function (fn) {
        return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
    };

})(jQuery, 'smartresize');
/**
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var CURRENT_URL = window.location.href.split('#')[0].split('?')[0],
        BASE_URL = 'http://localhost:9000/',
        $BODY = $('body'),
        $MENU_TOGGLE = $('#menu_toggle'),
        $SIDEBAR_MENU = $('#sidebar-menu'),
        $SIDEBAR_FOOTER = $('.sidebar-footer'),
        $LEFT_COL = $('.left_col'),
        $RIGHT_COL = $('.right_col'),
        $NAV_MENU = $('.nav_menu'),
        $FOOTER = $('footer');

// Sidebar
$(document).ready(function () {
    // TODO: This is some kind of easy fix, maybe we can improve this
    var setContentHeight = function () {
        // reset height
        $RIGHT_COL.css('min-height', $(window).height() + 150);

        var bodyHeight = $BODY.outerHeight(),
                footerHeight = $BODY.hasClass('footer_fixed') ? -10 : $FOOTER.height(),
                leftColHeight = $LEFT_COL.eq(1).height() + $SIDEBAR_FOOTER.height(),
                contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

        // normalize content
        contentHeight -= $NAV_MENU.height() + footerHeight;

        $RIGHT_COL.css('min-height', contentHeight);
    };

    $SIDEBAR_MENU.find('a').on('click', function (ev) {
        var $li = $(this).parent();

        if ($li.is('.active')) {
            $li.removeClass('active active-sm');
            $('ul:first', $li).slideUp(function () {
                setContentHeight();
            });
        } else {
            // prevent closing menu if we are on child menu
            if (!$li.parent().is('.child_menu')) {
                $SIDEBAR_MENU.find('li').removeClass('active active-sm');
                $SIDEBAR_MENU.find('li ul').slideUp();
            }

            $li.addClass('active');

            $('ul:first', $li).slideDown(function () {
                setContentHeight();
            });
        }
    });

    // toggle small or large menu
    $MENU_TOGGLE.on('click', function () {
        if ($BODY.hasClass('nav-md')) {
            $SIDEBAR_MENU.find('li.active ul').hide();
            $SIDEBAR_MENU.find('li.active').addClass('active-sm').removeClass('active');
        } else {
            $SIDEBAR_MENU.find('li.active-sm ul').show();
            $SIDEBAR_MENU.find('li.active-sm').addClass('active').removeClass('active-sm');
        }

        $BODY.toggleClass('nav-md nav-sm');

        setContentHeight();
    });

    // check active menu
    $SIDEBAR_MENU.find('a[href="' + CURRENT_URL + '"]').parent('li').addClass('current-page');

    $SIDEBAR_MENU.find('a').filter(function () {
        return this.href == CURRENT_URL;
    }).parent('li').addClass('current-page').parents('ul').slideDown(function () {
        setContentHeight();
    }).parent().addClass('active');

    // recompute content when resizing
    $(window).smartresize(function () {
        setContentHeight();
    });

    setContentHeight();

    // fixed sidebar
    if ($.fn.mCustomScrollbar) {
        $('.menu_fixed').mCustomScrollbar({
            autoHideScrollbar: true,
            theme: 'minimal',
            mouseWheel: {preventDefault: true}
        });
    }
});
// /Sidebar

// Panel toolbox
$(document).ready(function () {
    $('.collapse-link').on('click', function () {
        var $BOX_PANEL = $(this).closest('.x_panel'),
                $ICON = $(this).find('i'),
                $BOX_CONTENT = $BOX_PANEL.find('.x_content');

        // fix for some div with hardcoded fix class
        if ($BOX_PANEL.attr('style')) {
            $BOX_CONTENT.slideToggle(200, function () {
                $BOX_PANEL.removeAttr('style');
            });
        } else {
            $BOX_CONTENT.slideToggle(200);
            $BOX_PANEL.css('height', 'auto');
        }

        $ICON.toggleClass('fa-chevron-up fa-chevron-down');
    });

    $('.close-link').click(function () {
        var $BOX_PANEL = $(this).closest('.x_panel');

        $BOX_PANEL.remove();
    });
});
// /Panel toolbox

// Tooltip
// $(document).ready(function () {
//     $('[data-toggle="tooltip"]').tooltip({
//         container: 'body'
//     });
// });
// /Tooltip


// Switchery
$(document).ready(function () {
    if ($(".js-switch")[0]) {
        var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
        elems.forEach(function (html) {
            var switchery = new Switchery(html, {
                color: '#26B99A'
            });
        });
    }
});
// /Switchery

// iCheck
$(document).ready(function () {
    if ($("input.flat")[0]) {
        $(document).ready(function () {
            $('input.flat').iCheck({
                checkboxClass: 'icheckbox_flat-green',
                radioClass: 'iradio_flat-green'
            });
        });
    }
});
// /iCheck
var checkState = '';
// Table
$('table input').on('ifChecked', function () {
    checkState = '';
    $(this).parent().parent().parent().addClass('selected');
    countChecked();
});
$('table input').on('ifUnchecked', function () {
    checkState = '';
    $(this).parent().parent().parent().removeClass('selected');
    countChecked();
});



$('.bulk_action input').on('ifChecked', function () {
    checkState = '';
    $(this).parent().parent().parent().addClass('selected');
    countChecked();
});
$('.bulk_action input').on('ifUnchecked', function () {
    checkState = '';
    $(this).parent().parent().parent().removeClass('selected');
    countChecked();
});
$('.bulk_action input#check-all').on('ifChecked', function () {
    checkState = 'all';
    countChecked();
});
$('.bulk_action input#check-all').on('ifUnchecked', function () {
    checkState = 'none';
    countChecked();
});

function countChecked() {
    if (checkState === 'all') {
        $(".bulk_action input[name='table_records']").iCheck('check');
    }
    if (checkState === 'none') {
        $(".bulk_action input[name='table_records']").iCheck('uncheck');
    }

    var checkCount = $(".bulk_action input[name='table_records']:checked").length;

    if (checkCount) {
        $('.column-title').hide();
        $('.bulk-actions').show();
        $('.action-cnt').html(checkCount + ' Records Selected');
    } else {
        $('.column-title').show();
        $('.bulk-actions').hide();
    }
}

// Accordion
$(document).ready(function () {
    $(".expand").on("click", function () {
        $(this).next().slideToggle(200);
        $expand = $(this).find(">:first-child");

        if ($expand.text() == "+") {
            $expand.text("-");
        } else {
            $expand.text("+");
        }
    });
});


// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = (function () {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}
function hideChildMenu(option){
    if ($('#menu-hidden').val()==0)
        $(option).parent().parent().css('display','none');
}
if (!String.prototype.endsWith)
  String.prototype.endsWith = function(searchStr, Position) {
      // This works much better than >= because
      // it compensates for NaN:
      if (!(Position < this.length))
        Position = this.length;
      else
        Position |= 0; // round position
      return this.substr(Position - searchStr.length,
                         searchStr.length) === searchStr;
  };

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('xposApp')
        .constant('VERSION', "0.0.0")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1562129750189)
;
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['Store','$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController (Store, $stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

         vm.authorities = ['ROLE_USER','ROLE_ADMIN', 'ROLE_SUPER_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        getAllStore();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError (data) {
            vm.isSaving = false;
            alert(data.statusText);
        }

        function save () {
            vm.isSaving = true;
            vm.user.langKey = 'en';
            if (vm.user.id !== null) {
                 console.log(vm.user);
                User.update(vm.user, onSaveSuccess, onSaveError);

            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function getAllStore(){
                var dataQuery = {
                   active: 1
                };

                // get Stores
                Store.query(dataQuery, onSuccessGetStore, onErrorGetStore);
                function sort() {
                    var result = [vm.predicate + ':' + (vm.reverse ? 'asc' : 'desc')];
                    return result;
                }
                function onSuccessGetStore(data, headers) {
                     vm.stores = data.content;
                    
                }
                function onErrorGetStore(error) {
                    AlertService.error(error.data.message);
                }
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
                console.log(vm.user);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Auth','Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Auth, Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER','ROLE_ADMIN', 'ROLE_SUPER_ADMIN'];
        vm.$state = $state;
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.totalItems =data.totalElements;
            vm.queryCount = data.totalElements;
            vm.users = data.content;
            //console.log(vm.users);
        }

        function onError(error) {
            AlertService.error(error.data);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.logout = function() {
            Auth.logout();
            $state.go('home');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('adminsettings', {
            parent: 'admin',
            url: '/admin/settings',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPER_USER'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/settings/settings.html',
                    controller: 'SettingAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('SettingAdminService', SettingAdminService);

    SettingAdminService.$inject = ['$resource', '$localStorage', '$http'];

    function SettingAdminService ($resource,  $localStorage, $http) {
        var service = {
            getSeting : getSeting,
            getOptionSetting : getOptionSetting,
            updateSetting : updateSetting,
            getHardisks : getHardisks
        }
        var API_URL = $localStorage.API_URL;
        var setting = [];

        function getHardisks () {
            return $http.get(API_URL+'api/command/getHardisks').then(getHardiskComplete);

            function getHardiskComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                return properties;
            }
        }
        function getSeting(){
            var settingTmp =  $localStorage.setting;
            if (angular.isUndefined(setting)) settingTmp =  setting;
            return setting;
        };

        function getOptionSetting(key){
            return setting[key];
        };

        function updateSetting(setting){
            console.log(setting);
           $localStorage.setting = setting;
        } 

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('SettingAdminController', SettingAdminController);

    SettingAdminController.$inject = ['$scope', '$filter', 'SettingAdminService', 'ParseLinks',
    '$localStorage', '$window', 'PosSetting','$http', '$q','Principal'];

    function SettingAdminController ($scope, $filter, SettingAdminService, ParseLinks,
                                     $localStorage, $window, PosSetting ,$http, $q,Principal) {
        var vm = this;
        vm.setting = {
            virtualkeyboard : false,
            customerCode: "Test",
            diskSetting:"",
            teamViewerPath:"",
            twoMonitors: false

        };
        vm.hiddenHardiskSetting = true;
        vm.diskSetting = "";
        vm.diskObject ;
        vm.customerCodeObject;
        vm.showSuperSettingContent = false;

        initSetting ();

        function initSetting() {
            if (!angular.isUndefined(vm.setting)){
                vm.setting = $localStorage.setting;

                if(vm.setting.twoMonitors == "yes"){
                    vm.setting.twoMonitors = true;
                }
                if(vm.setting.twoMonitors == "no"){
                    vm.setting.twoMonitors = false;
                }

               
            }


            SettingAdminService.getHardisks().then(function(hardisks){
                vm.setting.hardisks = hardisks;
                //console.log(hardisks);
                vm.hiddenHardiskSetting = false;
                if (hardisks.length ==0){
                    vm.hiddenHardiskSetting = true;
                }

            },function(){
                vm.setting.hardisks = [];
                vm.hiddenHardiskSetting = true;
            });



            makeRestCall('api/setting?type=PRINT_DRINK').then(function(data){
                        vm.printDrink = data.data;
                        if(vm.printDrink != null){
                            if(vm.printDrink.setting == '1') vm.printDrink.setting = true;
                            if(vm.printDrink.setting == '0') vm.printDrink.setting = false;
                        }

                    },function(error){
            });

            makeRestCall('api/setting?type=STYLE').then(function(data){
                if(data != null){
                    vm.style = data.data;
                }
             },function(error){
            });

            makeRestCall('api/setting?type=DRINKS_LEFT').then(function(data){
                if(data != null){
                    vm.drinksLeft = data.data;
                        if(vm.drinksLeft != null){
                            if(vm.drinksLeft.setting == '1') vm.drinksLeft.setting = true;
                            if(vm.drinksLeft.setting == '0') vm.drinksLeft.setting = false;
                        }
                }

            },function(error){
            });
            makeRestCall('api/setting?type=SINGLE_ITEM').then(function(data){
                if(data != null){
                    vm.singleItem = data.data;
                        if(vm.singleItem != null){
                            if(vm.singleItem.setting == '1') vm.singleItem.setting = true;
                            if(vm.singleItem.setting == '0') vm.singleItem.setting = false;
                        }
                }
            },function(error){
            });

            makeRestCall('api/setting?type=SINGLE_KITCHEN').then(function(data){
                if(data != null){
                    vm.printSingleItemKitchen = data.data;
                        if(vm.singleItem != null){
                            if(vm.printSingleItemKitchen.setting == '1') vm.printSingleItemKitchen.setting = true;
                            if(vm.printSingleItemKitchen.setting == '0') vm.printSingleItemKitchen.setting = false;
                        }
                }
            },function(error){
            });

            makeRestCall('api/setting?type=SEARCH_CUSTOMER_BY_CODE').then(function(data){
                if(data != null){
                    vm.searchCustomerByCode = data.data;
                        if(vm.singleItem != null){
                            if(vm.searchCustomerByCode.setting == '1') vm.searchCustomerByCode.setting = true;
                            if(vm.searchCustomerByCode.setting == '0') vm.searchCustomerByCode.setting = false;
                        }
                }
            },function(error){
            });

            makeRestCall('api/setting?type=PRINT_ARTICAL_NUMBER_IN_KITCHEN').then(function(data){
                if(data != null){
                    vm.printArticalNumberInKitchen = data.data;
                        if(vm.singleItem != null){
                            if(vm.printArticalNumberInKitchen.setting == '1') vm.printArticalNumberInKitchen.setting = true;
                            if(vm.printArticalNumberInKitchen.setting == '0') vm.printArticalNumberInKitchen.setting = false;
                        }
                }
            },function(error){
            });

            makeRestCall('api/setting?type=FONT_SIZE_IN_KITCHEN').then(function(data){
                if(data != null){
                    vm.fontSizeKitchen = data.data;

                }
            },function(error){
            });


            vm.saveFontSize = function(){
                var input = Number(vm.fontSizeKitchen.setting);
                if(input <=0 || input > 50){
                    vm.fontSizeKitchen.setting = '13';
                }
                makePutCall('api/pos-settings',vm.fontSizeKitchen).then(function(data){
                     vm.fontSizeKitchen = data.data;
                     alert("OK");
                },function(error){
                });
            }

            makeRestCall('api/setting?type=FAST_LOGIN').then(function(data){
                if(data != null){
                    vm.fastLogin = data.data;

                }
            },function(error){
            });
            

            vm.saveFastLogin = function(){
                var input = Number(vm.fastLogin.setting);
                if(input <=0 || input > 20){
                    vm.fastLogin.setting = '3';
                }
                
                makePutCall('api/pos-settings',vm.fastLogin).then(function(data){
                     vm.fastLogin = data.data;
                     alert("OK");
                },function(error){
                });
            }

            makeRestCall('api/setting?type=COMMENTS_TEMPLATE').then(function(data){
                if(data != null){
                    vm.commentsTemplate = data.data;

                }
            },function(error){
            });
            

            vm.saveCommentTemplate = function(){
                makePutCall('api/pos-settings',vm.commentsTemplate).then(function(data){
                     vm.commentsTemplate = data.data;
                     alert("OK");
                },function(error){
                });
            }

            makeRestCall('api/setting?type=TIEN_VON').then(function(data){
                if(data != null){
                    vm.TIEN_VON = data.data;

                }
            },function(error){
            });
            

            vm.saveTienVon = function(){
                makePutCall('api/pos-settings',vm.TIEN_VON).then(function(data){
                     vm.TIEN_VON = data.data;
                     alert("OK");
                },function(error){
                });
            }

            makeRestCall('api/setting?type=SMARTSTORE').then(function(data){
                        vm.diskObject = data.data;
                        if(vm.diskObject  != null){
                        vm.setting.diskSetting = vm.diskObject.setting;
                        }

                    },function(error){
                });

            makeRestCall('api/setting?type=CUSTOMERCODE').then(function(data){

                    vm.customerCodeObject = data.data;
                    if(vm.customerCodeObject != null){
                        vm.setting.customerCode = vm.customerCodeObject.setting;
                    }
                    },function(error){
                });

             makeRestCall('api/setting?type=TEAMVIEWER_PATH').then(function(data){
                        if(data.data  != null){
                            vm.settingTeamviewer = data.data;
                            vm.setting.teamViewerPath = data.data.setting;
                        }

                    },function(error){
            });

            makeRestCall('api/setting?type=SHOW_IMAGE').then(function(data){
                        vm.showImage = data.data;
                        if(vm.showImage != null){
                            if(vm.showImage.setting == '1') vm.showImage.setting = true;
                            if(vm.showImage.setting == '0') vm.showImage.setting = false;
                        }

                    },function(error){
            });

            initSuper();

        }

        function initSuper(){
            makeRestCall('api/setting?type=STEPSMART').then(function(data){
                        if(data.data  != null){
                            vm.smartStep = data.data;
                        }

                    },function(error){
            });

            makeRestCall('api/setting?type=STEPSMARTCHANGE').then(function(data){
                        if(data.data  != null){
                            vm.smartChange = data.data;
                        }

                    },function(error){
            });

            makeRestCall('api/setting?type=MIN_LIMIT').then(function(data){
                        if(data.data  != null){
                            vm.minLimit = data.data;
                        }

                    },function(error){
            });

            makeRestCall('api/setting?type=MAX_LIMIT').then(function(data){
                        if(data.data  != null){
                            vm.maxLimit = data.data;
                        }

                    },function(error){
            });

            makeRestCall('api/setting?type=PASS_SETTING_SUPER_USER').then(function(data){
                    if(data.data  != null){
                            vm.smartStepPassword = data.data;
                    }
                    },function(error){
                });
        }

        Principal.identity().then(function(account) {
                    vm.currentAccount = account;
                    vm.currentRole = 'ROLE_USER';
                          for (var j = 0; j < vm.currentAccount.authorities.length; j++) {
                            if(vm.currentAccount.authorities[j] == 'ROLE_ADMIN'){
                                vm.currentRole = 'ROLE_ADMIN';
                                break;
                            }else
                            if(vm.currentAccount.authorities[j] == 'ROLE_SUPER_ADMIN'){
                                vm.currentRole = 'ROLE_SUPER_ADMIN';
                                break;
                            }
                            else
                            if(vm.currentAccount.authorities[j] == 'ROLE_SUPER_USER'){
                                vm.currentRole = 'ROLE_SUPER_USER';
                                break;
                            }
                          }
        });

        vm.t003Config = {layout: 'custom',
              customLayout: {
                'default': [
                  '{accept} {b}',
                  '6 7 8 9',
                  '2 3 4 5',
                  '000 00 0 1'
                ]
              },
              display: {
                'accept': 'OK'
              },
              kt: 'US International', showKbSelect: true,
             numberPad: true, showVersion: true, usePreview: false, autoAccept : true, reposition : true,
             position : {
                  // null (attach to input/textarea) or a jQuery object (attach elsewhere)
                  of : $(window),
                  my : 'center bottom',
                  at : 'center bottom',
                  // at2 is used when "usePreview" is false (centers keyboard at the bottom
                  // of the input/textarea)
                  at2: 'center bottom',
                  collision: 'flipfit flipfit'
                },
                visible: function(e, keyboard, el) {
                  keyboard.$preview[0].select();
                }

         }


        vm.saveSetting = function (){
             if (angular.isUndefined($localStorage.setting)) $localStorage.setting = vm.setting;
             $localStorage.setting.virtualkeyboard = vm.setting.virtualkeyboard;
             //$localStorage.setting = vm.setting;
             localStorage["jhi-isFirstApp"] = false;
             $window.location.reload();
        }

        vm.cancelSuperSetting = function(){
            initSuper();
        }
        vm.saveSuperSetting = function(){
            makePutCall('api/pos-settings',vm.smartStep).then(function(data){
                    makePutCall('api/pos-settings',vm.smartChange).then(function(data){
                            makePutCall('api/pos-settings',vm.minLimit).then(function(data){
                                    makePutCall('api/pos-settings',vm.maxLimit).then(function(data){
                                            initSuper();
                                            alert("OK");
                                        },function(error){
                                    });
                                },function(error){
                            });
                        },function(error){
                    });
                },function(error){
                });

        }

        vm.tryPassword = function(){
            if(vm.smartStep_Password == vm.smartStepPassword.setting){
                vm.showSuperSettingContent = true;
            }
        }



        vm.changePrintDrink = function(){
            if(vm.printDrink != null){
                        if(vm.printDrink.setting == true) vm.printDrink.setting = '1';
                        if(vm.printDrink.setting == false) vm.printDrink.setting = '0';
            }
            makePutCall('api/pos-settings',vm.printDrink).then(function(data){
                         vm.printDrink = data.data;
                        if(vm.printDrink != null){
                            if(vm.printDrink.setting == '1') vm.printDrink.setting = true;
                            if(vm.printDrink.setting == '0') vm.printDrink.setting = false;
                        }
                    },function(error){
                    });
        }

        vm.changeShowImage = function(){
            if(vm.showImage != null){
                        if(vm.showImage.setting == true) vm.showImage.setting = '1';
                        if(vm.showImage.setting == false) vm.showImage.setting = '0';
            }
            makePutCall('api/pos-settings',vm.showImage).then(function(data){
                        vm.showImage = data.data;
                        if(vm.showImage != null){
                            if(vm.showImage.setting == '1') vm.showImage.setting = true;
                            if(vm.showImage.setting == '0') vm.showImage.setting = false;
                        }
                    },function(error){
                    });
        }

        vm.changeDrinksPosition = function(){
            if(vm.drinksLeft != null){
                        if(vm.drinksLeft.setting == true) vm.drinksLeft.setting = '1';
                        if(vm.drinksLeft.setting == false) vm.drinksLeft.setting = '0';
            }
            makePutCall('api/pos-settings',vm.drinksLeft).then(function(data){
                         vm.drinksLeft = data.data;
                        if(vm.drinksLeft != null){
                            if(vm.drinksLeft.setting == '1') vm.drinksLeft.setting = true;
                            if(vm.drinksLeft.setting == '0') vm.drinksLeft.setting = false;
                        }
                    },function(error){
                    });
        }

        vm.changeSingleItem = function(){
            if(vm.singleItem != null){
                        if(vm.singleItem.setting == true) vm.singleItem.setting = '1';
                        if(vm.singleItem.setting == false) vm.singleItem.setting = '0';
            }
            makePutCall('api/pos-settings',vm.singleItem).then(function(data){
                         vm.singleItem = data.data;
                        if(vm.singleItem != null){
                            if(vm.singleItem.setting == '1') vm.singleItem.setting = true;
                            if(vm.singleItem.setting == '0') vm.singleItem.setting = false;
                        }
                    },function(error){
                    });
        }

        vm.changePrintSingleItemKitchen = function(){
            if(vm.printSingleItemKitchen != null){
                        if(vm.printSingleItemKitchen.setting == true) vm.printSingleItemKitchen.setting = '1';
                        if(vm.printSingleItemKitchen.setting == false) vm.printSingleItemKitchen.setting = '0';
            }
            makePutCall('api/pos-settings',vm.printSingleItemKitchen).then(function(data){
                         vm.printSingleItemKitchen = data.data;
                        if(vm.printSingleItemKitchen != null){
                            if(vm.printSingleItemKitchen.setting == '1') vm.printSingleItemKitchen.setting = true;
                            if(vm.printSingleItemKitchen.setting == '0') vm.printSingleItemKitchen.setting = false;
                        }
                    },function(error){
                    });
        }

        vm.changeSearchCustomerByCode = function(){
            if(vm.searchCustomerByCode != null){
                        if(vm.searchCustomerByCode.setting == true) vm.searchCustomerByCode.setting = '1';
                        if(vm.searchCustomerByCode.setting == false) vm.searchCustomerByCode.setting = '0';
            }
            makePutCall('api/pos-settings',vm.searchCustomerByCode).then(function(data){
                        vm.searchCustomerByCode = data.data;
                        if(vm.searchCustomerByCode != null){
                            if(vm.searchCustomerByCode.setting == '1') vm.searchCustomerByCode.setting = true;
                            if(vm.searchCustomerByCode.setting == '0') vm.searchCustomerByCode.setting = false;
                        }
                    },function(error){
                    });
        }

        vm.changePrintArticalNumberInKitchen = function(){
            if(vm.printArticalNumberInKitchen != null){
                        if(vm.printArticalNumberInKitchen.setting == true) vm.printArticalNumberInKitchen.setting = '1';
                        if(vm.printArticalNumberInKitchen.setting == false) vm.printArticalNumberInKitchen.setting = '0';
            }
            makePutCall('api/pos-settings',vm.printArticalNumberInKitchen).then(function(data){
                        vm.printArticalNumberInKitchen = data.data;
                        if(vm.printArticalNumberInKitchen != null){
                            if(vm.printArticalNumberInKitchen.setting == '1') vm.printArticalNumberInKitchen.setting = true;
                            if(vm.printArticalNumberInKitchen.setting == '0') vm.printArticalNumberInKitchen.setting = false;
                        }
                    },function(error){
                    });
        }
        function makeRestCall(url) {

            return $http.get($localStorage.API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

        function makePutCall(url,data) {

            return $http.put($localStorage.API_URL+url,data)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };


        vm.selectDisk = function(disk){
            if (angular.isUndefined(vm.diskObject) || vm.diskObject == null){
                 vm.diskObject = {};
                 vm.diskObject.type = "SMARTSTORE";
                 vm.diskObject.setting = disk.diskName;
                 PosSetting.save(vm.diskObject);
            } else {
                vm.diskObject.setting = disk.diskName;
                PosSetting.update(vm.diskObject,function(result){
                    vm.setting.diskSetting = disk.diskName;
                });

            }
        }

        vm.startTeamviewer = startTeamviewer;
        function startTeamviewer(){
            if(vm.setting.teamViewerPath != null  && vm.setting.teamViewerPath.length >1){
                if(vm.setting.teamViewerPath != vm.settingTeamviewer.setting){
                    vm.settingTeamviewer.setting = vm.setting.teamViewerPath;
                    // update to backend
                    makePutCall('api/pos-settings',vm.settingTeamviewer).then(function(data){
                        // start teamviewer
                        makeRestCall('api/command/startTeamViewer').then(function(data){
                                    var message = document.getElementById("alertTeamViewerStarted").innerHTML;
                                    alert(message);
                                },function(error){
                        });

                        },function(error){
                    });
                }
                else{
                    // start teamviewer
                    makeRestCall('api/command/startTeamViewer').then(function(data){
                                    var message = document.getElementById("alertTeamViewerStarted").innerHTML;
                                    alert(message);
                                },function(error){
                    });
                }

            }

        }

        vm.change2Monitors = function(){
            if(vm.setting.twoMonitors == true){
                
                $localStorage.setting.twoMonitors = "yes"; 
            }else{
               
                $localStorage.setting.twoMonitors = "no"; 
            }
            
            localStorage["jhi-isFirstApp"] = false;
            $window.location.reload();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('xposApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('data-backup', {
            parent: 'entity',
            url: '/data-backup',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUPER_ADMIN'],
                pageTitle: 'xposApp.dataBackup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/data-backup/data-backups.html',
                    controller: 'DataBackupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
       
    }

})();

(function() {
    'use strict';
    angular
        .module('xposApp')
        .factory('DataBackup', DataBackup);

    DataBackup.$inject = ['$resource','DateUtils', '$localStorage'];

    function DataBackup ($resource, DateUtils, $localStorage) {
        var resourceUrl =  $localStorage.API_URL+'api/data-backups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('DataBackupController', DataBackupController);

    DataBackupController.$inject = ['$state','$uibModal','DataBackup', '$http', '$q', '$localStorage'];

    function DataBackupController($state, $uibModal, DataBackup, $http, $q, $localStorage) {

        var vm = this;
        vm.apiUrl = $localStorage.API_URL;
        var API_URL = $localStorage.API_URL;

        vm.dataBackups = [];

        loadAll();

        function loadAll() {
            DataBackup.query(function(result) {
                vm.dataBackups = result;
                vm.searchQuery = null;
            });
        }

         var makeRestCall   = function (url) {
            return $http.get(API_URL+url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };

        

        vm.recovery = recovery;
        function recovery(fileName){
           var txt =  document.getElementById("confirmRecovery").innerHTML;
            var r = confirm(txt);
            if (r == true) {
                makeRestCall('api/data-backup/recovery?fileName='+fileName).then(function(data){
                        if(data.data != null && data.data.value == "OK"){
                            txt =  document.getElementById("recoverySuccess").innerHTML;
                            alert(txt);                                          
                        }else{
                            txt =  document.getElementById("errorRecovery").innerHTML;
                            alert(txt);  
                        }

                    },function(error){
                });
            } else {
               
            }
        }

        vm.remove = remove;
        function remove(fileName){
            var txt =  document.getElementById("confirmDelete").innerHTML;
            var r = confirm(txt);
            if (r == true) {
                makeRestCall('api/data-backup/remove?fileName='+fileName).then(function(data){
                        if(data.data != null && data.data.value == "OK"){
                               loadAll();                                               
                        }else{
                            txt =  document.getElementById("errorRemove").innerHTML;
                            alert(txt);   
                        }

                    },function(error){
                });
            } else {
               
            }
           
        }

        vm.backupManually = backupManually;
        function backupManually(){
            makeRestCall('api/backup-manually').then(function(data){
                        alert("OK");   
                        loadAll(); 
                    },function(error){
                        alert("ERROR");   
            });
        }

        vm.resetDB = resetDB;
        function resetDB(){
            makeRestCall('api/data-backup/reset').then(function(data){
                        alert("OK");   
                        loadAll(); 
                    },function(error){
                        alert("ERROR");   
            });
        }

        vm.clean = clean;
        function clean(){
            makeRestCall('api/delete-all-orders').then(function(data){
                        alert("OK");   
                    },function(error){
                        alert("ERROR");   
            });
        }

        vm.openXemHoaDon = function(){
            $uibModal.open({
                  templateUrl: 'app/admin/data-backup/modal-verify.html',
                  controller: function ($scope, $uibModalInstance) {
                    $scope.verified = false;
                    
                    $scope.cancel = function () {
                      $uibModalInstance.dismiss('cancel');
                    };
                    
                    $scope.tryPassword = function(){
                        //console.log($scope.passVerify);
                         makeRestCall('api/setting?type=PASS_2').then(function(data){
                          if(data != null){
                                var pass = data.data.setting;
                                if($scope.passVerify == pass){
                                    makeRestCall('api/bills/xem-bills').then(function(data){
                                        $state.go('bill');
                                        $scope.cancel();
                                    },function(error){
                                        $scope.cancel();
                                    });
                                    
                                }else {
                                    $scope.cancel();
                                }
                          }
                               
                            },function(error){
                        });
                         /*
                        
                        */
                    }
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$state','Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController ($state, Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        vm.back = function(){
            $state.go('home');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        }).state('registererror', {
            parent: 'account',
            url: '/expried',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/error.html',
                    controller: 'ErrorRegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .factory('RegisterAppSrevice', RegisterAppSrevice);

    RegisterAppSrevice.$inject = ['$http', '$localStorage', '$sessionStorage', '$q','$state'];

    function RegisterAppSrevice ($http, $localStorage, $sessionStorage, $q, $state) {
        var service = {
            register: register,
            initialize:initialize
        };

        return service;


        function register (register) {
            return $http.post("http://"+register.localservice+'/api/registerappsimple', register)
                        .then(registerSuccess);

            function registerSuccess (res, status, headers) {
                return res.data;
            }
        }
        function validateApp (url) {
                console.log("validateApp: register.service.js.28" );
                if (url=='/register') {
                    return;
                } else {

                // if (url=='/'){
                //     if (angular.isUndefined($localStorage.validateKey)) $state.go('register');
                //     return;
                // }
                 var validate = {
                    customerCode :$localStorage.customerCode,
                    productCode:$localStorage.productCode,
                    fullName:$localStorage.fullName,
                    email:$localStorage.email,
                    license:$localStorage.validateKey,
                    hardwareId:"MACTEST"
                };

                try {
                    /*
                    var macaddress = require('node-macaddress');
                    macaddress.one(function (err, mac) {
                        validate.hardwareId = mac;
                        var res = $http.post($localStorage.API_URL+'api/validateappsimple', validate)
                        res.success(function(data, status, headers, config) {
                            if (!angular.isUndefined($localStorage.validateKey)) {
                                if ((data.keyValidate == false || data.dayExp < 0)){
                                    if (url!='/register'){
                                        $state.go('registererror');
                                         }
                                    } else {
                                        if (url =='/expried')
                                        {
                                            $state.go('home');
                                        }
                                    }
                            }
                        });
                        res.error(function(data, status, headers, config) {

                            if (url!='/register'){
                                if (angular.isUndefined($localStorage.validateKey)){
                                     $state.go('register');
                                }else {
                                    $state.go('registererror');
                                }
                            }
                        });
                    });
                    */

                    var serialNumber = require('serial-number');

                    serialNumber(function (err, value) {
                        validate.hardwareId = value;
                        var res = $http.post($localStorage.API_URL+'api/validateappsimple', validate)
                        res.success(function(data, status, headers, config) {
                            if (!angular.isUndefined($localStorage.validateKey)) {
                                if ((data.keyValidate == false || data.dayExp < 0)){
                                    if (url!='/register'){
                                        $state.go('registererror');
                                         }
                                    } else {
                                        if (url =='/expried')
                                        {
                                            $state.go('home');
                                        }
                                    }
                            }
                        });
                        res.error(function(data, status, headers, config) {

                            if (url!='/register'){
                                if (angular.isUndefined($localStorage.validateKey)){
                                     $state.go('register');
                                }else {
                                    $state.go('registererror');
                                }
                            }
                        });
                    });

                } catch(e){
                    // if you not electron
                    validate.hardwareId = "MACTEST";
                    var res = $http.post($localStorage.API_URL+'api/validateappsimple', validate)
                    res.success(function(data, status, headers, config) {
			            if (!angular.isUndefined($localStorage.validateKey)) {
                             if ((data.keyValidate == false || data.dayExp < 0)){
                                    $state.go('registererror');
                                } else {
                                    if (url =='/expried')
                                    {
                                        $state.go('home');
                                    }
                                }
                        }
		            });
                    res.error(function(data, status, headers, config) {
                         $state.go('registererror');
                    });
                }
            }
        }
        function initialize(url){
             validateApp(url);
        //     if (!angular.isUndefined($localStorage.validateKey)) {
        //         validateApp().then(function(data){

        //             if ((data.keyValidate == false || data.dayExp < 0)){
        //                 $state.go('registererror');
        //             } else {
        //                 console.log(url);
        //                 if (url =='/expried')
        //                 {
        //                     $state.go('home');
        //                 }
        //             }
        //         }).catch(function (response) {

        //         });
        //     }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'RegisterAppSrevice','$rootScope', '$localStorage','PosSetting', '$state', '$http', '$q','$location','$window','$scope','SyncDataService'];

    function RegisterController ($translate, $timeout, Auth, RegisterAppSrevice, $rootScope, $localStorage, PosSetting, $state, $http, $q, $location, $window, $scope, SyncDataService) {
        var vm = this;
                    
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.register = register;
        vm.registerApp = {};
        vm.checkSync = checkSync;
        vm.login = login;
        vm.showDeleteData = false;
        vm.successSync = false;
        vm.status = {
            tableZone: false,
            table: false,
            product: false,
            productGroup: true,
            productCategory: true,
            user :false,
            setting : false,
            deleteData: false
        };
        
        /*
        vm.registerApp = {
            customerCode:"AE65DF94364222996B2A5321B6A7C6FE",
            productCode:"88DDC5EECF13CD3FC376270D67EF9C4A",
            fullName:"Test2",
            email:"test2",
            localservice:"localhost:9090",
            license:"GAWQE-F9A4J-CGZ2K-SDFJW-HWXRW-LM5WV-SSU2L-JM2DG-A9KEC-CYPQU-QTTT8-NSA3R-68F9B-4EH28-ZENLA-A"
        }
        */
        vm.success = null;
        $rootScope.$broadcast('isHideNav');
        var makeRestCall   = function (url) {
            return $http.get(url)
                .then(function (response) {
                  return response;
                }, function (response) {
                    // something went wrong
                    return $q.reject(response.data);
                });
        };
        function handleRegister(){
            console.log("vm.registerApp:");
            console.log(vm.registerApp);
            RegisterAppSrevice.register(vm.registerApp).then(function (result) {
                if (result.code === 1){
                    vm.success = 'OK';
                    vm.successSync = 'OK';
                    vm.error = false;
                    $localStorage.validateKey = result.validate;
                    $localStorage.customerCode = vm.registerApp.customerCode;
                    $localStorage.productCode = vm.registerApp.productCode;
                    $localStorage.fullName = vm.registerApp.fullName;
                    $localStorage.email = vm.registerApp.email;
                    $localStorage.API_URL_VAL = vm.registerApp.localservice;
                    $localStorage.API_URL = "http://"+vm.registerApp.localservice+"/";
                    console.log(vm.registerApp.localservice+"-"+$localStorage.API_URL_VAL);
                   
          
                    makeRestCall($localStorage.API_URL+'api/setting?type=CUSTOMERCODE').then(function(data){
                        var saveSetting = data.data;
                        saveSetting.type = "CUSTOMERCODE";
                        vm.success = "OK";
                        /*
                        if (saveSetting.setting!=vm.registerApp.customerCode){
                            vm.showDeleteData = true;
                            deleteAll();
                        } else {
                            vm.status.deleteData =true;
                        }
                        */
                        saveSetting.setting = vm.registerApp.customerCode;
                        PosSetting.update(saveSetting).$promise.then(function(response) {

                           sync();
                            
                        }, function(response) {
                            console.log("Update error");
                        });;
                        // $state.go('home',{reload:true});
                   
                        
                        
                    },function(error){
                        // var saveSetting = {};
                        // saveSetting.type = "CUSTOMERCODE";
                        // saveSetting.setting = vm.registerApp.customerCode;
                        // PosSetting.save(saveSetting);
                    });

                } else {
                    vm.error = 'ERROR'
                }
            }).catch(function (response) {
                console.log(response);
                vm.success = null;
                vm.error = 'ERROR'
            });
    }
    function login(){
        $localStorage.isFirstApp = true;
        $state.go('home');
    }
    function register () {
        try {
            /*
            //get mac address
            var macaddress = require('node-macaddress');
            macaddress.one(function (err, mac) {
                vm.registerApp.hardwareId = mac;
                handleRegister();

            });
            */
            // get bios serial
            var serialNumber = require('serial-number');
            serialNumber(function (err, value) {
                vm.registerApp.hardwareId = value;
                console.log("vm.registerApp.hardwareId: "+vm.registerApp.hardwareId);
                handleRegister();
            });

        } catch(e){
            // if you not electron
            vm.registerApp.hardwareId = "MACTEST";
            console.log("vm.registerApp.hardwareId: "+vm.registerApp.hardwareId);
            handleRegister();
        }
    }
    function checkSync(){
            if (vm.status.user == true)
            {
                return true;
            }
            return false;
            /*
            if (vm.status.tableZone == true && vm.status.table == true 
                && vm.status.product == true && vm.status.productGroup == true && vm.status.deleteData)
            {
                return true;
            }
            return false;
            */
        }

        function sync(){
            //deleteAll();
            //syncTableZone();
            //syncTable();
            syncUser();
            //syncSetting();
            //syncProduct();
        }
        function deleteAll(){
            SyncDataService.deleteAll().then(function(data){
                vm.status.deleteData = true;
            },function(error){
                vm.status.deleteData = true;
            })
        }
        function syncTableZone(){
            SyncDataService.syncTableZone().then(function(data){
                vm.status.tableZone = true;
            },function(error){
                vm.status.tableZone = true;
            })
        }

        function syncTable(){
            SyncDataService.syncTable().then(function(data){
                vm.status.table = true;
            },function(error){
                vm.status.table = true;
            })
        }

        function syncUser(){
            SyncDataService.syncUser().then(function(data){
                vm.status.user = true;
            },function(error){
                vm.status.user = true;
            })
        }

        function syncSetting(){
            SyncDataService.syncSetting().then(function(data){
                vm.status.setting = true;
            },function(error){
                vm.status.setting = true;
            })
        }

        function syncProduct(){
            SyncDataService.deleteProduct().then(function(data){
                syncCategory();
                // syncProductGroup();
            },function(error){
                
            })
        }
        function syncCategory(){
            SyncDataService.syncCategory().then(function(data){
                syncProductGroup();
            },function(error){
                
            })
        }

        function syncProductGroup(){
            SyncDataService.syncProductGroup().then(function(data){
                syncProductData();
            },function(error){
                
            })
        }

        function syncProductData(){
            SyncDataService.syncProduct().then(function(data){
                 vm.status.product = true;
            },function(error){
                
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('ErrorRegisterController', ErrorRegisterController);


    ErrorRegisterController.$inject = ['$translate', '$timeout', 'Auth', 'RegisterAppSrevice','$rootScope', '$localStorage','PosSetting', '$state'];

    function ErrorRegisterController ($translate, $timeout, Auth, RegisterAppSrevice, $rootScope, $localStorage, PosSetting, $state) {
        var vm = this;
        $rootScope.$broadcast('isHideNav');
        vm.registerApp = {
            customerCode : $localStorage.customerCode,
            productCode:   $localStorage.productCode,
            fullName:      $localStorage.fullName,
            email:         $localStorage.email,
            license:       $localStorage.validateKey
        }
        vm.extend = function (){
            $localStorage.extend = true;
            delete $localStorage.validateKey;
            delete $localStorage.email;
            delete $localStorage.fullName;
            delete $localStorage.productCode;
            delete $localStorage.customerCode;
            delete $localStorage.API_URL;
            delete $localStorage.API_URL_VAL;
            $state.go('register');
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('xposApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('xposApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('xposApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<script type="text/javascript">function stopEnterKey(evt) {\r\n        var evt = (evt) ? evt : ((event) ? event : null);\r\n        var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);\r\n        if ((evt.keyCode == 13) && (node.type == "text")) { return false; }\r\n    }\r\n    document.onkeypress = stopEnterKey;</script><style></style><div ng-cloak class="col-md-offset-2"><div class="row col-md-8"><div class="col-md-4 col-md-offset-5"><img src="content/images/logo.png" class="figure-img img-fluid rounded" width="50%" height="50%"></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Sai th\xF4ng tin \u0111\u0103ng nh\u1EADp!</strong> L\xE0m \u01A1n th\u1EED l\u1EA1i!</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username">T\xEAn \u0111\u0103ng nh\u1EADp</label><input type="text" class="form-control" id="username" ng-model="vm.username"></div><div class="form-group"><label for="password">M\u1EADt kh\u1EA9u</label><input type="password" class="form-control" id="password" ng-model="vm.password"></div><br><button type="submit" class="btn btn-primary col-md-offset-4" style="width: 45%">\u0110\u0103ng nh\u1EADp</button></form></div></div></div>');
$templateCache.put('app/home/navigate.html','<style>.element-error {\r\n\t\t\t border-style: solid;\r\n\t\t\t border-color: red;\r\n\t\t\t border-width: 1px;\r\n\t\t\t padding:5px;\r\n\t\t\t background-color: #ef865f;\r\n\t\t\t height: 170px;\r\n\t\t}\r\n\t\t.element {\r\n\t\t\t border-style: solid;\r\n\t\t\t border-color: black;\r\n\t\t\t border-width: 1px;\r\n\t\t\t padding:5px;\r\n\t\t\t background-color: #aaf7bd;\r\n\t\t\t height: 170px;\r\n\t\t\t margin-bottom: 30px;\r\n\t\t}</style><div><div class="jumbotron text-center"><h1>KaMa-POS</h1></div><div class="container" ng-if="vm.currentRole != \'ROLE_SUPER_ADMIN\'"><div class="col-md-12"><h2 class="col-md-6">Xin ch\xE0o <b>{{vm.account.login}}</b>!</h2><button class="btn btn-info btn-sm pull-right" ng-click="vm.logout()">\u0110\u0103ng xu\u1EA5t</button></div><div class="row"><div class="col-md-3 col-xs-6"><div class="element"><h3>Karaoke</h3><button class="btn btn-lg btn-info col-md-12" ng-click="vm.switchTo(\'order-karaoke\')">B\xE1n h\xE0ng</button> <button class="btn btn-md btn-info col-md-12" style="margin-top:15px" ng-click="vm.switchTo(\'bill\')">L\u1ECBch s\u1EED b\xE1n</button></div></div><div class="col-md-3 col-xs-6"><div class="element"><h3>Massage</h3><button class="btn btn-lg btn-info col-md-12" ng-click="vm.switchTo(\'order-matxa\')">B\xE1n h\xE0ng</button> <button class="btn btn-md btn-info col-md-12" style="margin-top:15px" ng-click="vm.switchTo(\'billMatxa\')">L\u1ECBch s\u1EED b\xE1n</button></div></div><div class="col-md-3 col-xs-6"><div class="element" ng-if="vm.currentRole == \'ROLE_ADMIN\'" ng-click="vm.switchTo(\'stockin\')"><h3>Nh\u1EADp Kho</h3></div></div><div class="col-md-3 col-xs-6" ng-if="vm.currentRole == \'ROLE_ADMIN\'" ng-click="vm.switchTo(\'thuchi\')"><div class="element"><h3>Thu Chi</h3></div></div><div class="col-md-3 col-xs-6" ng-if="vm.currentRole == \'ROLE_ADMIN\'"><div class="element"><h3>Thi\u1EBFt l\u1EADp</h3><button class="btn btn-md btn-primary col-md-6" style="margin-top:5px" ng-click="vm.switchTo(\'room\')">Ph\xF2ng h\xE1t</button> <button class="btn btn-md btn-info col-md-6" style="margin-top:5px" ng-click="vm.switchTo(\'product\')">S\u1EA3n ph\u1EA9m</button> <button class="btn btn-md btn-info col-md-6" style="margin-top:5px" ng-click="vm.switchTo(\'ticket\')">Lo\u1EA1i v\xE9 massage</button> <button class="btn btn-md btn-primary col-md-6" style="margin-top:5px" ng-click="vm.switchTo(\'config\')" ng-if="vm.currentRole == \'ROLE_ADMIN\'">Thi\u1EBFt l\u1EADp kh\xE1c</button></div></div></div></div><div class="container" ng-if="vm.currentRole == \'ROLE_SUPER_ADMIN\'"><div class="col-md-12"><h2 class="col-md-6">Xin ch\xE0o <b>{{vm.account.login}}</b>!</h2><button class="btn btn-info btn-sm pull-right" ng-click="vm.logout()">\u0110\u0103ng xu\u1EA5t</button></div><div class="row"><div class="col-md-3 col-xs-6"><div class="element"><h3>Gi\xE1m s\xE1t karaoke</h3><button class="btn btn-md btn-info col-md-12" ng-click="vm.switchTo(\'bill\')">Th\u1ED1ng k\xEA b\xE1n h\xE0ng</button> <button class="btn btn-md btn-info col-md-12" style="margin-top:15px" ng-click="vm.switchTo(\'thuchi\')">Th\u1ED1ng k\xEA thu chi</button></div></div><div class="col-md-3 col-xs-6"><div class="element" ng-click="vm.switchTo(\'billMatxa\')"><h3>Gi\xE1m s\xE1t Massage</h3></div></div><div class="col-md-3 col-xs-6"><div class="element" ng-click="vm.switchTo(\'store\')"><h3>C\u01A1 s\u1EDF</h3></div></div><div class="col-md-3 col-xs-6"><div class="element" ng-click="vm.switchTo(\'user-management\')"><h3>T\xE0i kho\u1EA3n</h3></div></div><div class="col-md-3 col-xs-6"><div class="element" ng-click="vm.switchTo(\'product\')"><h3>Thi\u1EBFt l\u1EADp s\u1EA3n ph\u1EA9m</h3></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button> <button type="button" class="btn btn-primary" ng-click="vm.back()">Quay l\u1EA1i</button></form></div></div></div>');
$templateCache.put('app/account/register/error.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2><i class="fa fa-2x fa-hand-paper-o"></i> <b>Error connection localservice or XPOS License Expired</b></h2><p>Please check connection local service !</p></div><div class="col-md-8 col-md-offset-2"><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.customerCode">Customer Code</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.regapp.customerCode.placeholder\' | translate}}" ng-model="vm.registerApp.customerCode" readonly="readonly"></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.productCode">Product Code</label><input type="text" class="form-control" id="productCode" name="productCode" placeholder="{{\'global.form.regapp.productCode.placeholder\' | translate}}" ng-model="vm.registerApp.productCode" readonly="readonly"></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.fullName">Full Name</label><input type="text" class="form-control" id="fullName" name="fullName" placeholder="{{\'global.form.regapp.fullName.placeholder\' | translate}}" ng-model="vm.registerApp.fullName" readonly="readonly"></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.email">Email</label><input type="text" class="form-control" id="email" name="email" placeholder="{{\'global.form.regapp.email.placeholder\' | translate}}" ng-model="vm.registerApp.email" readonly="readonly"></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.license">License</label><input type="text" class="form-control" id="license" name="license" placeholder="{{\'global.form.regapp.license.placeholder\' | translate}}" ng-model="vm.registerApp.license" readonly="readonly"></div><button type="submit" class="btn btn-primary" ui-sref="home">Login</button> <button type="submit" class="btn btn-primary" ng-click="vm.extend()">Register or Extend License</button></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">XPOS Registration</h1><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please check information and try again later.</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.customerCode">Customer Code</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.regapp.customerCode.placeholder\' | translate}}" ng-model="vm.registerApp.customerCode" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.customerCode.required">Your customer code is required.</p></div></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.productCode">Product Code</label><input type="text" class="form-control" id="productCode" name="productCode" placeholder="{{\'global.form.regapp.productCode.placeholder\' | translate}}" ng-model="vm.registerApp.productCode" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.productCode.required">Your Product code is required.</p></div></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.fullName">Full Name</label><input type="text" class="form-control" id="fullName" name="fullName" placeholder="{{\'global.form.regapp.fullName.placeholder\' | translate}}" ng-model="vm.registerApp.fullName" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.fullName.required">Your Fullname is required.</p></div></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.email">Email</label><input type="text" class="form-control" id="email" name="email" placeholder="{{\'global.form.regapp.email.placeholder\' | translate}}" ng-model="vm.registerApp.email" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.email.required">Your Email is required.</p></div></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.license">Email</label><input type="text" class="form-control" id="license" name="license" placeholder="{{\'global.form.regapp.license.placeholder\' | translate}}" ng-model="vm.registerApp.license" required><div ng-show="form.license.$dirty && form.license.$invalid"><p class="help-block" ng-show="form.license.$error.required" data-translate="register.messages.validate.license.required">Your License is required.</p></div></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.regapp.localservice">Localservice Address</label><input type="text" class="form-control" id="localservice" name="localservice" placeholder="{{\'global.form.regapp.localservice.placeholder\' | translate}}" ng-model="vm.registerApp.localservice" required><div ng-show="form.license.$dirty && form.localservice.$invalid"><p class="help-block" ng-show="form.license.$error.required" data-translate="register.messages.validate.localservice.required">Your License is required.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p></div><div class="col-md-8 col-md-offset-2"><div ng-show="vm.successSync"><h2 data-translate="register.messages.syncing">Syncing data...</h2><ul style="list-style:none"><li ng-show="vm.showDeleteData"><span ng-show="vm.status.deleteData"><i class="fa fa-check"></i></span>Clear data..!</li><!--\r\n                    <li><span ng-show="vm.status.tableZone"><i  class="fa fa-check"></i></span data-translate="register.messages.syncTableZone"> Sync table zone data</li>\r\n                    --><li><span ng-show="vm.status.table"><i class="fa fa-check"></i></span> Sync table data</li><li><span ng-show="vm.status.user"><i class="fa fa-check"></i></span> Sync user data</li><li><span ng-show="vm.status.setting"><i class="fa fa-check"></i></span> Sync setting data</li><!--\r\n                    <li><span ng-show="vm.status.productGroup"><i  class="fa fa-check"></i></span data-translate="register.messages.syncProductGroupData">Sync product group data</li>\r\n                    --><li><span ng-show="vm.status.product"><i class="fa fa-check"></i></span>Sync product data</li></ul></div><p></p><div ng-show="vm.checkSync()"><p data-translate="register.messages.registerSuccess">Register successfully. Please click Button login to use the system</p><button ng-click="vm.login()" class="btn btn-primary">Login</button></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length === 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length === 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/data-backup/data-backups.html','<div><h2 data-translate="global.dataBackup.title">Data Backups</h2><jhi-alert></jhi-alert><button type="button" style="margin-bottom:10px" ng-click="vm.backupManually()" class="btn btn-primary btn-sm col-sm-2"><span class="hidden-sm-down" data-translate="entity.action.backup">View</span></button> <button type="button" style="margin-bottom:10px; margin-left:30px" ng-click="vm.openXemHoaDon()" class="btn btn-primary btn-sm col-sm-2"><span class="hidden-sm-down">Xem h\xF3a \u0111\u01A1n</span></button><!--\r\n    <button type="button"  style="margin-bottom:10px; margin-left:30px;" ng-click = "vm.resetDB()"\r\n            class="btn btn-primary btn-sm col-sm-2 " >\r\n            <span class="hidden-sm-down" data-translate="entity.action.reset">View</span>\r\n    </button>\r\n    --> <button type="button" style="margin-bottom:10px; margin-right:30px" ng-click="vm.clean()" class="btn btn-danger btn-sm col-sm-2 pull-right"><span class="hidden-sm-down">Clean cache</span></button><div class="table-responsive col-sm-12" style="height: 620px; overflow-y:scroll;overflow-x: hidden"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.dataBackup.fileName">Back Up Name</span></th><th><span data-translate="global.dataBackup.filePath">Backup Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="dataBackup in vm.dataBackups track by dataBackup.fileName"><td>{{dataBackup.fileName}}</td><td>{{dataBackup.absolutePathFileName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" style="margin-right:20px" ng-click="vm.recovery(dataBackup.fileName)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-save"></span> <span class="hidden-sm-down" data-translate="global.dataBackup.recovery"></span></button> <button type="button" ng-click="vm.remove(dataBackup.fileName)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><span ng-show="false" id="confirmRecovery" data-translate="global.dataBackup.confirmRecovery"></span> <span ng-show="false" id="recoverySuccess" data-translate="global.dataBackup.recoverySuccess"></span> <span ng-show="false" id="errorRecovery" data-translate="global.dataBackup.errorRecovery"></span> <span ng-show="false" id="errorRemove" data-translate="global.dataBackup.errorRemove"></span> <span ng-show="false" id="confirmDelete" data-translate="global.dataBackup.confirmDelete"></span></div>');
$templateCache.put('app/admin/data-backup/modal-verify.html','<style>.modal-dialog {\r\n\t\twidth:50%;\r\n\t\theight:70%;\r\n\t\tmargin:20px auto;\r\n\t}</style><div><div class="modal-header"><div class="row"><div class="col-xs-12 col-md-12" style="margin-bottom: 5px"><div class="col-xs-2 col-md-2 well pull-right" style="cursor: pointer; height:50px;text-align: center;margin-bottom:0px;color:black;font-size: 14px;padding-top: 15px" ng-click="cancel()"><span>ESC</span></div></div></div></div><div class="modal-body" style="height:100px;padding-right:0px;overflow-y:scroll;overflow-x: hidden"><div class="row" style="margin-bottom: 10px" ng-show="verified == false"><label class="col-md-2 col-sm-2 col-xs-2">Password</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="password" id="passVerify" name="passVerify" ng-model="passVerify" class="form-control" style="width:100%"></div><span class="col-md-2 col-sm-2 col-xs-2"><button type="button" class="btn btn-info btn-flat col-xs-12" ng-click="tryPassword()">Try</button></span></div></div><div id="keyboard-wrapper"></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/settings/settings.html','<div class="row"><div class="x_panel"><div class="x_title"><h2 data-translate="global.setting.title">Seneral Setting</h2><div class="clearfix"></div></div><div class="x_content" ng-if="vm.currentRole == \'ROLE_ADMIN\'"><div class="form-horizontal form-label-left"><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.customerCode">Customer Code</label><div class="col-md-5 col-sm-5 col-xs-12"><input type="text" id="customer-code" ng-model="vm.setting.customerCode" class="form-control" readonly="readonly"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.virtualKeyboard">Virtual Keyboard</label><div class="col-md-9 col-sm-9 col-xs-12"><switch id="" name="" ng-model="vm.setting.virtualkeyboard" class="green" ng-change="vm.saveSetting()"></switch></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.twoMonitors">2 Monitors</label><div class="col-md-9 col-sm-9 col-xs-12"><switch id="" name="" ng-model="vm.setting.twoMonitors" class="green" ng-change="vm.change2Monitors()"></switch></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.printDrink">Print Drink</label><div class="col-md-9 col-sm-9 col-xs-12"><switch id="" name="" ng-model="vm.printDrink.setting" class="green" ng-change="vm.changePrintDrink()"></switch></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.showImage">Show Image</label><div class="col-md-9 col-sm-9 col-xs-12"><switch id="" name="" ng-model="vm.showImage.setting" class="green" ng-change="vm.changeShowImage()"></switch></div></div><!--\r\n\t\t\t\t<div class="form-group" ng-if="vm.style.setting == \'Fast\'">\r\n\t\t\t\t\t<label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.drinksLeft">Drinks at Left</label>\r\n\t\t\t\t\t<div class="col-md-9 col-sm-9 col-xs-12">\r\n\t\t\t\t\t\t<switch id="" name="" ng-model="vm.drinksLeft.setting" class="green" ng-change="vm.changeDrinksPosition()"></switch>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="form-group" ng-if="vm.style.setting == \'Fast\'">\r\n\t\t\t\t\t<label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.singleItem">Single Item</label>\r\n\t\t\t\t\t<div class="col-md-9 col-sm-9 col-xs-12">\r\n\t\t\t\t\t\t<switch id="" name="" ng-model="vm.singleItem.setting" class="green" ng-change="vm.changeSingleItem()"></switch>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="form-group" ng-if="vm.style.setting == \'Fast\'">\r\n\t\t\t\t\t<label class="control-label col-md-3 col-sm-3 col-xs-12" >Drucken Einzelartikel</label>\r\n\t\t\t\t\t<div class="col-md-9 col-sm-9 col-xs-12">\r\n\t\t\t\t\t\t<switch id="" name="" ng-model="vm.printSingleItemKitchen.setting" class="green" ng-change="vm.changePrintSingleItemKitchen()"></switch>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t<label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.searchCustomerByCode"></label>\r\n\t\t\t\t\t<div class="col-md-9 col-sm-9 col-xs-12">\r\n\t\t\t\t\t\t<switch id="" name="" ng-model="vm.searchCustomerByCode.setting" class="green" ng-change="vm.changeSearchCustomerByCode()"></switch>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t<label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.printArticalNumberInKitchen"></label>\r\n\t\t\t\t\t<div class="col-md-9 col-sm-9 col-xs-12">\r\n\t\t\t\t\t\t<switch id="" name="" ng-model="vm.printArticalNumberInKitchen.setting" class="green" ng-change="vm.changePrintArticalNumberInKitchen()"></switch>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t--><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3">Font size Kitchen</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" ng-model="vm.fontSizeKitchen.setting" class="form-control"></div><button class="btn btn-success col-md-3 col-sm-3 col-xs-3" ng-click="vm.saveFontSize()"><span data-translate="entity.action.save">Save</span></button></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3">Fast login</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" ng-model="vm.fastLogin.setting" class="form-control"></div><button class="btn btn-success col-md-3 col-sm-3 col-xs-3" ng-click="vm.saveFastLogin()"><span data-translate="entity.action.save">Save</span></button></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3" data-translate="global.order.commenttokitchen">Comments</label><div class="col-md-7 col-sm-7 col-xs-7"><input type="text" ng-model="vm.commentsTemplate.setting" class="form-control"></div><button class="btn btn-success col-md-1 col-sm-1 col-xs-1" ng-click="vm.saveCommentTemplate()"><span data-translate="entity.action.save">Save</span></button></div><!--\r\n\t\t\t\t<div class="form-group" >\r\n\t\t\t\t\t<label class="control-label col-md-3 col-sm-3 col-xs-3" >Ti\u1EC1n v\u1ED1n</label>\r\n\t\t\t\t\t<div class="col-md-7 col-sm-7 col-xs-7">\r\n\t\t\t\t\t\t\t<input type="text" ng-model="vm.TIEN_VON.setting"   class="form-control">\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<button class="btn btn-success col-md-1 col-sm-1 col-xs-1" ng-click="vm.saveTienVon()">\r\n\t\t\t\t\t\t\t<span data-translate="entity.action.save"> Save</span>\r\n\t\t\t\t\t</button>\r\n\t\t\t\t\t\r\n\t\t\t\t</div>\r\n\t\t\t\t--><div class="form-group" ng-show="!vm.hiddenHardiskSetting"><label class="control-label col-md-3 col-sm-3 col-xs-12" data-translate="global.setting.smartStorage">Smart Storage</label><div class="col-md-9 col-sm-9 col-xs-12"><span ng-repeat="disk in vm.setting.hardisks" class="ng-scope" role="button" ng-click="vm.selectDisk(disk)"><div class="col-md-2 col-sm-2 col-xs-6" style="cursor: pointer"><figure class="figure"><div ng-if="!(disk.diskName==vm.setting.diskSetting)"><img style="margin-left: 35px" ng-src="content/images/flash-drive.png" alt="" src="content/images/flash-drive.png"></div><div ng-if="disk.diskName==vm.setting.diskSetting"><img style="margin-left:35px" ng-src="content/images/flash-drive_selected.png" alt="" src="content/images/flash-drive_selected.png"></div><figcaption class="figure-caption text-center"><span ng-bind="disk.diskName"></span> <span>{{disk.diskDescription}}</span></figcaption></figure></div></span></div></div><!--\r\n\t\t\t\t<div class="form-group">\r\n\t\t\t\t\t<div class="control-label col-md-3 col-sm-3 col-xs-12">\r\n\t\t\t\t\t\t<button class="btn btn-success" ng-click="vm.saveSetting()">\r\n\t\t\t\t\t\t\t<span class="fa fa-save" ></span> <span data-translate="entity.action.save"> Save</span>\r\n\t\t\t\t\t\t</button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t--></div></div><div class="x_content" ng-if="vm.currentRole == \'ROLE_SUPER_USER\'"><div class="form-horizontal form-label-left" ng-if="vm.showSuperSettingContent == false"><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3">Password</label><div class="col-md-5 col-sm-5 col-xs-5 input-group input-group-md"><input type="password" id="smartStepPassword" ng-model="vm.smartStep_Password" class="form-control" ng-virtual-keyboard="vm.t003Config"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat ng-scope" ng-click="vm.tryPassword()">Try</button><!-- end ngIf: vm.isSearchButton --><!-- ngIf: vm.isSearchButton == false --></span></div></div></div><div class="form-horizontal form-label-left" ng-if="vm.showSuperSettingContent == true"><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3">Smart Step</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" id="smartStep" ng-model="vm.smartStep.setting" class="form-control" ng-virtual-keyboard="vm.t003Config"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3">Smart Change</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" id="smartChange" ng-model="vm.smartChange.setting" class="form-control" ng-virtual-keyboard="vm.t003Config"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3">Min Limit</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" id="minLimit" ng-model="vm.minLimit.setting" class="form-control" ng-virtual-keyboard="vm.t003Config"></div></div><div class="form-group"><label class="control-label col-md-3 col-sm-3 col-xs-3">Max Limit</label><div class="col-md-5 col-sm-5 col-xs-5"><input type="text" id="maxLimit" ng-model="vm.maxLimit.setting" class="form-control" ng-virtual-keyboard="vm.t003Config"></div></div><div class="form-group"><div class="control-label col-md-8 col-sm-8 col-xs-8"><button class="btn btn-success pull-right" ng-click="vm.saveSuperSetting()"><span class="fa fa-save"></span> <span data-translate="entity.action.save">Save</span></button> <button class="btn" ng-click="vm.cancelSuperSetting()" style="margin-right:30px"><span class=""></span> <span data-translate="entity.action.cancel">Cancel</span></button></div></div></div></div></div></div><span id="alertTeamViewerStarted" ng-show="false" data-translate="global.setting.alertTeamViewerStarted"></span>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>C\u1EEDa h\xE0ng</span></dt><dd>{{vm.user.store.storeName}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">T\u1EA1o ho\u1EB7c s\u1EEDa user</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.loginPass">Login pass</label><input type="text" class="form-control" name="loginPass" ng-model="vm.user.loginPass" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.loginPass.$invalid"><p class="help-block" ng-show="editForm.loginPass.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.loginPass.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label>Quy\u1EC1n</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div><div class="form-group"><label>C\u1EEDa h\xE0ng</label><select class="form-control" name="store" ng-model="vm.user.store" ng-options="store as store.storeName for store in vm.stores track by store.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #333;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="user-management.new" style="cursor: pointer"><span class="glyphicon glyphicon-flash"></span>&nbsp; <span>T\u1EA1o t\xE0i kho\u1EA3n m\u1EDBi</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>\u0110\u0103ng xu\u1EA5t</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><jhi-alert></jhi-alert><div class="row"></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th>C\u01A1 s\u1EDF</th><th></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td>{{user.store.storeName}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><!--\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n    --></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/bill/bill-detail.html','<div><h2><span>S\u1ED1 h\xF3a \u0111\u01A1n:</span> {{vm.bill.billCode}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Ph\xF2ng</span></dt><dd><span>{{vm.bill.room.name}}</span></dd><dt><span>Lo\u1EA1i ph\xF2ng</span></dt><dd><span>{{vm.bill.room.type}}</span></dd><dt><span>Gi\xE1 ph\xF2ng</span></dt><dd><span>{{vm.bill.room.price}}</span></dd><dt><span>Nh\xE2n vi\xEAn</span></dt><dd><span>{{vm.bill.waiter}}</span></dd><dt><span>Gi\u1EDD v\xE0o</span></dt><dd><span>{{vm.bill.startedAt | date:\'dd-MM-yyyy HH:mm\'}}</span></dd><dt><span>Gi\u1EDD ra</span></dt><dd><span>{{vm.bill.endAt | date:\'dd-MM-yyyy HH:mm\'}}</span></dd><br><dt><span>Th\u1EDDi gian t\xEDnh ti\u1EC1n</span></dt><dd><span>{{vm.bill.duration}} ph\xFAt</span></dd><br><dt><span>T\u1ED5ng ti\u1EC1n h\xE1t</span></dt><dd><span>{{vm.bill.roomMoney | number:0}}</span></dd><dt><span>T\u1ED5ng ti\u1EC1n \u0111\u1ED3</span></dt><dd><span>{{vm.bill.productMoney | number:0}}</span></dd><dt><span>Gi\u1EA3m gi\xE1</span></dt><dd><span>{{vm.bill.roomMoney + vm.bill.productMoney - vm.bill.totalValue | number:0}}</span></dd><dt><span>T\u1ED5ng ti\u1EC1n</span></dt><dd><span>{{vm.bill.totalValue | number:0}}</span></dd><br><dt><span>Tr\u1EA1ng th\xE1i</span></dt><dd><span>{{vm.bill.status}}</span></dd><br><dt><span>Danh s\xE1ch \u0111\u1ED3</span></dt><!-- Table row --><div class="row"><div class="table-responsive col-sm-12" style="height: 280px; overflow-y:scroll;overflow-x: hidden"><table class="table table-bordered table-sm"><thead><tr><th><span>STT</span></th><th><span>T\xEAn s\u1EA3n ph\u1EA9m</span></th><th><span>Gi\xE1</span></th><th><span>SL</span></th></tr></thead><tbody><tr ng-repeat="orderedProduct in vm.bill.listProducts"><td>{{$index +1}}</td><td>{{orderedProduct.name }}</td><td>{{orderedProduct.price | number:2}}</td><td>{{orderedProduct.quantity}}</td></tr></tbody></table></div><!-- /.col --></div><!-- /.row --></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></div>');
$templateCache.put('app/entities/bill/bill-print-preview.html','<style>#invoice-POS{\r\n  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);\r\n  padding:2mm;\r\n  margin: 0 auto;\r\n  width: 80mm;\r\n  background: #FFF;\r\n  \r\n\r\n::selection {background: #f31544; color: #FFF;}\r\n::moz-selection {background: #f31544; color: #FFF;}\r\nh1{\r\n  font-size: 1.5em;\r\n  color: #222;\r\n}\r\nh2{font-size: .9em;}\r\nh3{\r\n  font-size: 1.2em;\r\n  font-weight: 300;\r\n  line-height: 2em;\r\n}\r\np{\r\n  font-size: .7em;\r\n  color: #666;\r\n  line-height: 1.2em;\r\n}\r\n \r\n#top, #mid,#bot{ /* Targets all id with \'col-\' */\r\n  border-bottom: 1px solid #EEE;\r\n}\r\n\r\n#top{min-height: 100px;}\r\n#mid{min-height: 80px;} \r\n#bot{ min-height: 50px;}\r\n\r\n#top .logo{\r\n  //float: left;\r\n\theight: 60px;\r\n\twidth: 60px;\r\n\t/*background: url(\'content/images/logo.png\') no-repeat;*/\r\n\tbackground-size: 60px 60px;\r\n}\r\n\r\n.info{\r\n  display: block;\r\n  //float:left;\r\n  margin-left: 0;\r\n}\r\n.title{\r\n  float: right;\r\n}\r\n.title p{text-align: right;} \r\ntable{\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\ntd{\r\n  //padding: 5px 0 5px 15px;\r\n  //border: 1px solid #EEE\r\n}\r\n.tabletitle{\r\n  //padding: 5px;\r\n  font-size: .5em;\r\n  background: #EEE;\r\n}\r\n.service{border-bottom: 1px solid #EEE;}\r\n.item{width: 40mm;}\r\n.itemtext{font-size: .5em;}\r\n\r\n#legalcopy{\r\n  margin-top: 5mm;\r\n}\r\n\r\n  @print {\r\n           size: auto;   /* auto is the initial value */ \r\n\r\n    \t\t/* this affects the margin in the printer settings */ \r\n   \t\t\t margin: 5mm 5mm 5mm 5mm; \r\n        }</style><nav class="navbar navbar-default" role="navigation" style="padding:0px;margin-top: -15px;width:100%"><div class="container" style="width:100%"><div class="navbar-collapse" style="background-color: #D3E5F7; color: #555"><ul class="nav navbar-nav"><li ng-click="vm.print()"><a><button type="button" style="padding:0;margin:0;border:none;background-color: transparent"><span class="glyphicon glyphicon-print"></span> <span>In</span></button></a></li><li ng-click="vm.back()"><a><button type="button" style="padding:0;margin:0;border:none;background-color: transparent"><span class="glyphicon glyphicon-menu-left"></span> <span class="ng-scope">Quay l\u1EA1i</span></button></a></li></ul></div></div></nav><div id="invoice-POS"><center id="top"><!--\r\n      <div class="logo">\r\n      \t<img  ng-src="{{vm.apiUrl}}api/file/get-file/image/{{vm.store.storeImage}}"\r\n                                      class="figure-img img-fluid rounded"  width="50%" height="50%">\r\n      </div>\r\n      --></center><!--End InvoiceTop--><div id="mid"><div class="info"><h2 style="text-align: center">{{vm.store.storeName}}</h2><p>\u0110/c: {{vm.store.storeAddress}}<br>S\u0110T: {{vm.store.storePhone}}<br></p></div></div><!--End Invoice Mid--> <span class="legal" style="">Gi\u1EDD k\u1EBFt th\xFAc: {{vm.bill.endAt| date: \'dd-MM-yyyy HH:mm\'}}</span><br><span class="legal" style="">Th\u1EDDi l\u01B0\u1EE3ng: {{vm.bill.duration| number: 0}} ph\xFAt</span><br><span class="legal" style="">Nh\xE2n vi\xEAn: {{vm.bill.waiter }}</span><br><span class="legal" style="">Ph\xF2ng: {{vm.bill.room.name }}</span><br><span class="legal" style="">S\u1ED1 h\xF3a \u0111\u01A1n: {{vm.bill.billCode }}</span><br><div id="bot"><div id="table"><table><thead><tr style="border-top: dashed;border-width: 1px"><td style="width:40%"><h2>S\u1EA3n ph\u1EA9m</h2></td><td style="width:15%"><h2>SL</h2></td><td style=""><h2>Gi\xE1 ti\u1EC1n</h2></td><td style=""><h2>Th\xE0nh ti\u1EC1n</h2></td></tr></thead><tbody><tr ng-repeat="product in vm.bill.listProducts track by $index" class="tabletitle"><td>{{product.name}}</td><td>{{product.quantity}}</td><td>{{product.price |number:0}}</td><td>{{product.price * product.quantity | number:0}}</td></tr><tr style="border-top: dashed;border-width: 1px"><td><h2>Ti\u1EC1n \u0111\u1ED3</h2></td><td colspan="3" class="payment"><h2>{{vm.bill.productMoney |number:0}}</h2></td></tr><tr><td><h2>Ti\u1EC1n h\xE1t</h2></td><td colspan="3" class="payment"><h2>{{vm.bill.roomMoney |number:0}}</h2></td></tr><tr><td><h2>Gi\u1EA3m gi\xE1</h2></td><td colspan="3" class="payment"><h2>{{vm.bill.productMoney + vm.bill.roomMoney - vm.bill.totalValue |number:0}}</h2></td></tr><tr style="border-top: dashed;border-width: 1px"><td><h2>T\u1ED5ng</h2></td><td colspan="3" class="payment"><h2>{{vm.bill.totalValue |number:0}}</h2></td></tr></tbody></table></div><!--End Table--><div id="dd" style="margin-bottom:250px;margin-top: 20px;overflow: hidden"><span style="text-align: center; width:50%; float:left">Kh\xE1ch h\xE0ng<br><span style="font-size: 8px">(K\xED, ghi r\xF5 h\u1ECD t\xEAn)</span></span> <span style="text-align: center;width:50%;float: left">Thu ng\xE2n<br><span style="font-size: 8px">(K\xED, ghi r\xF5 h\u1ECD t\xEAn)</span></span></div><div id="legalcopy"><p class="legal" style="text-align: center"><strong>{{vm.store.thank}}</strong></p></div></div><!--End InvoiceBot--></div><!--End Invoice-->');
$templateCache.put('app/entities/bill/bills.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.account.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div id="main-report"><h2 class="col-sm-12">L\u1ECBch s\u1EED b\xE1n h\xE0ng karaoke</h2><div><div class="row"><div><div class="row" style="margin-top: 10px"><div class="form-group col-md-3 col-xs-12"><h2 class="col-sm-4">C\u01A1 s\u1EDF</h2><div class="form-group col-sm-6"><div class="form-group row"><select class="form-control" name="type" ng-model="vm.filterStore" ng-options="store as store.storeName for store in vm.stores track by store.id" ng-change="vm.loadAll()" ng-disabled="vm.currentRole != \'ROLE_SUPER_ADMIN\'"></select></div></div></div><div class="form-group col-md-3 col-xs-12"><h2 class="col-sm-4">T\u1EEB ng\xE0y</h2><div class="input-group date input-group-sm col-xs-6"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button> </span><!--https://angular-ui.github.io/bootstrap/--> <input id="date" type="text" class="form-control" name="date" ng-model="vm.dateSearch" ng-change="vm.loadAll()" uib-datepicker-popup="{{vm.dateformat}}" is-open="popup1.opened" datepicker-options="dateOptions" readonly="readonly"></div><!-- /.input group --></div><div class="form-group col-md-3 col-xs-12"><h2 class="col-sm-4">\u0110\u1EBFn ng\xE0y</h2><div class="input-group date input-group-sm col-xs-6"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button> </span><!--https://angular-ui.github.io/bootstrap/--> <input id="date" type="text" class="form-control" name="date2" ng-model="vm.dateTo" ng-change="vm.loadAll()" uib-datepicker-popup="{{vm.dateformat}}" is-open="popup2.opened" datepicker-options="dateOptions" readonly="readonly"></div><!-- /.input group --></div></div></div></div></div><div id="report" class="row col-md-12"><div class="col-md-4 col-xs-12" id="left-report"><table class="table"><tbody><tr><td>Gi\u1EDD b\xE1o c\xE1o</td><td>{{vm.time | date:\'dd-MM-yyyy HH:mm\'}}</td></tr><tr><td>S\u1ED1 \u0111\u01A1n h\xE0ng</td><td>{{vm.billCount}}</td></tr><tr><td><h2>T\u1ED5ng ti\u1EC1n Thu (FINISH)</h2></td><td style="font-weight: bold"><h2>{{vm.totalMoney | number:0}}</h2></td></tr><tr><td><h2>T\u1ED5ng ti\u1EC1n H\u1EE7y (DELETE)</h2></td><td style="font-weight: bold"><h2>{{vm.totalMoneyDelete | number:0}}</h2></td></tr></tbody></table></div><!-- end #left-report--><div class="col-md-8 col-xs-12" id="right-report"><table class="jh-table table table-striped"><thead><tr><th><span>S\u1EA3n ph\u1EA9m</span></th><th><span>S\u1ED1 l\u01B0\u1EE3ng b\xE1n</span></th><th><span>Ti\u1EC1n nh\u1EADp v\xE0o</span></th><th><span>Ti\u1EC1n b\xE1n ra</span></th></tr></thead><tbody><tr ng-repeat="product in vm.products track by $index"><td>{{product.name}}</td><td>{{product.count}}</td><td>{{product.inputMoney | number:0}}</td><td>{{product.totalMoney | number:0}}</td></tr><tr style="font-weight: bold; font-size: 15px"><td><b>T\u1ED5ng</b></td><td>{{vm.totalProduct }}</td><td>{{vm.totalInputMoneyProduct | number:0}}</td><td>{{vm.totalMoneyProduct | number:0}}</td></tr></tbody></table></div><!--end #right-report --></div><div class="table-responsive col-md-12" id="bills"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>M\xE3 \u0111\u01A1n h\xE0ng</span></th><th><span>Nh\xE2n vi\xEAn</span></th><th><span>Th\u1EDDi gian</span></th><th><span>T\u1ED5ng ti\u1EC1n</span></th><th><span>Tr\u1EA1ng th\xE1i</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="bill in vm.bills track by bill.id"><td>{{$index +1}}</td><td>{{bill.billCode}}</td><td>{{bill.waiter}}</td><td>{{bill.endAt | date:\'short\'}}</td><td>{{bill.totalValue | number:0}}</td><td>{{bill.status}}</td><td><div class="col-sm-12"><button type="submit" style="margin-bottom:10px" ng-click="vm.gotoDetail(bill.id)" class="btn btn-info btn-sm col-sm-6"><span class="hidden-sm-down">Chi ti\u1EBFt</span></button> <button type="submit" style="margin-bottom:10px" ng-if="vm.currentRole != \'ROLE_SUPER_ADMIN\' && bill.status != \'DELETE\'" ng-click="vm.printBill(bill.id)" class="btn btn-primary btn-sm col-sm-6"><span class="hidden-sm-down">In l\u1EA1i</span></button></div></td><td><button type="submit" style="margin-bottom:10px" ng-click="vm.deleteBill(bill)" class="btn btn-danger btn-sm col-sm-12" ng-if="vm.currentRole == \'ROLE_ADMIN\' && bill.status != \'DELETE\'"><span class="hidden-sm-down">X\xF3a</span></button></td></tr></tbody></table></div><!-- end bill --><!--\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n    --></div>');
$templateCache.put('app/entities/billMatxa/billMatxa-detail.html','<div><h2><span>S\u1ED1 h\xF3a \u0111\u01A1n:</span> {{vm.billMatxa.billCode}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>C\u01A1 s\u1EDF</span></dt><dd><span>{{vm.billMatxa.store.storeName}}</span></dd><dt><span>Ng\u01B0\u1EDDi b\xE1n</span></dt><dd><span>{{vm.billMatxa.waiter}}</span></dd><dt><span>Lo\u1EA1i v\xE9</span></dt><dd><span>{{vm.billMatxa.ticket.type}}</span></dd><dt><span>Gi\xE1 v\xE9</span></dt><dd><span>{{vm.billMatxa.ticket.price | number:0}}</span></dd><dt><span>Gi\u1EA3m gi\xE1</span></dt><dd><span>{{vm.billMatxa.discountValue | number:0}}</span></dd><dt><span>Ti\u1EC1n thu \u0111\u01B0\u1EE3c</span></dt><dd><span>{{vm.billMatxa.totalValue | number:0}}</span></dd><dt><span>Gi\u1EDD b\u1EAFt \u0111\u1EA7u b\xE1n v\xE9</span></dt><dd><span>{{vm.billMatxa.startedAt | date:\'dd-MM-yyyy HH:mm\'}}</span></dd><dt><span>Gi\u1EDD b\xE1n v\xE9 xong</span></dt><dd><span>{{vm.billMatxa.endAt | date:\'dd-MM-yyyy HH:mm\'}}</span></dd><dt><span>Tr\u1EA1ng th\xE1i \u0111\u01A1n h\xE0ng</span></dt><dd><span>{{vm.billMatxa.status}}</span></dd><dt><span>Tr\u1EA1ng th\xE1i in v\xE9</span></dt><dd><span>{{vm.billMatxa.paymentStatus}}</span></dd><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></dl></div>');
$templateCache.put('app/entities/billMatxa/billMatxa-print-preview.html','<style>#invoice-POS{\r\n  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);\r\n  margin: 0 auto;\r\n  width: 80mm;\r\n  background: #FFF;\r\n  min-height: 450px;\r\n  \r\n\r\n::selection {background: #f31544; color: #FFF;}\r\n::moz-selection {background: #f31544; color: #FFF;}\r\n}\r\n\r\np{\r\n  font-size: .7em;\r\n  color: #666;\r\n  line-height: 1.2em;\r\n}\r\n \r\n#top, #mid,#bot{ /* Targets all id with \'col-\' */\r\n  border-bottom: 1px solid #EEE;\r\n}\r\n\r\n#top{min-height: 100px;}\r\n#mid{min-height: 80px;} \r\n#bot{ min-height: 50px;}\r\n\r\n#top {\r\n  height: 60px;\r\n  width: 60px;\r\n  background-size: 60px 60px;\r\n}\r\n\r\n.info{\r\n  display: block;\r\n  margin-left: 0;\r\n}\r\n.title{\r\n  float: right;\r\n}\r\n.title p{text-align: right;} \r\ntable{\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.tabletitle{\r\n  font-size: .5em;\r\n  background: #EEE;\r\n}\r\n.service{border-bottom: 1px solid #EEE;}\r\n.item{width: 40mm;}\r\n.itemtext{font-size: .5em;}\r\n\r\n#legalcopy{\r\n  margin-top: 5mm;\r\n}\r\n\r\n  @print {\r\n           size: auto;   /* auto is the initial value */ \r\n\r\n        /* this affects the margin in the printer settings */ \r\n         margin: 5mm 5mm 5mm 5mm; \r\n        }</style><nav class="navbar navbar-default" role="navigation" style="padding:0px;margin-top: -15px;width:100%"><div class="container" style="width:100%"><div class="navbar-collapse" style="background-color: #D3E5F7; color: #555"><ul class="nav navbar-nav"><li ng-click="vm.print()"><a><button type="button" style="padding:0;margin:0;border:none;background-color: transparent" class="btn btn-lg"><span class="glyphicon glyphicon-print"></span> <span>In</span></button></a></li><li ng-click="vm.back()"><a><button type="button" style="padding:0;margin:0;border:none;background-color: transparent"><span class="glyphicon glyphicon-menu-left"></span> <span class="ng-scope">Quay l\u1EA1i</span></button></a></li></ul></div></div></nav><div id="invoice-POS"><div class="info"><h2 class="col-xs-12" style="text-align: center;font-weight: bold">{{vm.store.storeName}}</h2><p class="col-xs-12">\u0110/c: {{vm.store.storeAddress}}<br>S\u0110T: {{vm.store.storePhone}}<br></p></div><!--End Invoice Mid--><div class="content"><h2 class="col-xs-12">V\xE9 massage giao kh\xE1ch</h2><div class="row col-xs-12"><label class="col-xs-5">M\xE3 s\u1ED1:</label><label class="col-xs-7">{{vm.billMatxa.billCode }}</label></div><div class="row col-xs-12"><label class="col-xs-5">Lo\u1EA1i:</label><label class="col-xs-7">{{vm.billMatxa.ticket.type }}</label></div><div class="row col-xs-12"><label class="col-xs-5">Gi\u1EDD mua:</label><label class="col-xs-7">{{vm.billMatxa.startedAt| date: \'dd-MM-yyyy HH:mm:ss\'}}</label></div><div class="row col-xs-12"><label class="col-xs-5">Th\u1EDDi gian:</label><label class="col-xs-7">{{vm.billMatxa.ticket.duration }} ph\xFAt</label></div><div class="row col-xs-12"><label class="col-xs-5">Ng\u01B0\u1EDDi b\xE1n v\xE9:</label><label class="col-xs-7">{{vm.billMatxa.waiter }}</label></div><div class="row col-xs-12" ng-if="vm.billMatxa.customer != null"><label class="col-xs-5">Kh\xE1ch h\xE0ng:</label><label class="col-xs-7">{{vm.billMatxa.customer }}</label></div><div class="row col-xs-12"><h2 class="col-xs-5">Gi\xE1 v\xE9:</h2><h2 class="col-xs-7">{{vm.billMatxa.ticket.price | number:0}} \u0111</h2></div><div class="row col-xs-12" ng-if="vm.billMatxa.discountValue >0"><h2 class="col-xs-5">Gi\u1EA3m gi\xE1:</h2><h2 class="col-xs-7">{{vm.billMatxa.discountValue | number:0}} \u0111</h2></div><div class="row col-xs-12"><h2 class="col-xs-5">Th\xE0nh ti\u1EC1n:</h2><h2 class="col-xs-7"><b>{{vm.billMatxa.totalValue | number:0}} \u0111</b></h2></div><div class="row col-xs-12" style="margin-bottom:100px;margin-top: 20px;overflow: hidden"><div style="text-align: center; width: 50%; float:left">Kh\xE1ch h\xE0ng<br><span style="font-size: 8px">(K\xED, ghi r\xF5 h\u1ECD t\xEAn)</span></div><div style="text-align: center;width: 50%;float: left">Thu ng\xE2n<br><span style="font-size: 8px">(K\xED, ghi r\xF5 h\u1ECD t\xEAn)</span></div></div><div id="legalcopy2" class="row col-xs-12"><p class="legal" style="text-align: center"><strong>{{vm.store.thank}}</strong></p></div></div></div><!--End Invoice-->');
$templateCache.put('app/entities/billMatxa/billMatxas.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="billMatxa-detail({id:vm.currentBillMatxaId})" style="cursor: pointer" ng-if="vm.currentBillMatxaId != null"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span>Xem</span> </a><a ui-sref="billMatxa.delete({id:vm.currentBillMatxaId})" style="cursor: pointer" ng-if="vm.currentBillMatxaId != null"><span class="glyphicon glyphicon-remove"></span> <span>X\xF3a</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.account.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div id="main-report"><h2 class="col-sm-12">L\u1ECBch s\u1EED b\xE1n v\xE9 matxa</h2><div><div class="row"><div><div class="row" style="margin-top: 10px"><div class="form-group col-md-3 col-xs-12"><h2 class="col-sm-4">C\u01A1 s\u1EDF</h2><div class="form-group col-sm-6"><div class="form-group row"><select class="form-control" name="type" ng-model="vm.filterStore" ng-options="store as store.storeName for store in vm.stores track by store.id" ng-change="vm.loadAll()" ng-disabled="vm.currentRole != \'ROLE_SUPER_ADMIN\'"></select></div></div></div><div class="form-group col-md-3 col-xs-12"><h2 class="col-sm-4">T\u1EEB ng\xE0y</h2><div class="input-group date input-group-sm col-xs-6"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button> </span><!--https://angular-ui.github.io/bootstrap/--> <input id="date" type="text" class="form-control" name="date" ng-model="vm.dateSearch" ng-change="vm.loadAll()" uib-datepicker-popup="{{vm.dateformat}}" is-open="popup1.opened" datepicker-options="dateOptions" readonly="readonly"></div><!-- /.input group --></div><div class="form-group col-md-3 col-xs-12"><h2 class="col-sm-4">\u0110\u1EBFn ng\xE0y</h2><div class="input-group date input-group-sm col-xs-6"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button> </span><!--https://angular-ui.github.io/bootstrap/--> <input id="date" type="text" class="form-control" name="date2" ng-model="vm.dateTo" ng-change="vm.loadAll()" uib-datepicker-popup="{{vm.dateformat}}" is-open="popup2.opened" datepicker-options="dateOptions" readonly="readonly"></div><!-- /.input group --></div></div></div></div></div><div id="report" class="row col-md-12"><div class="col-md-5 col-xs-12" id="left-report"><table class="table"><tbody><tr><td>Gi\u1EDD b\xE1o c\xE1o</td><td>{{vm.time | date:\'dd-MM-yyyy HH:mm\'}}</td></tr><tr><td>S\u1ED1 \u0111\u01A1n h\xE0ng</td><td>{{vm.billMatxaCount}}</td></tr><tr><td><h2>T\u1ED5ng ti\u1EC1n THANH_CONG</h2></td><td style="font-weight: bold"><h2>{{vm.totalMoney | number:0}}</h2></td></tr><tr><td><h2>T\u1ED5ng ti\u1EC1n XOA</h2></td><td style="font-weight: bold"><h2>{{vm.totalMoneyDelete | number:0}}</h2></td></tr></tbody></table></div><!-- end #left-report--><div class="col-md-7 col-xs-12" id="right-report"><table class="jh-table table table-striped"><thead><tr><th><span>S\u1EA3n ph\u1EA9m</span></th><th><span>S\u1ED1 l\u01B0\u1EE3ng b\xE1n</span></th><th><span>Ti\u1EC1n b\xE1n</span></th></tr></thead><tbody><tr ng-repeat="product in vm.products track by $index"><td>{{product.type}}</td><td>{{product.count}}</td><td>{{product.totalMoney | number:0}}</td></tr></tbody></table></div><!--end #right-report --></div><div class="table-responsive col-md-12" id="billMatxas"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>M\xE3 \u0111\u01A1n h\xE0ng</span></th><th><span>Nh\xE2n vi\xEAn</span></th><th><span>Th\u1EDDi gian</span></th><th><span>T\u1ED5ng ti\u1EC1n</span></th><th><span>Tr\u1EA1ng th\xE1i b\xE1n</span></th><th><span>Tr\u1EA1ng th\xE1i In v\xE9</span></th><th></th></tr></thead><tbody><tr ng-repeat="billMatxa in vm.billMatxas track by billMatxa.id"><td>{{billMatxa.billCode}}</td><td>{{billMatxa.waiter}}</td><td>{{billMatxa.endAt | date:\'short\'}}</td><td>{{billMatxa.totalValue | number:0}}</td><td>{{billMatxa.status}}</td><td>{{billMatxa.paymentStatus}}</td><td><div class="col-sm-12"><button type="submit" style="margin-bottom:10px" ng-click="vm.gotoDetail(billMatxa.id)" class="btn btn-info btn-sm col-sm-12"><span class="hidden-sm-down">Chi ti\u1EBFt</span></button> <button type="submit" style="margin-bottom:10px" ng-if="vm.currentRole == \'ROLE_ADMIN\'" ng-click="vm.printBillMatxa(billMatxa.id)" class="btn btn-primary btn-sm col-sm-12"><span class="hidden-sm-down">In l\u1EA1i</span></button> <button type="submit" style="margin-bottom:10px" ng-if="vm.currentRole == \'ROLE_ADMIN\' && billMatxa.status != \'XOA\'" ng-click="vm.deleteBillMatxa(billMatxa)" class="btn btn-danger btn-sm col-sm-12"><span class="hidden-sm-down">X\xF3a</span></button></div></td></tr></tbody></table></div><!-- end billMatxa --><!--\r\n    <div class="text-center">\r\n        <jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count>\r\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination>\r\n    </div>\r\n    --></div>');
$templateCache.put('app/entities/config/config-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">X\xE1c nh\u1EADn h\xE0nh \u0111\u1ED9ng x\xF3a?</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Ban th\u1EF1c s\u1EF1 mu\u1ED1n x\xF3a?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()" style="margin-top:30px"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" style="margin-top:30px"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>X\xF3a ngay</span></button></div></form>');
$templateCache.put('app/entities/config/config-detail.html','<div><!--<jhi-alert-error></jhi-alert-error>--><dl class="dl-horizontal jh-entity-details"><dt><span>T\xEAn</span></dt><dd><span>{{vm.config.name}}</span></dd><dt><span>Lo\u1EA1i</span></dt><dd><span>{{vm.config.type}}</span></dd><dt><span>C\u01A1 s\u1EDF</span></dt><dd><span>{{vm.config.store.storeName}}</span></dd></dl><button type="button" ui-sref="config-detail.edit({id:vm.config.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">S\u1EEDa</span></button> <button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></div>');
$templateCache.put('app/entities/config/config-dialog.html','<style>.width80 {\r\n        width: 80%;\r\n    }\r\n    .width50 {\r\n        width: 50%;\r\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.config.id == null">Th\xEAm thi\u1EBFt l\u1EADp m\u1EDBi</h2><h2 ng-if="vm.config.id != null">S\u1EEDa thi\u1EBFt l\u1EADp</h2><div class="modal-body"><div class="row"><div class="col-xs-12"><div class="form-group col-xs-6"><label class="control-label" for="field_configName">T\xEAn</label><input type="text" class="form-control width80" ng-model="vm.config.name" required></div><div class="form-group col-xs-6"><label>Lo\u1EA1i</label><select class="form-control width80" name="type" ng-model="vm.config.type" ng-options="type  for type in vm.systemConfigs "></select></div></div></div></div><!-- end body --><div class="modal-footer col-xs-12"><button type="button" class="btn btn-info col-md-2 col-xs-5" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2 col-xs-5"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/config/config.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="config.new" style="cursor: pointer"><span class="glyphicon glyphicon-plus"></span> <span>T\u1EA1o m\u1EDBi</span> </a><a ui-sref="config-detail({id:vm.currentConfigId})" style="cursor: pointer" ng-if="vm.currentConfigId != null"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span>Xem</span> </a><a ui-sref="config.edit({id:vm.currentConfigId})" style="cursor: pointer" ng-if="vm.currentConfigId != null"><span class="glyphicon glyphicon-edit"></span> <span>S\u1EEDa</span> </a><a ui-sref="config.delete({id:vm.currentConfigId})" style="cursor: pointer" ng-if="vm.currentConfigId != null"><span class="glyphicon glyphicon-remove"></span> <span>X\xF3a</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.currentAccount.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><h2>Danh s\xE1ch c\xE1c thi\u1EBFt l\u1EADp</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>T\xEAn</span></th><th><span>Lo\u1EA1i</span></th><th><span>C\u01A1 s\u1EDF</span></th></tr></thead><tbody><tr ng-repeat="config in vm.configs track by config.id" ng-click="vm.selectConfig(config)" ng-style="vm.currentConfigId == config.id && {\'background-color\':\'#D3E5F7\'}"><td>{{$index +1}}</td><td>{{config.name}}</td><td>{{config.type}}</td><td>{{config.store.storeName}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/customer/customer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="global.customer.deleted" translate-values="{param: \'{{vm.customer.customerName}}\'}">Are you sure you want to delete this Customer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/customer/customer-detail.html','<div><h2><span data-translate="xposApp.customer.detail.title">Customer</span> {{vm.customer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="global.order.customername">Customer Name</span></dt><dd><span>{{vm.customer.customerName}}</span></dd><dt><span data-translate="global.customer.code">Code</span></dt><dd><span>{{vm.customer.code}}</span></dd><dt><span data-translate="global.order.customeraddress">Customer Address</span></dt><dd><span>{{vm.customer.customerAddress}}</span></dd><dt><span data-translate="global.order.customertaxcode">Customer Tax Code</span></dt><dd><span>{{vm.customer.customerTaxCode}}</span></dd><dt><span data-translate="global.order.customerphone">Customer Phone</span></dt><dd><span>{{vm.customer.customerPhone}}</span></dd><dt><span data-translate="global.order.customermail">Customer Mail</span></dt><dd><span>{{vm.customer.customerMail}}</span></dd><dt><span data-translate="global.customer.customertype">Customer Type</span></dt><dd><span data-translate="{{\'global.customer.customertype.\' + vm.customer.customerType}}">{{vm.customer.customerType}}</span></dd><dt><span data-translate="xposApp.customer.lastUpdateAt">Last Update At</span></dt><dd><span>{{vm.customer.lastUpdateAt | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="customer-detail.edit({id:vm.customer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/customer/customer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.customer.id == null">Th\xEAm kh\xE1ch h\xE0ng m\u1EDBi</h2><h2 ng-if="vm.customer.id != null">S\u1EEDa th\xF4ng tin kh\xE1ch h\xE0ng</h2><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-12 col-xs-12"><div class="form-group"><label class="control-label" for="field_customerName">T\xEAn kh\xE1ch h\xE0ng</label><input type="text" class="form-control" name="customerName" id="field_customerName" ng-model="vm.customer.customerName" required></div><div class="form-group"><label class="control-label" for="field_customerAddress">\u0110\u1ECBa ch\u1EC9</label><input type="text" class="form-control" name="customerAddress" id="field_customerAddress" ng-model="vm.customer.customerAddress"></div><div class="form-group"><label class="control-label" for="field_customerPhone">S\u1ED1 \u0111i\u1EC7n tho\u1EA1i</label><input type="text" class="form-control" name="customerPhone" id="field_customerPhone" ng-model="vm.customer.customerPhone"></div></div></div></div><!-- end body --><div class="modal-footer"><button type="button" class="btn btn-info col-md-2 pull-right" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2 pull-right"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/customer/customers.html','<style>.navbar-default .navbar-nav > li > a {\r\n        color : #154289;\r\n    }\r\n\r\n    .navbar-default .navbar-nav > .active > a, .navbar-default .navbar-nav > .active > a:hover, .navbar-default .navbar-nav > .active > a:focus {\r\n        color: #555;\r\n        background-color: #D3E5F7;\r\n        \r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><nav class="navbar navbar-default col-md-12" role="navigation" style="background-color:#C1DAF2; margin-top: 0px"><div class="container" style="width:100%"><div class="navbar-collapse" style="background-color:#C1DAF2; padding-left: 0px"><ul class="nav navbar-nav" uib-dropdown ng-switch="vm.isAuthenticated()" style="padding-left: 0px"><li ng-class="{active: vm.$state.includes(\'order-fast-buon\')}"><a ui-sref="order-fast-advance" style="cursor: pointer"><span class="hidden-sm">B\xE1n h\xE0ng</span></a></li><li ng-class="{active: vm.$state.includes(\'stockin\')}"><a ui-sref="stockin" style="cursor: pointer"><span class="hidden-sm">Nh\u1EADp kho</span></a></li><li ng-class="{active: vm.$state.includes(\'customer\')}"><a ui-sref="customer" style="cursor: pointer"><span class="hidden-sm">Kh\xE1ch h\xE0ng</span></a></li><li ng-class="{active: vm.$state.includes(\'product\')}"><a ui-sref="product" style="cursor: pointer"><span class="hidden-sm">S\u1EA3n ph\u1EA9m</span></a></li><li ng-class="{active: vm.$state.includes(\'bill\')}"><a ui-sref="bill" style="cursor: pointer"><span class="hidden-sm">H\xF3a \u0111\u01A1n</span></a></li><li ng-class="{active: vm.$state.includes(\'user-management\')}" has-authority="ROLE_ADMIN"><a ui-sref="user-management" style="cursor: pointer"><span class="hidden-sm">T\xE0i kho\u1EA3n</span></a></li><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="user-menu"><span><span style="color:#f49842">&nbsp;{{vm.currentAccount.login}}&nbsp;</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li></ul></li></ul></div></div></nav><div class="container" style="width:100%"><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()" style="background-color: #D3E5F7; color: #555"><ul class="nav navbar-nav"><li><a ui-sref="customer.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Th\xEAm m\u1EDBi</span></a></li><li ng-if="vm.currentCustomerId != null"><a ui-sref="customer.edit({id:vm.currentCustomerId})"><span class="glyphicon glyphicon glyphicon-edit"></span> <span class="hidden-sm-down">S\u1EEDa</span></a></li></ul></div></div><div><h2>Danh s\xE1ch kh\xE1ch h\xE0ng</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>T\xEAn Kh\xE1ch h\xE0ng</span></th><th><span>\u0110\u1ECBa ch\u1EC9</span></th><th><span>S\u1ED1 \u0111i\u1EC7n tho\u1EA1i</span></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.id" ng-click="vm.selectCustomer(customer)" ng-style="vm.currentCustomerId == customer.id && {\'background-color\':\'#D3E5F7\'}"><td>{{$index + 1}}</td><td>{{customer.customerName}}</td><td>{{customer.customerAddress}}</td><td>{{customer.customerPhone}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/order-fast-advance/modal-change-room.html','<style>.item-product {\r\n\t\theight:90px;\r\n\t\ttext-align: center;\r\n\t\tvertical-align: middle;\r\n\t\tfont-weight: bold;\r\n\t\t/*background-color: #FFCBCB;*/\r\n\t\tmargin:0px;\r\n\t\tpadding: 0px;\r\n\t\tposition: relative;\r\n\t\ttext-overflow: clip;\r\n\t\toverflow: hidden;\r\n\t}\r\n\r\n\t.centered {\r\n\t    position: absolute;\r\n\t    top: 50%;\r\n\t    left: 50%;\r\n\t    transform: translate(-50%, -50%);\r\n\t}\r\n\t.top-left {\r\n\t    position: absolute;\r\n\t    top: 0%;\r\n\t    left: 0%;\r\n\t}\r\n\t.top-right {\r\n\t    position: absolute;\r\n\t    top: 0%;\r\n\t    right: 0%;\r\n\t}\r\n\t.bottom-left {\r\n\t    position: absolute;\r\n\t    bottom: 0%;\r\n\t    left: 0%;\r\n\t}</style><div class=""><h3 class="modal-title">Ch\u1ECDn ph\xF2ng m\u1EDBi \u0111\u1EC3 chuy\u1EC3n sang</h3></div><div class="modal-body" style="height: 500px"><span ng-repeat="room in emptyRooms track by room.id" ng-click="selectRoom(room)"><div class="col-md-4 col-sm-4 col-xs-4 well item-product"><div class="top-left">{{room.price | number:0}}</div><div class="top-right" ng-if="room.type == \'VIP\'" style="color:blue">{{room.type}}</div><div class="centered" style="font-size: 20px">{{room.name}}</div><div class="bottom-left">{{room.orderStartAt | date: \'dd-MM-yy HH:mm\'}}</div></div></span></div><div class="modal-footer"><button style="margin-left:30px" class="btn btn-info col-xs-3 pull-right" type="button" ng-click="cancel()">H\u1EE7y</button></div>');
$templateCache.put('app/entities/order-fast-advance/modal-discount.html','<style></style><div class=""><h3 class="modal-title">Nh\u1EADp % khuy\u1EBFn m\u1EA1i</h3></div><div class="modal-body" style="height: 150px"><div id="content" class="row col-md-12"><input class="form-control" type="text" ng-model="number"></div><div id="number-pannel" class="row col-md-12" style="margin-top: 20px"><span ng-repeat="n in listNumber track by $index" ng-click="selectNumber(n)"><div class="col-md-1 border" style="height: 40px"><div class="centered" style="font-size: 20px">{{n}}</div></div></span><div class="col-md-2 border" style="height: 40px" ng-click="deleteNumber()"><div class="centered" style="font-size: 20px">X\xF3a</div></div></div></div><div class="modal-footer"><button style="margin-left:30px" class="btn btn-info col-xs-3 pull-right" type="button" ng-click="cancel()">H\u1EE7y</button> <button class="btn btn-primary col-xs-3 pull-right" ng-click="discount()">\u0110\u1ED3ng \xFD</button></div>');
$templateCache.put('app/entities/order-fast-advance/modal-update-product.html','<style></style><div class=""><h3 class="modal-title">Nh\u1EADp s\u1ED1 l\u01B0\u1EE3ng c\u1EE7a: {{productName}}</h3></div><div class="modal-body" style="height: 150px"><div id="content" class="row col-md-12"><input class="form-control" type="text" ng-model="number" disabled="disabled"></div><div id="number-pannel" class="row col-md-12" style="margin-top: 20px"><span ng-repeat="n in listNumber track by $index" ng-click="selectNumber(n)"><div class="col-md-1 border" style="height: 40px"><div class="centered" style="font-size: 20px">{{n}}</div></div></span><div class="col-md-2 border" style="height: 40px" ng-click="deleteNumber()"><div class="centered" style="font-size: 20px">X\xF3a</div></div></div></div><div class="modal-footer"><button style="margin-left:30px" class="btn btn-info col-xs-3 pull-right" type="button" ng-click="cancel()">H\u1EE7y</button> <button class="btn btn-primary col-xs-3 pull-right" ng-click="updateNumber()">\u0110\u1ED3ng \xFD</button></div>');
$templateCache.put('app/entities/order-fast-advance/order-karaoke.html','<style>figure.serif {\r\n\t    font-family: "Times New Roman", Times, serif;\r\n\t}\r\n\r\n\tfigure.sansserif {\r\n\t    font-family: Arial, Helvetica, sans-serif;\r\n\t    font-size: 14px;\r\n\t}\r\n\r\n\t.noselect {\r\n\t  -webkit-touch-callout: none; /* iOS Safari */\r\n\t    -webkit-user-select: none; /* Safari */\r\n\t     -khtml-user-select: none; /* Konqueror HTML */\r\n\t       -moz-user-select: none; /* Firefox */\r\n\t        -ms-user-select: none; /* Internet Explorer/Edge */\r\n\t            user-select: none; /* Non-prefixed version, currently\r\n\t                                  supported by Chrome and Opera */\r\n\t}\r\n\t\r\n\tth, thead, tr, td {\r\n\t\tpadding: 0px;\r\n\t\tborder-bottom-width: 0px;\r\n\t}\r\n\t.main-table > thead > tr > th, .main-table > tbody > tr > th, .main-table > tfoot > tr > th, .main-table > thead > tr > td, .main-table > tbody > tr > td, .main-table > tfoot > tr > td {\r\n    \tline-height: 0.8;\r\n\t}\r\n\t.elemLeftBottomTotalMoney{\r\n\t\tbackground-color:#dee6f4;;\r\n\t\tborder-style: solid;\r\n    \tborder-width: 1px;\r\n    \tborder-color: #331a00;\r\n    \theight:45px;\r\n    \tline-height:45px;\r\n    \tmargin: 0px;\r\n    \tpadding: 0px;\r\n\t}\r\n\t.item-product {\r\n\t\theight:90px;\r\n\t\ttext-align: center;\r\n\t\tvertical-align: middle;\r\n\t\tfont-weight: bold;\r\n\t\t/*background-color: #FFCBCB;*/\r\n\t\tmargin:0px;\r\n\t\tpadding: 0px;\r\n\t\tposition: relative;\r\n\t\ttext-overflow: clip;\r\n\t\toverflow: hidden;\r\n\t}\r\n\t.item-product-c008 {\r\n\t\theight:52px;\r\n\t\ttext-align: center;\r\n\t\tvertical-align: middle;\r\n\t\tfont-weight: bold;\r\n\t\t/*background-color: #FFCBCB;*/\r\n\t\tmargin:0px;\r\n\t\tpadding: 0px;\r\n\t\tposition: relative;\r\n\t\ttext-overflow: clip;\r\n\t\toverflow: hidden;\r\n\t}\r\n\t.centered {\r\n\t    position: absolute;\r\n\t    top: 50%;\r\n\t    left: 50%;\r\n\t    transform: translate(-50%, -50%);\r\n\t}\r\n\t.top-left {\r\n\t    position: absolute;\r\n\t    top: 0%;\r\n\t    left: 0%;\r\n\t}\r\n\t.top-right {\r\n\t    position: absolute;\r\n\t    top: 0%;\r\n\t    right: 0%;\r\n\t}\r\n\t.bottom-left {\r\n\t    position: absolute;\r\n\t    bottom: 0%;\r\n\t    left: 0%;\r\n\t}\r\n\t.li-menu:active, .li-menu:focus{\r\n\t\tbackground-color: #818DE8;\r\n\t}\r\n\r\n\t.border {\r\n\t\tborder-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\t.border-top-botom {\r\n\t\tborder-bottom-style: solid;\r\n\t\tborder-top-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\t.border-left-right {\r\n\t\tborder-left-style: solid;\r\n\t\tborder-right-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\r\n\t div.desc{\r\n\t\t    background-color: #000;\r\n\t\t    bottom: 0;\r\n\t\t    color: #fff;\r\n\t\t    left: 0;\r\n\t\t    opacity: 0.5;\r\n\t\t    position: absolute;\r\n\t\t    width: 100%;\r\n\t\t}\r\n\t\t    .fix{width:100%; padding:0px;}\r\n\t@media screen and (min-width: 601px) {\r\n\t  #total {\r\n\t    font-size: 40px;\r\n\t  }\r\n\t}\r\n\r\n\t@media screen and (max-width: 600px) {\r\n\t  #total {\r\n\t    font-size: 25px;\r\n\t  }\r\n\t}\r\n\r\n\t.productbox {\r\n\r\n\t    background-color:#ffffff;\r\n\t\tmargin:10px;\r\n\t\tmargin-bottom:10px;\r\n\t\t-webkit-box-shadow: 0 8px 6px -6px  #999;\r\n\t\t   -moz-box-shadow: 0 8px 6px -6px  #999;\r\n\t\t        box-shadow: 0 8px 6px -6px #999;\r\n\t}\r\n\r\n\t.producttitle {\r\n\t    font-weight:bold;\r\n\t\tpadding:5px 0 5px 0;\r\n\t\tmargin-top-60px;\r\n\t}\r\n\r\n\t.productprice {\r\n\t\tborder-top:1px solid #dadada;\r\n\t\tpadding-top:5px;\r\n\t}\r\n\r\n\t.pricetext {\r\n\t\tfont-weight:bold;\r\n\t\tfont-size:1.4em;\r\n\t}\r\n\r\n\t/* Bottom left text */\r\n.bottom-left {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  left: 2px;\r\n}\r\n.bottom-right {\r\n  position: absolute;\r\n  bottom: 8px;\r\n  right: 16px;\r\n}\r\n\r\n.top-left{\r\n   position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n\r\n}\r\n.top-right {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n}</style><!--\xE4\xFC --><div class="container" style=""><!-- end #account --><div class="col-md-12" style="height: 30px;background-color: #dbedf9;padding-top: 5px"><div class="col-md-4 row" id="top-left"><button class="col-md-4 btn btn-danger" style="padding-top: 0px" ng-click="vm.deleteSelectedOrderedItem()">X\xF3a \u0111\u1ED3</button> <button class="col-md-4 btn btn-success" style="padding-top: 0px" ng-click="vm.openModalDiscount()">Khuy\u1EBFn m\u1EA1i</button> <button class="col-md-4 btn btn-primary" style="padding-top: 0px" ng-click="vm.checkout()">Thanh to\xE1n</button></div><div class="col-md-4" id="top-middle" style=""><button class="col-md-4 btn btn-success pull-left" ng-if="vm.currentOrder != null" style="padding-top: 0px" ng-click="vm.changeRoom()">\u0110\u1ED5i ph\xF2ng</button> <button class="col-md-4 btn btn-primary" ng-if="vm.currentOrder.roomFree == \'0\'" style="padding-top: 0px" ng-click="vm.discountRoom()">Mi\u1EC5n ph\xED h\xE1t</button> <button class="col-md-4 btn btn-primary" ng-if="vm.currentOrder.roomFree == \'1\'" style="padding-top: 0px" ng-click="vm.cancelDiscountRoom()">H\u1EE7y mi\u1EC5n ph\xED h\xE1t</button> <button class="col-md-4 btn btn-danger pull-right" ng-if="vm.currentOrder != null" style="padding-top: 0px" ng-click="vm.deleteCurrentOrder()">H\u1EE7y ph\xF2ng</button></div><div class="col-md-4" id="top-right" style=""><a href="" ng-click="vm.logout()" id="logout" class="pull-right"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.currentAccount.login}}\'</span> </a><a ui-sref="navigate" style="cursor: pointer; margin-right: 20px" class="pull-right"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span></a></div></div><div id="content" class="col-md-12" style="background-color: #FFFFFF;padding-left: 10px;padding-right: 10px"><div class="col-md-4" id="left" style="padding: 0px"><div class="row col-md-12 col-xs-12"><label class="">Gi\u1EDD v\xE0o: <span>{{vm.currentOrder.startedAt | date: \'dd-MM-yy HH:mm\'}}</span></label></div><div class="row col-md-12 col-xs-12"><label class="">Ph\xF2ng: <span style="font-size: 20px">{{vm.currentOrder.room.name}}</span></label><label class="pull-right">Gi\xE1 ph\xF2ng: <span style="font-size: 20px">{{vm.currentOrder.roomPrice | number :0}}/ph\xFAt</span></label></div><div class="row col-md-12 col-xs-12"><label class="">Ti\u1EC1n \u0111\u1ED3: <span style="font-size: 20px">{{vm.currentOrder.productMoney | number :0}}</span></label><label class="pull-right">Gi\u1EA3m gi\xE1 (%) : <span style="font-size: 20px">{{vm.currentOrder.discountValue | number :0}}</span></label></div><div class="row col-md-12 col-xs-12" id="tableOrder" style="height: 650px; overflow-y:scroll;overflow-x: hidden;background-color: #f8f9f4"><table class="main-table table table-bordered table-sm"><thead><tr style="background-color:#dee6f4"><th><span>STT</span></th><th><span>S\u1EA3n ph\u1EA9m</span></th><th><span>Gi\xE1</span></th><th><span>S\u1ED1 l\u01B0\u1EE3ng</span></th></tr></thead><tbody><tr ng-repeat="orderedProduct in vm.currentOrder.listProducts  track by $index" ng-click="vm.selectItem(orderedProduct.orderedProductId, orderedProduct.quantity)" ng-style="orderedProduct.orderedProductId == vm.selectedOrderedProductIndex && {\'background-color\': \'#AEF3C7\'}"><td>{{$index + 1}}</td><td>{{orderedProduct.name}}</td><td>{{orderedProduct.price | number:0}}</td><td><input class="form-control" type="text" ng-model="orderedProduct.quantity" ng-click="vm.changeQuantityProduct(orderedProduct)"></td></tr></tbody></table><!-- end table--></div><!-- end #tableOrder --></div><!-- end #left --><div class="col-md-4" id="middle" style="padding-left: 0px;height:650px;background-color: #e8efea"><h2 style="margin-left: 10px">Danh s\xE1ch \u0111\u1ED3 \u0103n u\u1ED1ng</h2><span ng-repeat="product in vm.products track by product.id" ng-click="vm.selectProduct(product)"><div class="col-md-4 col-sm-4 col-xs-4 well item-product" style="background-color: #bed8c3"><div class="top-left">{{product.productSalePrice | number:0}}</div><div class="top-right" style="color:blue; margin-right: 5px">{{product.quantity}}</div><div class="bottom-left">{{product.productName}}</div></div></span></div><!-- end #middle --><div class="col-md-4" id="right" style="padding: 0px;height:650px; overflow-y:scroll;overflow-x: hidden;background-color: #eff2f7"><h2 style="margin-left: 10px">Danh s\xE1ch ph\xF2ng</h2><span ng-repeat="room in vm.rooms track by room.id" ng-click="vm.selectRoom(room)"><div class="col-md-6 col-sm-6 col-xs-6 well item-product" ng-style="room.orderStatus == \'INPROGRESS\' && {\'background-color\':\'#6abffc\'}"><div class="top-left">{{room.price | number:0}}</div><div class="top-right" ng-if="room.type == \'VIP\'" style="color:blue">{{room.type}}</div><div class="centered" style="font-size: 20px">{{room.name}}</div><div class="bottom-left">{{room.orderStartAt | date: \'dd-MM-yy HH:mm\'}}</div></div></span></div><!-- end #right --></div><!-- end #content --></div>');
$templateCache.put('app/entities/order-fast-advance/order-matxa.html','<style>figure.serif {\r\n\t    font-family: "Times New Roman", Times, serif;\r\n\t}\r\n\r\n\tfigure.sansserif {\r\n\t    font-family: Arial, Helvetica, sans-serif;\r\n\t    font-size: 14px;\r\n\t}\r\n\r\n\t.noselect {\r\n\t  -webkit-touch-callout: none; /* iOS Safari */\r\n\t    -webkit-user-select: none; /* Safari */\r\n\t     -khtml-user-select: none; /* Konqueror HTML */\r\n\t       -moz-user-select: none; /* Firefox */\r\n\t        -ms-user-select: none; /* Internet Explorer/Edge */\r\n\t            user-select: none; /* Non-prefixed version, currently\r\n\t                                  supported by Chrome and Opera */\r\n\t}\r\n\t\r\n\tth, thead, tr, td {\r\n\t\tpadding: 0px;\r\n\t\tborder-bottom-width: 0px;\r\n\t}\r\n\t.main-table > thead > tr > th, .main-table > tbody > tr > th, .main-table > tfoot > tr > th, .main-table > thead > tr > td, .main-table > tbody > tr > td, .main-table > tfoot > tr > td {\r\n    \tline-height: 0.8;\r\n\t}\r\n\t.elemLeftBottomTotalMoney{\r\n\t\tbackground-color:#dee6f4;;\r\n\t\tborder-style: solid;\r\n    \tborder-width: 1px;\r\n    \tborder-color: #331a00;\r\n    \theight:45px;\r\n    \tline-height:45px;\r\n    \tmargin: 0px;\r\n    \tpadding: 0px;\r\n\t}\r\n\t.item-ticket {\r\n\t\theight:90px;\r\n\t\ttext-align: center;\r\n\t\tvertical-align: middle;\r\n\t\tfont-weight: bold;\r\n\t\t/*background-color: #FFCBCB;*/\r\n\t\tmargin:0px;\r\n\t\tpadding: 0px;\r\n\t\tposition: relative;\r\n\t\ttext-overflow: clip;\r\n\t\toverflow: hidden;\r\n\t}\r\n\r\n\t.item-bill {\r\n\t\theight:135px;\r\n\t\ttext-align: center;\r\n\t\tvertical-align: middle;\r\n\t\tfont-weight: bold;\r\n\t\t/*background-color: #FFCBCB;*/\r\n\t\tmargin:0px;\r\n\t\tpadding: 0px;\r\n\t\tposition: relative;\r\n\t\ttext-overflow: clip;\r\n\t\toverflow: hidden;\r\n\t}\r\n\t.item-ticket-c008 {\r\n\t\theight:52px;\r\n\t\ttext-align: center;\r\n\t\tvertical-align: middle;\r\n\t\tfont-weight: bold;\r\n\t\t/*background-color: #FFCBCB;*/\r\n\t\tmargin:0px;\r\n\t\tpadding: 0px;\r\n\t\tposition: relative;\r\n\t\ttext-overflow: clip;\r\n\t\toverflow: hidden;\r\n\t}\r\n\t\r\n\r\n\r\n\t.li-menu:active, .li-menu:focus{\r\n\t\tbackground-color: #818DE8;\r\n\t}\r\n\r\n\t.border {\r\n\t\tborder-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\t.border-top-botom {\r\n\t\tborder-bottom-style: solid;\r\n\t\tborder-top-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\t.border-left-right {\r\n\t\tborder-left-style: solid;\r\n\t\tborder-right-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\r\n\t div.desc{\r\n\t\t    background-color: #000;\r\n\t\t    bottom: 0;\r\n\t\t    color: #fff;\r\n\t\t    left: 0;\r\n\t\t    opacity: 0.5;\r\n\t\t    position: absolute;\r\n\t\t    width: 100%;\r\n\t\t}\r\n\t\t    .fix{width:100%; padding:0px;}\r\n\t@media screen and (min-width: 601px) {\r\n\t  #total {\r\n\t    font-size: 40px;\r\n\t  }\r\n\t}\r\n\r\n\t@media screen and (max-width: 600px) {\r\n\t  #total {\r\n\t    font-size: 25px;\r\n\t  }\r\n\t}\r\n\r\n\t.ticketbox {\r\n\r\n\t    background-color:#ffffff;\r\n\t\tmargin:10px;\r\n\t\tmargin-bottom:10px;\r\n\t\t-webkit-box-shadow: 0 8px 6px -6px  #999;\r\n\t\t   -moz-box-shadow: 0 8px 6px -6px  #999;\r\n\t\t        box-shadow: 0 8px 6px -6px #999;\r\n\t}\r\n\r\n\t.tickettitle {\r\n\t    font-weight:bold;\r\n\t\tpadding:5px 0 5px 0;\r\n\t\tmargin-top-60px;\r\n\t}\r\n\r\n\t.ticketprice {\r\n\t\tborder-top:1px solid #dadada;\r\n\t\tpadding-top:5px;\r\n\t}\r\n\r\n\t.pricetext {\r\n\t\tfont-weight:bold;\r\n\t\tfont-size:1.4em;\r\n\t}\r\n\r\n\t/* Bottom left text */\r\n.centered {\r\n\t    position: absolute;\r\n\t    top: 50%;\r\n\t    left: 50%;\r\n\t    transform: translate(-50%, -50%);\r\n\t}\r\n\t.top-left {\r\n\t    position: absolute;\r\n\t    top: 0%;\r\n\t    left: 0%;\r\n\t}\r\n\t.top-right {\r\n\t    position: absolute;\r\n\t    top: 0%;\r\n\t    right: 0%;\r\n\t}\r\n\t.bottom-left {\r\n\t    position: absolute;\r\n\t    bottom: 0%;\r\n\t    left: 0%;\r\n\t}\r\n.bottom-right {\r\n\t    position: absolute;\r\n\t    bottom: 0%;\r\n\t    right: 0%;\r\n\t}</style><!--\xE4\xFC --><div class="container" style=""><!-- end #account --><div class="col-md-12" style="height: 30px;background-color: #dbedf9;padding-top: 5px"><div class="col-md-4" id="top-left"></div><div class="col-md-4" id="top-middle" style=""></div><div class="col-md-4" id="top-right" style=""><a href="" ng-click="vm.logout()" id="logout" class="pull-right"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.currentAccount.login}}\'</span> </a><a ui-sref="navigate" style="cursor: pointer; margin-right: 20px" class="pull-right"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="billMatxa" style="cursor: pointer; margin-right: 20px" class="pull-right"><span class="glyphicon glyphicon-list-alt"></span> <span>L\u1ECBch s\u1EED b\xE1n h\xE0ng</span></a></div></div><div id="content" class="col-md-12" style="background-color: #FFFFFF"><div class="col-md-6 col-xs-12" id="middle" style="padding-left: 0px;height:700px;background-color: #e8efea"><h2 style="margin-left: 10px">C\xE1c lo\u1EA1i v\xE9</h2><h2 style="margin-left: 10px">Click v\xE0o t\u1EEBng lo\u1EA1i v\xE9 \u0111\u1EC3 t\u1EA1o v\xE9 cho kh\xE1ch</h2><span ng-repeat="ticket in vm.tickets track by ticket.id" ng-click="vm.selectTicket(ticket)"><div class="col-xs-12" style="margin-top: 20px"><div class="col-md-12 col-sm-12 col-xs-12 well item-ticket" style="background-color: #bed8c3"><div class="top-left" style="font-size: 20px">{{ticket.price | number:0}} \u0111</div><div class="centered" style="font-size: 25px">{{ticket.type}}</div><div class="bottom-right" style="font-size: 25px">{{ticket.duration}} ph\xFAt</div></div></div></span></div><!-- end #middle --><div class="col-md-6 col-xs-12" id="right" style="padding: 0px;height:700px; overflow-y:scroll;overflow-x: hidden;background-color: #eff2f7"><h2 style="margin-left: 10px">V\xE9 \u0111ang \u0111\u1EB7t</h2><h2 style="margin-left: 10px">Click v\xE0o n\xFAt "In V\xE9"" \u0111\u1EC3 in v\xE9 \u0111\u01B0a kh\xE1ch v\xE0 thu ti\u1EC1n</h2><span ng-repeat="billMatxa in vm.billMatxas track by billMatxa.id"><div class="col-xs-12" style="margin-top: 20px"><div class="col-md-8 col-sm-8 col-xs-8 well item-bill" style="background-color: #dbedf9"><div class="top-left" style="font-size: 20px">{{billMatxa.totalValue | number:0}}</div><div class="top-right">M\xE3 s\u1ED1: {{billMatxa.billCode}}<br>Gi\u1EDD mua: {{billMatxa.startedAt | date:\'dd-MM-yyyy HH:mm:ss\'}}</div><div class="centered" style="font-size: 25px">{{billMatxa.ticket.type}}</div><button class="bottom-left btn btn-danger col-xs-3" ng-click="vm.cancelTicket(billMatxa)">H\u1EE7y v\xE9</button> <button class="bottom-right btn btn-primary col-xs-6" ng-click="vm.printBillMatxa(billMatxa)">In v\xE9</button></div><div class="col-md-4 col-sm-4 col-xs-4 well item-bill" style="background-color: #dbedf9"><div class="col-xs-12" style="padding-top: 0px;text-align: left"><label class="row col-xs-12">Gi\u1EA3m gi\xE1</label><input class="col-xs-12" type="number" ng-model="billMatxa.discountValue"></div><div class="col-xs-12" style="margin-top: 15px;text-align: left"><label class="row col-xs-12">Kh\xE1ch h\xE0ng</label><input class="col-xs-12" type="text" ng-model="billMatxa.customer"></div></div></div></span></div><!-- end #right --></div><!-- end #content --></div>');
$templateCache.put('app/entities/order-pos/make-order-add-customer.html','<style>* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.autocomplete {\r\n  /*the container must be positioned relative:*/\r\n  position: relative;\r\n  \r\n}\r\n\r\n.autocomplete-items {\r\n  position: absolute;\r\n  border: 1px solid #d4d4d4;\r\n  border-bottom: none;\r\n  border-top: none;\r\n  z-index: 99;\r\n  /*position the autocomplete items to be the same width as the container:*/\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n\r\n}\r\n.autocomplete-items div {\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  background-color: #e9e9e9; \r\n  border-bottom: 1px solid #d4d4d4; \r\n}\r\n.autocomplete-items div:hover {\r\n  /*when hovering an item:*/\r\n  background-color: #fff; \r\n}\r\n.autocomplete-active {\r\n  /*when navigating through the items using the arrow keys:*/\r\n  background-color: DodgerBlue !important; \r\n  color: #ffffff; \r\n}</style><script>function autocomplete(inp, arr) {\r\n          /*the autocomplete function takes two arguments,\r\n          the text field element and an array of possible autocompleted values:*/\r\n          var currentFocus;\r\n          /*execute a function when someone writes in the text field:*/\r\n          inp.addEventListener("input", function(e) {\r\n              var a, b, i, val = this.value;\r\n              /*close any already open lists of autocompleted values*/\r\n              closeAllLists();\r\n              if (!val) { return false;}\r\n              currentFocus = -1;\r\n              /*create a DIV element that will contain the items (values):*/\r\n              a = document.createElement("DIV");\r\n              a.setAttribute("id", this.id + "autocomplete-list");\r\n              a.setAttribute("class", "autocomplete-items");\r\n              /*append the DIV element as a child of the autocomplete container:*/\r\n              this.parentNode.appendChild(a);\r\n              /*for each item in the array...*/\r\n              for (i = 0; i < arr.length; i++) {\r\n                /*check if the item starts with the same letters as the text field value:*/\r\n                if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {\r\n                  /*create a DIV element for each matching element:*/\r\n                  b = document.createElement("DIV");\r\n                  /*make the matching letters bold:*/\r\n                  b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";\r\n                  b.innerHTML += arr[i].substr(val.length);\r\n                  /*insert a input field that will hold the current array item\'s value:*/\r\n                  b.innerHTML += "<input type=\'hidden\' value=\'" + arr[i] + "\'>";\r\n                  /*execute a function when someone clicks on the item value (DIV element):*/\r\n                  b.addEventListener("click", function(e) {\r\n                      /*insert the value for the autocomplete text field:*/\r\n                      inp.value = this.getElementsByTagName("input")[0].value;\r\n                      /*close the list of autocompleted values,\r\n                      (or any other open lists of autocompleted values:*/\r\n                      closeAllLists();\r\n                  });\r\n                  a.appendChild(b);\r\n                }\r\n              }\r\n          });\r\n          /*execute a function presses a key on the keyboard:*/\r\n          inp.addEventListener("keydown", function(e) {\r\n              var x = document.getElementById(this.id + "autocomplete-list");\r\n              if (x) x = x.getElementsByTagName("div");\r\n              if (e.keyCode == 40) {\r\n                /*If the arrow DOWN key is pressed,\r\n                increase the currentFocus variable:*/\r\n                currentFocus++;\r\n                /*and and make the current item more visible:*/\r\n                addActive(x);\r\n              } else if (e.keyCode == 38) { //up\r\n                /*If the arrow UP key is pressed,\r\n                decrease the currentFocus variable:*/\r\n                currentFocus--;\r\n                /*and and make the current item more visible:*/\r\n                addActive(x);\r\n              } else if (e.keyCode == 13) {\r\n                /*If the ENTER key is pressed, prevent the form from being submitted,*/\r\n                e.preventDefault();\r\n                if (currentFocus > -1) {\r\n                  /*and simulate a click on the "active" item:*/\r\n                  if (x) x[currentFocus].click();\r\n                }\r\n              }\r\n          });\r\n          function addActive(x) {\r\n            /*a function to classify an item as "active":*/\r\n            if (!x) return false;\r\n            /*start by removing the "active" class on all items:*/\r\n            removeActive(x);\r\n            if (currentFocus >= x.length) currentFocus = 0;\r\n            if (currentFocus < 0) currentFocus = (x.length - 1);\r\n            /*add class "autocomplete-active":*/\r\n            x[currentFocus].classList.add("autocomplete-active");\r\n          }\r\n          function removeActive(x) {\r\n            /*a function to remove the "active" class from all autocomplete items:*/\r\n            for (var i = 0; i < x.length; i++) {\r\n              x[i].classList.remove("autocomplete-active");\r\n            }\r\n          }\r\n          function closeAllLists(elmnt) {\r\n            /*close all autocomplete lists in the document,\r\n            except the one passed as an argument:*/\r\n            var x = document.getElementsByClassName("autocomplete-items");\r\n            for (var i = 0; i < x.length; i++) {\r\n              if (elmnt != x[i] && elmnt != inp) {\r\n                x[i].parentNode.removeChild(x[i]);\r\n              }\r\n            }\r\n          }\r\n          /*execute a function when someone clicks in the document:*/\r\n          document.addEventListener("click", function (e) {\r\n              closeAllLists(e.target);\r\n              });\r\n        }</script><div class="modal-body"><div id="keyboard-wrapper"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomerLabel" data-translate="global.order.createoreditlabel">Create or edit a Customer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="global.order.customername" for="field_customerName">Customer Name</label><input type="text" class="form-control" name="customerName" id="field_customerName" ng-model="vm.customer.customerName" required ng-virtual-keyboard="vm.t05Config"> <span style="color:red" ng-show=" editForm.customerName.$invalid"><p data-translate="global.order.validatecustomername" ng-show="editForm.customerName.$error.required">Customer name is required</p></span></div><div class="form-group"><label class="control-label" data-translate="global.customer.customerCompany" for="field_customerCompany">Customer Company</label><input type="text" class="form-control" name="customerName" id="field_customerCompany" ng-model="vm.customer.customerCompany" ng-virtual-keyboard="vm.t05Config"></div><div class="form-group"><label class="control-label" data-translate="global.customer.customerCity" for="field_customerCity">Customer City</label><input type="text" class="form-control" name="customerCity" id="field_customerCity" ng-model="vm.customer.customerCity" ng-virtual-keyboard="vm.t05Config"></div><div class="form-group"><label class="control-label" data-translate="global.customer.customerPostCode" for="field_customerPostCode">Customer Post Code</label><input type="text" class="form-control" name="customerPostCode" id="field_customerPostCode" ng-model="vm.customer.customerPostCode" ng-blur="vm.activeStreetSuggestion()" ng-virtual-keyboard="vm.t05Config"></div><div class="form-group"><label class="control-label" for="field_customerStreet" data-translate="global.customer.customerStreet">Street</label><div class="autocomplete"><input autocomplete="false" class="form-control" id="streetInput" type="text" name="streetInput" ng-model="vm.customer.street" ng-virtual-keyboard="vm.t05Config"></div></div><div class="form-group"><label class="control-label" data-translate="global.order.customeraddress" for="field_customerAddress">Customer Address</label><input type="text" class="form-control" name="customerAddress" id="field_customerAddress" ng-model="vm.customer.customerAddress" ng-virtual-keyboard="vm.t05Config"></div><div class="form-group"><label class="control-label" data-translate="global.order.customertaxcode" for="field_customerTaxCode">Customer Tax Code</label><input type="text" class="form-control" name="customerTaxCode" id="field_customerTaxCode" ng-model="vm.customer.customerTaxCode" ng-virtual-keyboard="vm.t05Config"></div><div class="form-group"><label class="control-label" data-translate="global.order.customerphone" for="field_customerPhone">Customer Phone</label><input type="text" class="form-control" name="customerPhone" id="field_customerPhone" ng-virtual-keyboard="vm.t05Config" ng-model="vm.customer.customerPhone"></div><div class="form-group"><label class="control-label" data-translate="global.order.customermail" for="field_customerMail">Customer Mail</label><input type="text" class="form-control" name="customerMail" id="field_customerMail" ng-model="vm.customer.customerMail" ng-virtual-keyboard="vm.t05Config"></div><div class="form-group"><label class="control-label" data-translate="global.order.customertype" for="field_customerType">Customer Type</label><select class="form-control" name="customerType" ng-model="vm.customer.customerType" id="field_customerType"><option ng-selected="selected" value="ECONOMIC" data-translate="global.order.customertypeeconomic">ECONOMIC</option><option value="VIP" data-translate="global.order.customertypevip">VIP</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-submit-add-customer"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div></div>');
$templateCache.put('app/entities/order-pos/make-order-change-table.html','<form name="editForm" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="global.order.changetable">Change table</h4></div><div class="modal-body"><!-- #table-map --><div class="row" id="table-map"><div class="col-md-12"><!-- Custom Tabs --><div class="nav-tabs-custom"><!-- table-map-menu --><ul class="nav nav-tabs" id="table-map-menu"><li class="list-inline-item"><button class="btn btn-primary btn-sm" ng-click="vm.filter(\'TableZone\', \'All\')"><span data-translate="global.order.all">Alles</span></button></li><li class="list-inline-item" ng-repeat="tableZone in vm.tableZones track by tableZone.id"><button class="btn btn-primary btn-sm" ng-click="vm.filter(\'TableZone\',tableZone.tableZoneName)"><span class="hidden-sm-dow">{{tableZone.tableZoneName}}</span></button></li></ul><!-- /#table-map-menu  --><div class="tab-content"><div class="tab-pane active" id="tab_1"><div class="row"><!-- elements --> <span ng-repeat="tablePos in vm.tables track by tablePos.id" ng-show="tablePos.statusForOrder !=\'INPROGRESS\'" ng-click="vm.changeTable(tablePos.tableNo)"><div class="col-md-2 col-sm-2 col-xs-6" style="cursor: pointer"><figure class="figure"><img ng-src="{{tablePos.statusForOrder == \'INPROGRESS\' ? \'content/images/order.png\' : \'content/images/order1.png\'}}" alt="" width="100%"><figcaption class="figure-caption text-center">{{tablePos.tableNo}}</figcaption><!-- <figcaption class="figure-caption text-center" data-translate="{{\'xposApp.OrderStatus.\' + tablePos.statusForOrder}}">{{tablePos.statusForOrder}}</figcaption>  --></figure></div></span><!-- /elements --></div></div><!-- /.tab-pane --></div><!-- /.tab-content --></div><!-- nav-tabs-custom --></div><!-- /.col --></div><!-- /.row /#table-map --></div><!-- /.modal-body --><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Stornieren</span></button></div></form>');
$templateCache.put('app/entities/order-pos/make-order-delete-order.html','<section class=""><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="global.order.delete_order_confirm">Do you want to delete this Order?</h4></div><div class="modal-body"><div class="row"><div class="col-md-2"></div><button class="btn btn-primary col-md-2" ng-click="vm.deleteOrder()">Yes</button><div class="col-md-4"></div><button class="btn btn-success col-md-2" ng-click="vm.clear()">No</button><div class="col-md-2"></div></div></div><!-- /.modal-body --><!--<div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n    </div>--></section>');
$templateCache.put('app/entities/order-pos/make-order-merge-table.html','<form name="editForm" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="global.order.mergetable">Merge Table</h4></div><div class="modal-body"><!-- #table-map --><div class="row" id="table-map"><div class="col-md-12"><!-- Custom Tabs --><div class="nav-tabs-custom"><!-- table-map-menu --><ul class="nav nav-tabs" id="table-map-menu"><li class="list-inline-item"><button class="btn btn-primary btn-sm" ng-click="vm.filter(\'TableZone\', \'All\')"><span data-translate="global.order.all">Alles</span></button></li><li class="list-inline-item" ng-repeat="tableZone in vm.tableZones track by tableZone.id"><button class="btn btn-primary btn-sm" ng-click="vm.filter(\'TableZone\',tableZone.tableZoneName)"><span class="hidden-sm-dow">{{tableZone.tableZoneName}}</span></button></li></ul><!-- /#table-map-menu  --><div class="tab-content"><div class="tab-pane active" id="tab_1"><div class="row"><!-- elements --> <span ng-repeat="tablePos in vm.tables track by tablePos.id" ng-show="tablePos.statusForOrder ==\'INPROGRESS\' && tablePos.tableNo != vm.currentOrder.tablePos" ng-click="vm.mergeTable(tablePos)"><div class="col-md-2 col-sm-2 col-xs-6" style="cursor: pointer"><figure class="figure"><img ng-src="{{tablePos.statusForOrder == \'INPROGRESS\' ? \'content/images/order.png\' : \'content/images/order1.png\'}}" alt="" width="100%"><figcaption class="figure-caption text-center">{{tablePos.tableNo}}</figcaption><!-- <figcaption class="figure-caption text-center" data-translate="{{\'xposApp.OrderStatus.\' + tablePos.statusForOrder}}">{{tablePos.statusForOrder}}</figcaption>  --></figure></div></span><!-- /elements --></div></div><!-- /.tab-pane --></div><!-- /.tab-content --></div><!-- nav-tabs-custom --></div><!-- /.col --></div><!-- /.row /#table-map --></div><!-- /.modal-body --><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Stornieren</span></button></div></form>');
$templateCache.put('app/entities/order-pos/make-order-new-order.html','<section class=""><span ng-if="vm.showErrorOrderAfterReport == false"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="global.order.new_order_confirm">Do you want to create new Order?</h4></div><div class="modal-body"><div class="row"><div class="col-md-2"></div><button class="btn btn-primary col-md-2" ng-click="vm.createNewOrder()" data-translate="global.order.yes">Yes</button><div class="col-md-4"></div><button class="btn btn-success col-md-2" ng-click="vm.clear()" data-translate="global.order.no">No</button><div class="col-md-2"></div></div></div></span><span ng-if="vm.showErrorOrderAfterReport == true"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="global.order.notify_create_order_after_daily_report">Can not order after daily report</h4></div><div class="modal-body"><div class="row"><div class="col-md-5"></div><button class="btn btn-success col-md-2" ng-click="vm.clear()" data-translate="global.order.ok">OK</button><div class="col-md-5"></div></div></div></span><!-- /.modal-body --><!--<div class="modal-footer">\r\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\r\n            <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>\r\n        </button>\r\n    </div>--></section>');
$templateCache.put('app/entities/order-pos/make-order-quick-comment.html','<section class=""><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="global.order.quickComment">Quick Comment</h4></div><div class="modal-body"><div class="row col-sm-12"><form class="form-horizontal col-sm-12"><div class="form-group"><div class="col-sm-10"><input type="text" class="form-control" id="search" ng-model="vm.comment" ng-virtual-keyboard="vm.t04Config"></div><button class="btn btn-primary col-sm-2" ng-click="vm.addComment(vm.comment)" data-translate="global.order.commenttokitchen">Comment</button></div></form></div><div class="row col-sm-12"><form class="form-horizontal col-sm-12"><div class="form-group" ng-repeat="tempComment in vm.comments" style="margin-bottom:10px"><div class="col-sm-12" ng-click="vm.selectCommentTemplate(tempComment)"><input type="text" class="form-control" value="{{tempComment}}" readonly="readonly"></div></div></form></div><!-- ./table --></div><!-- /.modal-body --><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></section>');
$templateCache.put('app/entities/order-pos/make-order-select-customer.html','<section class=""><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="global.order.selectcustomer">Select Customer</h4></div><div class="modal-body"><div class="row col-sm-12"><form class="form-horizontal col-sm-12"><div class="form-group"><div class="col-sm-9"><input type="text" class="form-control" id="search" ng-model="vm.search" ng-change="vm.loadAllCustomer()" ng-virtual-keyboard="vm.t04Config"></div><div class="col-sm-3"><button class="btn btn-primary" ng-click="vm.loadAllCustomer()" data-translate="global.order.search">Search</button></div></div></form></div><div class="row"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.order.customername">Customer Name</span></th><th><span data-translate="global.customer.customerCompany">Customer Company</span></th><th><span data-translate="global.customer.customerCity">Customer City</span></th><th><span data-translate="global.customer.customerPostCode">Customer Post Code</span></th><th><span data-translate="global.customer.customerStreet">Customer Street</span></th><th><span data-translate="global.order.customeraddress">Customer Address</span></th><th><span data-translate="global.order.customertaxcode">Customer Tax Code</span></th><th><span data-translate="global.order.customerphone">Customer Phone</span></th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers | orderBy:\'+\': true track by customer.id"><td>{{customer.customerName}}</td><td>{{customer.customerCompany}}</td><td>{{customer.customerCity}}</td><td>{{customer.customerPostCode}}</td><td>{{customer.street}}</td><td>{{customer.customerAddress}}</td><td>{{customer.customerTaxCode}}</td><td>{{customer.customerPhone}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.selectCustomer(customer)" class="btn btn-info btn-sm"><span class="hidden-sm-down" data-translate="global.order.select">Select</span></button></div></td></tr></tbody></table></div><!-- ./table --></div><!-- /.modal-body --><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></section>');
$templateCache.put('app/entities/order-pos/make-order-split.html','<style>.btn-cal-number {\r\n\twidth: 64px;\r\n\theight: 40px;\r\n\tmargin: 1px 0px;\r\n}\r\n\r\n.btn-cal-clear, .btn-cal-enter {\r\n\twidth: 100%;\r\n\theight: 82px;\r\n\tmargin: 1px 0px;\r\n}\r\n\r\n.btn-cal-back {\r\n\twidth: 100%;\r\n\theight: 40px;\r\n\tmargin: 1px 0px;\r\n}\r\n\r\n.btn-cal-zero {\r\n\twidth: 198px;\r\n\theight: 40px;\r\n\tmargin: 1px 0px;\r\n}\r\n\r\n.modal-content {\r\n\r\n\twidth: 354px;\r\n}</style><section><div class="modal-body"><div class="row"><div class="col-md-6" ng-show="vm.rightView == null"><section class="invoice" style="margin: 0px; padding: 10px"><!-- title row --><div class="row"><div class="col-xs-12"><h2 class="page-header-split-bill col-sm-6"><span data-translate="global.order.originalOrder">Original Order</span></h2><h2 class="page-header-split-bill pull-right col-sm-6">{{vm.currentOrder.startedAt | date:\'short\'}}</h2></div><!-- /.col --></div><div class="row invoice-info"><div class="col-sm-12"><form class="form-horizontal invoice-col"><div class="form-group"><div class="row"><label class="col-sm-2" for="tbl" data-translate="global.order.table">Tisch:</label><span class="col-sm-10"><b>{{vm.currentOrder.tablePos}}</b></span></div></div></form></div><div class="col-sm-12" style="margin: 5px 0px"><div class="input-group input-group-lg" style="width: 100%"><input type="text" class="form-control" ng-model="vm.currentOrder.totalValue" readonly="readonly" style="font-size: 36px; text-align: right"></div></div></div><!-- /.row --><!-- Table row --><div class="row"><div class="table-responsive col-sm-12"><table class="table table-bordered"><thead><tr><th><span data-translate="global.order.item">Item</span></th><th><span data-translate="global.order.qty">Qty</span></th><th><span data-translate="global.order.vat">VAT</span></th><th><span data-translate="global.order.total">Total</span></th><th></th></tr></thead><tbody><tr ng-repeat="orderedProduct in vm.currentOrder.listProducts"><td>{{orderedProduct.product.productName }}</td><td>{{orderedProduct.quantity}}</td><td>{{orderedProduct.taxRate*100 | number : 0}}&nbsp;%</td><td>{{orderedProduct.quantity * orderedProduct.product.productSalePrice}}&nbsp;{{orderedProduct.product.productCurrencyUnit === \'EUR\'?\'\u20AC\':\'\'}}</td><td><button class="btn btn-primary btn-sm" ng-disabled="orderedProduct.quantity == 0 || vm.isPaymentSplitting == false || (vm.currentOrder.listProducts.length ==1 && vm.currentOrder.listProducts[0].quantity ==1)" ng-click="vm.switchItem(orderedProduct)"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></button></td></tr></tbody></table></div><!-- /.col --></div><!-- /.row --><div class="row no-print"><div class="col-xs-12"><button type="button" class="btn btn-primary pull-right" ng-disabled="(vm.splittingOrder.listProducts != null && vm.splittingOrder.listProducts.length > 0) || vm.rightView != null" ng-click="vm.openPaymentCurrentOrder()" data-translate="global.order.payment">Payment</button></div></div></section></div><div class="col-md-6" ng-show="vm.isPaymentSplitting == true"><section class="invoice" style="margin: 0px; padding: 10px"><!-- title row --><div class="row"><div class="col-xs-12"><h2 class="page-header-split-bill col-sm-6"><span data-translate="global.order.splittedOrder">Splitted Order</span></h2><h2 class="page-header-split-bill pull-right col-sm-6">{{vm.splittingOrder.startedAt | date:\'short\'}}</h2></div><!-- /.col --></div><div class="row invoice-info"><div class="col-sm-12"><form class="form-horizontal invoice-col"><div class="form-group"><div class="row"><label class="col-sm-2" for="tbl" data-translate="global.order.table">Tisch:</label><span class="col-sm-10"><b>{{vm.splittingOrder.tablePos}}</b></span></div></div></form></div><div class="col-sm-12" style="margin: 5px 0px"><div class="input-group input-group-lg" style="width: 100%"><input type="text" class="form-control" ng-model="vm.splittingOrder.totalValue" readonly="readonly" style="font-size: 36px; text-align: right"></div></div></div><!-- /.row --><!-- Table row --><div class="row"><div class="table-responsive col-sm-12"><table class="table table-bordered"><thead><tr><th><span data-translate="global.order.item">Item</span></th><th><span data-translate="global.order.qty">Qty</span></th><th><span data-translate="global.order.vat">VAT</span></th><th><span data-translate="global.order.total">Total</span></th><th></th></tr></thead><tbody><tr ng-repeat="orderedProduct in vm.splittingOrder.listProducts"><td>{{orderedProduct.product.productName }}</td><td>{{orderedProduct.quantity}}</td><td>{{orderedProduct.taxRate*100 | number : 0}}&nbsp;%</td><td>{{orderedProduct.quantity * orderedProduct.product.productSalePrice}}&nbsp;{{orderedProduct.product.productCurrencyUnit === \'EUR\'?\'\u20AC\':\'\'}}</td><td><button class="btn btn-primary btn-sm" ng-click="vm.removeSplitting(orderedProduct)"><span class="hidden-sm-dow">-</span></button></td></tr></tbody></table></div><!-- /.col --></div><div class="row no-print"><div class="col-xs-12"><button type="button" class="btn btn-primary pull-left" ng-disabled="vm.splittingOrder.totalValue == null || vm.splittingOrder.totalValue == 0 || vm.rightView != null" ng-click="vm.openPaymentSplitting()" data-translate="global.order.payment">Bezahlen</button> <button type="button" class="btn btn-primary pull-left" style="margin-left:20px" ng-disabled="vm.splittingOrder.totalValue == null || vm.splittingOrder.totalValue == 0 || vm.rightView != null" ng-click="vm.cancelSplitMeal()" data-translate="global.order.cancel">Stornieren</button></div></div></section></div><div class="col-md-6" ng-hide="vm.rightView == null "><section class="invoice" style="margin: 0px; padding: 10px" ng-show="vm.customerView != null"><div class="modal-body"><div class="row col-sm-12"><form class="form-horizontal col-sm-12"><div class="form-group"><div class="col-sm-9"><input type="text" class="form-control" id="search" ng-model="vm.search" ng-blur="vm.loadAllCustomer()" ng-enter="vm.loadAllCustomer()"></div><div class="col-sm-3"><button class="btn btn-primary" ng-click="vm.loadAllCustomer()" data-translate="global.order.search">Search</button></div></div></form></div><div class="row"><div class="table-responsive col-sm-12" style="height: 450px; overflow-y:scroll;overflow-x: hidden"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.order.customername">Kundenname</span></th><th><span data-translate="global.order.customeraddress">Kundenadresse</span></th><th><span data-translate="global.order.customertaxcode">Kunden Steuernummer</span></th><th><span data-translate="global.order.customerphone">Kunden Telefonnummer</span></th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.id"><td>{{customer.customerName}}</td><td>{{customer.customerAddress}}</td><td>{{customer.customerTaxCode}}</td><td>{{customer.customerPhone}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.selectCustomer(customer)" class="btn btn-info btn-sm"><span class="hidden-sm-down">Select</span></button></div></td></tr></tbody></table></div></div><!-- ./table --></div><!-- /.modal-body --><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeSelectCustomer()"><span data-translate="entity.action.cancel">Stornieren</span></button></div></section><section class="invoice" style="margin: 0px; padding: 10px; width: 375px" ng-show="vm.paymentView != null "><div class="modal-body"><div class="row" style="margin-bottom: 20px"><div class="form-group"><label for="" class="col-sm-6 control-label" style="padding-top: 7px" data-translate="global.order.method">Payment Method</label><div class="col-sm-6"><select class="form-control" name="paymnetMethod" ng-model="vm.paymnetMethod"><option value="CASH" data-translate="global.order.cash.CASH"></option><option value="CARD" data-translate="global.order.cash.CARD"></option></select></div></div><br><br><div class="form-group"><label for="" class="col-sm-6 control-label" style="padding-top: 7px" data-translate="{{\'global.order.cash.\' + vm.paymnetMethod}}">{{vm.paymnetMethod}}</label><div class="col-sm-6"><form name="Calc"><input type="text" name="Input" class="form-control text-right" ng-model="vm.cash"></form></div></div><br><br><div class="form-group"><label for="" class="col-sm-6 control-label" data-translate="global.order.expatriate_paid_guests">KH ph\u1EA3i thanh to\xE1n</label><div class="col-sm-6"><span ng-if="vm.isPaymentSplitting == true"><label for="" class="control-label pull-right" style="margin-right:10px">{{vm.splittingOrder.totalValue | number:2}}</label></span><span ng-if="vm.isPaymentSplitting == false"><label for="" class="control-label pull-right" style="margin-right:10px">{{vm.currentOrder.totalValue | number:2}}</label></span></div></div><br><div class="form-group"><label for="" class="col-sm-6 control-label" ng-if="vm.paymnetMethod == \'CASH\'" data-translate="global.order.charge">Expenses paid guests</label><label for="" class="col-sm-6 control-label" ng-if="vm.paymnetMethod == \'CARD\'" data-translate="global.order.tip">Tip</label><div class="col-sm-6"><label for="" class="control-label pull-right" style="margin-right:10px">{{vm.charge | number:2}}</label></div></div></div><div class="row"><div class="col-md-12"><div class="cal-row-1"><button class="btn btn-primary btn-lg col-md-6" ng-disabled="vm.charge == \'N/A\' || vm.cash < 0 || vm.cash.length == 0 || vm.charge <0" ng-if="vm.paymnetMethod == \'CASH\'" ng-click="vm.paymentSplitting(null)">Checkout</button> <button class="btn btn-success btn-lg col-md-6" ng-disabled="vm.charge == \'N/A\' || vm.cash < 0 || vm.cash.length == 0 || vm.charge <0" ng-click="vm.paymentSplitting(\'BILL\')">Checkout & Print</button></div><div class="cal-row-1"><button class="btn btn-warning btn-lg col-md-6" ng-disabled="vm.charge == \'N/A\' || vm.cash.length == 0 || vm.cash < 0 || vm.charge <0" ng-click="vm.paymentSplitting(\'EVIDENCE\')">Bewirtung</button> <button class="btn btn-info btn-lg col-md-6" ng-disabled="vm.charge == \'N/A\' || vm.cash < 0 || vm.cash.length == 0 || vm.charge <0" ng-click="vm.paymentSplitting(\'BILLA4\')" data-translate="global.order.printA4">Print A4</button></div><div class="cal-row-1"><div class="pull-left" style="width: 202px"><button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',1)">1</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',2)">2</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',3)">3</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',4)">4</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',5)">5</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',6)">6</button></div><div class="pull-right" style="width: 118px"><button class="btn-cal-clear" ng-click="vm.typeNumber(\'Delete\',null)">Delete</button></div></div><div class="cal-row-2"><div class="pull-left" style="width: 202px"><button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',7)">7</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',8)">8</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',9)">9</button></div><div class="pull-right" style="width: 118px"><button class="btn-cal-back" ng-click="vm.typeNumber(\'Slice\',null)"><i class="fa fa-long-arrow-left" aria-hidden="true"></i></button></div></div><div class="cal-row-3"><div class="pull-left" style="width: 202px"><button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',0)">0</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',\'00\')">00</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',\'.\')">.</button> <button class="btn-cal-zero" ng-click="vm.typeNumber(\'Number\',\'000\')">000</button></div><div class="pull-right" style="width: 118px"><button class="btn-cal-enter" data-dismiss="modal" ng-click="vm.cancelSplitting()">Cancel</button></div></div></div></div></div></section></div></div></div><button type="submit" ng-click="vm.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="global.order.back"> Back</span></button></section><!-- /.modal-content -->');
$templateCache.put('app/entities/order-pos/order-pos-create-new.html','<div><h2 data-translate="xposApp.orderPos.createNew.title">Create a new Order</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="tableNo"><span data-translate="xposApp.tablePos.tableNo">Table No</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tableZone"><span data-translate="xposApp.tablePos.tableZone">Table Zone</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="xposApp.orderPos.createOrderStatus">Current Status</span></th><th><span data-translate="xposApp.orderPos.createOrderBookedAt">Booked At</span></th><th></th></tr><tr><th><input type="text" ng-model="vm.search.tableNo" ng-enter="vm.transition()" class="form-control" placeholder="{{\'xposApp.tablePos.searchByTableNo\'| translate }}"></th><th><input type="text" ng-model="vm.search.tableZone" ng-enter="vm.transition()" class="form-control" placeholder="{{\'xposApp.tablePos.searchByTableZone\'| translate }}"></th><th></th><th></th><th class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-info btn-sm" ng-click="vm.transition()"><span class="glyphicon glyphicon-search"></span> <span class="hidden-sm-dow" data-translate="entity.action.search">Search</span></button> <button class="btn btn-primary btn-sm" ng-click="vm.cleanTransition()"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-sm-dow" data-translate="entity.action.cleansearch">Clean search</span></button></div></th></tr></thead><tbody><tr ng-repeat="tablePos in vm.tablePos track by tablePos.id"><!-- <td><a ui-sref="table-pos-detail({id:tablePos.id})">{{tablePos.id}}</a></td>  --><td>{{tablePos.tableNo}}</td><td>{{tablePos.tableZone}}</td><td data-translate="{{\'xposApp.OrderStatus.\' + tablePos.statusForOrder}}">{{tablePos.statusForOrder}}</td><td>{{tablePos.nextBookedAt | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-primary btn-sm" ng-click="vm.clickMakeOrder(tablePos.id)"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="xposApp.orderPos.createNew.actionMakeOrder">Make Order</span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" max-size="5" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" boundary-links="true" style="margin: 0px"></uib-pagination></div></div>');
$templateCache.put('app/entities/order-pos/order-pos-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.orderPos.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="xposApp.orderPos.delete.question" translate-values="{id: \'{{vm.orderPos.id}}\'}">Are you sure you want to delete this Order Pos?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/order-pos/order-pos-detail.html','<div><h2><span data-translate="xposApp.orderPos.detail.title">Order Pos</span> {{vm.orderPos.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="xposApp.orderPos.tablePos">Table Pos</span></dt><dd><span>{{vm.orderPos.tablePos}}</span></dd><dt><span data-translate="xposApp.orderPos.waiter">Waiter</span></dt><dd><span>{{vm.orderPos.waiter}}</span></dd><dt><span data-translate="xposApp.orderPos.startedAt">Started At</span></dt><dd><span>{{vm.orderPos.startedAt | date:\'medium\'}}</span></dd><dt><span data-translate="xposApp.orderPos.endAt">End At</span></dt><dd><span>{{vm.orderPos.endAt | date:\'medium\'}}</span></dd><dt><span data-translate="xposApp.orderPos.orderStatus">Order Status</span></dt><dd><span data-translate="{{\'xposApp.OrderStatus.\' + vm.orderPos.orderStatus}}">{{vm.orderPos.orderStatus}}</span></dd><dt><span data-translate="xposApp.orderPos.products">Products</span></dt><dd><span>{{vm.orderPos.products}}</span></dd><dt><span data-translate="xposApp.orderPos.totalValue">Total Value</span></dt><dd><span>{{vm.orderPos.totalValue}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="order-pos-detail.edit({id:vm.orderPos.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/order-pos/order-pos-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderPosLabel" data-translate="xposApp.orderPos.home.createOrEditLabel">Create or edit a Order Pos</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="false"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.orderPos.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="xposApp.orderPos.tablePos" for="field_tablePos">Table Pos</label><input type="text" class="form-control" name="tablePos" id="field_tablePos" ng-model="vm.orderPos.tablePos" ng-disabled="vm.orderPos.id"></div><div class="form-group"><label class="control-label" data-translate="xposApp.orderPos.waiter" for="field_waiter">Waiter</label><!--  <input type="text" class="form-control" name="waiter" id="field_waiter"\r\n                    ng-model="vm.orderPos.waiter"\r\n                    />\r\n           --><select class="form-control" name="waiter" ng-model="vm.orderPos.waiter" id="field_waiter"><option ng-repeat="w in vm.waiters">{{w.login}}</option></select></div><div class="form-group"><label class="control-label" data-translate="xposApp.orderPos.startedAt" for="field_startedAt">Started At</label><input id="field_startedAt" type="text" class="form-control" name="startedAt" datetime-picker="{{dateformat}}" ng-model="vm.orderPos.startedAt" ng-disabled="vm.orderPos.id" is-open="vm.datePickerOpenStatus.startAt"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startAt\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="form-group"><label class="control-label" data-translate="xposApp.orderPos.endAt" for="field_endAt">End At</label><input id="field_endAt" type="text" class="form-control" name="endAt" datetime-picker="{{dateformat}}" ng-model="vm.orderPos.endAt" ng-disabled="vm.orderPos.id"></div><div class="form-group"><label class="control-label" data-translate="xposApp.orderPos.orderStatus" for="field_orderStatus">Order Status</label><select ng-disabled="vm.orderPos.id" class="form-control" name="orderStatus" ng-model="vm.orderPos.orderStatus" id="field_orderStatus"><option value="INPROGRESS" data-translate="xposApp.OrderStatus.INPROGRESS">INPROGRESS</option><option value="RESERVATION" data-translate="xposApp.OrderStatus.RESERVATION">RESERVATION</option><option value="FINISH" data-translate="xposApp.OrderStatus.FINISH">FINISH</option></select></div><div class="form-group"><label class="control-label" data-translate="xposApp.orderPos.products" for="field_products">Products</label><input type="text" class="form-control" name="products" id="field_products" ng-model="vm.orderPos.products" ng-disabled="vm.orderPos.id"></div><div class="form-group"><label class="control-label" data-translate="xposApp.orderPos.totalValue" for="field_totalValue">Total Value</label><input type="number" class="form-control" name="totalValue" id="field_totalValue" ng-model="vm.orderPos.totalValue" ng-disabled="vm.orderPos.id"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/order-pos/order-pos-select-meal.html','{{vm.test}}');
$templateCache.put('app/entities/order-pos/order-pos.html','<div ng-show="true"><!--\r\n   <jhi-alert></jhi-alert>\r\n    <br/>\r\n     <div class= "row">\r\n                <div class="form-group col-sm-3 " ng-if="vm.currentRole == \'ROLE_ADMIN\'">\r\n                                <h2 class="col-sm-4" data-translate="global.bill.from">From</h2>\r\n                                <div class="input-group date input-group-sm col-sm-8">\r\n                                   <span class="input-group-btn">\r\n                                        <button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button>\r\n                                    </span>\r\n                                    <input id="date" type="text" class="form-control" \r\n                                    name="date" ng-model="vm.dateSearch" ng-change="vm.loadAllOrder()"\r\n                                    uib-datepicker-popup="{{vm.dateformat}}"  is-open="popup1.opened"\r\n                                    datepicker-options="dateOptions" readonly\r\n                                    />\r\n                                   \r\n                                </div>\r\n\r\n                </div>\r\n\r\n                <div class="form-group col-sm-3 " ng-if="vm.currentRole == \'ROLE_ADMIN\'" style="text-align: center; font-size: 30px;font-weight: bold;">\r\n                    <lable> {{vm.total |number:2 }}</lable>\r\n                </div>\r\n                <div class="form-group col-sm-3 " ng-if="vm.currentRole == \'ROLE_ADMIN\'"  style="text-align: center; font-size: 30px;font-weight: bold;">\r\n                    <lable> {{vm.totalWait |number:2 }}</lable>\r\n                </div>\r\n                 \r\n    </div>\r\n\r\n    <div style="margin-bottom: 20px;">\r\n        <div ng-if="vm.currentRole == \'ROLE_SUPER_USER\'">\r\n            <div class= "row" >\r\n                <div class= "row" ng-if="vm.searchOr == null || vm.searchOr.length == 0" ng-show="vm.currentRole == \'ROLE_SUPER_USER\'">\r\n                   \r\n                    <div class="form-group col-sm-2 " style="margin-left:60px;">\r\n                        <button type="button" class="btn btn-primary btn-lg col-sm-12" ng-click="vm.printwaiter()"\r\n                        >\r\n                                <span class="hidden-sm-down" data-translate="global.report.printForWaiter">Print Waiter</span>\r\n                         </button>\r\n                    </div>\r\n\r\n                    <div class="form-group col-sm-2 " style="margin-left:60px;">\r\n                        <button type="button" class="btn btn-danger btn-lg col-sm-12" \r\n                                ng-click="vm.openModalVerify()">\r\n                            <span class="hidden-sm-down" data-translate="entity.action.delete">Delete</span>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class="row" style="margin-top:0px;font-size: 30px;" ng-show="vm.currentRole == \'ROLE_SUPER_USER\'">\r\n                    <div class="col-sm-6 report-col" style="font-weight:bold">\r\n                                <span  data-translate="global.report.totalTurnover">Total Turnover</span>:\r\n                                <span >{{vm.report.totalTurnOver | number : 2}} &nbsp \u20AC</span>\r\n                   </div>\r\n\r\n                   <div class="col-sm-6 report-col" style="font-weight:bold">\r\n                                <span  >Kartenzahlung</span>:\r\n                                <span >{{vm.report.card | number : 2}} &nbsp \u20AC</span>\r\n                   </div>\r\n                </div>\r\n                <div class="row" style="margin-top:0px;font-size: 30px;" ng-show="vm.currentRole == \'ROLE_SUPER_USER\'">\r\n                   <div class="col-sm-6 report-col" style="font-weight:bold">\r\n                                <span>Bar-Einnahme</span>:\r\n                                <span>{{vm.report.cash | number : 2}} &nbsp \u20AC</span>\r\n                   </div>\r\n                           \r\n                    <div class="col-sm-6 report-col" style="font-weight:bold">\r\n                                <span > Trinkgeld f\xFCr Kartenzahlung:</span>\r\n                                <span >{{vm.report.tipMoney}} &nbsp \u20AC</span>\r\n                    </div>\r\n                    \r\n                   \r\n                    \r\n                </div>\r\n\r\n            </div>\r\n\r\n           \r\n        </div>\r\n    </div>\r\n\r\n    <div class="table-responsive">\r\n        <table class="jh-table table table-striped">\r\n            <thead>\r\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n                   <th ><span data-translate="global.bill.waiter">Waiter</span> </th>\r\n                    <th><span data-translate="global.bill.time">End At</span> </th>\r\n                    <th ><span data-translate="global.bill.totalValue">Total Value</span> </th>\r\n                    <th><span data-translate="global.order.method">Payment</span> </th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat="orderPos in vm.orderPos track by orderPos.id">\r\n                        <td>\r\n                            <span>{{orderPos.waiter}}</span>\r\n                        </td>\r\n                        <td>{{orderPos.startedAt | date:\'short\'}}</td>\r\n                        <td>{{orderPos.totalValue | number:2}} </td>\r\n                        <td>\r\n                            <span ng-if="orderPos.paymentMethod != null" data-translate="global.order.cash.{{orderPos.paymentMethod }}"></span>\r\n\r\n                        </td>\r\n                        <td >\r\n\r\n                            <span>\r\n                                <button type="submit" style="margin-bottom:0px;" ng-if="orderPos.orderStatus != \'INPROGRESS\'"\r\n                                                ng-click="vm.print(\'bill\',orderPos)"\r\n                                                class="btn btn-info">\r\n                                            <span class="hidden-sm-down" data-translate="global.order.print">Print</span>\r\n                                </button>\r\n                                <button type="submit" style="margin-left:10px;" ng-if="orderPos.orderStatus != \'INPROGRESS\'"\r\n                                                ng-click="vm.print(\'evidence\',orderPos)"\r\n                                                class="btn btn-warning ">\r\n                                            <span class="hidden-sm-down" >Bewirtung</span>\r\n                                </button>\r\n                                <button type="submit" style="margin-left:10px;" ng-if="orderPos.orderStatus != \'FINISH\'"\r\n                                                ng-click="vm.delete(orderPos)"\r\n                                                class="btn btn-danger ">\r\n                                            <span class="hidden-sm-down" data-translate="global.order.deleteorder">Delete</span>\r\n                                </button>\r\n                            </span>\r\n                        </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    --></div>');
$templateCache.put('app/entities/order-pos/payment-dialog.html','<div class="modal-content"><div class="modal-header"><button type="button" class="btn-danger btn-lg pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title col-sm-8" data-translate="global.order.payment">Thanh to\xE1n b\u1EB1ng ti\u1EC1n m\u1EB7t</h4></div><style type="text/css">.btn-cal-number {\r\n      width: 65px;\r\n      height: 40px;\r\n      margin: 1px 0px;\r\n      }\r\n      .btn-cal-clear, .btn-cal-enter {\r\n      width: 100%;\r\n      height: 82px;\r\n      margin: 1px 0px;\r\n      }\r\n      .btn-cal-back {\r\n      width: 100%;\r\n      height: 40px;\r\n      margin: 1px 0px;\r\n      }\r\n      .btn-cal-zero {\r\n      width: 200px;\r\n      height: 40px;\r\n      margin: 1px 0px;\r\n      }\r\n      .modal-content {\r\n      \t/*width:600px;*/\r\n      \twidth:354px;\r\n      }</style><div style="background-color: white; overflow: hidden"><div style="float:left;width: 354px"><div class=""><!--\r\n\t\t      <div class="form-group">\r\n\t\t         <label for="" class="col-xs-6 control-label"\r\n\t\t            style="padding-top: 7px; " data-translate="global.order.method"> Payment Method</label>\r\n\t\t         <div class="col-xs-6">\r\n\t\t            <select class="form-control" name="paymnetMethod" ng-model="vm.paymnetMethod">\r\n\t\t               <option value="CASH" data-translate="global.order.cash.CASH"></option>\r\n\t\t               <option value="CARD" data-translate="global.order.cash.CARD"></option>\r\n\t\t            </select>\r\n\t\t         </div>\r\n\t\t      </div>\r\n\t\t    --><div class="row" style="font-weight: bold"><button class="btn btn-default btn-lg col-xs-5" ng-click="vm.selectPaymentMethod(\'CASH\')" data-translate="global.order.cash.CASH" ng-style="vm.paymnetMethod == \'CASH\' && {\'background-color\': \'blue\' }" style="color:white" ng-click="vm.changeFilterSearch(\'Customer\')">CASH</button> <button class="btn btn-default btn-lg col-xs-5 pull-right" ng-click="vm.selectPaymentMethod(\'CARD\')" data-translate="global.order.cash.CARD" ng-style="vm.paymnetMethod == \'CARD\' && {\'background-color\': \'blue\' }" style="color:white">CARD</button></div><div class="form-group" style="margin-top: 20px"><label style="padding-top: 7px" for="" class="col-xs-6 control-label" data-translate="{{\'global.order.cash.\' + vm.paymnetMethod}}">{{vm.paymnetMethod}}</label><div class="col-xs-6"><form name="Calc"><input type="text" name="Input" class="form-control text-right" ng-model="vm.cash" style="font-size: 15px; text-align: right;font-weight: bold"></form></div></div><br><br><div class="form-group"><label for="" class="col-xs-6 control-label" data-translate="global.order.expatriate_paid_guests">KH ph\u1EA3i thanh to\xE1n</label><div class="col-xs-6"><label for="" class="control-label pull-right" style="margin-right:10px">{{vm.currentOrder.totalValue |number:2}} \u20AC</label></div></div><br><div class="form-group"><label for="" class="col-xs-6 control-label" ng-if="vm.paymnetMethod == \'CASH\'" data-translate="global.order.charge">Expenses paid guests</label><label for="" class="col-xs-6 control-label" ng-if="vm.paymnetMethod == \'CARD\'" data-translate="global.order.tip">Tip</label><div class="col-xs-6"><label for="" class="control-label pull-right" style="margin-right:10px">{{vm.charge/100 | number:2}} \u20AC</label></div></div><br></div><div class="row"><div class="col-xs-12"><div class="cal-row-1"><button ng-if="vm.paymnetMethod == \'CASH\'" class="btn btn-primary btn-lg col-xs-6" ng-disabled="vm.charge == \'N/A\' || vm.cash.length == 0 ||vm.cash == null || vm.cash < 0 || vm.charge <0" ng-click="vm.payment(null)" data-translate="global.order.checkout">Checkout</button> <button class="btn btn-success btn-lg col-xs-6" ng-disabled="vm.charge == \'N/A\' || vm.cash.length == 0 || vm.cash < 0 || vm.charge <0" ng-click="vm.payment(\'BILL\')" data-translate="global.order.print">Print</button></div><div class="cal-row-1"><button class="btn btn-warning btn-lg col-xs-6" ng-disabled="vm.charge == \'N/A\' || vm.cash.length == 0 || vm.cash < 0 || vm.charge <0" ng-click="vm.payment(\'EVIDENCE\')">Bewirtung</button> <button class="btn btn-info btn-lg col-xs-6" ng-disabled="vm.charge == \'N/A\' || vm.cash.length == 0 || vm.cash < 0 || vm.charge <0" ng-click="vm.payment(\'WAIT\')" data-translate="global.order.wait">Wait</button></div><div class="cal-row-1"><div class="pull-left" style="width: 202px"><button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',1)">1</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',2)">2</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',3)">3</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',4)">4</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',5)">5</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',6)">6</button></div><div class="pull-right" style="width: 150px"><button class="btn-cal-clear" ng-click="vm.typeNumber(\'Delete\',null)" style="font-size: 20px"><b>ENTF</b></button></div></div><div class="cal-row-2"><div class="pull-left" style="width: 202px"><button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',7)">7</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',8)">8</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',9)">9</button></div><div class="pull-right" style="width: 150px"><button class="btn-cal-back" ng-click="vm.typeNumber(\'Slice\',null)" style="font-size: 20px"><i class="fa fa-long-arrow-left" aria-hidden="true"></i></button></div></div><div class="cal-row-3"><div class="pull-left" style="width: 202px"><button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',0)">0</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',\'00\')">00</button> <button class="btn-cal-number" ng-click="vm.typeNumber(\'Number\',\'000\')">000</button> <button class="btn-cal-zero" ng-click="vm.typeNumber(\'Number\',\'0000\')">0000</button></div><div class="pull-right" style="width: 150px"><button class="btn-cal-enter" data-dismiss="modal" ng-click="vm.clear()" style="font-size: 20px"><b>ESC</b></button></div></div></div></div></div><!-- end modal-body --><!--\r\n\t\t<div style="float:left;width: 150px;">\r\n\t\t\t<img src="content/images/0euro.png" height=57  width=150 alt="" >\r\n\t\t\t<img src="content/images/5euro.jpg" height=57  width=150 alt="" ng-click="vm.typeMoneyIcon(500)">\r\n\t\t\t<img src="content/images/10euro.jpg" height=57 width=150 alt="" ng-click="vm.typeMoneyIcon(1000)">\r\n\t\t\t<img src="content/images/20euro.jpg" height=57 width=150 alt="" ng-click="vm.typeMoneyIcon(2000)">\r\n\t\t\t<img src="content/images/50euro.jpg" height=57 width=150 alt="" ng-click="vm.typeMoneyIcon(5000)">\r\n\t\t\t<img src="content/images/100euro.jpg" height=57 width=150 alt="" ng-click="vm.typeMoneyIcon(10000)">\r\n\t\t\t<img src="content/images/200euro.jpg" height=57 width=150 alt="" ng-click="vm.typeMoneyIcon(20000)">\r\n\t\t\t<img src="content/images/500euro.jpg" height=57 width=150 alt="" ng-click="vm.typeMoneyIcon(50000)">\r\n\t\t</div>\r\n\t\t<div style="float:left;width: 80px;">\r\n\t\t\t<img src="content/images/1cent.jpg" height=57  width=80 alt="" ng-click="vm.typeMoneyIcon(1)">\r\n\t\t\t<img src="content/images/2cent.jpg" height=57  width=80 alt="" ng-click="vm.typeMoneyIcon(2)">\r\n\t\t\t<img src="content/images/5cent.jpg" height=57 width=80 alt="" ng-click="vm.typeMoneyIcon(5)">\r\n\t\t\t<img src="content/images/10cent.jpg" height=57 width=80 alt="" ng-click="vm.typeMoneyIcon(10)">\r\n\t\t\t<img src="content/images/20cent.jpg" height=57 width=80 alt="" ng-click="vm.typeMoneyIcon(20)">\r\n\t\t\t<img src="content/images/50cent.jpg" height=57 width=80 alt="" ng-click="vm.typeMoneyIcon(50)">\r\n\t\t\t<img src="content/images/1euro.jpg" height=57 width=80 alt="" ng-click="vm.typeMoneyIcon(100)">\r\n\t\t\t<img src="content/images/2euro.jpg" height=57 width=80 alt="" ng-click="vm.typeMoneyIcon(200)">\r\n\t\t</div>\r\n\t\t--></div></div>');
$templateCache.put('app/entities/order-pos/payment-dialog2.html','<style type="text/css">.modal-dialog {\r\n\t\twidth:100%;\r\n\t\theight:100%;\r\n\t\tmargin: 0;\r\n\t}\r\n      .border {\r\n\t\tborder-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\t.border-bottom {\r\n\t\tborder-bottom-style: solid;\r\n\t\tborder-width: 1px;\r\n\t\tborder-color: #331a00;\r\n\t}\r\n\r\n\t.input-money{\r\n\t\tfloat: left;\r\n\t\twidth: 70%;\r\n\t\ttext-align: right;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 30px;\r\n\t}\r\n\t.title-method {\r\n\t\tfont-size: 30px;\r\n\t}\r\n\r\n\t#keyboard > div > button {\r\n\t\theight: 62px;\r\n\t\tfont-size: bold;\r\n\t\tbackground-color: #C1D0EA;\r\n\t\tline-height:60px;\r\n\t\ttext-align:center;\r\n\t\tfont-size: 30px;\r\n\t}</style><div class="modal-content"><div id="payment" style="background-color: white; overflow: hidden"><div class="col-xs-4 border" id="payment_method" style="height: 670px"><span id="bargeld" class="col-xs-12 border-bottom" style="padding-bottom: 5px;height:20%" ng-style="vm.currentMethod == \'cash\' && {\'background-color\': \'#C1D0EA\'}" ng-click="vm.selectPaymentMethod(\'cash\')"><label class="title-method pull-right">Bargeld</label><div class="row col-xs-12" style="overflow: hidden"><input type="text" class="form-control input-money" readonly="true" ng-model="vm.cash"> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left" ng-click="vm.typeNumber(\'Full\')">\u0110\u1EE7 ti\u1EC1n</button> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left;margin-top: 10px" ng-click="vm.typeNumber(\'CE\')">CE</button></div></span><span id="karte" class="col-xs-12 border-bottom" style="padding-bottom: 5px;height:20%" ng-style="vm.currentMethod == \'card\' && {\'background-color\': \'#C1D0EA\'}" ng-click="vm.selectPaymentMethod(\'card\')"><label class="title-method pull-right">Karte</label><div class="row col-xs-12" style="overflow: hidden"><input type="text" class="form-control input-money" readonly="true" ng-model="vm.card"> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left" ng-click="vm.typeNumber(\'Full\')">\u0110\u1EE7 ti\u1EC1n</button> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left;margin-top: 10px" ng-click="vm.typeNumber(\'CE\')">CE</button></div></span><span id="gutschein" class="col-xs-12 border-bottom" style="padding-bottom: 5px;height:20%" ng-style="vm.currentMethod == \'voucher\' && {\'background-color\': \'#C1D0EA\'}" ng-click="vm.selectPaymentMethod(\'voucher\')"><label class="title-method pull-right">Gutschein</label><div class="row col-xs-12" style="overflow: hidden"><input type="text" class="form-control input-money" readonly="true" ng-model="vm.voucher"> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left" ng-click="vm.typeNumber(\'Full\')">\u0110\u1EE7 ti\u1EC1n</button> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left;margin-top: 10px" ng-click="vm.typeNumber(\'CE\')">CE</button></div></span><span id="check" class="col-xs-12 border-bottom" style="padding-bottom: 5px;height:20%" ng-style="vm.currentMethod == \'check\' && {\'background-color\': \'#C1D0EA\'}" ng-click="vm.selectPaymentMethod(\'check\')"><label class="title-method pull-right">Check</label><div class="row col-xs-12" style="overflow: hidden"><input type="text" class="form-control input-money" readonly="true" ng-model="vm.check"> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left" ng-click="vm.typeNumber(\'Full\')">\u0110\u1EE7 ti\u1EC1n</button> <button class="btn btn-default btn-md col-xs-3 border pull-right" style="float: left;margin-top: 10px" ng-click="vm.typeNumber(\'CE\')">CE</button></div></span></div><!-- end #payment_method --><div class="col-xs-4 border" id="money_paper" style="height: 670px; padding-right: 5px"><div class="col-xs-4" id="lef_money_paper"><img src="content/images/1cent.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(0.01)"> <img src="content/images/2cent.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(0.02)"> <img src="content/images/5cent.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(0.05)"> <img src="content/images/geld_10.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(0.1)"> <img src="content/images/geld_20.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(0.2)"> <img src="content/images/geld_50.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(0.5)"></div><div class="col-xs-8" id="right_money_paper"><span class="col-xs-12" style="margin-right: 0px;padding-right: 0px"><span class="col-xs-6" style="margin:0px;padding: 0px"><img src="content/images/geld_100.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(1)"> </span><span class="col-xs-6 pull-right" style="margin:0px;padding: 0px"><img src="content/images/geld_200-1.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(2)"> </span></span><img src="content/images/5euro.png" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(5)"> <img src="content/images/10euro.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(10)"> <img src="content/images/20euro.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(20)"> <img src="content/images/50euro.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(50)"> <img src="content/images/100euro.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(100)"> <img src="content/images/200euro.jpg" style="width: 100%" alt="" ng-click="vm.typeMoneyIcon(200)"></div></div><!-- end #money_paper --><div class="col-xs-4 border" id="summary" style="height: 670px;padding:0px"><div id="keyboard" class="border-bottom"><div class="col-xs-12" style="padding:0px"><button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(0)">0</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(1)">1</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(2)">2</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(3)">3</button></div><div class="col-xs-12" style="padding:0px"><button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(4)">4</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(5)">5</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(6)">6</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(7)">7</button></div><div class="col-xs-12" style="padding:0px"><button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(8)">8</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(9)">9</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(\',\')">,</button> <button class="btn btn-default btn-md col-xs-3 border" ng-click="vm.typeNumber(\'CE\')">CE</button></div></div><!-- end keyboard--><div id="top_summary" style="padding-top: 220px"><div class="col-xs-12"><label class="col-xs-3" style="font-size: 15px">Summe:</label><span class="col-xs-8"><input type="text" readonly="true" class="form-control input-money" style="float: left;width: 100%" ng-model="vm.summe"></span></div><div class="col-xs-12" style="margin-top: 20px"><label class="col-xs-3" style="font-size: 15px">Gegeben:</label><span class="col-xs-8"><input type="text" readonly="true" class="form-control input-money" style="float: left;width: 100%" ng-model="vm.totalValue"></span></div><div class="col-xs-12" style="margin-top: 20px"><label class="col-xs-3" style="font-size: 15px">R\xFCckgeld:</label><span class="col-xs-8"><input type="text" readonly="true" class="form-control input-money" style="float: left;width: 100%" ng-model="vm.charge"></span></div></div><!-- end #top_summary --><div id="bottom_summary" style="padding-top: 200px"><div class="col-xs-12"><button class="btn btn-primary btn-lg col-xs-6" ng-click="vm.payment(null)" data-translate="global.order.checkout">Checkout</button> <button class="btn btn-success btn-lg col-xs-6" ng-click="vm.payment(\'BILL\')" data-translate="global.order.print">Print</button></div><div class="col-xs-12" style="margin-top: 20px"><button class="btn btn-warning btn-lg col-xs-6" ng-click="vm.payment(\'EVIDENCE\')">Bewirtung</button> <button class="btn btn-danger btn-lg col-xs-6" ng-click="vm.clear()">ESC</button></div></div><!-- end #bottom_summary --></div><!-- end #summary --></div></div>');
$templateCache.put('app/entities/product/product-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">X\xE1c nh\u1EADn h\xE0nh \u0111\u1ED9ng x\xF3a?</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Ban th\u1EF1c s\u1EF1 mu\u1ED1n x\xF3a?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()" style="margin-top:30px"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" style="margin-top:30px"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>X\xF3a ngay</span></button></div></form>');
$templateCache.put('app/entities/product/product-detail.html','<div><!--<jhi-alert-error></jhi-alert-error>--><dl class="dl-horizontal jh-entity-details"><dt><span>T\xEAn</span></dt><dd><span>{{vm.product.productName}}</span></dd><dt><span>Gi\xE1 nh\u1EADp v\xE0o</span></dt><dd><span>{{vm.product.productInputPrice}}</span></dd><dt><span>Gi\xE1 b\xE1n ra</span></dt><dd><span>{{vm.product.productSalePrice}}</span></dd><dt><span>T\u1ED3n kho</span></dt><dd><span>{{vm.product.quantity}}</span></dd><dt><span>Nh\xF3m</span></dt><dd><span>{{vm.product.group.name}}</span></dd><dt><span>C\u01A1 s\u1EDF</span></dt><dd><span>{{vm.product.store.storeName}}</span></dd></dl><button type="button" ui-sref="product-detail.edit({id:vm.product.id})" class="btn btn-primary" ng-if="vm.currentRole == \'ROLE_ADMIN\'"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">S\u1EEDa</span></button> <button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></div>');
$templateCache.put('app/entities/product/product-dialog.html','<style>.width80 {\r\n        width: 80%;\r\n    }\r\n    .width50 {\r\n        width: 50%;\r\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.product.id == null">Th\xEAm s\u1EA3n ph\u1EA9m m\u1EDBi</h2><h2 ng-if="vm.product.id != null">S\u1EEDa s\u1EA3n ph\u1EA9m</h2><div class="modal-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group col-xs-12"><label class="control-label">T\xEAn</label><input type="text" class="form-control width80" ng-model="vm.product.productName" required></div><div class="form-group col-xs-12"><label class="control-label">Gi\xE1 nh\u1EADp v\xE0o</label><input type="text" class="form-control width80" ng-model="vm.product.productInputPrice" required></div><div class="form-group col-xs-12"><label class="control-label">Gi\xE1 b\xE1n ra</label><input type="text" class="form-control width80" ng-model="vm.product.productSalePrice" required></div><div class="form-group col-xs-12"><label class="control-label">Nh\xF3m</label><select class="form-control width80" name="type" ng-model="vm.product.group" ng-options="group as group.name for group in vm.groups "></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group col-xs-12"><label class="control-label">C\u01A1 s\u1EDF</label><input type="text" class="form-control width80" ng-model="vm.product.store.storeName" readonly="true"></div><div class="col-xs-12"><img ng-src="{{vm.apiUrl}}api/file/get-file/image/{{vm.product.productImage}}"></div><div class="form-group col-xs-12 row"><label class="control-label col-xs-12" for="field_productImage">\u1EA2nh s\u1EA3n ph\u1EA9m</label><div class="input-group input-group-md col-xs-12 row"><input type="file" ngf-select ng-model="vm.uploadedImage" ngf-pattern="\'*.png\'" ngf-accept="\'.png\'" class="form-control" id="myFileField"> <span class="input-group-btn"><button type="button" ng-click="vm.uploadImage()" class="btn btn-primary">T\u1EA3i l\xEAn</button></span></div></div></div></div></div><!-- end body --><div class="modal-footer col-xs-12"><button type="button" class="btn btn-info col-md-2 col-xs-5" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2 col-xs-5"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/product/product.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="product.new" style="cursor: pointer" ng-if="vm.currentRole == \'ROLE_ADMIN\'"><span class="glyphicon glyphicon-plus"></span> <span>T\u1EA1o m\u1EDBi</span> </a><a ui-sref="product-detail({id:vm.currentProductId})" style="cursor: pointer" ng-if="vm.currentProductId != null"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span>Xem</span> </a><a ui-sref="product.edit({id:vm.currentProductId})" style="cursor: pointer" ng-if="vm.currentProductId != null"><span class="glyphicon glyphicon-edit"></span> <span>S\u1EEDa</span> </a><a ui-sref="product.delete({id:vm.currentProductId})" style="cursor: pointer" ng-if="vm.currentProductId != null"><span class="glyphicon glyphicon-remove"></span> <span>X\xF3a</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.account.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><div class="row col-md-12" style="margin-top: 10px"><h2 class="col-md-6 col-xs-12">Danh s\xE1ch s\u1EA3n ph\u1EA9m</h2><div class="form-group col-md-6 col-xs-12"><h2 class="col-sm-4">C\u01A1 s\u1EDF</h2><div class="form-group col-sm-6"><div class="form-group row"><select class="form-control" name="type" ng-model="vm.filterStore" ng-options="store as store.storeName for store in vm.stores track by store.id" ng-change="vm.loadAll()" ng-disabled="vm.currentRole != \'ROLE_SUPER_ADMIN\'"></select></div></div></div></div><div class="table-responsive row col-md-12"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>T\xEAn s\u1EA3n ph\u1EA9m</span></th><th><span>Gi\xE1 nh\u1EADp</span></th><th><span>Gi\xE1 b\xE1n</span></th><th><span>T\u1ED3n kho</span></th><th><span>Nh\xF3m s\u1EA3n ph\u1EA9m</span></th><th><span>C\u01A1 s\u1EDF</span></th></tr></thead><tbody><tr ng-repeat="product in vm.products track by product.id" ng-click="vm.selectProduct(product)" ng-style="vm.currentProductId == product.id && {\'background-color\':\'#D3E5F7\'}"><td>{{$index +1}}</td><td>{{product.productName}}</td><td>{{product.productInputPrice |number:0}}</td><td>{{product.productSalePrice |number:0}}</td><td>{{product.quantity |number:0}}</td><td>{{product.group.name}}</td><td>{{product.store.storeName}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pos-setting/pos-setting-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.posSetting.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="xposApp.posSetting.delete.question" translate-values="{id: \'{{vm.posSetting.id}}\'}">Are you sure you want to delete this Pos Setting?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pos-setting/pos-setting-detail.html','<div><h2><span data-translate="xposApp.posSetting.detail.title">Pos Setting</span> {{vm.posSetting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="xposApp.posSetting.pos">Pos</span></dt><dd><span>{{vm.posSetting.pos}}</span></dd><dt><span data-translate="xposApp.posSetting.setting">Setting</span></dt><dd><span>{{vm.posSetting.setting}}</span></dd><dt><span data-translate="xposApp.posSetting.type">Type</span></dt><dd><span>{{vm.posSetting.type}}</span></dd><dt><span data-translate="xposApp.posSetting.lastUpdate">Last Update</span></dt><dd><span>{{vm.posSetting.lastUpdate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pos-setting-detail.edit({id:vm.posSetting.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pos-setting/pos-setting-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPosSettingLabel" data-translate="xposApp.posSetting.home.createOrEditLabel">Create or edit a Pos Setting</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.posSetting.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.posSetting.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="xposApp.posSetting.pos" for="field_pos">Pos</label><input type="text" class="form-control" name="pos" id="field_pos" ng-model="vm.posSetting.pos"></div><div class="form-group"><label class="control-label" data-translate="xposApp.posSetting.setting" for="field_setting">Setting</label><input type="text" class="form-control" name="setting" id="field_setting" ng-model="vm.posSetting.setting"></div><div class="form-group"><label class="control-label" data-translate="xposApp.posSetting.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.posSetting.type"></div><div class="form-group"><label class="control-label" data-translate="xposApp.posSetting.lastUpdate" for="field_lastUpdate">Last Update</label><div class="input-group"><input id="field_lastUpdate" type="text" class="form-control" name="lastUpdate" datetime-picker="{{dateformat}}" ng-model="vm.posSetting.lastUpdate" is-open="vm.datePickerOpenStatus.lastUpdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastUpdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pos-setting/pos-settings.html','<div><h2 data-translate="xposApp.posSetting.home.title">Pos Settings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pos-setting.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="xposApp.posSetting.home.createLabel">Create new Pos Setting</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="xposApp.posSetting.pos">Pos</span></th><th><span data-translate="xposApp.posSetting.setting">Setting</span></th><th><span data-translate="xposApp.posSetting.type">Type</span></th><th><span data-translate="xposApp.posSetting.lastUpdate">Last Update</span></th><th></th></tr></thead><tbody><tr ng-repeat="posSetting in vm.posSettings track by posSetting.id"><td><a ui-sref="pos-setting-detail({id:posSetting.id})">{{posSetting.id}}</a></td><td>{{posSetting.pos}}</td><td>{{posSetting.setting}}</td><td>{{posSetting.type}}</td><td>{{posSetting.lastUpdate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pos-setting-detail({id:posSetting.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pos-setting.edit({id:posSetting.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pos-setting.delete({id:posSetting.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/room/room-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">X\xE1c nh\u1EADn h\xE0nh \u0111\u1ED9ng x\xF3a?</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Ban th\u1EF1c s\u1EF1 mu\u1ED1n x\xF3a?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()" style="margin-top:30px"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" style="margin-top:30px"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>X\xF3a ngay</span></button></div></form>');
$templateCache.put('app/entities/room/room-detail.html','<div><!--<jhi-alert-error></jhi-alert-error>--><dl class="dl-horizontal jh-entity-details"><dt><span>T\xEAn ph\xF2ng</span></dt><dd><span>{{vm.room.name}}</span></dd><dt><span>Lo\u1EA1i ph\xF2ng</span></dt><dd><span>{{vm.room.type}}</span></dd><dt><span>Gi\xE1 ti\u1EC1n m\u1EB7c \u0111\u1ECBnh (ph\xFAt)</span></dt><dd><span>{{vm.room.price}}</span></dd><dt><span>Gi\xE1 ti\u1EC1n theo khung gi\u1EDD</span></dt><dd><li ng-repeat="timeFram in vm.room.listPriceByTimeFrameDTO">{{timeFram.fromHour}} - {{timeFram.toHour}} : {{timeFram.price |number:0}}</li></dd><dt><span>T\u1EA7ng</span></dt><dd><span>{{vm.room.floor}}</span></dd><dt><span>C\u01A1 s\u1EDF</span></dt><dd><span>{{vm.room.store.storeName}}</span></dd><dt><span>Ghi ch\xFA</span></dt><dd><span>{{vm.room.note}}</span></dd></dl><button type="button" ui-sref="room-detail.edit({id:vm.room.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">S\u1EEDa</span></button> <button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></div>');
$templateCache.put('app/entities/room/room-dialog.html','<style>.width80 {\r\n        width: 80%;\r\n    }\r\n    .width50 {\r\n        width: 50%;\r\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.room.id == null">Th\xEAm ph\xF2ng m\u1EDBi</h2><h2 ng-if="vm.room.id != null">S\u1EEDa th\xF4ng tin ph\xF2ng</h2><div class="modal-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group col-xs-12"><label class="control-label" for="field_roomName">T\xEAn ph\xF2ng</label><input type="text" class="form-control width80" name="roomName" id="field_roomName" ng-model="vm.room.name" required></div><div class="form-group col-xs-12"><label class="control-label" for="field_roomFloor">T\u1EA7ng</label><input type="number" class="form-control width80" name="roomFloor" id="field_roomFloor" ng-model="vm.room.floor"></div><div class="form-group col-xs-12"><label>Lo\u1EA1i</label><select class="form-control width80" name="type" ng-model="vm.room.type" ng-options="type  for type in vm.types "></select></div></div><div class="col-md-6 col-xs-12"><div class="form-group col-xs-12"><label class="control-label" for="field_roomPhone">Gi\xE1 ti\u1EC1n m\u1EB7c \u0111\u1ECBnh (theo ph\xFAt)</label><input type="number" class="form-control width80" name="price" id="field_price" ng-model="vm.room.price" required></div><br><div class="form-group col-xs-12"><label class="control-label">Gi\xE1 ti\u1EC1n theo khung gi\u1EDD</label><button type="button" class="btn btn-primary btn-xs" ng-click="vm.addTimeFrameToListPriceByTimeFrameDTO();">Th\xEAm</button></div><div class="form-group col-xs-12"><span ng-repeat="timeFrame in vm.listPriceByTimeFrameDTO track by $index"><div class="col-xs-12" style="margin-bottom: 10px"><label>T\u1EEB</label><input style="width:10%" ng-model="timeFrame.fromHour"><label style="margin-left: 10px">\u0110\u1EBFn</label><input style="width:10%" ng-model="timeFrame.toHour"><label style="margin-left: 10px">Gi\xE1 ti\u1EC1n</label><input style="width:20%" ng-model="timeFrame.price"> <button type="button" class="btn btn-danger btn-xs" ng-click="vm.deleteTimeFrame($index)" style="margin-left: 10px">X\xF3a</button></div></span></div><!--\r\n                <div class="form-group col-xs-12">\r\n                    <label class="control-label"  for="field_note">Ghi ch\xFA</label>\r\n                    <textarea rows="4" class="form-control width80" name="note" id="field_note"\r\n                                ng-model="vm.room.note"  \r\n                    >\r\n                    </textarea>\r\n                </div>\r\n                --></div></div></div><!-- end body --><div class="modal-footer col-xs-12"><button type="button" class="btn btn-info col-md-2 col-xs-5" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2 col-xs-5"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/room/room.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="room.new" style="cursor: pointer"><span class="glyphicon glyphicon-plus"></span> <span>T\u1EA1o m\u1EDBi</span> </a><a ui-sref="room-detail({id:vm.currentRoomId})" style="cursor: pointer" ng-if="vm.currentRoomId != null"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span>Xem</span> </a><a ui-sref="room.edit({id:vm.currentRoomId})" style="cursor: pointer" ng-if="vm.currentRoomId != null"><span class="glyphicon glyphicon-edit"></span> <span>S\u1EEDa</span> </a><a ui-sref="room.delete({id:vm.currentRoomId})" style="cursor: pointer" ng-if="vm.currentRoomId != null"><span class="glyphicon glyphicon-remove"></span> <span>X\xF3a</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.currentAccount.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><h2>Danh s\xE1ch ph\xF2ng</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>T\xEAn ph\xF2ng</span></th><th><span>Lo\u1EA1i ph\xF2ng</span></th><th><span>Gi\xE1 ti\u1EC1n m\u1EB7c \u0111\u1ECBnh</span></th><th><span>Gi\xE1 ti\u1EC1n theo gi\u1EDD</span></th><th><span>T\u1EA7ng</span></th><th><span>C\u01A1 s\u1EDF</span></th></tr></thead><tbody><tr ng-repeat="room in vm.rooms track by room.id" ng-click="vm.selectRoom(room)" ng-style="vm.currentRoomId == room.id && {\'background-color\':\'#D3E5F7\'}"><td>{{$index +1}}</td><td>{{room.name}}</td><td>{{room.type}}</td><td>{{room.price |number:0}}</td><td><li ng-repeat="timeFram in room.listPriceByTimeFrameDTO">{{timeFram.fromHour}} - {{timeFram.toHour}} : {{timeFram.price |number:0}}</li></td><td>{{room.floor}}</td><td>{{room.store.storeName}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/stockin/stockin-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.stockin.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">X\xE1c nh\u1EADn h\xE0nh \u0111\u1ED9ng x\xF3a \u0111\u01A1n nh\u1EADp kho</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>B\u1EA1n c\xF3 ch\u1EAFc l\xE0 mu\u1ED1n th\u1EF1c hi\u1EC7n h\xE0nh vi nguy hi\u1EC3m n\xE0y?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>X\xF3a ngay</span></button></div></form>');
$templateCache.put('app/entities/stockin/stockin-detail.html','<div><!--<jhi-alert-error></jhi-alert-error>--><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="global.product.code">Product Code</span></dt><dd><span>{{vm.product.productCode}}</span></dd><dt><span data-translate="global.product.articalNumber">Product Artical Number</span></dt><dd><span>{{vm.product.productArticalNumber}}</span></dd><dt><span data-translate="global.product.name">Product Name</span></dt><dd><span>{{vm.product.productName}}</span></dd><!--\r\n        <dt><span data-translate="global.product.image">Product Image</span></dt>\r\n        <dd>\r\n            <span>{{vm.product.productImage}}</span>\r\n        </dd>\r\n       \r\n        <dt><span data-translate="global.product.purchasePrice">Product Purchase Price</span></dt>\r\n        <dd>\r\n            <span>{{vm.product.productPurchasePrice}}</span>\r\n        </dd>\r\n          --><dt><span data-translate="global.product.salePrice">Product Sale Price</span></dt><dd><span>{{vm.product.productSalePrice}} \u20AC</span></dd><dt><span data-translate="global.product.vat">VAT</span></dt><dd><span>{{vm.product.tax.taxRate * 100}} %</span></dd><!--\r\n        <dt><span data-translate="global.product.productCurrencyUnit">Product Currency Unit</span></dt>\r\n        <dd>\r\n            <span data-translate="{{\'global.CurrencyUnit.\' + vm.product.productCurrencyUnit}}">{{vm.product.productCurrencyUnit}}</span>\r\n        </dd>\r\n        <dt><span data-translate="global.product.productType">Product Type</span></dt>\r\n        <dd>\r\n            <span data-translate="{{\'global.ProductType.\' + vm.product.productType}}">{{vm.product.productType}}</span>\r\n        </dd>\r\n        <dt><span data-translate="global.product.lastUpdate">Last Update</span></dt>\r\n        <dd>\r\n            <span>{{vm.product.lastUpdate | date:\'medium\'}}</span>\r\n        </dd>\r\n        <dt><span data-translate="global.product.version">Version</span></dt>\r\n        <dd>\r\n            <span>{{vm.product.version}}</span>\r\n        </dd>\r\n        --><dt><span data-translate="global.product.category">Product Category</span></dt><dd><span>{{vm.product.productCategory.productCategoryName}}</span></dd><dt><span data-translate="global.product.groups">Product Groups</span></dt><dd><li ng-repeat="productGroup in vm.product.productGroups track by productGroup.id"><!--<a ui-sref="product-group-detail({id:productGroup.id})">{{productGroup.productGroupName}}</a> --> {{productGroup.productGroupName}}</li></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="product-detail.edit({id:vm.product.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/stockin/stockin-dialog.html','<style>.navbar-default .navbar-nav > li > a {\r\n        color : #154289;\r\n    }\r\n\r\n    .navbar-default .navbar-nav > .active > a, .navbar-default .navbar-nav > .active > a:hover, .navbar-default .navbar-nav > .active > a:focus {\r\n        color: #555;\r\n        background-color: #D3E5F7;\r\n        \r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.stockin.id == null">Ti\u1EBFn h\xE0nh nh\u1EADp kho</h2><h2 ng-if="vm.stockin.id != null">S\u1EEDa th\xF4ng tin s\u1EA3n ph\u1EA9m</h2><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label">Ng\u01B0\u1EDDi giao h\xE0ng</label><input type="text" style="width: 100%" ng-model="vm.stockin.shipper"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label">Ghi ch\xFA</label><input type="text" style="width: 100%" ng-model="vm.stockin.note"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label">Ng\xE0y gi\u1EDD nh\u1EADp kho</label><p>{{vm.stockin.inputAt | date:\'dd-MM-yyyy HH:mm\'}}</p></div></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>M\xE3 s\u1EA3n ph\u1EA9m</span></th><th><span>T\xEAn s\u1EA3n ph\u1EA9m</span></th><th><span>S\u1ED1 l\u01B0\u1EE3ng nh\u1EADp kho</span></th></tr></thead><tbody><tr ng-repeat="product in vm.products track by product.id" ng-click="vm.selectProduct(product)" ng-style="vm.currentProductId == product.id && {\'background-color\':\'#D3E5F7\'}"><td>{{$index + 1}}</td><td>{{product.productCode}}</td><td>{{product.productName}}</td><td><input type="number" style="width: 100%" ng-model="product.quantity"></td></tr></tbody></table></div></div><!-- end body --><div class="modal-footer"><button type="button" class="btn btn-info col-md-2" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/stockin/stockin.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="stockin.new" style="cursor: pointer"><span class="glyphicon glyphicon-plus"></span> <span>T\u1EA1o m\u1EDBi</span> </a><a ui-sref="stockin.delete({id:vm.currentStockinId})" style="cursor: pointer" ng-if="vm.currentStockinId != null"><span class="glyphicon glyphicon-remove"></span> <span>X\xF3a</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.currentAccount.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><h2>L\u1ECBch s\u1EED nh\u1EADp kho</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>Ng\u01B0\u1EDDi nh\u1EADp kho</span></th><th><span>Ng\u01B0\u1EDDi giao h\xE0ng</span></th><th><span>Ng\xE0y nh\u1EADp kho</span></th><th><span>Chi ti\u1EBFt</span></th><th>Ghi ch\xFA</th></tr></thead><tbody><tr ng-repeat="stockin in vm.stockins track by stockin.id" ng-click="vm.selectStockin(stockin)"><td>{{$index + 1}}</td><td>{{stockin.waiter}}</td><td>{{stockin.shipper}}</td><td>{{stockin.inputAt | date: \'dd-MM-yyyy\'}}</td><td><span ng-repeat="p in stockin.listStockinProduct track by $index"><p ng-if="p.inputQuantity >0">{{p.inputQuantity}} x {{p.productName}}</p></span></td><td>{{stockin.note}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/store/store-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">X\xE1c nh\u1EADn h\xE0nh \u0111\u1ED9ng x\xF3a?</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Ban th\u1EF1c s\u1EF1 mu\u1ED1n x\xF3a?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()" style="margin-top:30px"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" style="margin-top:30px"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>X\xF3a ngay</span></button></div></form>');
$templateCache.put('app/entities/store/store-detail.html','<div><!--<jhi-alert-error></jhi-alert-error>--><dl class="dl-horizontal jh-entity-details"><dt><span>T\xEAn c\u01A1 s\u1EDF</span></dt><dd><span>{{vm.store.storeName}}</span></dd><dt><span>\u0110\u1ECBa ch\u1EC9</span></dt><dd><span>{{vm.store.storeAddress}}</span></dd><dt><span>S\u0110T</span></dt><dd><span>{{vm.store.storePhone}}</span></dd><dt><span>\u1EA2nh</span></dt><dd><img ng-src="{{vm.apiUrl}}api/file/get-file/image/{{vm.store.storeImage}}"></dd></dl><button type="button" ui-sref="store-detail.edit({id:vm.store.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">S\u1EEDa</span></button> <button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></div>');
$templateCache.put('app/entities/store/store-dialog.html','<style>.width80 {\r\n        width: 80%;\r\n    }\r\n    .width50 {\r\n        width: 50%;\r\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.store.id == null">Th\xEAm c\u01A1 s\u1EDF m\u1EDBi</h2><h2 ng-if="vm.store.id != null">S\u1EEDa th\xF4ng tin c\u01A1 s\u1EDF</h2><div class="modal-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group col-xs-12"><label class="control-label" for="field_storeName">T\xEAn c\u01A1 s\u1EDF</label><input type="text" class="form-control width80" name="storeName" id="field_storeName" ng-model="vm.store.storeName" required></div><div class="form-group col-xs-12"><label class="control-label" for="field_storeAddress">\u0110\u1ECBa ch\u1EC9</label><input type="text" class="form-control width80" name="storeAddress" id="field_storeAddress" ng-model="vm.store.storeAddress" required></div><div class="form-group col-xs-12"><label class="control-label" for="field_storePhone">S\u0110T</label><input type="text" class="form-control width80" name="storePhone" id="field_storePhone" ng-model="vm.store.storePhone" required></div><div class="form-group col-xs-12"><label class="control-label" for="field_thank">L\u1EDDi c\u1EA3m \u01A1n (in bill)</label><input type="text" class="form-control width80" name="thank" id="field_thank" ng-model="vm.store.thank"></div></div><div class="col-md-6 col-xs-12"><div class="col-xs-12"><img ng-src="{{vm.apiUrl}}api/file/get-file/image/{{vm.store.storeImage}}"></div><div class="form-group col-xs-12 row"><label class="control-label col-xs-12" for="field_storeImage">\u1EA2nh c\u01A1 s\u1EDF</label><div class="input-group input-group-md col-xs-12 row"><input type="file" ngf-select ng-model="vm.uploadedImage" ngf-pattern="\'*.png\'" ngf-accept="\'.png\'" class="form-control" id="myFileField"> <span class="input-group-btn"><button type="button" ng-click="vm.uploadImage()" class="btn btn-primary">T\u1EA3i l\xEAn</button></span></div></div></div></div></div><!-- end body --><div class="modal-footer col-xs-12"><button type="button" class="btn btn-info col-md-2 col-xs-5" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2 col-xs-5"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/store/store.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="store.new" style="cursor: pointer"><span class="glyphicon glyphicon-plus"></span> <span>T\u1EA1o m\u1EDBi</span> </a><a ui-sref="store-detail({id:vm.currentStoreId})" style="cursor: pointer" ng-if="vm.currentStoreId != null"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span>Xem</span> </a><a ui-sref="store.edit({id:vm.currentStoreId})" style="cursor: pointer" ng-if="vm.currentStoreId != null"><span class="glyphicon glyphicon-edit"></span> <span>S\u1EEDa</span> </a><a ui-sref="store.delete({id:vm.currentStoreId})" style="cursor: pointer" ng-if="vm.currentStoreId != null"><span class="glyphicon glyphicon-remove"></span> <span>X\xF3a</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.currentAccount.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><h2>Danh s\xE1ch c\u01A1 s\u1EDF</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>T\xEAn c\u01A1 s\u1EDF</span></th><th><span>\u0110\u1ECBa ch\u1EC9</span></th><th><span>S\u0110T</span></th></tr></thead><tbody><tr ng-repeat="store in vm.stores track by store.id" ng-click="vm.selectStore(store)" ng-style="vm.currentStoreId == store.id && {\'background-color\':\'#D3E5F7\'}"><td ng-if="store.id != 1">{{$index }}</td><td ng-if="store.id != 1">{{store.storeName}}</td><td ng-if="store.id != 1">{{store.storeAddress}}</td><td ng-if="store.id != 1">{{store.storePhone}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/thuchi/thuchi-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.thuchi.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">X\xE1c nh\u1EADn h\xE0nh \u0111\u1ED9ng x\xF3a?</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Ban th\u1EF1c s\u1EF1 mu\u1ED1n x\xF3a?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()" style="margin-top:30px"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" style="margin-top:30px"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>X\xF3a ngay</span></button></div></form>');
$templateCache.put('app/entities/thuchi/thuchi-detail.html','<div><!--<jhi-alert-error></jhi-alert-error>--><dl class="dl-horizontal jh-entity-details"><dt><span>Ng\xE0y gi\u1EDD</span></dt><dd><span>{{vm.thuchi.inputAt | date: \'dd-MM-yyyy HH:mm\'}}</span></dd><dt><span>Ng\u01B0\u1EDDi ch\u1ECBu tr\xE1ch nhi\u1EC7m</span></dt><dd><span>{{vm.thuchi.person}}</span></dd><dt><span>Thu</span></dt><dd><span>{{vm.thuchi.thu}}</span></dd><dt><span>Chi</span></dt><dd><span>{{vm.thuchi.chi}}</span></dd><dt><span>Gi\u1EA3i th\xEDch chi ti\u1EBFt</span></dt><dd><span><pre>{{vm.thuchi.description}}</pre></span></dd><dt><span>C\u01A1 s\u1EDF</span></dt><dd><span>{{vm.thuchi.store.storeName}}</span></dd></dl><button type="button" ui-sref="thuchi-detail.edit({id:vm.thuchi.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">S\u1EEDa</span></button> <button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></div>');
$templateCache.put('app/entities/thuchi/thuchi-dialog.html','<style>.width80 {\r\n        width: 80%;\r\n    }\r\n    .width50 {\r\n        width: 50%;\r\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.thuchi.id == null">Nh\u1EADp thu chi</h2><h2 ng-if="vm.thuchi.id != null">S\u1EEDa thu chi</h2><div class="modal-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group col-xs-12"><label class="control-label">{{vm.thuchi.person}} {{vm.thuchi.inputAt | date: \'dd-MM-yyyy HH:mm\'}}</label></div><div class="form-group col-xs-12"><label class="control-label">Thu</label><input type="number" class="form-control width80" ng-model="vm.thuchi.thu"></div><div class="form-group col-xs-12"><label class="control-label">Chi</label><input type="number" class="form-control width80" ng-model="vm.thuchi.chi"></div></div><div class="col-md-6 col-xs-12"><label class="control-label" for="field_note">Gi\u1EA3i th\xEDch chi ti\u1EBFt</label><textarea rows="6" class="form-control width80" name="note" id="field_note" ng-model="vm.thuchi.description">\r\n                </textarea></div></div></div><!-- end body --><div class="modal-footer col-xs-12"><button type="button" class="btn btn-info col-md-2 col-xs-5" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2 col-xs-5"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/thuchi/thuchi.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="thuchi.new" style="cursor: pointer"><span class="glyphicon glyphicon-plus"></span> <span>T\u1EA1o m\u1EDBi</span> </a><a ui-sref="thuchi-detail({id:vm.currentThuchiId})" style="cursor: pointer" ng-if="vm.currentThuchiId != null"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span>Xem</span> </a><a ui-sref="thuchi.edit({id:vm.currentThuchiId})" style="cursor: pointer" ng-if="vm.currentThuchiId != null"><span class="glyphicon glyphicon-edit"></span> <span>S\u1EEDa</span> </a><!--\r\n       <a ui-sref="thuchi.delete({id:vm.currentThuchiId})" style="cursor: pointer;" ng-if="vm.currentThuchiId != null">\r\n            <span class="glyphicon glyphicon-remove" ></span>\r\n            <span>X\xF3a</span>\r\n       </a>\r\n        --> <a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.account.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><h2 class="form-group col-md-4 col-sm-12">L\u1ECBch s\u1EED Thu Chi</h2><div class="col-md-12" style="margin-top:10px"><div class="form-group col-md-4 col-xs-12"><h2 class="col-sm-4">C\u01A1 s\u1EDF</h2><div class="form-group col-sm-6"><div class="form-group row"><select class="form-control" name="type" ng-model="vm.filterStore" ng-options="store as store.storeName for store in vm.stores track by store.id" ng-change="vm.loadAll()" ng-disabled="vm.currentRole != \'ROLE_SUPER_ADMIN\'"></select></div></div></div><div class="form-group col-md-4 col-xs-12"><h2 class="col-sm-4">T\u1EEB ng\xE0y</h2><div class="input-group date input-group-sm col-sm-8"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button> </span><!--https://angular-ui.github.io/bootstrap/--> <input id="date" type="text" class="form-control" name="date" ng-model="vm.dateSearch" ng-change="vm.loadAll()" uib-datepicker-popup="{{vm.dateformat}}" is-open="popup1.opened" datepicker-options="dateOptions" readonly="readonly"></div><!-- /.input group --></div><div class="form-group col-md-4 col-xs-12"><h2 class="col-sm-4">\u0110\u1EBFn ng\xE0y</h2><div class="input-group date input-group-sm col-sm-8"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button> </span><!--https://angular-ui.github.io/bootstrap/--> <input id="date" type="text" class="form-control" name="date2" ng-model="vm.dateTo" ng-change="vm.loadAll()" uib-datepicker-popup="{{vm.dateformat}}" is-open="popup2.opened" datepicker-options="dateOptions" readonly="readonly"></div><!-- /.input group --></div></div><div class="col-md-12"><h2 class="col-md-4">T\u1ED5ng thu: {{vm.totalThu | number:0}}</h2><h2 class="col-md-4">T\u1ED5ng chi: {{vm.totalChi | number:0}}</h2></div><div class="table-responsive col-md-12"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>Ng\xE0y gi\u1EDD</span></th><th><span>Thu</span></th><th><span>Chi</span></th><th><span>L\xFD do</span></th><th><span>Ng\u01B0\u1EDDi ch\u1ECBu tr\xE1ch nhi\u1EC7m</span></th><th><span>C\u01A1 s\u1EDF</span></th></tr></thead><tbody><tr ng-repeat="thuchi in vm.thuchis track by thuchi.id" ng-click="vm.selectThuchi(thuchi)" ng-style="vm.currentThuchiId == thuchi.id && {\'background-color\':\'#D3E5F7\'}"><td>{{$index +1}}</td><td>{{thuchi.inputAt | date: \'dd-MM-yyyy HH:mm\'}}</td><td>{{thuchi.thu | number:0}}</td><td>{{thuchi.chi | number:0}}</td><td><pre>{{thuchi.description}}</pre></td><td>{{thuchi.person}}</td><td>{{thuchi.store.storeName}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ticket/ticket-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticket.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">X\xE1c nh\u1EADn h\xE0nh \u0111\u1ED9ng x\xF3a?</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Ban th\u1EF1c s\u1EF1 mu\u1ED1n x\xF3a?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()" style="margin-top:30px"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" style="margin-top:30px"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>X\xF3a ngay</span></button></div></form>');
$templateCache.put('app/entities/ticket/ticket-detail.html','<div><!--<jhi-alert-error></jhi-alert-error>--><dl class="dl-horizontal jh-entity-details"><dt><span>Lo\u1EA1i v\xE9</span></dt><dd><span>{{vm.ticket.type}}</span></dd><dt><span>Gi\xE1 ti\u1EC1n</span></dt><dd><span>{{vm.ticket.price}}</span></dd><dt><span>D\u1ECBch v\u1EE5</span></dt><dd><span><pre>{{vm.ticket.note}}</pre></span></dd><dt><span>C\u01A1 s\u1EDF</span></dt><dd><span>{{vm.ticket.store.storeName}}</span></dd></dl><button type="button" ui-sref="ticket-detail.edit({id:vm.ticket.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">S\u1EEDa</span></button> <button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Quay l\u1EA1i</span></button></div>');
$templateCache.put('app/entities/ticket/ticket-dialog.html','<style>.width80 {\r\n        width: 80%;\r\n    }\r\n    .width50 {\r\n        width: 50%;\r\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()"><h2 ng-if="vm.ticket.id == null">Th\xEAm lo\u1EA1i v\xE9 m\u1EDBi</h2><h2 ng-if="vm.ticket.id != null">S\u1EEDa lo\u1EA1i v\xE9</h2><div class="modal-body"><div class="row"><div class="col-md-6 col-xs-12"><div class="form-group col-xs-12"><label class="control-label">Lo\u1EA1i</label><input type="text" class="form-control width80" ng-model="vm.ticket.type" required></div><div class="form-group col-xs-12"><label class="control-label">Gi\xE1 ti\u1EC1n</label><input type="text" class="form-control width80" ng-model="vm.ticket.price" required></div><div class="form-group col-xs-12"><label class="control-label">Th\u1EDDi gian ph\u1EE5c v\u1EE5 (ph\xFAt)</label><input type="text" class="form-control width80" ng-model="vm.ticket.duration" required></div></div><div class="col-md-6 col-xs-12"></div></div></div><!-- end body --><div class="modal-footer col-xs-12"><button type="button" class="btn btn-info col-md-2 col-xs-5" ng-click="vm.back()">&nbsp;<span>H\u1EE7y b\u1ECF</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving == false" class="btn btn-primary col-md-2 col-xs-5"><span></span>&nbsp;<span>L\u01B0u</span></button></div></form>');
$templateCache.put('app/entities/ticket/ticket.html','<style>body {\r\n      margin: 0;\r\n      font-family: Arial, Helvetica, sans-serif;\r\n    }\r\n\r\n    .topnav {\r\n      overflow: hidden;\r\n      background-color: #51596a;\r\n    }\r\n\r\n    .topnav a {\r\n      float: left;\r\n      display: block;\r\n      color: #f2f2f2;\r\n      text-align: center;\r\n      padding: 14px 16px;\r\n      text-decoration: none;\r\n      font-size: 17px;\r\n    }\r\n\r\n    .topnav a:hover {\r\n      background-color: #ddd;\r\n      color: black;\r\n    }\r\n\r\n    .topnav a.active {\r\n      background-color: #4CAF50;\r\n      color: white;\r\n    }\r\n\r\n    .topnav .icon {\r\n      display: none;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav a:not(:first-child) {display: none;}\r\n      .topnav a.icon {\r\n        float: right;\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n      .topnav.responsive {position: relative;}\r\n      .topnav.responsive .icon {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n      }\r\n      .topnav.responsive a {\r\n        float: none;\r\n        display: block;\r\n        text-align: left;\r\n      }\r\n    }\r\n    .container {\r\n         padding-right: 0px; \r\n         padding-left: 0px;\r\n         margin-right: auto;\r\n         margin-left: auto;\r\n    }\r\n       \r\n      \r\n        .table > thead > tr > th\r\n         {\r\n            font-size: .9em;\r\n            font-weight: 400;\r\n            border-bottom: 0;\r\n            letter-spacing: 1px;\r\n            vertical-align: top;\r\n            padding: 8px;\r\n            background: #51596a;\r\n            text-transform: uppercase;\r\n            color: #ffffff;\r\n            white-space: nowrap;\r\n\r\n        }\r\n\r\n        td {\r\n            max-width: 100px;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n\r\n        }\r\n        .table > tbody > tr > td {\r\n            padding: 8px;\r\n        }</style><script>function myFunction() {\r\n      var x = document.getElementById("myTopnav");\r\n      if (x.className === "topnav") {\r\n        x.className += " responsive";\r\n      } else {\r\n        x.className = "topnav";\r\n      }\r\n    }</script><div class="topnav" id="myTopnav"><a ui-sref="navigate" style="cursor: pointer"><span class="glyphicon glyphicon-home"></span> <span>Trang ch\u1EE7</span> </a><a ui-sref="ticket.new" style="cursor: pointer"><span class="glyphicon glyphicon-plus"></span> <span>T\u1EA1o m\u1EDBi</span> </a><a ui-sref="ticket-detail({id:vm.currentTicketId})" style="cursor: pointer" ng-if="vm.currentTicketId != null"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span>Xem</span> </a><a ui-sref="ticket.edit({id:vm.currentTicketId})" style="cursor: pointer" ng-if="vm.currentTicketId != null"><span class="glyphicon glyphicon-edit"></span> <span>S\u1EEDa</span> </a><a ui-sref="ticket.delete({id:vm.currentTicketId})" style="cursor: pointer" ng-if="vm.currentTicketId != null"><span class="glyphicon glyphicon-remove"></span> <span>X\xF3a</span> </a><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span> <span>\u0110\u0103ng xu\u1EA5t \'{{vm.currentAccount.login}}\'</span> </a><a href="javascript:void(0);" class="icon" onclick="myFunction()"><i class="fa fa-bars"></i></a></div><div><h2>Danh s\xE1ch c\xE1c lo\u1EA1i v\xE9 matxa</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>STT</th><th><span>Lo\u1EA1i v\xE9</span></th><th><span>Gi\xE1 ti\u1EC1n</span></th><th><span>Th\u1EDDi gian ph\u1EE5c v\u1EE5</span></th><th><span>C\u01A1 s\u1EDF</span></th></tr></thead><tbody><tr ng-repeat="ticket in vm.tickets track by ticket.id" ng-click="vm.selectTicket(ticket)" ng-style="vm.currentTicketId == ticket.id && {\'background-color\':\'#D3E5F7\'}"><td>{{$index +1}}</td><td>{{ticket.type}}</td><td>{{ticket.price | number:0}}</td><td>{{ticket.duration}} ph\xFAt</td><td>{{ticket.store.storeName}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/leftmenu.html','<div class="col-md-3 left_col"><div class="left_col scroll-view"><div class="navbar nav_title" style="border: 0"><a href="index.html" class="site_title"><b style="font-size:20px">X</b> POS</a></div><div class="clearfix"></div><br><!-- sidebar menu --><div id="sidebar-menu" class="main_menu_side hidden-print main_menu"><div class="menu_section" ng-show="vm.isAuthenticated()"><ul class="nav side-menu"><h3><span data-translate="global.menu.entities.dashboard-boss">Boss\'s Dashboard</span></h3><li><a ui-sref="table-zone"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.tableZone">Table Zone Management</span></a></li><li><a ui-sref="table-pos"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.tablePos">Table Management</span></a></li><li><a ui-sref="product-category"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.productCategory">Product Category</span></a></li><li><a ui-sref="product-group"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.productGroup">Product Group</span></a></li><li><a ui-sref="product"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.product">Product</span></a></li><li><a ui-sref="customer"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.customer">Customer Management</span></a></li><li><a ui-sref="order-pos"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.orderPos">Order Management</span></a></li><br><h3><span data-translate="global.menu.entities.dashboard-staff">Staff\'s Dashboard</span></h3><li><a ui-sref="make-order"><i class="fa fa-table"></i> <span data-translate="global.menu.entities.makeOrder">Make Order</span></a></li><!--<li >\r\n                        <a>\r\n                            <i class="fa fa-user-circle-o"></i><span>Administrator</span><span class="fa fa-chevron-down"></span></a>\r\n                        <ul class="nav child_menu">\r\n                            <li ui-sref-active="active" >\r\n                                <a ui-sref="user-management" ng-click="vm.collapseNavbar()">\r\n                                    <span class="glyphicon glyphicon-user"></span>&nbsp;\r\n                                    <span  data-translate="global.menu.admin.userManagement"> User management </span>\r\n                                </a>\r\n                            </li>\r\n                            <li ui-sref-active="active">\r\n                                <a ui-sref="jhi-metrics">\r\n                                    <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\r\n                                    <span data-translate="global.menu.admin.metrics">Metrics</span>\r\n                                </a>\r\n                            </li>\r\n                            <li ui-sref-active="active">\r\n                                <a ui-sref="jhi-health">\r\n                                    <span class="glyphicon glyphicon-heart"></span>&nbsp;\r\n                                    <span data-translate="global.menu.admin.health">Health</span>\r\n                                </a>\r\n                            </li>\r\n                            <li ui-sref-active="active">\r\n                                <a ui-sref="jhi-configuration">\r\n                                    <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\r\n                                    <span data-translate="global.menu.admin.configuration">Configuration</span>\r\n                                </a>\r\n                            </li>\r\n                            <li ui-sref-active="active">\r\n                                <a ui-sref="audits">\r\n                                    <span class="glyphicon glyphicon-bell"></span>&nbsp;\r\n                                    <span data-translate="global.menu.admin.audits">Audits</span>\r\n                                </a>\r\n                            </li>\r\n                            <li ui-sref-active="active">\r\n                                <a ui-sref="logs">\r\n                                    <span class="glyphicon glyphicon-tasks"></span>&nbsp;\r\n                                    <span data-translate="global.menu.admin.logs">Logs</span>\r\n                                </a>\r\n                            </li>\r\n                            <li ui-sref-active="active">\r\n                                <a ui-sref="docs">\r\n                                    <span class="glyphicon glyphicon-book"></span>&nbsp;\r\n                                    <span data-translate="global.menu.admin.apidocs">API</span>\r\n                                </a>\r\n                            </li>\r\n                            <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><!--    </ul>--><!--</li>--></ul></div></div><!-- /sidebar menu --><!-- /menu footer buttons --></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<style>.ui-keyboard-button {\r\n    border: 1px solid #404040;\r\n    padding: 0 0.5em;\r\n    margin: 1px;\r\n    min-width: 5em;\r\n    height: 3.5em;\r\n    line-height: 3em;\r\n    vertical-align: top;\r\n    font-family: Helvetica, Arial, sans-serif;\r\n    font-weight: bold;\r\n    color: #333;\r\n    text-align: center;\r\n    border-radius: 5px;\r\n    -webkit-box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\r\n    box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);\r\n    background-image: none;\r\n    background-color: silver;\r\n    cursor: pointer;\r\n    overflow: hidden;\r\n    -moz-user-focus: ignore;\r\n}</style><div class="top_nav" ng-if="vm.isNav"><div class="nav_menu"><nav><div class="nav navbar-left"><ul class="nav navbar-nav"><li class="background-item-menu col-xs-3" style="margin:0px;padding:0px"><a class="user-profile" data-toggle="tooltip" title="{{\'global.menu.entities.makeOrder\' | translate}}" ng-click="vm.goOrder()"><img class="margin-right-0" src="content/images/meal1.png" alt=""></a></li><li class="background-item-menu col-xs-3" style="margin:0px;padding:0px"><a ui-sref="customer" class="user-profile" data-toggle="tooltip" title="{{\'global.menu.entities.customer\' | translate}}"><img class="margin-right-0" src="content/images/team.png" alt=""></a></li><li class="background-item-menu col-xs-3" style="margin:0px;padding:0px"><a ui-sref="product" class="user-profile" data-toggle="tooltip" title="{{\'global.menu.entities.product\' | translate}}"><img class="margin-right-0" src="content/images/pan.png" alt=""></a></li><li class="background-item-menu col-xs-3" style="margin:0px;padding:0px"><a ui-sref="bill" class="user-profile" data-toggle="tooltip" title="{{\'global.menu.entities.bill\' | translate}}"><img class="margin-right-0" src="content/images/bill.png" alt=""></a></li><!--\r\n\r\n                        <li style="overflow: hidden;" class=" col-xs-1">\r\n                                <input type="text" class="form-control" id="input_focus"\r\n                                ng-model="vm.inputFocus" ng-change="vm.checkLogOut(vm.inputFocus)" style="width:0;opacity: 0;" />\r\n                                \r\n                        </li>\r\n                     --></ul><div class="input-group input-group-md" style="padding: 6px 0px 0px 5px; margin-left:5px"><input type="text" id="input_search" class="form-control" ng-model="vm.searchData" ng-keyup="vm.onKeyup($event)" ng-change="vm.inputSearch()" ng-virtual-keyboard="t01Config"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-flat" ng-click="search()" data-translate="global.order.search">Suchen</button> </span><!--\r\n                        <span class="input-group-btn">\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click="search()" ng-if="vm.isSearchButton"\r\n                            data-translate="global.order.search" >Suchen</button>\r\n                            <button type="button" class="btn btn-info btn-flat" ng-click=" vm.clearSearch()" ng-if="vm.isSearchButton == false"\r\n                            data-translate="global.order.clear">Clear</button>\r\n                        </span>\r\n                    --></div></div><div class="nav navbar-right" ng-show="vm.isNav"><ul class="nav navbar-nav" uib-dropdown ng-switch="vm.isAuthenticated()" style="float:right"><li><a btn id="close" ng-click="vm.shutDown()" ng-if="vm.shutdownMode.setting ==\'0\' || vm.shutdownMode == null"><i style="color: blue" class="fa fa-power-off"></i></a> <a btn id="close" ng-click="vm.shutDown()" ng-if="vm.shutdownMode.setting ==\'1\'"><i class="fa fa-power-off"></i></a></li><li uib-dropdown ng-switch-when="true" has-authority="ROLE_ADMIN"><a href="javascript:;" class="user-profile dropdown-toggle" uib-dropdown-toggle aria-expanded="false"><i class="fa fa-2x fa-cogs"></i></a><ul class="dropdown-menu dropdown-usermenu pull-right" uib-dropdown-menu><li><a ui-sref="syncdata"><span data-translate="global.menu.entities.syncData">Sync</span></a></li><li><a ui-sref="adminsettings"><span data-translate="global.menu.entities.generalSetting">General Setting</span></a></li><li><a ui-sref="prints"><span data-translate="global.menu.entities.printSetting">Print Setting</span></a></li><li><a ui-sref="daily-reports"><span data-translate="global.menu.entities.reports">Reports</span></a></li><li><a ui-sref="monthly-reports"><span data-translate="global.report.monthly">Reports</span></a></li><li ng-if="vm.useTIM == \'1\'"><a ui-sref="timreport"><span data-translate="global.menu.entities.dailyTimReport">Tim Report</span></a></li><!--\r\n\r\n                                <li>\r\n                                    <a>\r\n                                        <span data-translate="global.menu.entities.logBunch">Log Bunch</span>\r\n                                    </a>\r\n                                </li>\r\n                                --><li><a ui-sref="printdata"><span>GDPdU GoBD</span></a></li><li><a ui-sref="data-backup"><span data-translate="global.menu.entities.backup">Backup and Recovery</span></a></li><li><a ui-sref="user-management"><span data-translate="global.menu.admin.userManagement">User Management</span></a></li><li><a ui-sref="bill"><span data-translate="global.menu.entities.bill">Bill</span></a></li><!--\r\n                                <li>\r\n                                    <a ui-sref="bill-edit">\r\n                                        <span>Edit Bill</span>\r\n                                    </a>\r\n                                </li>\r\n                                --><li><a ui-sref="tienvon"><span>Ti\u1EC1n v\u1ED1n</span></a></li></ul></li><li uib-dropdown ng-switch-when="true" has-authority="ROLE_SUPER_ADMIN"><a href="javascript:;" class="user-profile dropdown-toggle" uib-dropdown-toggle aria-expanded="false"><i class="fa fa-2x fa-cogs"></i></a><ul class="dropdown-menu dropdown-usermenu pull-right" uib-dropdown-menu><li><a ui-sref="data-backup"><span data-translate="global.menu.entities.backup">Backup and Recovery</span></a></li></ul></li><li uib-dropdown ng-switch-when="true"><a href="javascript:;" class="user-profile dropdown-toggle" uib-dropdown-toggle aria-expanded="false"><!--<img src="content/images/avatar.png" alt="">-->{{vm.account.login}} <b class="caret"></b></a><ul class="dropdown-menu dropdown-usermenu pull-right" uib-dropdown-menu><li><a ui-sref="settings"><span class="glyphicon glyphicon-wrench pull-right"></span>&nbsp; <span>Setting</span></a></li><li><a ui-sref="password"><span class="glyphicon glyphicon-lock pull-right"></span>&nbsp; <span>Change Password</span></a></li><li><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out pull-right"></span>&nbsp; <span>Logout</span></a></li></ul></li><!--<li ng-switch-when="false">\r\n                            <a href="" ng-click="vm.login()" id="login">\r\n                                <span class="glyphicon glyphicon-log-in"></span>&nbsp;\r\n                                <span data-translate="global.menu.account.login">Login</span>\r\n                            </a>\r\n                        </li>--><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><!-- <span class="glyphicon glyphicon-flag"></span> --> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></nav></div><span id="alertShutdown" ng-show="false" data-translate="error.shutdownNotPermission">You don\'t have permission to shutdown app</span></div>');}]);})();